module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[321.134,473.894],[321.134,404.332],[267.237,475.211],[267.237,407.05]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[321.134,548.76],[321.134,479.198],[267.237,548.568],[267.237,480.408]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[321.134,553.32],[321.134,622.883],[267.237,553.037],[267.237,621.198]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[321.134,628.211],[321.134,697.774],[267.237,626.419],[267.237,694.579]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[321.134,705.163],[321.134,774.725],[267.237,701.82],[267.237,769.98]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,471.657],[379.101,399.713],[306.172,473.461],[306.172,403.437]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,549.085],[379.101,477.142],[306.172,548.823],[306.172,478.8]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,553.802],[379.101,625.745],[306.172,553.414],[306.172,623.437]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,631.256],[379.101,703.2],[306.172,628.801],[306.172,698.824]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,710.842],[379.101,782.785],[306.172,706.263],[306.172,776.286]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,471.657],[379.101,399.713],[394.499,472.13],[394.499,400.69]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,549.085],[379.101,477.142],[394.499,549.017],[394.499,477.577]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,553.802],[379.101,625.745],[394.499,553.7],[394.499,625.14]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,631.256],[379.101,703.2],[394.499,630.612],[394.499,702.052]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[379.101,710.842],[379.101,782.785],[394.499,709.64],[394.499,781.08]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[453.509,470.689],[453.509,397.715],[394.499,472.13],[394.499,400.69]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[453.509,549.226],[453.509,476.253],[394.499,549.017],[394.499,477.577]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[453.509,554.01],[453.509,626.984],[394.499,553.7],[394.499,625.14]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[453.509,632.574],[453.509,705.547],[394.499,630.612],[394.499,702.052]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[453.509,713.299],[453.509,786.273],[394.499,709.64],[394.499,781.08]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[514.27,469.782],[514.27,395.231],[452.954,471.267],[452.954,398.31]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[514.27,550.017],[514.27,475.466],[452.954,549.787],[452.954,476.83]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[514.27,635.166],[514.27,709.717],[452.954,633.116],[452.954,706.073]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[514.27,717.636],[514.27,792.187],[452.954,713.822],[452.954,786.78]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[514.27,554.905],[514.27,629.456],[452.954,554.57],[452.954,627.527]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,467.209],[583.134,389.896],[499.079,469.271],[499.079,394.171]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,550.416],[583.134,473.103],[499.079,550.096],[499.079,474.997]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,555.484],[583.134,632.797],[499.079,555.02],[499.079,630.12]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,638.719],[583.134,716.032],[499.079,635.872],[499.079,710.972]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,724.244],[583.134,801.557],[499.079,718.95],[499.079,794.049]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,467.209],[583.134,389.896],[597.63,467.732],[597.63,390.981]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,550.416],[583.134,473.103],[597.63,550.335],[597.63,473.584]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,555.484],[583.134,632.797],[597.63,555.366],[597.63,632.117]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,638.719],[583.134,716.032],[597.63,637.997],[597.63,714.747]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[583.134,724.244],[583.134,801.557],[597.63,722.9],[597.63,799.651]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.147,466.072],[666.147,387.539],[597.63,467.732],[597.63,390.981]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.147,550.592],[666.147,472.06],[597.63,550.335],[597.63,473.584]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.147,555.741],[666.147,634.273],[597.63,555.366],[597.63,632.117]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.147,640.289],[666.147,718.822],[597.63,637.997],[597.63,714.747]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.147,727.164],[666.147,805.696],[597.63,722.9],[597.63,799.651]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.063,466.106],[666.063,387.609],[728.56,468.496],[728.56,392.566]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.063,550.587],[666.063,472.091],[728.56,550.216],[728.56,474.286]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.063,555.733],[666.063,634.229],[728.56,555.194],[728.56,631.125]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.063,640.242],[666.063,718.739],[728.56,636.941],[728.56,712.872]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[666.063,727.077],[666.063,805.573],[728.56,720.938],[728.56,796.868]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[855.62,461.513],[855.62,378.089],[778.37,463.385],[778.37,381.969]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[855.62,551.299],[855.62,467.874],[778.37,551.009],[778.37,469.592]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[855.62,556.768],[855.62,640.192],[778.37,556.346],[778.37,637.762]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[855.62,646.582],[855.62,730.007],[778.37,643.999],[778.37,725.415]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[855.62,738.868],[855.62,822.293],[778.37,734.063],[778.37,815.479]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.234,458.277],[947.234,371.379],[841.42,460.873],[841.42,376.76]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.234,551.8],[947.234,464.902],[841.42,551.398],[841.42,467.286]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.234,557.497],[947.234,644.395],[841.42,556.912],[841.42,641.024]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.234,651.051],[947.234,737.949],[841.42,647.467],[841.42,731.579]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.234,747.179],[947.234,834.077],[841.42,740.514],[841.42,824.626]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.235,458.277],[947.235,371.379],[960.543,458.937],[960.543,372.749]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.235,551.8],[947.235,464.902],[960.543,551.698],[960.543,465.509]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.235,557.497],[947.235,644.395],[960.543,557.348],[960.543,643.537]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.235,651.051],[947.235,737.949],[960.543,650.139],[960.543,736.328]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[947.235,747.179],[947.235,834.077],[960.543,745.483],[960.543,831.672]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1047.19,456.838],[1047.19,368.395],[960.543,458.937],[960.543,372.749]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1047.19,552.023],[1047.19,463.581],[960.543,551.698],[960.543,465.509]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1047.19,557.821],[1047.19,646.263],[960.543,557.348],[960.543,643.537]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1047.19,653.038],[1047.19,741.48],[960.543,650.139],[960.543,736.328]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1047.19,750.875],[1047.19,839.317],[960.543,745.483],[960.543,831.672]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1135.66,454.73],[1135.66,364.026],[1045.31,456.918],[1045.31,368.563]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1135.66,552.35],[1135.66,461.646],[1045.31,552.011],[1045.31,463.655]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1135.66,558.296],[1135.66,649],[1045.31,557.803],[1045.31,646.158]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1135.66,655.948],[1135.66,746.652],[1045.31,652.927],[1045.31,741.282]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1135.66,756.287],[1135.66,846.991],[1045.31,750.667],[1045.31,839.023]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,450.89],[1248.36,356.065],[1122.72,453.972],[1122.72,362.454]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,552.945],[1248.36,458.12],[1122.72,552.467],[1122.72,460.95]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,559.161],[1248.36,653.986],[1122.72,558.467],[1122.72,649.984]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,661.25],[1248.36,756.075],[1122.72,656.995],[1122.72,748.512]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,766.148],[1248.36,860.973],[1122.72,758.234],[1122.72,849.751]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,450.89],[1248.36,356.065],[1260.19,451.676],[1260.19,357.695]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,552.945],[1248.36,458.12],[1260.19,552.823],[1260.19,458.842]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,559.161],[1248.36,653.986],[1260.19,558.984],[1260.19,652.965]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,661.25],[1248.36,756.075],[1260.19,660.165],[1260.19,754.146]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1248.36,766.148],[1248.36,860.973],[1260.19,764.129],[1260.19,858.11]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1363.46,449.173],[1363.46,352.506],[1260.19,451.676],[1260.19,357.695]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1363.46,553.211],[1363.46,456.544],[1260.19,552.823],[1260.19,458.842]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1363.46,559.548],[1363.46,656.215],[1260.19,558.984],[1260.19,652.965]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1363.46,663.62],[1363.46,760.287],[1260.19,660.164],[1260.19,754.146]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1363.46,770.555],[1363.46,867.222],[1260.19,764.129],[1260.19,858.11]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1470.67,443.511],[1470.67,344.096],[1365.84,446.135],[1365.84,349.445]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1470.67,550.506],[1470.67,451.091],[1365.84,550.198],[1365.84,453.507]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1470.67,557.023],[1470.67,656.439],[1365.84,556.536],[1365.84,653.227]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1470.67,664.054],[1470.67,763.469],[1365.84,660.633],[1365.84,757.324]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1470.67,774.03],[1470.67,873.445],[1365.84,767.594],[1365.84,864.285]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,438.722],[1611.48,334.335],[1459.77,442.569],[1459.77,342.175]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,551.069],[1611.48,446.681],[1459.77,550.617],[1459.77,450.223]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,557.912],[1611.48,662.3],[1459.77,557.198],[1459.77,657.592]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,670.296],[1611.48,774.684],[1459.77,665.282],[1459.77,765.676]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,785.772],[1611.48,890.16],[1459.77,776.34],[1459.77,876.733]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,438.722],[1611.48,334.335],[1620.94,439.706],[1620.94,336.34]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,551.069],[1611.48,446.681],[1620.94,550.953],[1620.94,447.587]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,557.912],[1611.48,662.3],[1620.94,557.73],[1620.94,661.096]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,670.296],[1611.48,774.684],[1620.94,669.014],[1620.94,772.38]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1611.48,785.772],[1611.48,890.16],[1620.94,783.36],[1620.94,886.726]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,436.568],[1746.22,329.944],[1620.94,439.706],[1620.94,336.34]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,551.322],[1746.22,444.698],[1620.94,550.953],[1620.94,447.587]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,558.312],[1746.22,664.936],[1620.94,557.73],[1620.94,661.096]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,673.104],[1746.22,779.728],[1620.94,669.014],[1620.94,772.38]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,791.054],[1746.22,897.678],[1620.94,783.36],[1620.94,886.726]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,436.568],[1746.22,329.944],[1811.97,444.684],[1811.97,346.488]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,551.322],[1746.22,444.698],[1811.97,550.368],[1811.97,452.171]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,558.312],[1746.22,664.936],[1811.97,556.806],[1811.97,655.003]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,673.104],[1746.22,779.728],[1811.97,662.525],[1811.97,760.721]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1746.22,791.054],[1746.22,897.678],[1811.97,771.152],[1811.97,869.349]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1829.76,446.88],[1829.76,350.963],[1883.39,453.5],[1883.39,364.458]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1829.76,550.11],[1829.76,454.193],[1883.39,549.332],[1883.39,460.29]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1829.76,556.398],[1829.76,652.315],[1883.39,555.169],[1883.39,644.212]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1829.76,659.662],[1829.76,755.579],[1883.39,651.033],[1883.39,740.075]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:1,
                    verts:[[1829.76,765.768],[1829.76,861.684],[1883.39,749.533],[1883.39,838.576]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[286.578,472.733],[286.578,401.936],[226.63,473.924],[226.63,404.395]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[286.578,548.929],[286.578,478.131],[226.63,548.756],[226.63,479.226]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[286.578,553.57],[286.578,624.368],[226.63,553.314],[226.63,622.844]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[286.578,629.791],[286.578,700.589],[226.63,628.17],[226.63,697.699]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[286.578,708.109],[286.578,778.907],[226.63,705.085],[226.63,774.615]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,470.634],[353.086,397.602],[272.256,472.259],[272.256,400.956]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,549.234],[353.086,476.202],[272.256,548.998],[272.256,477.695]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,554.022],[353.086,627.054],[272.256,553.672],[272.256,624.975]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,632.648],[353.086,705.68],[272.256,630.437],[272.256,701.74]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,713.438],[353.086,786.47],[272.256,709.314],[272.256,780.617]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,470.634],[353.086,397.602],[367.659,471.149],[367.659,398.666]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,549.234],[353.086,476.202],[367.659,549.159],[367.659,476.676]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,554.022],[353.086,627.054],[367.659,553.911],[367.659,626.394]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,632.648],[353.086,705.68],[367.659,631.947],[367.659,704.43]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[353.086,713.438],[353.086,786.47],[367.659,712.13],[367.659,784.613]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[432.576,469.86],[432.576,396.004],[367.659,471.149],[367.659,398.666]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[432.576,549.347],[432.576,475.491],[367.659,549.159],[367.659,476.676]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[432.576,554.189],[432.576,628.044],[367.659,553.911],[367.659,626.394]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[432.576,633.702],[432.576,707.557],[367.659,631.947],[367.659,704.43]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[432.576,715.403],[432.576,789.258],[367.659,712.13],[367.659,784.613]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[499.078,550.12],[499.078,474.86],[431.961,549.915],[431.961,476.074]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[499.078,719.331],[499.078,794.591],[431.961,715.937],[431.961,789.777]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[499.078,469.122],[499.078,393.863],[431.961,470.444],[431.961,396.603]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[499.078,555.053],[499.078,630.313],[431.961,554.755],[431.961,628.596]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[499.078,636.078],[499.078,711.337],[431.961,634.252],[431.961,708.093]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,466.745],[576.59,388.934],[484.976,468.571],[484.976,392.72]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,550.488],[576.59,472.677],[484.976,550.205],[484.976,474.354]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,555.589],[576.59,633.4],[484.976,555.178],[484.976,631.029]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,639.36],[576.59,717.171],[484.976,636.839],[484.976,712.69]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,725.436],[576.59,803.247],[484.976,720.747],[484.976,796.598]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,466.745],[576.59,388.934],[589.856,467.305],[589.856,390.096]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,550.488],[576.59,472.677],[589.856,550.401],[589.856,473.192]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,555.589],[576.59,633.4],[589.856,555.463],[589.856,632.672]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,639.36],[576.59,717.171],[589.856,638.586],[589.856,715.796]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[576.59,725.436],[576.59,803.247],[589.856,723.997],[589.856,801.206]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.929,465.845],[663.929,387.069],[589.856,467.305],[589.856,390.096]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.929,550.627],[663.929,471.852],[589.856,550.401],[589.856,473.192]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.929,555.792],[663.929,634.567],[589.856,555.463],[589.856,632.672]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.929,640.602],[663.929,719.377],[589.856,638.586],[589.856,715.796]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.929,727.745],[663.929,806.521],[589.856,723.997],[589.856,801.206]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.75,465.879],[663.75,387.139],[720.123,468.417],[720.123,392.401]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.75,550.622],[663.75,471.882],[720.123,550.229],[720.123,474.213]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.75,555.784],[663.75,634.524],[720.123,555.212],[720.123,631.228]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.75,640.556],[663.75,719.296],[720.123,637.051],[720.123,713.067]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[663.75,727.66],[663.75,806.4],[720.123,721.142],[720.123,797.158]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[866.485,461.885],[866.485,378.858],[784.25,463.504],[784.25,382.217]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[866.485,551.241],[866.485,468.215],[784.25,550.99],[784.25,469.702]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[866.485,556.684],[866.485,639.71],[784.25,556.319],[784.25,637.607]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[866.485,646.07],[866.485,729.096],[784.25,643.833],[784.25,725.121]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[866.485,737.915],[866.485,820.942],[784.25,733.756],[784.25,815.044]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.083,458.981],[966.083,372.839],[854.102,461.213],[854.102,377.466]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.083,551.691],[966.083,465.549],[854.102,551.345],[854.102,467.598]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.083,557.338],[966.083,643.48],[854.102,556.835],[854.102,640.582]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.083,650.079],[966.083,736.221],[854.102,646.997],[854.102,730.744]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.083,745.371],[966.083,831.513],[854.102,739.64],[854.102,823.386]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.084,458.981],[966.084,372.839],[977.429,459.667],[977.429,374.262]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.084,551.691],[966.084,465.549],[977.429,551.585],[977.429,466.179]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.084,557.338],[966.084,643.48],[977.429,557.184],[977.429,642.589]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.084,650.079],[966.084,736.221],[977.429,649.131],[977.429,734.537]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[966.084,745.371],[966.084,831.513],[977.429,743.609],[977.429,829.015]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1068.26,457.877],[1068.26,370.551],[977.429,459.667],[977.429,374.262]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1068.26,551.862],[1068.26,464.536],[977.429,551.585],[977.429,466.179]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1068.26,557.587],[1068.26,644.913],[977.429,557.184],[977.429,642.589]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1068.26,651.603],[1068.26,738.929],[977.429,649.131],[977.429,734.537]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1068.26,748.205],[1068.26,835.532],[977.429,743.609],[977.429,829.015]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1160.23,456.098],[1160.23,366.862],[1066.2,457.95],[1066.2,370.702]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1160.23,552.138],[1160.23,462.902],[1066.2,551.851],[1066.2,464.603]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1160.23,557.988],[1160.23,647.224],[1066.2,557.57],[1066.2,644.818]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1160.23,654.059],[1160.23,743.295],[1066.2,651.502],[1066.2,738.75]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1160.23,752.774],[1160.23,842.009],[1066.2,748.017],[1066.2,835.265]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,452.735],[1279.46,359.889],[1149.66,455.322],[1149.66,365.253]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,552.659],[1279.46,459.814],[1149.66,552.258],[1149.66,462.189]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,558.746],[1279.46,651.591],[1149.66,558.163],[1149.66,648.231]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,658.703],[1279.46,751.548],[1149.66,655.131],[1149.66,745.199]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,761.41],[1279.46,854.256],[1149.66,754.767],[1149.66,844.835]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,452.735],[1279.46,359.889],[1288.8,453.531],[1288.8,361.541]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,552.659],[1279.46,459.814],[1288.8,552.535],[1288.8,460.545]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,558.746],[1279.46,651.591],[1288.8,558.566],[1288.8,650.556]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,658.703],[1279.46,751.548],[1288.8,657.603],[1288.8,749.593]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1279.46,761.41],[1279.46,854.256],[1288.8,759.365],[1288.8,851.355]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1394.36,451.451],[1394.36,357.228],[1288.8,453.531],[1288.8,361.541]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1394.36,552.858],[1394.36,458.635],[1288.8,552.535],[1288.8,460.545]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1394.36,559.035],[1394.36,653.257],[1288.8,558.566],[1288.8,650.556]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1394.36,660.475],[1394.36,754.698],[1288.8,657.603],[1288.8,749.593]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1394.36,764.706],[1394.36,858.929],[1288.8,759.365],[1288.8,851.355]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1502.91,446.335],[1502.91,349.853],[1396.69,448.498],[1396.69,354.261]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1502.91,550.174],[1502.91,453.692],[1396.69,549.92],[1396.69,455.683]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1502.91,556.499],[1502.91,652.982],[1396.69,556.098],[1396.69,650.335]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1502.91,660.372],[1502.91,756.854],[1396.69,657.553],[1396.69,751.79]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1502.91,767.103],[1502.91,863.586],[1396.69,761.8],[1396.69,856.037]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,442.258],[1647.28,341.543],[1494.93,445.397],[1494.93,347.94]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,550.653],[1647.28,449.938],[1494.93,550.284],[1494.93,452.828]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,557.256],[1647.28,657.972],[1494.93,556.673],[1494.93,654.13]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,665.687],[1647.28,766.402],[1494.93,661.595],[1494.93,759.052]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,777.101],[1647.28,877.816],[1494.93,769.404],[1494.93,866.861]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,442.258],[1647.28,341.543],[1653.73,443.227],[1653.73,343.516]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,550.653],[1647.28,449.938],[1653.73,550.54],[1653.73,450.829]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,557.256],[1647.28,657.972],[1653.73,557.076],[1653.73,656.787]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,665.687],[1647.28,766.402],[1653.73,664.425],[1653.73,764.135]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1647.28,777.101],[1647.28,877.816],[1653.73,774.727],[1653.73,874.438]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,440.696],[1778,338.357],[1653.73,443.227],[1653.73,343.516]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,550.837],[1778,448.499],[1653.73,550.54],[1653.73,450.829]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,557.546],[1778,659.885],[1653.73,557.076],[1653.73,656.787]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,667.724],[1778,770.063],[1653.73,664.425],[1653.73,764.135]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,780.933],[1778,883.272],[1653.73,774.727],[1653.73,874.437]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,440.696],[1778,338.357],[1819.27,448.591],[1819.27,354.451]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,550.837],[1778,448.499],[1819.27,549.909],[1819.27,455.769]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,557.546],[1778,659.885],[1819.27,556.081],[1819.27,650.221]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,667.724],[1778,770.063],[1819.27,657.432],[1819.27,751.572]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1778,780.933],[1778,883.272],[1819.27,761.572],[1819.27,855.712]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1830.42,450.724],[1830.42,358.799],[1864,457.147],[1864,371.891]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1830.42,549.658],[1830.42,457.733],[1864,548.903],[1864,463.647]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1830.42,555.685],[1830.42,647.61],[1864,554.492],[1864,639.749]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1830.42,654.652],[1830.42,746.577],[1864,646.279],[1864,731.535]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:2,
                    verts:[[1830.42,756.342],[1830.42,848.267],[1864,740.592],[1864,825.848]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[255.794,471.486],[255.794,399.362],[189.796,472.536],[189.796,401.529]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[255.794,549.11],[255.794,476.986],[189.796,548.958],[189.796,477.95]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[255.794,553.839],[255.794,625.963],[189.796,553.613],[189.796,624.62]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[255.794,631.488],[255.794,703.613],[189.796,630.059],[189.796,701.067]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[255.794,711.274],[255.794,783.399],[189.796,708.609],[189.796,779.617]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.836,469.546],[330.836,395.357],[242.223,470.971],[242.223,398.298]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.836,549.392],[330.836,475.203],[242.223,549.185],[242.223,476.512]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.836,554.256],[330.836,628.446],[242.223,553.95],[242.223,626.623]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.836,634.129],[330.836,708.318],[242.223,632.19],[242.223,704.863]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.836,716.199],[330.836,790.388],[242.223,712.583],[242.223,785.256]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.837,469.546],[330.837,395.357],[344.466,470.102],[344.466,396.505]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.837,549.392],[330.837,475.203],[344.466,549.312],[344.466,475.714]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.837,554.256],[330.837,628.446],[344.466,554.137],[344.466,627.734]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.837,634.129],[330.837,708.318],[344.466,633.372],[344.466,706.97]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[330.837,716.199],[330.837,790.388],[344.466,714.788],[344.466,788.385]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[415.099,468.979],[415.099,394.186],[344.466,470.102],[344.466,396.505]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[415.099,549.475],[415.099,474.682],[344.466,549.312],[344.466,475.714]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[415.099,554.378],[415.099,629.171],[344.466,554.137],[344.466,627.734]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[415.099,634.9],[415.099,709.693],[344.466,633.372],[344.466,706.97]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[415.099,717.638],[415.099,792.431],[344.466,714.788],[344.466,788.385]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[487.065,468.424],[487.065,392.415],[414.427,469.569],[414.427,394.789]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[487.065,550.228],[487.065,474.219],[414.427,550.05],[414.427,475.271]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[487.065,555.211],[487.065,631.219],[414.427,554.953],[414.427,629.732]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[487.065,637.042],[487.065,713.05],[414.427,635.461],[414.427,710.24]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[487.065,721.124],[487.065,797.133],[414.427,718.183],[414.427,792.963]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,466.262],[572.836,387.934],[474.171,467.835],[474.171,391.195]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,550.563],[572.836,472.234],[474.171,550.319],[474.171,473.679]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,555.698],[572.836,634.026],[474.171,555.343],[474.171,631.983]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,640.026],[572.836,718.354],[474.171,637.854],[474.171,714.494]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,726.675],[572.836,805.003],[474.171,722.635],[474.171,799.275]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,466.262],[572.836,387.934],[584.765,466.856],[584.765,389.165]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,550.563],[572.836,472.234],[584.765,550.471],[584.765,472.779]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,555.698],[572.836,634.026],[584.765,555.564],[584.765,633.255]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,640.026],[572.836,718.354],[584.765,639.206],[584.765,716.898]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[572.836,726.675],[572.836,805.003],[584.765,725.15],[584.765,802.842]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.891,465.608],[663.891,386.577],[584.765,466.856],[584.765,389.165]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.891,550.664],[663.891,471.634],[584.765,550.471],[584.765,472.779]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.891,555.845],[663.891,634.876],[584.765,555.564],[584.765,633.255]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.891,640.93],[663.891,719.96],[584.765,639.206],[584.765,716.898]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.891,728.355],[663.891,807.386],[584.765,725.15],[584.765,802.842]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.617,465.64],[663.617,386.645],[713.479,468.308],[713.479,392.175]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.617,550.659],[663.617,471.663],[713.479,550.246],[713.479,474.113]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.617,555.838],[663.617,634.833],[713.479,555.237],[713.479,631.37]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.617,640.885],[663.617,719.88],[713.479,637.202],[713.479,713.335]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[663.617,728.272],[663.617,807.267],[713.479,721.422],[713.479,797.555]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[877.786,462.263],[877.786,379.643],[791.335,463.626],[791.335,382.469]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[877.786,551.182],[877.786,468.562],[791.335,550.971],[791.335,469.814]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[877.786,556.599],[877.786,639.219],[791.335,556.292],[791.335,637.449]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[877.786,645.548],[877.786,728.168],[791.335,643.666],[791.335,724.823]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[877.786,736.944],[877.786,819.564],[791.335,733.444],[791.335,814.601]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.26,459.702],[984.26,374.335],[867.289,461.567],[867.289,378.201]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.26,551.579],[984.26,466.211],[867.289,551.29],[867.289,467.924]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.26,557.176],[984.26,642.544],[867.289,556.755],[867.289,640.122]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.26,649.083],[984.26,734.451],[867.289,646.508],[867.289,729.874]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.26,743.519],[984.26,828.887],[867.289,738.73],[867.289,822.096]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.261,459.702],[984.261,374.334],[993.608,460.407],[993.608,375.795]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.261,551.579],[984.261,466.211],[993.608,551.47],[993.608,466.858]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.261,557.176],[984.261,642.544],[993.608,557.017],[993.608,641.629]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.261,649.083],[984.261,734.451],[993.608,648.11],[993.608,732.722]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[984.261,743.519],[984.261,828.887],[993.608,741.71],[993.608,826.321]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1087.6,458.924],[1087.6,372.721],[993.608,460.407],[993.608,375.795]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1087.6,551.7],[1087.6,465.497],[993.608,551.47],[993.608,466.858]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1087.6,557.351],[1087.6,643.554],[993.608,557.017],[993.608,641.629]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1087.6,650.157],[1087.6,736.36],[993.608,648.11],[993.608,732.722]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1087.6,745.517],[1087.6,831.719],[993.608,741.71],[993.608,826.321]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1182.01,457.466],[1182.01,369.699],[1085.4,458.99],[1085.4,372.857]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1182.01,551.926],[1182.01,464.158],[1085.4,551.69],[1085.4,465.557]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1182.01,557.68],[1182.01,645.447],[1085.4,557.336],[1085.4,643.469]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1182.01,652.17],[1182.01,739.938],[1085.4,650.067],[1085.4,736.2]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1182.01,749.261],[1182.01,837.028],[1085.4,745.349],[1085.4,831.482]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,454.571],[1306.12,363.696],[1173.77,456.681],[1173.77,368.07]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,552.374],[1306.12,461.499],[1173.77,552.047],[1173.77,463.437]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,558.332],[1306.12,649.207],[1173.77,557.856],[1173.77,646.467]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,656.168],[1306.12,747.043],[1173.77,653.255],[1173.77,741.865]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,756.696],[1306.12,847.571],[1173.77,751.278],[1173.77,839.888]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,454.571],[1306.12,363.696],[1313.03,455.369],[1313.03,365.35]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,552.374],[1306.12,461.499],[1313.03,552.251],[1313.03,462.232]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,558.332],[1306.12,649.207],[1313.03,558.152],[1313.03,648.171]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,656.168],[1306.12,747.043],[1313.03,655.066],[1313.03,745.085]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1306.12,756.696],[1306.12,847.571],[1313.03,754.647],[1313.03,844.666]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1419.55,453.688],[1419.55,361.867],[1313.03,455.369],[1313.03,365.35]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1419.55,552.511],[1419.55,460.689],[1313.03,552.251],[1313.03,462.232]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1419.55,558.531],[1419.55,650.352],[1313.03,558.152],[1313.03,648.171]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1419.55,657.386],[1419.55,749.208],[1313.03,655.066],[1313.03,745.085]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1419.55,758.961],[1419.55,850.783],[1313.03,754.647],[1313.03,844.666]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1528.09,449.086],[1528.09,355.46],[1421.81,450.818],[1421.81,358.991]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1528.09,549.851],[1528.09,456.225],[1421.81,549.647],[1421.81,457.82]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1528.09,555.989],[1528.09,649.615],[1421.81,555.667],[1421.81,647.495]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1528.09,656.787],[1528.09,750.413],[1421.81,654.529],[1421.81,746.357]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1528.09,760.358],[1528.09,853.984],[1421.81,756.111],[1421.81,847.938]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,445.673],[1673.9,348.502],[1522.85,448.162],[1522.85,353.576]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,550.252],[1673.9,453.082],[1522.85,549.959],[1522.85,455.374]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,556.622],[1673.9,653.793],[1522.85,556.16],[1522.85,650.746]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,661.236],[1673.9,758.407],[1522.85,657.991],[1522.85,752.577]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,768.728],[1673.9,865.899],[1522.85,762.624],[1522.85,857.21]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,445.673],[1673.9,348.502],[1677.59,446.615],[1677.59,350.423]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,550.252],[1673.9,453.082],[1677.59,550.141],[1677.59,453.949]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,556.622],[1673.9,653.793],[1677.59,556.447],[1677.59,652.639]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,661.236],[1673.9,758.407],[1677.59,660.008],[1677.59,756.2]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1673.9,768.728],[1673.9,865.899],[1677.59,766.418],[1677.59,862.61]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,444.63],[1799.38,346.376],[1677.59,446.615],[1677.59,350.423]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,550.375],[1799.38,452.121],[1677.59,550.141],[1677.59,453.949]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,556.816],[1799.38,655.07],[1677.59,556.447],[1677.59,652.639]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,662.596],[1799.38,760.85],[1677.59,660.008],[1677.59,756.2]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,771.286],[1799.38,869.54],[1677.59,766.418],[1677.59,862.61]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,444.63],[1799.38,346.376],[1818.7,452.238],[1818.7,361.886]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,550.375],[1799.38,452.121],[1818.7,549.48],[1818.7,459.127]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,556.816],[1799.38,655.07],[1818.7,555.404],[1818.7,645.756]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,662.596],[1799.38,760.85],[1818.7,652.678],[1818.7,743.03]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1799.38,771.286],[1799.38,869.54],[1818.7,752.628],[1818.7,842.981]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1823.91,454.293],[1823.91,366.074],[1839.61,460.478],[1839.61,378.681]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1823.91,549.239],[1823.91,461.019],[1839.61,548.512],[1839.61,466.715]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1823.91,555.022],[1823.91,643.242],[1839.61,553.874],[1839.61,635.671]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1823.91,649.999],[1823.91,738.219],[1839.61,641.937],[1839.61,723.734]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:3,
                    verts:[[1823.91,747.59],[1823.91,835.809],[1839.61,732.423],[1839.61,814.22]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[228.798,470.145],[228.798,396.592],[156.774,471.036],[156.774,398.433]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[228.798,549.305],[228.798,475.753],[156.774,549.176],[156.774,476.572]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[228.798,554.127],[228.798,627.68],[156.774,553.935],[156.774,626.539]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[228.798,633.314],[228.798,706.867],[156.774,632.101],[156.774,704.704]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[228.798,714.68],[228.798,788.233],[156.774,712.416],[156.774,785.02]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.335,468.385],[312.335,392.96],[216.094,469.589],[216.094,395.445]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.335,549.561],[312.335,474.136],[216.094,549.386],[216.094,475.242]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.335,554.506],[312.335,629.931],[216.094,554.247],[216.094,628.391]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.335,635.709],[312.335,711.134],[216.094,634.071],[216.094,708.215]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.335,719.146],[312.335,794.572],[216.094,716.09],[216.094,790.234]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.336,468.385],[312.336,392.96],[324.902,468.98],[324.902,394.188]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.336,549.561],[312.336,474.136],[324.902,549.475],[324.902,474.683]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.336,554.506],[312.336,629.931],[324.902,554.378],[324.902,629.17]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.336,635.709],[312.336,711.134],[324.902,634.899],[324.902,709.691]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[312.336,719.146],[312.336,794.572],[324.902,717.636],[324.902,792.427]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[401.031,468.038],[401.031,392.244],[324.901,468.98],[324.901,394.188]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[401.031,549.612],[401.031,473.817],[324.901,549.475],[324.901,474.683]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[401.031,554.581],[401.031,630.375],[324.901,554.378],[324.901,629.17]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[401.031,636.181],[401.031,711.976],[324.901,634.899],[324.901,709.691]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[401.031,720.027],[401.031,795.822],[324.901,717.636],[324.901,792.427]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[478.155,467.678],[478.155,390.87],[400.302,468.634],[400.302,392.851]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[478.155,550.343],[478.155,473.535],[400.302,550.195],[400.302,474.412]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[478.155,555.379],[478.155,632.187],[400.302,555.163],[400.302,630.947]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[478.155,638.071],[478.155,714.879],[400.302,636.752],[400.302,712.535]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[478.155,723.038],[478.155,799.847],[400.302,720.585],[400.302,796.368]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,465.751],[571.753,386.874],[466.581,467.056],[466.581,389.579]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,550.642],[571.753,471.765],[466.581,550.44],[466.581,472.963]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,555.813],[571.753,634.69],[466.581,555.519],[466.581,632.996]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,640.732],[571.753,719.609],[466.581,638.93],[466.581,716.407]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,727.987],[571.753,806.864],[466.581,724.637],[466.581,802.114]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,465.751],[571.753,386.874],[582.245,466.374],[582.245,388.167]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,550.642],[571.753,471.765],[582.245,550.545],[582.245,472.337]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,555.813],[571.753,634.69],[582.245,555.672],[582.245,633.88]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,640.732],[571.753,719.609],[582.245,639.871],[582.245,718.079]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[571.753,727.987],[571.753,806.864],[582.245,726.386],[582.245,804.594]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.903,465.347],[665.903,386.037],[582.245,466.374],[582.245,388.167]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.903,550.705],[665.903,471.394],[582.245,550.545],[582.245,472.337]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.903,555.904],[665.903,635.214],[582.245,555.672],[582.245,633.88]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.903,641.289],[665.903,720.599],[582.245,639.871],[582.245,718.079]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.903,729.024],[665.903,808.334],[582.245,726.386],[582.245,804.594]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.538,465.379],[665.538,386.103],[708.548,468.158],[708.548,391.864]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.538,550.7],[665.538,471.423],[708.548,550.269],[708.548,473.975]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.538,555.897],[665.538,635.173],[708.548,555.271],[708.548,631.565]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.538,641.246],[665.538,720.522],[708.548,637.409],[708.548,713.703]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[665.538,728.943],[665.538,808.219],[708.548,721.807],[708.548,798.101]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[889.404,462.631],[889.404,380.405],[799.487,463.734],[799.487,382.693]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[889.404,551.125],[889.404,468.9],[799.487,550.954],[799.487,469.913]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[889.404,556.516],[889.404,638.741],[799.487,556.267],[799.487,637.308]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[889.404,645.04],[889.404,727.265],[799.487,643.516],[799.487,724.557]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[889.404,735.999],[889.404,818.225],[799.487,733.166],[799.487,814.207]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,460.418],[1001.67,375.818],[880.837,461.917],[880.837,378.925]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,551.468],[1001.67,466.868],[880.837,551.236],[880.837,468.245]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,557.014],[1001.67,641.615],[880.837,556.677],[880.837,639.668]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,648.095],[1001.67,732.695],[880.837,646.025],[880.837,729.017]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,741.682],[1001.67,826.282],[880.837,737.833],[880.837,820.824]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,460.418],[1001.67,375.818],[1009.01,461.135],[1009.01,377.304]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,551.468],[1001.67,466.868],[1009.01,551.357],[1009.01,467.526]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,557.014],[1001.67,641.615],[1009.01,556.853],[1009.01,640.684]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,648.095],[1001.67,732.695],[1009.01,647.105],[1009.01,730.936]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1001.67,741.682],[1001.67,826.282],[1009.01,739.841],[1009.01,823.672]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1105.23,459.953],[1105.23,374.854],[1009.01,461.135],[1009.01,377.304]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1105.23,551.54],[1105.23,466.442],[1009.01,551.357],[1009.01,467.526]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1105.23,557.119],[1105.23,642.218],[1009.01,556.853],[1009.01,640.684]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1105.23,648.737],[1105.23,733.835],[1009.01,647.105],[1009.01,730.936]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1105.23,742.875],[1105.23,827.974],[1009.01,739.841],[1009.01,823.672]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1201.08,458.805],[1201.08,372.475],[1102.89,460.01],[1102.89,374.973]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1201.08,551.718],[1201.08,465.388],[1102.89,551.531],[1102.89,466.494]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1201.08,557.378],[1201.08,643.708],[1102.89,557.106],[1102.89,642.143]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1201.08,650.321],[1201.08,736.652],[1102.89,648.658],[1102.89,733.695]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1201.08,745.822],[1201.08,832.153],[1102.89,742.728],[1102.89,827.765]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,456.362],[1328.59,367.41],[1195.14,458.018],[1195.14,370.842]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,552.097],[1328.59,463.145],[1195.14,551.84],[1195.14,464.665]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,557.928],[1328.59,646.88],[1195.14,557.555],[1195.14,644.731]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,653.694],[1328.59,742.646],[1195.14,651.409],[1195.14,738.584]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,752.095],[1328.59,841.047],[1195.14,747.844],[1195.14,835.02]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,456.362],[1328.59,367.41],[1333.18,457.154],[1333.18,369.052]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,552.097],[1328.59,463.145],[1333.18,551.974],[1333.18,463.872]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,557.928],[1328.59,646.88],[1333.18,557.75],[1333.18,645.852]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,653.694],[1328.59,742.646],[1333.18,652.601],[1333.18,740.703]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1328.59,752.095],[1328.59,841.047],[1333.18,750.062],[1333.18,838.164]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1439.53,455.849],[1439.53,366.345],[1333.18,457.154],[1333.18,369.052]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1439.53,552.176],[1439.53,462.673],[1333.18,551.974],[1333.18,463.872]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1439.53,558.044],[1439.53,647.548],[1333.18,557.75],[1333.18,645.852]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1439.53,654.404],[1439.53,743.907],[1333.18,652.601],[1333.18,740.703]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1439.53,753.415],[1439.53,842.918],[1333.18,750.062],[1333.18,838.164]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1546.95,451.723],[1546.95,360.834],[1441.7,453.058],[1441.7,363.556]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1546.95,549.541],[1546.95,458.653],[1441.7,549.384],[1441.7,459.882]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1546.95,555.499],[1546.95,646.388],[1441.7,555.252],[1441.7,644.753]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1546.95,653.35],[1546.95,744.238],[1441.7,651.609],[1441.7,741.112]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1546.95,753.893],[1546.95,844.781],[1441.7,750.619],[1441.7,840.121]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,448.92],[1692.47,355.121],[1544.25,450.82],[1544.25,358.995]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,549.87],[1692.47,456.072],[1544.25,549.647],[1544.25,457.822]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,556.019],[1692.47,649.818],[1544.25,555.667],[1544.25,647.492]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,657.003],[1692.47,750.802],[1544.25,654.526],[1544.25,746.351]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,760.765],[1692.47,854.564],[1544.25,756.105],[1544.25,847.931]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,448.92],[1692.47,355.121],[1693.65,449.829],[1693.65,356.975]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,549.87],[1692.47,456.072],[1693.65,549.763],[1693.65,456.909]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,556.02],[1692.47,649.818],[1693.65,555.851],[1693.65,648.705]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,657.003],[1692.47,750.802],[1693.65,655.818],[1693.65,748.672]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1692.47,760.766],[1692.47,854.564],[1693.65,758.535],[1693.65,851.389]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1811.88,448.329],[1693.65,449.83],[1811.88,353.917],[1693.65,356.975]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1811.88,549.94],[1811.88,455.528],[1693.65,549.763],[1693.65,456.909]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1811.88,556.129],[1693.65,555.851],[1811.88,650.541],[1693.65,648.705]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1811.88,657.773],[1693.65,655.818],[1811.88,752.185],[1693.65,748.672]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:4,
                    verts:[[1811.88,762.214],[1693.65,758.535],[1811.88,856.626],[1693.65,851.389]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[205.604,468.698],[205.604,393.606],[127.6,469.414],[127.6,395.084]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[205.604,549.516],[205.604,474.423],[127.6,549.412],[127.6,475.081]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[205.604,554.439],[205.604,629.531],[127.6,554.285],[127.6,628.615]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[205.604,635.283],[205.604,710.376],[127.6,634.309],[127.6,708.639]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[205.604,718.352],[205.604,793.445],[127.6,716.535],[127.6,790.865]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.561,467.142],[297.561,390.393],[193.886,468.103],[193.886,392.377]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.561,549.742],[297.561,472.993],[193.886,549.602],[193.886,473.877]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.561,554.774],[297.561,631.523],[193.886,554.567],[193.886,630.293]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.561,637.402],[297.561,714.151],[193.886,636.093],[193.886,711.819]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.561,722.303],[297.561,799.052],[193.886,719.863],[193.886,795.589]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.562,467.142],[297.562,390.393],[308.942,467.774],[308.942,391.699]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.562,549.742],[297.562,472.993],[308.942,549.65],[308.942,473.575]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.562,554.774],[297.562,631.523],[308.942,554.638],[308.942,630.713]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.562,637.402],[297.562,714.151],[308.942,636.541],[308.942,712.616]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[297.562,722.303],[297.562,799.052],[308.942,720.697],[308.942,796.773]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[390.317,467.027],[390.317,390.157],[308.942,467.774],[308.942,391.699]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[390.317,549.759],[390.317,472.888],[308.942,549.65],[308.942,473.575]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[390.317,554.798],[390.317,631.669],[308.942,554.638],[308.942,630.713]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[390.317,637.557],[390.317,714.428],[308.942,636.541],[308.942,712.616]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[390.317,722.593],[390.317,799.463],[308.942,720.697],[308.942,796.773]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[472.268,639.178],[472.268,716.847],[389.536,638.138],[389.536,714.999]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[472.268,466.876],[472.268,389.207],[389.536,467.63],[389.536,390.769]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[472.268,550.468],[472.268,472.798],[389.536,550.351],[389.536,473.49]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[472.268,555.559],[472.268,633.228],[389.536,555.39],[389.536,632.251]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[472.268,725.097],[472.268,802.766],[389.536,723.164],[389.536,800.025]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,465.201],[573.223,385.733],[462.123,466.222],[462.123,387.851]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,550.727],[573.223,471.26],[462.123,550.569],[462.123,472.198]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,555.937],[573.223,635.404],[462.123,555.707],[462.123,634.078]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,641.492],[573.223,720.959],[462.123,640.081],[462.123,718.452]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,729.4],[573.223,808.868],[462.123,726.777],[462.123,805.148]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,465.201],[573.223,385.733],[582.187,465.85],[582.187,387.08]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,550.727],[573.223,471.26],[582.187,550.627],[582.187,471.856]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,555.937],[573.223,635.404],[582.187,555.79],[582.187,634.561]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,641.492],[573.223,720.959],[582.187,640.594],[582.187,719.365]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[573.223,729.4],[573.223,808.868],[582.187,727.732],[582.187,806.502]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.843,465.052],[669.843,385.426],[582.187,465.85],[582.187,387.08]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.843,550.75],[669.843,471.124],[582.187,550.627],[582.187,471.856]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.843,555.97],[669.843,635.597],[582.187,555.79],[582.187,634.561]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.843,641.696],[669.843,721.323],[582.187,640.594],[582.187,719.365]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.843,729.781],[669.843,809.408],[582.187,727.732],[582.187,806.502]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.388,465.083],[669.388,385.489],[705.248,467.957],[705.248,391.447]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.388,550.745],[669.388,471.152],[705.248,550.3],[705.248,473.791]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.388,555.963],[669.388,635.557],[705.248,555.316],[705.248,631.825]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.388,641.654],[669.388,721.248],[705.248,637.686],[705.248,714.196]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[669.388,729.703],[669.388,809.297],[705.248,722.323],[705.248,798.832]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[901.243,462.972],[901.243,381.113],[808.589,463.815],[808.589,382.861]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[901.243,551.073],[901.243,469.214],[808.589,550.942],[808.589,469.988]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[901.243,556.439],[901.243,638.298],[808.589,556.249],[808.589,637.203]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[901.243,644.568],[901.243,726.427],[808.589,643.404],[808.589,724.358]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[901.243,735.123],[901.243,816.982],[808.589,732.957],[808.589,813.911]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,461.108],[1018.26,377.249],[894.633,462.245],[894.633,379.606]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,551.361],[1018.26,467.502],[894.633,551.185],[894.633,468.546]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,556.859],[1018.26,640.718],[894.633,556.603],[894.633,639.242]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,647.142],[1018.26,731.001],[894.633,645.572],[894.633,728.211]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,739.909],[1018.26,823.768],[894.633,736.99],[894.633,819.629]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,461.108],[1018.26,377.249],[1023.59,461.832],[1023.59,378.749]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,551.361],[1018.26,467.502],[1023.59,551.249],[1023.59,468.166]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,556.859],[1018.26,640.718],[1023.59,556.696],[1023.59,639.779]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,647.142],[1018.26,731.001],[1023.59,646.143],[1023.59,729.226]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1018.26,739.909],[1018.26,823.768],[1023.59,738.052],[1023.59,821.135]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1121.17,460.943],[1121.17,376.907],[1023.59,461.832],[1023.59,378.749]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1121.17,551.387],[1121.17,467.351],[1023.59,551.249],[1023.59,468.166]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1121.17,556.896],[1121.17,640.932],[1023.59,556.696],[1023.59,639.779]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1121.17,647.37],[1121.17,731.406],[1023.59,646.143],[1023.59,729.226]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1121.17,740.333],[1121.17,824.369],[1023.59,738.052],[1023.59,821.135]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1217.61,460.093],[1217.61,375.144],[1118.74,460.993],[1118.74,377.009]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1217.61,551.519],[1217.61,466.57],[1118.74,551.379],[1118.74,467.396]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1217.61,557.088],[1217.61,642.037],[1118.74,556.885],[1118.74,640.868]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1217.61,648.544],[1217.61,733.493],[1118.74,647.302],[1118.74,731.285]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1217.61,742.517],[1217.61,827.466],[1118.74,740.206],[1118.74,824.189]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,458.084],[1347.18,370.979],[1213.88,459.309],[1213.88,373.52]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,551.83],[1347.18,464.725],[1213.88,551.64],[1213.88,465.851]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,557.54],[1347.18,644.645],[1213.88,557.264],[1213.88,643.054]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,651.318],[1347.18,738.423],[1213.88,649.625],[1213.88,735.415]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,747.675],[1347.18,834.78],[1213.88,744.528],[1213.88,830.317]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,458.084],[1347.18,370.979],[1349.56,458.864],[1349.56,372.596]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,551.83],[1347.18,464.725],[1349.56,551.709],[1349.56,465.441]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,557.54],[1347.18,644.645],[1349.56,557.365],[1349.56,643.633]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,651.318],[1347.18,738.423],[1349.56,650.241],[1349.56,736.509]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1347.18,747.675],[1347.18,834.78],[1349.56,745.672],[1349.56,831.94]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1454.81,457.905],[1454.81,370.609],[1349.56,458.864],[1349.56,372.596]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1454.81,551.858],[1454.81,464.561],[1349.56,551.709],[1349.56,465.441]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1454.81,557.581],[1454.81,644.877],[1349.56,557.365],[1349.56,643.633]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1454.81,651.564],[1454.81,738.86],[1349.56,650.241],[1349.56,736.509]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1454.81,748.133],[1349.56,745.672],[1454.81,835.429],[1349.56,831.94]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1560.2,454.218],[1456.88,455.19],[1560.2,365.921],[1456.88,367.902]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1560.2,549.248],[1560.2,460.95],[1456.88,549.133],[1456.88,461.845]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1560.2,555.036],[1560.2,643.333],[1456.88,554.856],[1456.88,642.144]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1560.2,650.097],[1456.88,648.83],[1560.2,738.394],[1456.88,736.118]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1560.2,747.774],[1456.88,745.39],[1560.2,836.071],[1456.88,832.679]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1559.84,453.343],[1704.06,451.972],[1559.84,364.137],[1704.06,361.344]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1559.84,549.35],[1559.84,460.145],[1704.06,549.511],[1704.06,458.883]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1559.84,555.199],[1704.06,555.453],[1559.84,644.404],[1704.06,646.082]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1559.84,651.237],[1704.06,653.024],[1559.84,740.443],[1704.06,743.653]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1559.84,749.919],[1704.06,753.28],[1559.84,839.125],[1704.06,843.909]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1702.97,452.845],[1702.97,363.122],[1816.86,451.773],[1816.86,360.937]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1702.97,549.409],[1702.97,459.686],[1816.86,549.535],[1816.86,458.699]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1702.97,555.291],[1702.97,645.014],[1816.86,555.49],[1816.86,646.326]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1702.97,651.887],[1702.97,741.61],[1816.86,653.284],[1816.86,744.12]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:5,
                    verts:[[1702.97,751.141],[1816.86,753.769],[1702.97,840.864],[1816.86,844.605]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[186.236,467.135],[186.236,390.379],[102.324,467.657],[102.324,391.456]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[186.236,549.743],[186.236,472.987],[102.324,549.667],[102.324,473.467]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[186.236,554.775],[186.236,631.531],[102.324,554.663],[102.324,630.864]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[186.236,637.411],[186.236,714.166],[102.324,636.701],[102.324,712.901]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[186.236,722.32],[186.236,799.075],[102.324,720.996],[102.324,797.196]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,465.805],[286.504,387.634],[175.63,466.501],[175.63,389.071]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,549.937],[286.504,471.766],[175.63,549.835],[175.63,472.405]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,555.061],[286.504,633.232],[175.63,554.912],[175.63,632.342]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,639.221],[286.504,717.391],[175.63,638.273],[175.63,715.704]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,725.695],[286.504,803.866],[175.63,723.929],[175.63,801.36]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,465.805],[286.504,387.634],[296.575,466.474],[296.575,389.015]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,549.937],[286.504,471.766],[296.575,549.839],[296.575,472.38]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,555.061],[286.504,633.232],[296.575,554.917],[296.575,632.377]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,639.221],[286.504,717.391],[296.575,638.31],[296.575,715.769]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[286.504,725.695],[286.504,803.866],[296.575,723.997],[296.575,801.457]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[382.916,465.938],[382.916,387.908],[296.575,466.474],[296.575,389.015]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[382.916,549.917],[382.916,471.887],[296.575,549.839],[296.575,472.38]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[382.916,555.033],[382.916,633.063],[296.575,554.917],[296.575,632.377]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[382.916,639.04],[382.916,717.07],[296.575,638.31],[296.575,715.769]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[382.916,725.359],[382.916,803.389],[296.575,723.997],[296.575,801.457]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[469.333,555.755],[469.333,634.354],[382.085,555.634],[382.085,633.656]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[469.333,640.375],[469.333,718.975],[382.085,639.633],[382.085,717.656]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[469.333,727.324],[469.333,805.924],[382.085,725.944],[382.085,803.967]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[469.333,466.009],[469.333,387.409],[382.085,466.547],[382.085,388.524]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[469.333,550.602],[469.333,472.002],[382.085,550.519],[382.085,472.496]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,464.602],[577.143,384.491],[460.724,465.326],[460.724,385.993]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,550.82],[577.143,470.71],[460.724,550.708],[460.724,471.375]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,556.072],[577.143,636.182],[460.724,555.909],[460.724,635.241]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,642.319],[577.143,722.429],[460.724,641.318],[460.724,720.651]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,730.939],[577.143,811.049],[460.724,729.078],[460.724,808.411]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,464.602],[577.143,384.491],[584.493,465.274],[584.493,385.886]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,550.82],[577.143,470.71],[584.493,550.716],[584.493,471.328]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,556.072],[577.143,636.182],[584.493,555.92],[584.493,635.308]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,642.319],[577.143,722.429],[584.493,641.39],[584.493,720.778]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[577.143,730.939],[577.143,811.049],[584.493,729.211],[584.493,808.599]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.602,464.713],[675.602,384.722],[584.493,465.274],[584.493,385.886]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.602,550.803],[675.602,470.812],[584.493,550.716],[584.493,471.328]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.602,556.047],[675.602,636.038],[584.493,555.92],[584.493,635.308]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.602,642.165],[675.602,722.156],[584.493,641.39],[584.493,720.778]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.602,730.653],[675.602,810.644],[584.493,729.211],[584.493,808.599]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.058,464.742],[675.058,384.782],[703.503,467.696],[703.503,390.906]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.058,550.798],[675.058,470.839],[703.503,550.341],[703.503,473.551]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.058,556.04],[675.058,636],[703.503,555.375],[703.503,632.164]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.058,642.125],[675.058,722.085],[703.503,638.047],[703.503,714.836]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[675.058,730.578],[675.058,810.538],[703.503,722.993],[703.503,799.783]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[913.226,463.274],[913.226,381.739],[818.537,463.858],[818.537,382.949]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[913.226,551.026],[913.226,469.491],[818.537,550.935],[818.537,470.026]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[913.226,556.371],[913.226,637.906],[818.537,556.239],[818.537,637.148]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[913.226,644.151],[913.226,725.686],[818.537,643.346],[818.537,724.255]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[913.226,734.347],[913.226,815.882],[818.537,732.849],[818.537,813.758]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,461.758],[1034,378.597],[908.587,462.539],[908.587,380.215]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,551.261],[1034,468.099],[908.587,551.14],[908.587,468.816]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,556.712],[1034,639.874],[908.587,556.537],[908.587,638.86]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,646.244],[1034,729.406],[908.587,645.167],[908.587,727.49]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,738.239],[1034,821.401],[908.587,736.235],[908.587,818.559]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,461.758],[1034,378.597],[1037.35,462.483],[1037.35,380.1]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,551.261],[1034,468.099],[1037.35,551.148],[1037.35,468.765]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,556.712],[1034,639.874],[1037.35,556.549],[1037.35,638.933]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,646.244],[1034,729.406],[1037.35,645.243],[1037.35,727.627]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1034,738.239],[1034,821.401],[1037.35,736.378],[1037.35,818.762]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1135.49,461.878],[1135.49,378.846],[1037.35,462.483],[1037.35,380.1]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1135.49,551.242],[1135.49,468.209],[1037.35,551.148],[1037.35,468.765]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1135.49,556.685],[1135.49,639.718],[1037.35,556.549],[1037.35,638.933]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1135.49,646.079],[1135.49,729.111],[1037.35,645.243],[1037.35,727.627]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1135.49,737.931],[1135.49,820.964],[1037.35,736.378],[1037.35,818.762]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1231.74,461.312],[1231.74,377.671],[1132.98,461.92],[1132.98,378.932]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1231.74,551.33],[1231.74,467.689],[1132.98,551.236],[1132.98,468.248]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1231.74,556.813],[1231.74,640.454],[1132.98,556.676],[1132.98,639.664]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1231.74,646.861],[1231.74,730.502],[1132.98,646.021],[1132.98,729.009]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1231.74,739.387],[1231.74,823.028],[1132.98,737.824],[1132.98,820.812]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,459.716],[1362.21,374.362],[1230.14,460.538],[1230.14,376.066]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,551.577],[1362.21,466.224],[1230.14,551.45],[1230.14,466.978]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,557.173],[1362.21,642.526],[1230.14,556.987],[1230.14,641.459]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,649.064],[1230.14,647.93],[1362.21,734.418],[1230.14,732.401]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,743.484],[1230.14,741.374],[1362.21,828.838],[1230.14,825.845]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,459.716],[1362.21,374.362],[1362.5,460.479],[1362.5,375.945]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,551.577],[1362.21,466.224],[1362.5,551.459],[1362.5,466.925]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,557.173],[1362.21,642.526],[1362.5,557.001],[1362.5,641.535]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,649.064],[1362.21,734.418],[1362.5,648.01],[1362.5,732.545]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.21,743.484],[1362.21,828.838],[1362.5,741.524],[1362.5,826.058]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.5,460.479],[1465.86,459.842],[1362.5,375.945],[1465.86,374.624]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.5,551.459],[1465.86,551.558],[1362.5,466.925],[1465.86,466.34]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.5,557.001],[1465.86,557.144],[1362.5,641.535],[1465.86,642.362]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.5,648.01],[1465.86,648.89],[1362.5,732.545],[1465.86,734.108]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1362.5,741.524],[1465.86,743.16],[1362.5,826.058],[1465.86,828.378]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1467.81,457.197],[1467.81,371.993],[1568.5,456.556],[1568.5,370.686]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1467.81,548.897],[1467.81,463.694],[1568.5,548.973],[1568.5,463.103]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1467.81,554.483],[1467.81,639.687],[1568.5,554.602],[1568.5,640.472]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1467.81,646.214],[1568.5,647.05],[1467.81,731.418],[1568.5,732.919]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1467.81,740.468],[1568.5,742.041],[1467.81,825.672],[1568.5,827.91]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1570.29,455.713],[1570.29,368.967],[1709.61,454.816],[1709.61,367.141]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1570.29,549.072],[1570.29,462.327],[1709.61,549.177],[1709.61,461.501]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1570.29,554.759],[1570.29,641.504],[1709.61,554.925],[1709.61,642.601]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1570.29,648.149],[1570.29,734.894],[1709.61,649.317],[1709.61,736.993]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1570.29,744.108],[1570.29,830.854],[1709.61,746.306],[1709.61,833.982]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1706.48,455.649],[1706.48,368.837],[1815.5,454.954],[1815.5,367.422]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1706.48,549.079],[1706.48,462.268],[1815.5,549.161],[1815.5,461.628]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1706.48,554.771],[1706.48,641.582],[1815.5,554.899],[1815.5,642.432]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1706.48,648.232],[1706.48,735.044],[1815.5,649.137],[1815.5,736.67]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:6,
                    verts:[[1706.48,744.265],[1706.48,831.076],[1815.5,745.968],[1815.5,833.501]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[170.758,465.444],[170.758,386.889],[81.0398,465.75],[81.0398,387.521]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[170.758,549.989],[170.758,471.434],[81.0398,549.945],[81.0398,471.715]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[170.758,555.139],[170.758,633.694],[81.0398,555.073],[81.0398,633.303]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[170.758,639.712],[170.758,718.267],[81.0398,639.295],[81.0398,717.525]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[170.758,726.611],[170.758,805.167],[81.0398,725.835],[81.0398,804.065]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,464.367],[279.189,384.665],[161.4,464.772],[161.4,385.501]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,550.146],[279.189,470.444],[161.4,550.087],[161.4,470.816]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,555.371],[279.189,635.073],[161.4,555.284],[161.4,634.555]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,641.179],[279.189,720.881],[161.4,640.627],[161.4,719.897]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,729.347],[279.189,809.049],[161.4,728.318],[161.4,807.589]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,464.367],[279.189,384.665],[287.821,465.07],[287.821,386.117]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,550.146],[279.189,470.444],[287.821,550.044],[287.821,471.09]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,555.371],[279.189,635.073],[287.821,555.22],[287.821,634.173]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,641.179],[279.189,720.881],[287.821,640.221],[287.821,719.175]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[279.189,729.347],[279.189,809.049],[287.821,727.562],[287.821,806.515]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[378.815,464.76],[378.815,385.476],[287.821,465.07],[287.821,386.117]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[378.815,550.089],[378.815,470.805],[287.821,550.044],[287.821,471.09]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[378.815,555.286],[378.815,634.57],[287.821,555.22],[287.821,634.173]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[378.815,640.643],[378.815,719.927],[287.821,640.221],[287.821,719.175]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[378.815,728.349],[378.815,807.632],[287.821,727.562],[287.821,806.515]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[469.31,465.068],[469.31,385.458],[377.937,465.377],[377.937,386.098]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[469.31,555.967],[469.31,635.577],[377.937,555.897],[377.937,635.176]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[469.31,641.675],[469.31,721.285],[377.937,641.249],[377.937,720.527]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[469.31,550.748],[469.31,471.138],[377.937,550.7],[377.937,471.421]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[469.31,729.742],[469.31,809.352],[377.937,728.949],[377.937,808.227]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,463.945],[583.436,383.13],[462.342,464.358],[462.342,383.987]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,550.922],[583.436,470.107],[462.342,550.858],[462.342,470.486]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,556.22],[583.436,637.035],[462.342,556.127],[462.342,636.498]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,643.225],[583.436,724.04],[462.342,642.654],[462.342,723.026]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,732.624],[583.436,813.439],[462.342,731.563],[462.342,811.934]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,463.945],[583.436,383.13],[589.092,464.638],[589.092,384.567]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,550.922],[583.436,470.107],[589.092,550.814],[589.092,470.743]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,556.22],[583.436,637.035],[589.092,556.064],[589.092,636.135]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,643.225],[583.436,724.04],[589.092,642.268],[589.092,722.34]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[583.436,732.624],[583.436,813.439],[589.092,730.845],[589.092,810.917]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[683.096,464.32],[683.096,383.908],[589.092,464.638],[589.092,384.567]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[683.096,550.864],[683.096,470.451],[589.092,550.814],[589.092,470.743]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[683.096,556.135],[683.096,636.548],[589.092,556.064],[589.092,636.135]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[683.096,642.707],[683.096,723.12],[589.092,642.268],[589.092,722.34]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[683.096,731.661],[683.096,812.074],[589.092,730.845],[589.092,810.917]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[682.467,642.669],[682.467,723.052],[703.255,638.501],[703.255,715.644]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[682.467,731.591],[682.467,811.974],[703.255,723.839],[703.255,800.982]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[682.467,464.348],[682.467,383.965],[703.255,467.367],[703.255,390.223]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[682.467,550.859],[682.467,470.477],[703.255,550.392],[703.255,473.248]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[682.467,556.129],[682.467,636.512],[703.255,555.449],[703.255,632.592]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[925.3,463.527],[925.3,382.263],[829.258,463.851],[829.258,382.935]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[925.3,550.987],[925.3,469.723],[829.258,550.936],[829.258,470.021]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[925.3,556.314],[925.3,637.578],[829.258,556.241],[829.258,637.157]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[925.3,643.803],[925.3,725.067],[829.258,643.355],[829.258,724.271]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[925.3,733.699],[925.3,814.963],[829.258,732.866],[829.258,813.781]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,462.356],[1048.88,379.837],[922.636,462.787],[922.636,380.73]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,551.168],[1048.88,468.648],[922.636,551.101],[922.636,469.044]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,556.578],[1048.88,639.097],[922.636,556.481],[922.636,638.538]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,645.419],[1048.88,727.938],[922.636,644.824],[922.636,726.881]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,736.704],[1048.88,819.224],[922.636,735.597],[922.636,817.655]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,462.356],[1048.88,379.837],[1050.28,463.079],[1050.28,381.334]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,551.168],[1048.88,468.648],[1050.28,551.056],[1050.28,469.311]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,556.578],[1048.88,639.097],[1050.28,556.415],[1050.28,638.16]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,645.419],[1048.88,727.938],[1050.28,644.421],[1050.28,726.166]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1048.88,736.704],[1048.88,819.224],[1050.28,734.849],[1050.28,816.594]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1148.26,462.747],[1148.26,380.647],[1050.28,463.079],[1050.28,381.334]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1148.26,551.107],[1148.26,469.007],[1050.28,551.056],[1050.28,469.311]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1148.26,556.49],[1148.26,638.59],[1050.28,556.415],[1050.28,638.16]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1148.26,644.879],[1050.28,644.421],[1148.26,726.979],[1050.28,726.166]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1148.26,735.7],[1050.28,734.849],[1148.26,817.8],[1050.28,816.594]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1243.62,462.451],[1145.7,462.782],[1243.62,380.032],[1145.7,380.718]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1243.62,551.153],[1145.7,551.102],[1243.62,468.735],[1145.7,469.039]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1243.62,556.556],[1145.7,556.482],[1243.62,638.975],[1145.7,638.545]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1243.62,645.289],[1145.7,644.832],[1243.62,727.707],[1145.7,726.895]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1243.62,736.462],[1145.7,735.612],[1243.62,818.88],[1145.7,817.676]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1244.07,461.69],[1244.07,378.455],[1373.97,461.247],[1373.97,377.536]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1244.07,551.271],[1244.07,468.036],[1373.97,551.34],[1373.97,467.629]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1244.07,556.728],[1244.07,639.962],[1373.97,556.828],[1373.97,640.538]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1244.07,646.338],[1244.07,729.573],[1373.97,646.951],[1373.97,730.661]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1244.07,738.414],[1373.97,739.553],[1244.07,821.649],[1373.97,823.264]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1372.3,556.66],[1372.3,639.573],[1473.11,556.737],[1473.11,640.016]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1372.3,645.924],[1372.3,728.838],[1473.11,646.395],[1473.11,729.674]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1372.3,737.645],[1372.3,820.558],[1473.11,738.52],[1473.11,821.799]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1372.3,461.99],[1372.3,379.077],[1473.11,461.649],[1473.11,378.37]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1372.3,551.225],[1372.3,468.312],[1473.11,551.278],[1473.11,467.999]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1474.94,459.07],[1474.94,375.81],[1572.43,458.729],[1572.43,375.116]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1474.94,548.677],[1474.94,465.418],[1572.43,548.717],[1572.43,465.104]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1474.94,554.136],[1474.94,637.395],[1572.43,554.199],[1572.43,637.812]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1474.94,643.773],[1474.94,727.033],[1572.43,644.217],[1572.43,727.83]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1474.94,735.877],[1474.94,819.136],[1572.43,736.712],[1572.43,820.325]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1576.19,457.92],[1576.19,373.467],[1709.93,457.448],[1709.93,372.505]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1576.19,548.812],[1576.19,464.359],[1709.93,548.868],[1709.93,463.925]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1576.19,554.349],[1576.19,638.802],[1709.93,554.437],[1709.93,639.38]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1576.19,645.271],[1576.19,729.725],[1709.93,645.886],[1709.93,730.83]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1576.19,738.696],[1576.19,823.149],[1709.93,739.853],[1709.93,824.796]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1704.99,458.239],[1704.99,374.117],[1808.76,457.876],[1808.76,373.378]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1704.99,548.775],[1704.99,464.653],[1808.76,548.818],[1808.76,464.319]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1704.99,554.29],[1704.99,638.412],[1808.76,554.357],[1808.76,638.856]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1704.99,644.856],[1704.99,728.978],[1808.76,645.328],[1808.76,729.827]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:7,
                    verts:[[1704.99,737.914],[1704.99,822.036],[1808.76,738.803],[1808.76,823.301]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[159.286,463.614],[159.286,383.11],[63.9018,463.681],[63.9018,383.248]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[159.286,550.255],[159.286,469.752],[63.9018,550.246],[63.9018,469.813]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[159.286,555.533],[159.286,636.037],[63.9018,555.519],[63.9018,635.951]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[159.286,642.203],[159.286,722.707],[63.9018,642.113],[63.9018,722.545]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[159.286,731.258],[159.286,811.762],[63.9018,731.089],[63.9018,811.522]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.682,462.816],[275.682,381.464],[151.317,462.904],[151.317,381.645]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.682,550.372],[275.682,469.019],[151.317,550.359],[151.317,469.1]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.682,555.705],[275.682,637.057],[151.317,555.686],[151.317,636.945]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.682,643.289],[275.682,724.642],[151.317,643.17],[151.317,724.429]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.682,733.283],[275.682,814.636],[151.317,733.06],[151.317,814.319]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.683,462.816],[275.683,381.464],[282.742,463.552],[282.742,382.984]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.683,550.372],[275.683,469.019],[282.742,550.264],[282.742,469.696]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.683,555.705],[275.683,637.057],[282.742,555.546],[282.742,636.115]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.683,643.289],[275.683,724.642],[282.742,642.287],[282.742,722.856]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[275.683,733.283],[275.683,814.636],[282.742,731.414],[282.742,811.983]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[378.037,463.486],[378.037,382.846],[282.741,463.552],[282.741,382.984]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[378.037,550.274],[378.037,469.634],[282.741,550.264],[282.741,469.696]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[378.037,555.561],[378.037,636.201],[282.741,555.546],[282.741,636.115]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[378.037,642.378],[378.037,723.017],[282.741,642.287],[282.741,722.856]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[378.037,731.583],[378.037,812.223],[282.741,731.414],[282.741,811.983]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[472.184,464.045],[472.184,383.337],[377.115,464.111],[377.115,383.473]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[472.184,550.906],[472.184,470.198],[377.115,550.896],[377.115,470.259]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[472.184,556.197],[472.184,636.905],[377.115,556.182],[377.115,636.82]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[472.184,643.088],[472.184,723.796],[377.115,642.997],[377.115,723.634]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[472.184,732.369],[472.184,813.077],[377.115,732.2],[377.115,812.837]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,463.224],[592.051,381.636],[466.961,463.312],[466.961,381.817]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,551.033],[592.051,469.445],[466.961,551.02],[466.961,469.525]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,556.382],[592.051,637.971],[466.961,556.362],[466.961,637.857]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,644.221],[592.051,725.809],[466.961,644.1],[466.961,725.594]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,734.476],[592.051,816.064],[466.961,734.251],[466.961,815.745]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,463.224],[592.051,381.636],[595.937,463.934],[595.937,383.107]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,551.033],[592.051,469.445],[595.937,550.924],[595.937,470.097]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,556.382],[592.051,637.971],[595.937,556.222],[595.937,637.049]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,644.221],[592.051,725.809],[595.937,643.241],[595.937,724.068]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[592.051,734.476],[592.051,816.064],[595.937,732.653],[595.937,813.48]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[692.262,463.867],[692.262,382.968],[595.937,463.934],[595.937,383.107]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[692.262,550.934],[692.262,470.035],[595.937,550.924],[595.937,470.097]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[692.262,556.237],[692.262,637.136],[595.937,556.222],[595.937,637.049]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[692.262,643.333],[692.262,724.232],[595.937,643.241],[595.937,724.068]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[692.262,732.825],[692.262,813.724],[595.937,732.653],[595.937,813.48]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[691.552,463.893],[691.552,383.022],[704.463,466.963],[704.463,389.386]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[691.552,550.93],[691.552,470.059],[704.463,550.454],[704.463,472.877]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[691.552,556.232],[691.552,637.103],[704.463,555.54],[704.463,633.117]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[691.552,643.297],[691.552,724.168],[704.463,639.059],[704.463,716.636]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[691.552,732.759],[691.552,813.63],[704.463,724.876],[704.463,802.453]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[937.425,463.722],[937.425,382.667],[840.688,463.789],[840.688,382.807]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[937.425,550.956],[937.425,469.902],[840.688,550.946],[840.688,469.964]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[937.425,556.27],[937.425,637.324],[840.688,556.255],[840.688,637.237]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[937.425,643.533],[840.688,643.441],[937.425,724.588],[840.688,724.423]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[937.425,733.198],[840.688,733.025],[937.425,814.252],[840.688,814.008]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.91,462.894],[936.73,462.983],[1062.91,380.952],[936.73,381.135]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.91,551.085],[936.73,551.071],[1062.91,469.142],[936.73,469.223]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.91,556.456],[936.73,556.437],[1062.91,638.399],[936.73,638.284]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.91,644.676],[936.73,644.554],[1062.91,726.618],[936.73,726.401]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.91,735.323],[936.73,735.096],[1062.91,817.265],[936.73,816.943]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.4,643.688],[1159.55,643.781],[1062.4,724.862],[1159.55,725.027]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.4,733.484],[1159.55,733.658],[1062.4,814.659],[1159.55,814.904]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.4,463.61],[1062.4,382.436],[1159.55,463.543],[1159.55,382.296]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.4,550.974],[1062.4,469.799],[1159.55,550.984],[1159.55,469.737]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1062.4,556.295],[1062.4,637.469],[1159.55,556.31],[1159.55,637.557]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1156.95,463.57],[1156.95,382.352],[1253.4,463.503],[1253.4,382.213]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1156.95,550.98],[1156.95,469.762],[1253.4,550.99],[1253.4,469.701]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1156.95,556.304],[1156.95,637.522],[1253.4,556.319],[1253.4,637.609]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1156.95,643.744],[1156.95,724.961],[1253.4,643.836],[1253.4,725.126]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1156.95,733.589],[1253.4,733.76],[1156.95,814.807],[1253.4,815.05]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1255.8,462.759],[1255.8,380.672],[1382.72,462.67],[1382.72,380.487]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1255.8,551.106],[1255.8,469.018],[1382.72,551.119],[1382.72,468.936]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1255.8,556.487],[1255.8,638.574],[1382.72,556.507],[1382.72,638.69]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1255.8,644.862],[1255.8,726.95],[1382.72,644.985],[1382.72,727.168]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1255.8,735.669],[1255.8,817.757],[1382.72,735.898],[1382.72,818.081]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1379.2,643.991],[1379.2,725.401],[1476.92,644.085],[1476.92,725.568]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1379.2,734.049],[1379.2,815.459],[1476.92,734.223],[1476.92,815.706]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1379.2,463.39],[1379.2,381.98],[1476.92,463.322],[1476.92,381.839]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1379.2,551.008],[1379.2,469.598],[1476.92,551.018],[1476.92,469.535]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1379.2,556.345],[1379.2,637.755],[1476.92,556.36],[1476.92,637.843]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1478.63,460.803],[1478.63,379.344],[1572.47,460.736],[1572.47,379.207]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1478.63,548.474],[1478.63,467.014],[1572.47,548.481],[1572.47,466.952]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1478.63,553.814],[1478.63,635.273],[1572.47,553.826],[1572.47,635.355]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1478.63,641.513],[1478.63,722.972],[1572.47,641.601],[1572.47,723.13]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1478.63,731.625],[1478.63,813.084],[1572.47,731.79],[1572.47,813.319]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1578.03,459.963],[1578.03,377.632],[1705.7,459.871],[1705.7,377.443]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1578.03,548.572],[1578.03,466.241],[1705.7,548.583],[1705.7,466.156]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1578.03,553.97],[1578.03,636.301],[1705.7,553.987],[1705.7,636.414]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1578.03,642.608],[1578.03,724.94],[1705.7,642.729],[1705.7,725.156]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1578.03,733.685],[1578.03,816.017],[1705.7,733.912],[1705.7,816.339]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1699.12,460.619],[1699.12,378.969],[1797.42,460.549],[1797.42,378.825]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1699.12,548.495],[1699.12,466.845],[1797.42,548.503],[1797.42,466.78]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1699.12,553.848],[1699.12,635.498],[1797.42,553.861],[1797.42,635.585]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1699.12,641.753],[1699.12,723.403],[1797.42,641.845],[1797.42,723.568]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:8,
                    verts:[[1699.12,732.076],[1699.12,813.727],[1797.42,732.249],[1797.42,813.973]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[152.012,461.632],[152.012,379.018],[51.1512,461.433],[51.1512,378.608]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[152.012,550.544],[152.012,467.931],[51.1512,550.573],[51.1512,467.748]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[152.012,555.96],[152.012,638.573],[51.1512,556.003],[51.1512,638.828]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[152.012,644.901],[152.012,727.515],[51.1512,645.172],[51.1512,727.997]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[152.012,736.29],[152.012,818.903],[51.1512,736.795],[51.1512,819.62]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[276.116,461.145],[276.116,378.014],[145.586,460.885],[145.586,377.477]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[276.116,550.615],[276.116,467.483],[145.586,550.652],[145.586,467.245]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[276.116,556.064],[276.116,639.196],[145.586,556.12],[145.586,639.528]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[276.116,645.564],[276.116,728.695],[145.586,645.917],[145.586,729.325]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[276.116,737.526],[276.116,820.657],[145.586,738.185],[145.586,821.593]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[380.657,462.108],[380.657,380.002],[281.462,461.912],[281.462,379.598]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[380.657,550.475],[380.657,468.368],[281.462,550.503],[281.462,468.189]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[380.657,555.857],[380.657,637.964],[281.462,555.899],[281.462,638.214]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[380.657,644.253],[380.657,726.359],[281.462,644.519],[281.462,726.833]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[380.657,735.081],[380.657,817.187],[281.462,735.577],[281.462,817.892]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[477.991,551.078],[477.991,469.178],[379.696,551.108],[379.696,469.002]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[477.991,644.622],[477.991,726.522],[379.696,644.887],[379.696,726.993]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[477.991,735.222],[477.991,817.122],[379.696,735.715],[379.696,817.821]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[477.991,462.934],[477.991,381.033],[379.696,462.742],[379.696,380.635]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[477.991,556.448],[477.991,638.348],[379.696,556.491],[379.696,638.597]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[602.972,462.434],[602.972,379.997],[474.614,462.18],[474.614,379.471]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[602.972,551.156],[602.972,468.719],[474.614,551.195],[474.614,468.486]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[602.972,556.56],[602.972,638.997],[474.614,556.617],[474.614,639.326]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[602.972,645.312],[602.972,727.749],[474.614,645.662],[474.614,728.371]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[602.972,736.506],[602.972,818.943],[474.614,737.156],[474.614,819.865]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[703.068,463.349],[703.068,381.894],[605.017,463.157],[605.017,381.496]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[703.068,551.014],[703.068,469.559],[605.017,551.044],[605.017,469.383]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[703.068,556.354],[703.068,637.809],[605.017,556.397],[605.017,638.058]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[703.068,644.049],[703.068,725.504],[605.017,644.313],[605.017,725.974]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[703.068,734.156],[605.017,734.649],[703.068,815.611],[605.017,816.309]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.792,463.685],[852.792,382.592],[851.492,466.697],[851.492,388.835]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.792,550.962],[852.792,469.868],[851.492,550.495],[851.492,472.634]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.792,556.278],[852.792,637.372],[851.492,555.6],[851.492,633.462]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.792,643.584],[852.792,724.677],[851.492,639.426],[851.492,717.288]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.792,733.291],[852.792,814.385],[851.492,725.559],[851.492,803.42]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.788,463.666],[949.574,463.855],[852.788,382.552],[949.574,382.945]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.788,550.965],[852.788,469.851],[949.574,550.936],[949.574,470.025]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.788,556.283],[852.788,637.397],[949.574,556.24],[949.574,637.151]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.788,643.61],[949.574,643.349],[852.788,724.724],[949.574,724.26]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[852.788,733.34],[949.574,732.854],[852.788,814.454],[949.574,813.765]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.837,463.12],[950.837,381.42],[949.575,463.855],[949.575,382.945]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.837,551.05],[950.837,469.349],[949.575,550.936],[949.575,470.025]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.837,556.406],[950.837,638.106],[949.575,556.24],[949.575,637.151]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.837,644.364],[950.837,726.064],[949.575,643.349],[949.575,724.26]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.837,734.743],[950.837,816.443],[949.575,732.854],[949.575,813.765]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.836,463.12],[950.836,381.42],[1076.09,463.367],[1076.09,381.933]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.836,551.05],[950.836,469.349],[1076.09,551.011],[1076.09,469.576]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.836,556.406],[950.836,638.106],[1076.09,556.35],[1076.09,637.785]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.836,644.364],[950.836,726.064],[1076.09,644.023],[1076.09,725.458]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[950.836,734.743],[950.836,816.443],[1076.09,734.108],[1076.09,815.543]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1073.71,643.048],[1073.71,723.725],[1169.41,642.79],[1169.41,723.266]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1073.71,732.295],[1073.71,812.972],[1169.41,731.815],[1169.41,812.291]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1073.71,464.073],[1073.71,383.396],[1169.41,464.26],[1169.41,383.784]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1073.71,550.902],[1073.71,470.225],[1169.41,550.873],[1169.41,470.396]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1073.71,556.191],[1073.71,636.868],[1169.41,556.149],[1169.41,636.625]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1166.8,464.28],[1166.8,383.825],[1261.18,464.465],[1261.18,384.207]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1166.8,550.87],[1166.8,470.415],[1261.18,550.841],[1261.18,470.584]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1166.8,556.144],[1166.8,636.6],[1261.18,556.103],[1261.18,636.36]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1166.8,642.763],[1166.8,723.218],[1261.18,642.508],[1261.18,722.765]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1166.8,731.764],[1166.8,812.219],[1261.18,731.29],[1261.18,811.548]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,463.741],[1265.45,382.707],[1261.18,464.465],[1261.18,384.207]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,550.953],[1265.45,469.92],[1261.18,550.841],[1261.18,470.584]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,556.266],[1265.45,637.299],[1261.18,556.103],[1261.18,636.36]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,643.507],[1265.45,724.54],[1261.18,642.508],[1261.18,722.765]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,733.148],[1265.45,814.182],[1261.18,731.29],[1261.18,811.548]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,463.741],[1265.45,382.707],[1388.67,463.984],[1388.67,383.212]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,550.953],[1265.45,469.92],[1388.67,550.916],[1388.67,470.143]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,556.266],[1265.45,637.299],[1388.67,556.211],[1388.67,636.984]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,643.507],[1265.45,724.54],[1388.67,643.171],[1388.67,723.944]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1265.45,733.148],[1265.45,814.182],[1388.67,732.523],[1388.67,813.296]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1383.42,642.212],[1383.42,722.239],[1477.59,641.958],[1477.59,721.787]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1383.42,730.74],[1383.42,810.767],[1477.59,730.267],[1477.59,810.097]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1383.42,464.679],[1383.42,384.652],[1477.59,464.863],[1477.59,385.033]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1383.42,550.808],[1383.42,470.781],[1477.59,550.78],[1477.59,470.95]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1383.42,556.054],[1383.42,636.082],[1477.59,556.013],[1477.59,635.843]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1479.18,462.399],[1479.18,382.598],[1569.01,462.581],[1569.01,382.968]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1479.18,548.286],[1479.18,468.484],[1569.01,548.265],[1569.01,468.651]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1479.18,553.518],[1479.18,633.319],[1569.01,553.484],[1569.01,633.097]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1479.18,639.432],[1479.18,719.234],[1569.01,639.196],[1569.01,718.809]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1479.18,727.711],[1479.18,807.513],[1569.01,727.266],[1569.01,806.879]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,461.845],[1576.2,381.468],[1569.01,462.581],[1569.01,382.968]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,548.351],[1576.2,467.974],[1569.01,548.265],[1569.01,468.651]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,553.62],[1576.2,633.998],[1569.01,553.484],[1569.01,633.097]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,640.155],[1576.2,720.532],[1569.01,639.196],[1569.01,718.809]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,729.07],[1576.2,809.447],[1569.01,727.266],[1569.01,806.879]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,461.845],[1576.2,381.468],[1697.43,462.093],[1697.43,381.972]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,548.351],[1576.2,467.974],[1697.43,548.322],[1697.43,468.202]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,553.62],[1576.2,633.998],[1697.43,553.574],[1697.43,633.695]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,640.155],[1576.2,720.532],[1697.43,639.832],[1697.43,719.953]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1576.2,729.07],[1576.2,809.447],[1697.43,728.463],[1697.43,808.584]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1689.4,462.799],[1689.4,383.412],[1782.07,462.986],[1782.07,383.794]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1689.4,548.239],[1689.4,468.852],[1782.07,548.217],[1782.07,469.024]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1689.4,553.443],[1689.4,632.83],[1782.07,553.409],[1782.07,632.601]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1689.4,638.912],[1689.4,718.299],[1782.07,638.667],[1782.07,717.86]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:9,
                    verts:[[1689.4,726.732],[1689.4,806.119],[1782.07,726.272],[1782.07,805.465]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[149.22,459.488],[149.22,374.593],[43.1411,458.993],[43.1411,373.572]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[149.22,550.856],[149.22,465.961],[43.1411,550.928],[43.1411,465.506]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[149.22,556.421],[149.22,641.316],[43.1411,556.528],[43.1411,641.949]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[149.22,647.819],[149.22,732.715],[43.1411,648.492],[43.1411,733.914]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[149.22,741.732],[149.22,826.628],[43.1411,742.988],[43.1411,828.409]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[280.696,459.346],[280.696,374.301],[144.504,458.706],[144.504,372.978]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[280.696,550.876],[280.696,465.831],[144.504,550.969],[144.504,465.242]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[280.696,556.452],[280.696,641.497],[144.504,556.59],[144.504,642.317]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[280.696,648.012],[280.696,733.057],[144.504,648.884],[144.504,734.611]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[280.696,742.091],[280.696,827.136],[144.504,743.717],[144.504,829.445]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[386.812,460.621],[386.812,376.933],[284.182,460.143],[284.182,375.946]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[386.812,550.691],[386.812,467.002],[284.182,550.76],[284.182,466.563]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[386.812,556.177],[386.812,639.866],[284.182,556.28],[284.182,640.478]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[386.812,646.277],[386.812,729.965],[284.182,646.927],[284.182,731.125]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[386.812,738.855],[386.812,822.543],[284.182,740.069],[284.182,824.266]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[486.811,461.731],[486.811,378.54],[385.816,461.264],[385.816,377.573]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[486.811,551.265],[486.811,468.074],[385.816,551.337],[385.816,467.646]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[486.811,646.282],[486.811,729.473],[385.816,646.926],[385.816,730.618]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[486.811,556.719],[486.811,639.909],[385.816,556.824],[385.816,640.515]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[486.811,738.31],[385.816,739.508],[486.811,821.5],[385.816,823.2]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.225,461.57],[616.225,378.207],[485.385,460.96],[485.385,376.941]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.225,551.29],[616.225,467.927],[485.385,551.384],[485.385,467.366]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.225,556.755],[616.225,640.118],[485.385,556.892],[485.385,640.911]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.225,646.504],[485.385,647.347],[616.225,729.867],[485.385,731.365]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.225,738.722],[485.385,740.29],[616.225,822.085],[485.385,824.308]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.358,462.304],[715.511,462.762],[616.358,379.728],[715.511,380.678]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.358,551.176],[616.358,468.6],[715.511,551.105],[715.511,469.021]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.358,556.589],[715.511,556.486],[616.358,639.165],[715.511,638.57]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.358,645.491],[715.511,644.858],[616.358,728.067],[715.511,726.942]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[616.358,736.838],[715.511,735.661],[616.358,819.414],[715.511,817.745]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.489,463.5],[865.489,382.208],[856.168,466.502],[856.168,388.432]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.489,550.991],[865.489,469.698],[856.168,550.526],[856.168,472.455]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.489,556.32],[865.489,637.612],[856.168,555.644],[856.168,633.714]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.489,643.84],[865.489,725.132],[856.168,639.694],[856.168,717.765]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.489,733.767],[865.489,815.06],[856.168,726.058],[856.168,804.128]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.536,463.481],[865.536,382.168],[961.728,463.926],[961.728,383.09]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.536,550.994],[865.536,469.681],[961.728,550.925],[961.728,470.089]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.536,556.324],[865.536,637.637],[961.728,556.224],[961.728,637.06]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.536,643.866],[865.536,725.179],[961.728,643.252],[961.728,724.088]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[865.536,733.816],[865.536,815.129],[961.728,732.674],[961.728,813.51]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.932,463.198],[964.932,381.581],[961.73,463.926],[961.73,383.09]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.932,551.038],[964.932,469.421],[961.73,550.925],[961.73,470.089]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.932,556.388],[964.932,638.005],[961.73,556.224],[961.73,637.06]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.932,644.257],[964.932,725.874],[961.73,643.252],[961.73,724.088]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.932,734.544],[964.932,816.161],[961.73,732.674],[961.73,813.51]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.931,463.198],[964.931,381.581],[1088.43,463.774],[1088.43,382.775]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.931,551.038],[964.931,469.421],[1088.43,550.948],[1088.43,469.95]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.931,556.388],[964.931,638.005],[1088.43,556.258],[1088.43,637.257]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.931,644.257],[964.931,725.874],[1088.43,643.461],[1088.43,724.46]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[964.931,734.544],[964.931,816.161],[1088.43,733.064],[1088.43,814.062]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1084.22,642.505],[1084.22,722.76],[1177.9,641.907],[1177.9,721.698]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1084.22,731.285],[1084.22,811.54],[1177.9,730.173],[1177.9,809.964]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1084.22,464.467],[1084.22,384.212],[1177.9,464.9],[1177.9,385.109]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1084.22,550.841],[1084.22,470.586],[1177.9,550.774],[1177.9,470.983]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1084.22,556.102],[1084.22,636.357],[1177.9,556.005],[1177.9,635.795]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1175.28,464.912],[1175.28,385.136],[1267.07,465.337],[1267.07,386.015]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1175.28,550.772],[1175.28,470.995],[1267.07,550.706],[1267.07,471.385]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1175.28,556.002],[1175.28,635.779],[1267.07,555.906],[1267.07,635.228]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1175.28,641.89],[1175.28,721.666],[1267.07,641.304],[1267.07,720.626]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1175.28,730.141],[1175.28,809.917],[1267.07,729.051],[1267.07,808.373]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,464.636],[1273.11,384.562],[1267.07,465.337],[1267.07,386.015]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,550.815],[1273.11,470.741],[1267.07,550.706],[1267.07,471.385]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,556.064],[1273.11,636.138],[1267.07,555.906],[1267.07,635.228]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,642.272],[1273.11,722.345],[1267.07,641.304],[1267.07,720.626]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,730.851],[1273.11,810.924],[1267.07,729.052],[1267.07,808.373]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,464.636],[1273.11,384.562],[1391.99,465.191],[1391.99,385.712]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,550.815],[1273.11,470.741],[1391.99,550.729],[1391.99,471.25]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,556.064],[1273.11,636.138],[1391.99,555.939],[1391.99,635.417]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,642.272],[1273.11,722.345],[1391.99,641.506],[1391.99,720.984]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1273.11,730.851],[1273.11,810.924],[1391.99,729.426],[1391.99,808.905]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1385.13,727.713],[1385.13,806.476],[1475.36,726.642],[1475.36,804.957]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1385.13,465.858],[1385.13,387.095],[1475.36,466.275],[1475.36,387.96]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1385.13,550.625],[1385.13,471.863],[1475.36,550.561],[1475.36,472.246]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1385.13,555.789],[1385.13,634.551],[1475.36,555.695],[1475.36,634.01]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1385.13,640.585],[1385.13,719.347],[1475.36,640.009],[1475.36,718.323]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1476.81,463.862],[1476.81,385.579],[1562.34,464.27],[1562.34,386.411]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1476.81,548.114],[1476.81,469.831],[1562.34,548.066],[1562.34,470.207]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1476.81,553.246],[1476.81,631.529],[1562.34,553.17],[1562.34,631.029]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1476.81,637.526],[1476.81,715.809],[1562.34,636.994],[1562.34,714.853]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1476.81,724.125],[1476.81,802.408],[1562.34,723.123],[1562.34,800.982]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,463.573],[1571.01,384.989],[1562.34,464.27],[1562.34,386.411]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,548.148],[1571.01,469.564],[1562.34,548.066],[1562.34,470.207]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,553.3],[1571.01,631.883],[1562.34,553.17],[1562.34,631.029]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,637.903],[1571.01,716.487],[1562.34,636.994],[1562.34,714.853]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,724.834],[1571.01,803.418],[1562.34,723.123],[1562.34,800.982]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,463.573],[1571.01,384.989],[1685.53,464.125],[1685.53,386.115]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,548.148],[1571.01,469.564],[1685.53,548.083],[1685.53,470.073]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,553.3],[1571.01,631.883],[1685.53,553.197],[1685.53,631.207]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,637.903],[1571.01,716.487],[1685.53,637.183],[1685.53,715.193]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1571.01,724.834],[1571.01,803.418],[1685.53,723.48],[1685.53,801.49]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1676.2,464.789],[1676.2,387.469],[1763.16,465.205],[1763.16,388.316]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1676.2,548.005],[1676.2,470.685],[1763.16,547.956],[1763.16,471.067]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1676.2,553.074],[1676.2,630.394],[1763.16,552.997],[1763.16,629.886]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1676.2,636.317],[1676.2,713.637],[1763.16,635.776],[1763.16,712.665]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:10,
                    verts:[[1676.2,721.851],[1676.2,799.171],[1763.16,720.832],[1763.16,797.721]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[151.302,457.174],[151.302,369.816],[40.3515,456.35],[40.3515,368.115]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[151.302,551.192],[151.302,463.835],[40.3515,551.312],[40.3515,463.078]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[151.302,556.919],[151.302,644.277],[40.3515,557.097],[40.3515,645.331]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[151.302,650.969],[151.302,738.327],[40.3515,652.09],[40.3515,740.325]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[151.302,747.606],[151.302,834.964],[40.3515,749.697],[40.3515,837.932]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[289.704,457.417],[289.704,370.318],[148.474,456.358],[148.474,368.132]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[289.704,551.157],[289.704,464.058],[148.474,551.311],[148.474,463.085]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[289.704,556.867],[289.704,643.966],[148.474,557.095],[148.474,645.321]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[289.704,650.638],[289.704,737.737],[148.474,652.079],[148.474,740.305]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[289.704,746.989],[289.704,834.089],[148.474,749.677],[148.474,837.903]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[396.696,459.023],[291.174,458.24],[396.696,373.634],[291.174,372.017]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[396.696,550.923],[396.696,465.534],[291.174,551.037],[291.174,464.814]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[396.696,556.521],[396.696,641.911],[291.174,556.69],[291.174,642.913]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[396.696,648.452],[291.174,649.518],[396.696,733.841],[291.174,735.741]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[396.696,742.912],[291.174,744.9],[396.696,828.301],[291.174,831.123]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[395.672,649.119],[498.772,648.071],[395.672,734.514],[498.772,732.652]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[395.672,743.585],[498.772,741.636],[395.672,828.981],[498.772,826.218]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[395.672,459.676],[498.772,460.435],[395.672,374.281],[498.772,375.854]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[395.672,551.583],[498.772,551.466],[395.672,466.188],[498.772,466.884]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[395.672,557.182],[498.772,557.01],[395.672,642.577],[498.772,641.592]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,459.65],[499.4,374.226],[498.773,460.435],[498.773,375.854]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,551.587],[499.4,466.163],[498.773,551.466],[498.773,466.884]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,557.187],[499.4,642.611],[498.773,557.01],[498.773,641.592]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,649.155],[499.4,734.579],[498.773,648.071],[498.773,732.652]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,743.653],[499.4,829.077],[498.773,741.636],[498.773,826.217]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,459.65],[499.4,374.226],[631.859,460.635],[631.859,376.268]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,551.587],[499.4,466.163],[631.859,551.435],[631.859,467.068]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,557.187],[499.4,642.611],[631.859,556.966],[631.859,641.333]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,649.155],[499.4,734.579],[631.859,647.795],[631.859,732.162]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[499.4,743.653],[631.859,741.124],[499.4,829.077],[631.859,825.491]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[630.013,461.375],[630.013,377.803],[729.603,462.109],[729.603,379.323]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[630.013,551.32],[630.013,467.747],[729.603,551.206],[729.603,468.421]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[630.013,556.799],[630.013,640.371],[729.603,556.634],[729.603,639.419]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[630.013,646.773],[630.013,730.346],[729.603,645.761],[729.603,728.546]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[630.013,739.223],[630.013,822.796],[729.603,737.34],[729.603,820.126]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.813,463.253],[878.813,381.695],[861.452,466.231],[861.452,387.87]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.813,551.029],[878.813,469.471],[861.452,550.568],[861.452,472.206]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.813,556.376],[878.813,637.934],[861.452,555.705],[861.452,634.066]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.813,644.181],[878.813,725.739],[861.452,640.069],[861.452,718.43]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.813,734.402],[878.813,815.96],[861.452,726.754],[861.452,805.115]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.911,463.234],[878.911,381.656],[973.867,463.933],[973.867,383.105]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.911,551.032],[878.911,469.454],[973.867,550.924],[973.867,470.096]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.911,556.38],[878.911,637.958],[973.867,556.222],[973.867,637.05]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.911,644.207],[878.911,725.785],[973.867,643.242],[973.867,724.07]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[878.911,734.451],[878.911,816.029],[973.867,732.656],[973.867,813.484]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.989,463.216],[978.989,381.619],[973.868,463.933],[973.868,383.105]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.989,551.035],[978.989,469.438],[973.868,550.924],[973.868,470.096]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.989,556.384],[978.989,637.981],[973.868,556.222],[973.868,637.05]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.989,644.232],[978.989,725.829],[973.868,643.242],[973.868,724.07]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.989,734.497],[978.989,816.094],[973.868,732.656],[973.868,813.483]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.988,463.216],[978.988,381.619],[1099.91,464.115],[1099.91,383.483]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.988,551.035],[978.988,469.438],[1099.91,550.895],[1099.91,470.263]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.988,556.384],[978.988,637.981],[1099.91,556.181],[1099.91,636.814]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.988,644.232],[978.988,725.829],[1099.91,642.99],[1099.91,723.623]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[978.988,734.497],[978.988,816.094],[1099.91,732.188],[1099.91,812.82]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1093.93,642.056],[1093.93,721.963],[1185.02,641.13],[1185.02,720.317]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1093.93,730.451],[1093.93,810.357],[1185.02,728.728],[1185.02,807.915]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1093.93,464.792],[1093.93,384.885],[1185.02,465.462],[1185.02,386.276]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1093.93,550.791],[1093.93,470.884],[1185.02,550.687],[1185.02,471.5]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1093.93,556.029],[1093.93,635.935],[1185.02,555.878],[1185.02,635.065]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1182.41,465.468],[1182.41,386.288],[1271.11,466.121],[1271.11,387.641]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1182.41,550.686],[1182.41,471.505],[1271.11,550.585],[1271.11,472.105]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1182.41,555.877],[1182.41,635.057],[1271.11,555.729],[1271.11,634.209]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1182.41,641.122],[1182.41,720.303],[1271.11,640.221],[1271.11,718.7]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1182.41,728.714],[1182.41,807.894],[1271.11,727.037],[1271.11,805.516]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,465.445],[1278.83,386.241],[1271.11,466.121],[1271.11,387.641]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,550.689],[1278.83,471.485],[1271.11,550.585],[1271.11,472.105]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,555.882],[1278.83,635.086],[1271.11,555.729],[1271.11,634.209]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,641.154],[1278.83,720.358],[1271.11,640.221],[1271.11,718.7]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,728.772],[1278.83,807.977],[1271.11,727.037],[1271.11,805.516]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,465.445],[1278.83,386.241],[1392.81,466.293],[1392.81,387.998]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,550.689],[1278.83,471.485],[1392.81,550.558],[1392.81,472.263]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,555.882],[1278.83,635.086],[1392.81,555.691],[1392.81,633.986]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,641.154],[1278.83,720.358],[1392.81,639.984],[1392.81,718.279]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1278.83,728.772],[1278.83,807.977],[1392.81,726.596],[1392.81,804.891]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1384.44,639.103],[1384.44,716.713],[1470.38,638.229],[1470.38,715.16]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1384.44,724.958],[1384.44,802.568],[1470.38,723.332],[1470.38,800.264]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1384.44,466.931],[1384.44,389.32],[1470.38,467.564],[1470.38,390.632]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1384.44,550.459],[1384.44,472.848],[1470.38,550.361],[1470.38,473.43]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1384.44,555.547],[1384.44,633.158],[1470.38,555.404],[1470.38,632.336]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1471.7,465.197],[1471.7,388.3],[1552.67,465.813],[1552.67,389.556]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1471.7,547.957],[1471.7,471.06],[1552.67,547.885],[1552.67,471.628]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1471.7,552.998],[1471.7,629.895],[1552.67,552.884],[1552.67,629.141]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1471.7,635.785],[1471.7,712.682],[1552.67,634.982],[1552.67,711.24]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1471.7,720.85],[1471.7,797.747],[1552.67,719.34],[1552.67,795.597]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,465.154],[1562.69,388.213],[1552.67,465.813],[1552.67,389.556]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,547.962],[1562.69,471.021],[1552.67,547.885],[1552.67,471.628]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,553.006],[1562.69,629.948],[1552.67,552.884],[1552.67,629.141]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,635.842],[1562.69,712.783],[1552.67,634.982],[1552.67,711.24]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,720.956],[1562.69,797.898],[1552.67,719.34],[1552.67,795.597]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,465.154],[1562.69,388.213],[1670.28,465.981],[1670.28,389.898]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,547.962],[1562.69,471.021],[1670.28,547.865],[1670.28,471.782]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,553.006],[1562.69,629.948],[1670.28,552.853],[1670.28,628.936]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,635.842],[1562.69,712.783],[1670.28,634.764],[1670.28,710.847]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1562.69,720.956],[1562.69,797.898],[1670.28,718.929],[1670.28,795.012]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1659.79,466.604],[1659.79,391.167],[1741.01,467.222],[1741.01,392.427]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1659.79,547.792],[1659.79,472.355],[1741.01,547.719],[1741.01,472.925]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1659.79,552.737],[1659.79,628.174],[1741.01,552.622],[1741.01,627.417]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1659.79,633.952],[1659.79,709.388],[1741.01,633.146],[1741.01,707.941]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:11,
                    verts:[[1659.79,717.402],[1659.79,792.838],[1741.01,715.886],[1741.01,790.68]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[158.764,454.686],[158.764,364.679],[43.4142,453.494],[43.4142,362.22]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[158.764,551.554],[158.764,461.548],[43.4142,551.728],[43.4142,460.454]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[158.764,557.455],[158.764,647.461],[43.4142,557.711],[43.4142,648.985]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[158.764,654.356],[43.4142,655.977],[158.764,744.362],[43.4142,747.251]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[158.764,753.923],[43.4142,756.947],[158.764,843.929],[43.4142,848.221]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[303.51,455.356],[158.017,453.838],[303.51,366.063],[158.017,362.93]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[303.51,551.457],[158.017,551.678],[303.51,462.164],[158.017,460.77]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[303.51,557.311],[158.017,557.637],[303.51,646.604],[158.017,648.545]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[303.51,653.444],[158.017,655.509],[303.51,742.736],[158.017,746.417]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[303.51,752.221],[158.017,756.074],[303.51,841.514],[158.017,846.982]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[302.802,456.202],[302.802,367.81],[410.572,457.315],[410.572,370.106]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[302.802,551.334],[302.802,462.941],[410.572,551.172],[410.572,463.964]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[302.802,557.128],[302.802,645.521],[410.572,556.889],[410.572,644.097]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[302.802,652.292],[410.572,650.777],[302.802,740.684],[410.572,737.985]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[302.802,750.073],[410.572,747.249],[302.802,838.465],[410.572,834.457]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[409.525,457.979],[409.525,370.761],[514.048,459.049],[514.048,372.98]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[409.525,551.846],[409.525,464.629],[514.048,551.68],[514.048,465.611]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[409.525,557.564],[409.525,644.781],[514.048,557.323],[514.048,643.392]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[409.525,651.462],[409.525,738.68],[514.048,649.985],[514.048,736.054]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[409.525,747.944],[409.525,835.162],[514.048,745.197],[514.048,831.266]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,458.253],[516.834,371.331],[514.049,459.049],[514.049,372.98]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,551.804],[516.834,464.881],[514.049,551.68],[514.049,465.611]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,557.502],[516.834,644.425],[514.049,557.323],[514.049,643.392]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,651.083],[516.834,738.006],[514.049,649.985],[514.049,736.054]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,747.239],[516.834,834.162],[514.049,745.196],[514.049,831.265]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,458.253],[516.834,371.331],[649.957,459.63],[649.957,374.185]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,551.804],[516.834,464.881],[649.957,551.59],[649.957,466.145]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,557.502],[516.834,644.425],[649.957,557.192],[649.957,642.637]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,651.083],[516.834,738.006],[649.957,649.182],[649.957,734.627]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[516.834,747.239],[516.834,834.162],[649.957,743.703],[649.957,829.148]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[646.07,460.373],[646.07,375.726],[745.383,461.391],[745.383,377.834]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[646.07,551.475],[646.07,466.827],[745.383,551.318],[745.383,467.761]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[646.07,557.024],[646.07,641.672],[745.383,556.795],[745.383,640.352]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[646.07,648.156],[646.07,732.804],[745.383,646.752],[745.383,730.308]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[646.07,741.796],[646.07,826.444],[745.383,739.184],[745.383,822.74]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.756,462.947],[892.756,381.06],[867.354,465.886],[867.354,387.154]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.756,551.076],[892.756,469.19],[867.354,550.621],[867.354,471.889]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.756,556.445],[892.756,638.331],[867.354,555.782],[867.354,634.514]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.756,644.604],[892.756,726.49],[867.354,640.545],[867.354,719.277]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.756,735.188],[892.756,817.075],[867.354,727.64],[867.354,806.372]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.904,462.928],[892.904,381.022],[985.968,463.881],[985.968,382.997]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.904,551.079],[892.904,469.173],[985.968,550.932],[985.968,470.048]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.904,556.449],[892.904,638.355],[985.968,556.234],[985.968,637.118]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.904,644.629],[892.904,726.536],[985.968,643.314],[985.968,724.198]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[892.904,735.236],[892.904,817.142],[985.968,732.789],[985.968,813.673]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.981,463.179],[992.981,381.541],[985.969,463.881],[985.969,382.997]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.981,551.04],[992.981,469.403],[985.969,550.932],[985.969,470.048]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.981,556.392],[992.981,638.03],[985.969,556.234],[985.969,637.118]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.981,644.283],[992.981,725.92],[985.969,643.314],[985.969,724.197]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.981,734.592],[992.981,816.23],[985.969,732.789],[985.969,813.673]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.98,463.179],[992.98,381.541],[1110.53,464.395],[1110.53,384.062]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.98,551.04],[992.98,469.403],[1110.53,550.852],[1110.53,470.52]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.98,556.392],[992.98,638.03],[1110.53,556.118],[1110.53,636.451]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.98,644.283],[992.98,725.92],[1110.53,642.604],[1110.53,722.937]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[992.98,734.592],[992.98,816.23],[1110.53,731.47],[1110.53,811.802]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1102.83,729.783],[1102.83,809.41],[1190.78,727.47],[1190.78,806.131]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1102.83,465.052],[1102.83,385.424],[1190.78,465.952],[1190.78,387.292]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1102.83,550.75],[1102.83,471.123],[1190.78,550.611],[1190.78,471.95]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1102.83,555.97],[1102.83,635.598],[1190.78,555.767],[1190.78,634.428]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1102.83,641.697],[1102.83,721.325],[1190.78,640.454],[1190.78,719.114]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1188.2,727.472],[1188.2,806.134],[1273.34,725.234],[1273.34,802.96]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1188.2,465.952],[1188.2,387.29],[1273.34,466.823],[1273.34,389.097]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1188.2,550.611],[1188.2,471.949],[1273.34,550.476],[1273.34,472.75]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1188.2,555.768],[1188.2,634.429],[1273.34,555.571],[1273.34,633.298]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1188.2,640.455],[1188.2,719.117],[1273.34,639.251],[1273.34,716.978]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,466.175],[1282.64,387.753],[1273.34,466.823],[1273.34,389.097]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,550.576],[1282.64,472.154],[1273.34,550.476],[1273.34,472.75]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,555.717],[1282.64,634.139],[1273.34,555.571],[1273.34,633.298]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,640.146],[1282.64,718.568],[1273.34,639.251],[1273.34,716.978]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,726.898],[1282.64,805.32],[1273.34,725.234],[1273.34,802.96]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,466.175],[1282.64,387.753],[1391.18,467.298],[1391.18,390.081]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,550.576],[1282.64,472.154],[1391.18,550.402],[1391.18,473.185]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,555.717],[1282.64,634.139],[1391.18,555.464],[1391.18,632.681]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,640.146],[1282.64,718.568],[1391.18,638.596],[1391.18,715.813]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1282.64,726.898],[1282.64,805.32],[1391.18,724.016],[1391.18,801.233]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1381.41,637.758],[1381.41,714.323],[1462.76,636.607],[1462.76,712.279]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1381.41,722.456],[1381.41,799.022],[1462.76,720.317],[1462.76,795.988]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1381.41,467.905],[1381.41,391.34],[1462.76,468.738],[1462.76,393.067]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1381.41,550.308],[1381.41,473.743],[1462.76,550.179],[1462.76,474.508]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1381.41,555.328],[1381.41,631.893],[1462.76,555.14],[1462.76,630.811]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1463.95,466.414],[1463.95,390.78],[1540.15,467.22],[1540.15,392.423]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1463.95,547.814],[1463.95,472.18],[1540.15,547.719],[1540.15,472.923]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1463.95,552.772],[1463.95,628.406],[1540.15,552.623],[1540.15,627.419]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1463.95,634.2],[1463.95,709.833],[1540.15,633.149],[1540.15,707.945]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1463.95,717.867],[1463.95,793.501],[1540.15,715.89],[1540.15,790.687]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,466.6],[1551.4,391.159],[1540.15,467.22],[1540.15,392.423]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,547.792],[1551.4,472.352],[1540.15,547.719],[1540.15,472.923]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,552.738],[1551.4,628.178],[1540.15,552.623],[1540.15,627.419]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,633.957],[1551.4,709.397],[1540.15,633.149],[1540.15,707.945]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,717.411],[1551.4,792.851],[1540.15,715.89],[1540.15,790.687]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,466.6],[1551.4,391.159],[1651.89,467.674],[1651.89,393.349]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,547.792],[1551.4,472.352],[1651.89,547.666],[1651.89,473.341]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,552.738],[1551.4,628.178],[1651.89,552.538],[1651.89,626.863]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,633.957],[1551.4,709.397],[1651.89,632.557],[1651.89,706.881]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1551.4,717.411],[1551.4,792.851],[1651.89,714.776],[1651.89,789.101]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1640.37,468.256],[1640.37,394.535],[1715.82,469.054],[1715.82,396.163]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1640.37,547.597],[1640.37,473.877],[1715.82,547.504],[1715.82,474.612]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1640.37,552.43],[1640.37,626.151],[1715.82,552.282],[1715.82,625.174]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1640.37,631.798],[1640.37,705.519],[1715.82,630.757],[1715.82,703.649]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:12,
                    verts:[[1640.37,713.35],[1640.37,787.071],[1715.82,711.392],[1715.82,784.283]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[49.6864,457.366],[49.6864,372.338],[47.4796,463.246],[47.4796,384.324]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[49.6864,548.878],[49.6864,463.849],[47.4796,548.186],[47.4796,469.264]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[49.6864,554.452],[49.6864,639.48],[47.4796,553.36],[47.4796,632.283]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[49.6864,645.994],[49.6864,731.022],[47.4796,638.328],[47.4796,717.251]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[49.6864,740.054],[49.6864,825.083],[47.4796,725.634],[47.4796,804.556]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1245,448.203],[53.1245,353.66],[50.4185,455.415],[50.4185,368.361]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1245,549.955],[53.1245,455.412],[50.4185,549.107],[50.4185,462.053]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1245,556.153],[53.1245,650.696],[50.4185,554.814],[50.4185,641.868]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1245,657.938],[53.1245,752.481],[50.4185,648.536],[50.4185,735.591]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1245,762.524],[53.1245,857.067],[50.4185,744.838],[50.4185,831.892]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1239,450.423],[172.241,452.024],[53.1239,355.88],[172.241,359.184]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1239,552.174],[53.1239,457.631],[172.241,551.942],[172.241,459.102]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1239,558.372],[53.1239,652.915],[172.241,558.028],[172.241,650.867]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1239,660.158],[172.241,657.979],[53.1239,754.701],[172.241,750.818]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[53.1239,764.743],[172.241,760.68],[53.1239,859.286],[172.241,853.519]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.778,451.148],[173.778,357.377],[172.24,452.024],[172.24,359.184]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.778,552.069],[173.778,458.298],[172.24,551.942],[172.24,459.102]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.778,558.216],[173.778,651.987],[172.24,558.028],[172.24,650.867]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.778,659.17],[173.778,752.941],[172.24,657.979],[172.24,750.818]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.778,762.902],[173.778,856.673],[172.24,760.68],[172.24,853.519]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.779,451.148],[173.779,357.377],[322.562,453.168],[322.562,361.547]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.779,552.069],[173.779,458.298],[322.562,551.775],[322.562,460.154]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.779,558.216],[173.779,651.987],[322.562,557.781],[322.562,649.402]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.779,659.17],[173.779,752.941],[322.562,656.421],[322.562,748.042]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[173.779,762.902],[173.779,856.673],[322.562,757.774],[322.562,849.395]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[319.511,454.033],[319.511,363.333],[428.76,455.501],[428.76,366.363]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[319.511,551.649],[319.511,460.949],[428.76,551.436],[428.76,462.298]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[319.511,557.595],[319.511,648.295],[428.76,557.279],[428.76,646.417]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[319.511,655.243],[319.511,745.943],[428.76,653.246],[428.76,742.384]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[319.511,755.578],[319.511,846.278],[428.76,751.852],[428.76,840.99]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[427.698,456.177],[427.698,367.026],[532.857,457.578],[532.857,369.931]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[427.698,552.125],[427.698,462.974],[532.857,551.908],[532.857,464.261]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[427.698,557.97],[427.698,647.121],[532.857,557.654],[532.857,645.302]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[427.698,653.95],[427.698,743.101],[532.857,652.016],[532.857,739.663]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[427.698,752.571],[427.698,841.722],[532.857,748.974],[532.857,836.621]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,456.777],[537.899,368.27],[532.859,457.578],[532.859,369.931]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,552.032],[537.899,463.525],[532.859,551.908],[532.859,464.261]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,557.835],[537.899,646.342],[532.859,557.654],[532.859,645.302]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,653.122],[537.899,741.629],[532.859,652.016],[532.859,739.663]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,751.03],[537.899,839.537],[532.859,748.974],[532.859,836.621]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,456.777],[537.899,368.27],[670.62,458.564],[670.62,371.975]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,552.032],[537.899,463.525],[670.62,551.756],[670.62,465.166]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,557.835],[537.899,646.342],[670.62,557.432],[670.62,644.021]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,653.122],[537.899,741.629],[670.62,650.654],[670.62,737.243]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[537.899,751.03],[537.899,839.537],[670.62,746.441],[670.62,833.031]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[664.637,459.305],[664.637,373.511],[762.894,460.615],[762.894,376.226]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[664.637,551.641],[664.637,465.847],[762.894,551.438],[762.894,467.049]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[664.637,557.265],[664.637,643.059],[762.894,556.97],[762.894,641.359]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[664.637,649.631],[664.637,735.425],[762.894,647.823],[762.894,732.212]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[664.637,744.539],[664.637,830.333],[762.894,741.176],[762.894,825.565]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.305,462.588],[907.305,380.317],[873.89,465.472],[873.89,386.295]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.305,551.132],[907.305,468.861],[873.89,550.685],[873.89,471.509]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.305,556.526],[907.305,638.797],[873.89,555.876],[873.89,635.052]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.305,645.099],[907.305,727.37],[873.89,641.117],[873.89,720.294]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.305,736.109],[907.305,818.38],[873.89,728.704],[873.89,807.881]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.504,462.57],[907.504,380.279],[998.003,463.775],[998.003,382.779]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.504,551.135],[907.504,468.844],[998.003,550.948],[998.003,469.951]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.504,556.53],[907.504,638.82],[998.003,556.258],[998.003,637.255]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.504,645.124],[907.504,727.415],[998.003,643.459],[998.003,724.456]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[907.504,736.156],[907.504,818.447],[998.003,733.06],[998.003,814.057]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,463.092],[1006.87,381.362],[998.004,463.775],[998.004,382.779]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,551.054],[1006.87,469.324],[998.004,550.948],[998.004,469.951]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,556.412],[1006.87,638.142],[998.004,556.258],[998.004,637.255]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,644.403],[1006.87,726.133],[998.004,643.459],[998.004,724.456]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,734.815],[1006.87,816.546],[998.004,733.06],[998.004,814.057]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,463.092],[1006.87,381.362],[1120.23,464.618],[1120.23,384.526]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,551.054],[1006.87,469.324],[1120.23,550.817],[1120.23,470.725]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,556.412],[1006.87,638.142],[1120.23,556.068],[1120.23,636.16]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,644.403],[1006.87,726.133],[1120.23,642.296],[1120.23,722.388]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1006.87,734.815],[1006.87,816.546],[1120.23,730.896],[1120.23,810.988]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1110.87,641.42],[1110.87,720.831],[1195.16,639.869],[1195.16,718.075]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1110.87,729.267],[1110.87,808.678],[1195.16,726.382],[1195.16,804.588]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1110.87,465.253],[1110.87,385.841],[1195.16,466.376],[1195.16,388.17]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1110.87,550.719],[1110.87,471.308],[1195.16,550.545],[1195.16,472.339]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1110.87,555.925],[1110.87,635.337],[1195.16,555.672],[1195.16,633.878]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1192.63,466.369],[1192.63,388.155],[1273.74,467.449],[1273.74,390.395]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1192.63,550.546],[1192.63,472.332],[1273.74,550.379],[1273.74,473.324]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1192.63,555.674],[1192.63,633.888],[1273.74,555.43],[1273.74,632.485]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1192.63,639.879],[1192.63,718.093],[1273.74,638.387],[1273.74,715.442]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1192.63,726.401],[1192.63,804.616],[1273.74,723.627],[1273.74,800.681]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,466.831],[1284.55,389.113],[1273.74,467.449],[1273.74,390.395]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,550.475],[1284.55,472.757],[1273.74,550.379],[1273.74,473.324]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,555.57],[1284.55,633.288],[1273.74,555.43],[1273.74,632.485]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,639.241],[1284.55,716.959],[1273.74,638.387],[1273.74,715.442]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,725.214],[1284.55,802.932],[1273.74,723.627],[1273.74,800.681]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,466.831],[1284.55,389.113],[1387.15,468.213],[1387.15,391.977]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,550.475],[1284.55,472.757],[1387.15,550.26],[1387.15,474.025]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,555.57],[1284.55,633.288],[1387.15,555.258],[1387.15,631.493]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,639.241],[1284.55,716.959],[1387.15,637.333],[1387.15,713.569]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1284.55,725.214],[1284.55,802.932],[1387.15,721.667],[1387.15,797.902]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1376.08,720.19],[1376.08,795.809],[1452.56,717.573],[1452.56,792.097]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1376.08,468.788],[1376.08,393.169],[1452.56,469.807],[1452.56,395.282]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1376.08,550.171],[1376.08,474.553],[1452.56,550.013],[1452.56,475.489]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1376.08,555.129],[1376.08,630.747],[1452.56,554.899],[1452.56,629.423]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1376.08,636.539],[1376.08,712.158],[1452.56,635.132],[1452.56,709.656]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1453.61,467.52],[1453.61,393.036],[1524.85,468.501],[1524.85,395.035]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1453.61,547.684],[1453.61,473.2],[1524.85,547.569],[1524.85,474.103]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1453.61,552.567],[1453.61,627.051],[1524.85,552.385],[1524.85,625.851]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1453.61,632.757],[1453.61,707.241],[1524.85,631.478],[1524.85,704.944]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1453.61,715.153],[1453.61,789.638],[1524.85,712.748],[1524.85,786.214]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,467.921],[1537.21,393.852],[1524.85,468.501],[1524.85,395.035]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,547.637],[1537.21,473.568],[1524.85,547.569],[1524.85,474.103]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,552.493],[1537.21,626.561],[1524.85,552.385],[1524.85,625.851]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,632.235],[1537.21,706.304],[1524.85,631.478],[1524.85,704.944]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,714.172],[1537.21,788.241],[1524.85,712.748],[1524.85,786.214]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,467.921],[1537.21,393.852],[1630.49,469.219],[1630.49,396.498]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,547.637],[1537.21,473.568],[1630.49,547.484],[1630.49,474.763]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,552.493],[1537.21,626.561],[1630.49,552.252],[1630.49,624.973]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,632.235],[1537.21,706.304],[1630.49,630.543],[1630.49,703.264]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1537.21,714.172],[1537.21,788.241],[1630.49,710.989],[1630.49,783.71]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1618.04,469.76],[1618.04,397.6],[1687.73,470.72],[1687.73,399.557]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1618.04,547.421],[1618.04,475.262],[1687.73,547.308],[1687.73,476.146]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1618.04,552.151],[1618.04,624.311],[1687.73,551.973],[1687.73,623.136]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1618.04,629.838],[1618.04,701.997],[1687.73,628.587],[1687.73,699.749]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:13,
                    verts:[[1618.04,709.662],[1618.04,781.822],[1687.73,707.308],[1687.73,778.471]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[42.048,454.329],[42.048,366.146],[23.8168,460.421],[23.8168,378.564]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[42.048,549.235],[42.048,461.052],[23.8168,548.518],[23.8168,466.662]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[42.048,555.016],[42.048,643.198],[23.8168,553.885],[23.8168,635.741]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[42.048,649.953],[42.048,738.135],[23.8168,642.012],[23.8168,723.868]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[42.048,747.502],[42.048,835.684],[23.8168,732.564],[23.8168,814.42]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4487,444.838],[70.4487,346.801],[48.095,452.308],[48.095,362.027]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4487,550.35],[70.4487,452.313],[48.095,549.472],[48.095,459.192]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4487,556.777],[70.4487,654.814],[48.095,555.391],[48.095,645.671]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4487,662.324],[70.4487,760.361],[48.095,652.587],[48.095,742.867]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4487,770.774],[70.4487,868.811],[48.095,752.457],[48.095,842.738]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4479,447.14],[70.4479,349.103],[192.491,449.196],[192.491,353.348]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4479,552.652],[70.4479,454.615],[192.491,552.353],[192.491,456.504]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4479,559.079],[70.4479,657.116],[192.491,558.636],[192.491,654.485]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4479,664.626],[70.4479,762.662],[192.491,661.827],[192.491,757.675]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[70.4479,773.076],[70.4479,871.113],[192.491,767.857],[192.491,863.705]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.527,448.298],[196.527,351.493],[192.49,449.196],[192.49,353.348]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.527,552.484],[196.527,455.679],[192.49,552.353],[192.49,456.504]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.527,558.83],[196.527,655.635],[192.49,558.636],[192.49,654.485]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.527,663.05],[196.527,759.855],[192.49,661.827],[192.49,757.675]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.527,770.138],[196.527,866.943],[192.49,767.857],[192.49,863.705]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.528,448.298],[196.528,351.493],[347.385,450.867],[347.385,356.796]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.528,552.484],[196.528,455.679],[347.385,552.11],[347.385,458.039]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.528,558.83],[196.528,655.635],[347.385,558.277],[347.385,652.348]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.528,663.05],[196.528,759.855],[347.385,659.554],[347.385,753.624]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[196.528,770.138],[196.528,866.943],[347.385,763.617],[347.385,857.688]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[341.824,451.745],[341.824,358.609],[451.633,453.594],[451.633,362.427]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[341.824,551.982],[341.824,458.846],[451.633,551.713],[451.633,460.546]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[341.824,558.088],[341.824,651.224],[451.633,557.69],[451.633,648.857]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[341.824,658.358],[341.824,751.494],[451.633,655.841],[451.633,747.008]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[341.824,761.387],[341.824,854.523],[451.633,756.692],[451.633,847.86]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[450.563,454.282],[450.563,363.098],[555.448,456.034],[555.448,366.73]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[450.563,552.419],[450.563,461.235],[555.448,552.148],[555.448,462.843]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[450.563,656.566],[450.563,747.75],[555.448,654.147],[555.448,743.452]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[450.563,757.436],[450.563,848.621],[555.448,752.938],[555.448,842.242]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[450.563,558.397],[450.563,649.581],[555.448,558.002],[555.448,647.307]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,455.233],[562.834,365.07],[555.449,456.034],[555.449,366.73]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,552.272],[562.834,462.108],[555.449,552.148],[555.449,462.843]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,558.183],[562.834,648.346],[555.449,558.002],[555.449,647.307]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,655.253],[562.834,745.417],[555.449,654.147],[555.449,743.452]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,754.994],[562.834,845.158],[555.449,752.938],[555.449,842.242]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,455.233],[562.834,365.07],[693.96,457.448],[693.96,369.661]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,552.272],[562.834,462.108],[693.96,551.929],[693.96,464.141]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,558.183],[562.834,648.346],[693.96,557.684],[693.96,645.471]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,655.253],[562.834,745.417],[693.96,652.195],[693.96,739.983]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[562.834,754.994],[562.834,845.158],[693.96,749.308],[693.96,837.095]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[685.835,458.182],[685.835,371.182],[782.19,459.792],[782.19,374.519]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[685.835,551.815],[685.835,464.815],[782.19,551.565],[782.19,466.293]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[685.835,557.518],[685.835,644.518],[782.19,557.156],[782.19,642.428]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[685.835,651.183],[685.835,738.183],[782.19,648.96],[782.19,734.232]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[685.835,747.424],[685.835,834.424],[782.19,743.29],[782.19,828.562]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.445,462.186],[922.445,379.483],[881.078,464.996],[881.078,385.309]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.445,551.194],[922.445,468.492],[881.078,550.759],[881.078,471.072]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.445,556.616],[922.445,639.319],[881.078,555.983],[881.078,635.67]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.445,645.654],[922.445,728.357],[881.078,641.774],[881.078,721.462]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.445,737.142],[922.445,819.844],[881.078,729.926],[881.078,809.614]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.694,462.168],[922.694,379.446],[1009.93,463.625],[1009.93,382.467]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.694,551.197],[922.694,468.475],[1009.93,550.971],[1009.93,469.813]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.694,556.62],[922.694,639.342],[1009.93,556.292],[1009.93,637.45]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.694,645.679],[922.694,728.4],[1009.93,643.667],[1009.93,724.825]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[922.694,737.188],[922.694,819.909],[1009.93,733.446],[1009.93,814.604]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,462.964],[1020.61,381.097],[1009.93,463.625],[1009.93,382.467]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,551.074],[1020.61,469.207],[1009.93,550.971],[1009.93,469.813]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,556.441],[1020.61,638.308],[1009.93,556.292],[1009.93,637.45]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,644.579],[1020.61,726.446],[1009.93,643.667],[1009.93,724.825]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,735.142],[1020.61,817.01],[1009.93,733.446],[1009.93,814.604]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,462.964],[1020.61,381.097],[1128.98,464.795],[1128.98,384.891]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,551.074],[1020.61,469.207],[1128.98,550.79],[1128.98,470.887]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,556.441],[1020.61,638.308],[1128.98,556.028],[1128.98,635.932]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,644.579],[1020.61,726.446],[1128.98,642.052],[1128.98,721.956]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1020.61,735.143],[1020.61,817.01],[1128.98,730.443],[1128.98,810.346]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1118.02,641.212],[1118.02,720.463],[1198.12,639.365],[1198.12,717.179]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1118.02,728.881],[1118.02,808.132],[1198.12,725.445],[1198.12,803.259]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1118.02,465.403],[1118.02,386.152],[1198.12,466.741],[1198.12,388.927]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1118.02,550.696],[1118.02,471.445],[1198.12,550.488],[1198.12,472.674]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1118.02,555.891],[1118.02,635.142],[1198.12,555.59],[1198.12,633.404]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1195.65,725.481],[1195.65,803.31],[1272.3,722.194],[1272.3,798.649]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1195.65,466.727],[1195.65,388.898],[1272.3,468.007],[1272.3,391.552]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1195.65,550.491],[1195.65,472.661],[1272.3,550.292],[1272.3,473.837]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1195.65,555.593],[1195.65,633.422],[1272.3,555.305],[1272.3,631.76]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1195.65,639.384],[1195.65,717.213],[1272.3,637.617],[1272.3,714.072]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,467.421],[1284.51,390.337],[1272.3,468.007],[1272.3,391.552]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,550.383],[1284.51,473.299],[1272.3,550.292],[1272.3,473.837]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,555.437],[1284.51,632.521],[1272.3,555.305],[1272.3,631.76]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,638.426],[1284.51,715.51],[1272.3,637.617],[1272.3,714.072]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,723.698],[1284.51,800.783],[1272.3,722.194],[1272.3,798.649]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,467.421],[1284.51,390.337],[1380.72,469.046],[1380.72,393.705]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,550.383],[1284.51,473.299],[1380.72,550.131],[1380.72,474.79]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,555.437],[1284.51,632.521],[1380.72,555.07],[1380.72,630.411]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,638.426],[1284.51,715.51],[1380.72,636.182],[1380.72,711.523]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1284.51,723.698],[1284.51,800.783],[1380.72,719.526],[1380.72,794.867]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1368.44,718.137],[1368.44,792.897],[1439.79,715.076],[1439.79,788.557]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1368.44,635.436],[1368.44,710.196],[1439.79,633.79],[1439.79,707.27]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1368.44,469.587],[1368.44,394.827],[1439.79,470.779],[1439.79,397.298]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1368.44,550.048],[1368.44,475.287],[1439.79,549.863],[1439.79,476.382]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1368.44,554.949],[1368.44,629.709],[1439.79,554.68],[1439.79,628.161]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1440.71,468.527],[1440.71,395.089],[1506.82,469.669],[1506.82,397.415]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1440.71,547.566],[1440.71,474.127],[1506.82,547.431],[1506.82,475.178]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1440.71,552.38],[1440.71,625.819],[1506.82,552.168],[1506.82,624.422]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1440.71,631.444],[1440.71,704.883],[1506.82,629.957],[1506.82,702.21]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1440.71,712.684],[1440.71,786.123],[1506.82,709.886],[1506.82,782.139]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,469.128],[1520.18,396.313],[1506.82,469.669],[1506.82,397.415]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,547.495],[1520.18,474.68],[1506.82,547.431],[1506.82,475.178]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,552.269],[1520.18,625.084],[1506.82,552.168],[1506.82,624.422]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,630.662],[1520.18,703.477],[1506.82,629.957],[1506.82,702.21]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,711.211],[1520.18,784.027],[1506.82,709.886],[1506.82,782.139]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,469.128],[1520.18,396.313],[1606.13,470.628],[1606.13,399.371]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,547.495],[1520.18,474.68],[1606.13,547.319],[1606.13,476.061]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,552.269],[1520.18,625.084],[1606.13,551.99],[1606.13,623.247]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,630.662],[1520.18,703.477],[1606.13,628.706],[1606.13,699.963]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1520.18,711.211],[1520.18,784.027],[1606.13,707.533],[1606.13,778.79]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1592.88,471.129],[1592.88,400.391],[1656.81,472.233],[1656.81,402.641]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1592.88,547.26],[1592.88,476.522],[1656.81,547.13],[1656.81,477.539]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1592.88,551.897],[1592.88,622.635],[1656.81,551.692],[1656.81,621.284]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1592.88,628.054],[1592.88,698.792],[1656.81,626.615],[1656.81,696.206]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:14,
                    verts:[[1592.88,706.306],[1592.88,777.043],[1656.81,703.598],[1656.81,773.19]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[40.4677,451.037],[40.4677,359.437],[4.43177,457.315],[4.43177,372.233]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[40.4677,549.621],[40.4677,458.021],[4.43177,548.884],[4.43177,463.802]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[40.4677,555.627],[40.4677,647.227],[4.43177,554.461],[4.43177,639.543]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[40.4677,654.243],[40.4677,745.844],[4.43177,646.061],[4.43177,731.143]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[40.4677,755.574],[40.4677,847.174],[4.43177,740.18],[4.43177,825.262]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5181,441.273],[96.5181,339.535],[52.4115,448.957],[52.4115,355.196]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5181,550.769],[96.5181,449.03],[52.4115,549.866],[52.4115,456.105]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5181,557.439],[96.5181,659.178],[52.4115,556.013],[52.4115,649.773]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5181,666.971],[96.5181,768.71],[52.4115,656.955],[52.4115,750.716]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5181,779.517],[96.5181,881.255],[52.4115,760.676],[52.4115,854.436]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5173,443.662],[96.5173,341.923],[220.382,446.222],[220.382,347.207]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5173,553.158],[96.5173,451.419],[220.382,552.786],[220.382,453.771]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5173,559.828],[96.5173,661.566],[220.382,559.277],[220.382,658.291]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5173,669.36],[96.5173,771.098],[220.382,665.876],[220.382,764.89]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[96.5173,781.906],[96.5173,883.644],[220.382,775.408],[220.382,874.422]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.132,445.307],[227.132,345.318],[220.382,446.222],[220.382,347.207]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.132,552.919],[227.132,452.93],[220.382,552.786],[220.382,453.771]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.132,559.474],[227.132,659.462],[220.382,559.277],[220.382,658.291]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.132,667.121],[227.132,767.11],[220.382,665.876],[220.382,764.89]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.132,777.731],[227.132,877.719],[220.382,775.408],[220.382,874.422]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.133,445.307],[227.133,345.318],[378.557,448.471],[378.557,351.851]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.133,552.919],[227.133,452.93],[378.557,552.458],[378.557,455.838]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.133,559.474],[227.133,659.462],[378.557,558.792],[378.557,655.413]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.133,667.121],[227.133,767.11],[378.557,662.814],[378.557,759.434]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[227.133,777.731],[227.133,877.719],[378.557,769.698],[378.557,866.318]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[370.328,449.356],[370.328,353.677],[479.598,451.613],[479.598,358.337]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[370.328,552.33],[370.328,456.651],[479.598,552.001],[479.598,458.725]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[370.328,558.602],[370.328,654.281],[479.598,558.116],[479.598,651.393]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[370.328,661.61],[370.328,757.289],[479.598,658.538],[479.598,751.814]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[370.328,767.452],[370.328,863.131],[479.598,761.722],[479.598,854.999]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[478.532,452.313],[478.532,359.016],[582.085,454.435],[582.085,363.414]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[478.532,558.841],[478.532,652.138],[582.085,558.363],[582.085,649.383]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[478.532,659.284],[478.532,752.582],[582.085,656.356],[582.085,747.376]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[478.532,762.492],[478.532,855.789],[582.085,757.045],[582.085,848.066]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[478.532,552.724],[478.532,459.427],[582.085,552.395],[582.085,461.375]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,453.641],[591.892,361.769],[582.086,454.435],[582.086,363.414]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,552.518],[591.892,460.646],[582.086,552.395],[582.086,461.375]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,558.541],[591.892,650.414],[582.086,558.363],[582.086,649.383]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,657.451],[591.892,749.324],[582.086,656.356],[582.086,747.376]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,759.083],[591.892,850.955],[582.086,757.045],[582.086,848.065]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,453.641],[591.892,361.769],[720.086,456.298],[720.086,367.277]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,552.518],[591.892,460.646],[720.086,552.107],[720.086,463.086]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,558.541],[591.892,650.414],[720.086,557.943],[720.086,646.964]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,657.451],[591.892,749.324],[720.086,653.783],[720.086,742.804]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[591.892,759.083],[591.892,850.955],[720.086,752.26],[720.086,841.281]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[709.789,457.018],[709.789,368.77],[803.318,458.935],[803.318,372.744]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[709.789,551.995],[709.789,463.747],[803.318,551.698],[803.318,465.507]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[709.789,557.78],[709.789,646.029],[803.318,557.349],[803.318,643.54]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[709.789,652.789],[709.789,741.037],[803.318,650.142],[803.318,736.333]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[709.789,750.411],[709.789,838.659],[803.318,745.489],[803.318,831.68]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.148,461.753],[938.148,378.585],[888.941,464.468],[888.941,384.215]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.148,551.261],[938.148,468.094],[888.941,550.841],[888.941,470.587]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.148,556.714],[938.148,639.882],[888.941,556.102],[888.941,636.355]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.148,646.252],[938.148,729.42],[888.941,642.503],[888.941,722.756]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.148,738.255],[938.148,821.422],[888.941,731.281],[888.941,811.534]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.447,461.735],[938.447,378.549],[1021.71,463.441],[1021.71,382.085]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.447,551.264],[938.447,468.078],[1021.71,551],[1021.71,469.644]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.447,556.718],[938.447,639.904],[1021.71,556.333],[1021.71,637.689]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.447,646.276],[938.447,729.463],[1021.71,643.921],[1021.71,725.277]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[938.447,738.299],[938.447,821.485],[1021.71,733.919],[1021.71,815.275]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,462.807],[1034.14,380.772],[1021.71,463.441],[1021.71,382.085]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,551.098],[1034.14,469.062],[1021.71,551],[1021.71,469.644]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,556.476],[1034.14,638.512],[1021.71,556.333],[1021.71,637.689]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,644.796],[1034.14,726.831],[1021.71,643.921],[1021.71,725.277]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,735.546],[1034.14,817.581],[1021.71,733.919],[1021.71,815.275]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,462.807],[1034.14,380.772],[1136.69,464.933],[1136.69,385.178]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,551.098],[1034.14,469.062],[1136.69,550.769],[1136.69,471.014]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,556.476],[1034.14,638.512],[1136.69,555.997],[1136.69,635.752]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,644.796],[1034.14,726.831],[1136.69,641.861],[1136.69,721.616]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1034.14,735.546],[1034.14,817.581],[1136.69,730.088],[1136.69,809.842]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1124.21,641.062],[1124.21,720.196],[1199.6,638.929],[1199.6,716.405]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1124.21,728.602],[1124.21,807.736],[1199.6,724.635],[1199.6,802.11]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1124.21,465.512],[1124.21,386.378],[1199.6,467.057],[1199.6,389.581]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1124.21,550.679],[1124.21,471.545],[1199.6,550.44],[1199.6,472.964]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1124.21,555.867],[1124.21,635.001],[1199.6,555.519],[1199.6,632.994]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1197.21,467.036],[1197.21,389.539],[1268.96,468.506],[1268.96,392.586]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1197.21,550.443],[1197.21,472.945],[1268.96,550.215],[1268.96,474.295]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1197.21,555.523],[1197.21,633.021],[1268.96,555.192],[1268.96,631.112]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1197.21,638.957],[1197.21,716.455],[1268.96,636.928],[1268.96,712.848]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1197.21,724.687],[1197.21,802.184],[1268.96,720.913],[1268.96,796.833]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,467.955],[1282.48,391.443],[1268.96,468.506],[1268.96,392.586]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,550.3],[1282.48,473.789],[1268.96,550.215],[1268.96,474.295]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,555.316],[1282.48,631.828],[1268.96,555.192],[1268.96,631.112]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,637.689],[1282.48,714.201],[1268.96,636.928],[1268.96,712.848]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,722.328],[1282.48,798.84],[1268.96,720.913],[1268.96,796.833]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,467.955],[1282.48,391.443],[1371.85,469.807],[1371.85,395.283]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,550.3],[1282.48,473.789],[1371.85,550.013],[1371.85,475.489]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,555.316],[1282.48,631.828],[1371.85,554.899],[1371.85,629.423]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,637.689],[1282.48,714.201],[1371.85,635.131],[1371.85,709.655]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1282.48,722.328],[1282.48,798.84],[1371.85,717.571],[1371.85,792.095]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1358.48,716.274],[1358.48,790.255],[1424.46,712.801],[1424.46,785.332]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1358.48,554.785],[1358.48,628.767],[1424.46,554.48],[1424.46,627.011]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1358.48,470.313],[1358.48,396.331],[1424.46,471.665],[1424.46,399.135]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1358.48,549.935],[1358.48,475.954],[1424.46,549.726],[1424.46,477.195]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1358.48,634.434],[1358.48,708.415],[1424.46,632.567],[1424.46,705.097]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1425.24,469.445],[1425.24,396.958],[1486.08,470.733],[1486.08,399.584]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1425.24,547.458],[1425.24,474.971],[1486.08,547.306],[1486.08,476.157]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1425.24,552.21],[1425.24,624.696],[1486.08,551.971],[1486.08,623.12]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1425.24,630.249],[1425.24,702.735],[1486.08,628.57],[1486.08,699.719]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1425.24,710.435],[1425.24,782.921],[1486.08,707.276],[1486.08,778.425]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,470.232],[1500.33,398.564],[1486.08,470.733],[1486.08,399.584]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,547.365],[1500.33,475.697],[1486.08,547.306],[1486.08,476.157]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,552.064],[1500.33,623.732],[1486.08,551.971],[1486.08,623.12]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,629.222],[1500.33,700.89],[1486.08,628.57],[1486.08,699.719]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,708.503],[1500.33,780.171],[1486.08,707.276],[1486.08,778.425]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,470.232],[1500.33,398.564],[1578.87,471.915],[1578.87,401.994]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,547.365],[1500.33,475.697],[1578.87,547.167],[1578.87,477.246]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,552.064],[1500.33,623.732],[1578.87,551.751],[1578.87,621.672]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,629.222],[1500.33,700.89],[1578.87,627.029],[1578.87,696.95]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1500.33,708.503],[1500.33,780.171],[1578.87,704.377],[1578.87,774.298]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1564.9,472.375],[1564.9,402.931],[1623.1,473.608],[1623.1,405.444]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1564.9,547.113],[1564.9,477.67],[1623.1,546.968],[1623.1,478.805]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1564.9,551.666],[1564.9,621.109],[1623.1,551.437],[1623.1,619.6]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1564.9,626.429],[1564.9,695.872],[1623.1,624.822],[1623.1,692.985]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:15,
                    verts:[[1564.9,703.249],[1564.9,772.693],[1623.1,700.226],[1623.1,768.389]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[46.096,447.498],[46.096,352.222],[-9.68358,453.921],[-9.68358,365.314]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[46.096,550.037],[46.096,454.762],[-9.68358,549.283],[-9.68358,460.676]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[46.096,556.284],[46.096,651.559],[-9.68358,555.091],[-9.68358,643.697]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[46.096,658.857],[46.096,754.133],[-9.68358,650.485],[-9.68358,739.091]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[46.096,764.253],[46.096,859.529],[-9.68358,748.503],[-9.68358,837.109]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.581,437.539],[132.581,331.923],[64.5529,445.372],[64.5529,347.89]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.581,551.208],[132.581,445.592],[64.5529,550.287],[64.5529,452.805]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.581,558.132],[132.581,663.748],[64.5529,556.678],[64.5529,654.16]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.581,671.839],[132.581,777.455],[64.5529,661.628],[64.5529,759.11]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.581,788.674],[132.581,894.29],[64.5529,769.465],[64.5529,866.947]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.58,440.019],[132.58,334.403],[256.844,443.13],[256.844,340.826]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.58,553.688],[132.58,448.072],[256.844,553.235],[256.844,450.931]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.58,560.612],[132.58,666.228],[256.844,559.942],[256.844,662.247]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.58,674.318],[132.58,779.935],[256.844,670.083],[256.844,772.388]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[132.58,791.154],[132.58,896.77],[256.844,783.255],[256.844,885.559]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.514,442.208],[266.514,338.922],[256.844,443.13],[256.844,340.826]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.514,553.369],[266.514,450.083],[256.844,553.235],[256.844,450.931]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.514,560.141],[266.514,663.427],[256.844,559.942],[256.844,662.247]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.514,671.339],[266.514,774.625],[256.844,670.083],[256.844,772.388]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.514,785.597],[266.514,888.883],[256.844,783.255],[256.844,885.56]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.515,442.208],[266.515,338.922],[416.658,446.013],[416.658,346.777]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.515,553.369],[266.515,450.083],[416.658,552.816],[416.658,453.58]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.515,560.141],[266.515,663.427],[416.658,559.322],[416.658,658.558]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.515,671.339],[266.515,774.625],[416.658,666.16],[416.658,765.396]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[266.515,785.597],[266.515,888.883],[416.658,775.937],[416.658,875.174]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[405.619,446.895],[405.619,348.597],[513.053,449.584],[513.053,354.148]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[405.619,552.688],[405.619,454.39],[513.053,552.296],[513.053,456.86]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[405.619,559.132],[405.619,657.43],[513.053,558.553],[513.053,653.989]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[405.619,664.959],[405.619,763.257],[513.053,661.299],[513.053,756.735]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[405.619,773.699],[405.619,871.997],[513.053,766.873],[513.053,862.309]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[512.002,450.297],[512.002,354.836],[613.01,452.804],[613.01,360.034]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[512.002,553.037],[512.002,457.575],[613.01,552.648],[613.01,459.878]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[512.002,559.295],[512.002,654.756],[613.01,558.73],[613.01,651.5]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[512.002,662.068],[512.002,757.53],[613.01,658.607],[613.01,751.377]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[512.002,767.67],[512.002,863.131],[613.01,761.231],[613.01,854.002]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,452.026],[625.293,358.42],[613.012,452.804],[613.012,360.034]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,552.769],[625.293,459.163],[613.012,552.648],[613.012,459.878]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,558.905],[625.293,652.511],[613.012,558.73],[613.012,651.5]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,659.681],[625.293,753.287],[613.012,658.607],[613.012,751.377]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,763.23],[625.293,856.836],[613.012,761.231],[613.012,854.002]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,452.026],[625.293,358.42],[749.069,455.137],[749.069,364.87]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,552.769],[625.293,459.163],[749.069,552.287],[749.069,462.019]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,558.905],[625.293,652.511],[749.069,558.204],[749.069,648.471]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,659.681],[625.293,753.287],[749.069,655.386],[749.069,745.653]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[625.293,763.23],[625.293,856.836],[749.069,755.242],[749.069,845.509]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[736.594,455.837],[736.594,366.32],[826.292,458.064],[826.292,370.938]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[736.594,552.178],[736.594,462.662],[826.292,551.833],[826.292,464.707]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[736.594,558.047],[736.594,647.563],[826.292,557.545],[826.292,644.671]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[736.594,654.42],[736.594,743.936],[826.292,651.345],[826.292,738.47]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[736.594,753.445],[736.594,842.961],[826.292,747.725],[826.292,834.851]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.359,739.409],[954.359,823.06],[897.487,732.733],[897.487,813.594]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.359,461.303],[954.359,377.652],[897.487,463.903],[897.487,383.042]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.359,551.331],[954.359,467.681],[897.487,550.928],[897.487,470.068]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.359,556.815],[954.359,640.466],[897.487,556.229],[897.487,637.09]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.359,646.873],[954.359,730.524],[897.487,643.284],[897.487,724.144]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.706,461.286],[954.706,377.618],[1033.24,463.236],[1033.24,381.66]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.706,551.334],[954.706,467.666],[1033.24,551.032],[1033.24,469.456]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.706,556.819],[954.706,640.487],[1033.24,556.38],[1033.24,637.956]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.706,646.896],[954.706,730.564],[1033.24,644.204],[1033.24,725.78]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[954.706,739.452],[954.706,823.12],[1033.24,734.446],[1033.24,816.022]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,462.634],[1047.36,380.413],[1033.25,463.236],[1033.25,381.66]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,551.125],[1047.36,468.904],[1033.25,551.032],[1033.25,469.456]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,556.515],[1047.36,638.736],[1033.25,556.38],[1033.25,637.956]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,645.035],[1047.36,727.256],[1033.25,644.204],[1033.25,725.78]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,735.99],[1047.36,818.211],[1033.25,734.446],[1033.25,816.022]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,462.634],[1047.36,380.413],[1143.27,465.045],[1143.27,385.411]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,551.125],[1047.36,468.904],[1143.27,550.751],[1143.27,471.117]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,556.515],[1047.36,638.736],[1143.27,555.972],[1143.27,635.606]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,645.035],[1047.36,727.256],[1143.27,641.706],[1143.27,721.34]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1047.36,735.99],[1047.36,818.211],[1143.27,729.799],[1143.27,809.433]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1129.36,640.953],[1129.36,720.003],[1199.53,638.548],[1199.53,715.727]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1129.36,728.399],[1129.36,807.449],[1199.53,723.925],[1199.53,801.104]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1129.36,465.59],[1129.36,386.541],[1199.53,467.333],[1199.53,390.154]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1129.36,550.667],[1129.36,471.618],[1199.53,550.397],[1199.53,473.218]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1129.36,555.849],[1129.36,634.898],[1199.53,555.456],[1199.53,632.636]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1197.23,467.307],[1197.23,390.099],[1263.67,468.956],[1263.67,393.518]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1197.23,550.401],[1197.23,473.193],[1263.67,550.145],[1263.67,474.707]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1197.23,555.462],[1197.23,632.67],[1263.67,555.091],[1263.67,630.529]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1197.23,638.584],[1197.23,715.792],[1263.67,636.307],[1263.67,711.745]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1197.23,723.993],[1197.23,801.201],[1263.67,719.759],[1263.67,795.197]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,468.442],[1278.39,392.452],[1263.67,468.956],[1263.67,393.518]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,550.225],[1278.39,474.236],[1263.67,550.145],[1263.67,474.707]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,555.207],[1278.39,631.196],[1263.67,555.091],[1263.67,630.529]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,637.017],[1278.39,713.006],[1263.67,636.307],[1263.67,711.745]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,721.078],[1278.39,797.068],[1263.67,719.759],[1263.67,795.197]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,468.442],[1278.39,392.452],[1360.52,470.506],[1360.52,396.731]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,550.225],[1278.39,474.236],[1360.52,549.905],[1360.52,476.131]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,555.207],[1278.39,631.196],[1360.52,554.742],[1360.52,628.516]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,637.017],[1278.39,713.006],[1360.52,634.167],[1360.52,707.941]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1278.39,721.078],[1278.39,797.068],[1360.52,715.778],[1360.52,789.552]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1346.14,554.636],[1346.14,627.908],[1406.53,554.298],[1406.53,625.961]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1346.14,714.576],[1346.14,787.848],[1406.53,710.725],[1406.53,782.388]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1346.14,470.974],[1346.14,397.702],[1406.53,472.474],[1406.53,400.811]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1346.14,549.833],[1346.14,476.561],[1406.53,549.6],[1406.53,477.938]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1346.14,633.521],[1346.14,706.793],[1406.53,631.45],[1406.53,703.113]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1407.18,470.282],[1407.18,398.665],[1462.6,471.704],[1462.6,401.563]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1407.18,547.359],[1407.18,475.742],[1462.6,547.192],[1462.6,477.052]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1407.18,552.054],[1407.18,623.672],[1462.6,551.791],[1462.6,621.931]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1407.18,629.157],[1407.18,700.775],[1462.6,627.304],[1462.6,697.445]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1407.18,708.382],[1407.18,779.999],[1462.6,704.895],[1462.6,775.036]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,471.245],[1477.64,400.627],[1462.6,471.704],[1462.6,401.563]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,547.246],[1477.64,476.629],[1462.6,547.192],[1462.6,477.052]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,551.876],[1477.64,622.493],[1462.6,551.791],[1462.6,621.931]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,627.902],[1477.64,698.52],[1462.6,627.304],[1462.6,697.445]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,706.021],[1477.64,776.638],[1462.6,704.895],[1462.6,775.036]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,471.245],[1477.64,400.627],[1548.7,473.091],[1548.7,404.391]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,547.246],[1477.64,476.629],[1548.7,547.029],[1548.7,478.329]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,551.876],[1477.64,622.493],[1548.7,551.533],[1548.7,620.233]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,627.902],[1477.64,698.52],[1548.7,625.496],[1548.7,694.196]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1477.64,706.021],[1477.64,776.638],[1548.7,701.494],[1548.7,770.194]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1534.12,473.51],[1534.12,405.246],[1586.61,474.858],[1586.61,407.992]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1534.12,546.98],[1534.12,478.715],[1586.61,546.821],[1586.61,479.956]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1534.12,551.455],[1534.12,619.72],[1586.61,551.205],[1586.61,618.07]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1534.12,624.949],[1534.12,693.213],[1586.61,623.192],[1586.61,690.058]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:16,
                    verts:[[1534.12,700.465],[1534.12,768.729],[1586.61,697.161],[1586.61,764.026]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[60.287,443.73],[60.287,344.542],[-17.284,450.24],[-17.284,357.812]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[60.287,550.48],[60.287,451.292],[-17.284,549.715],[-17.284,457.287]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[60.287,556.983],[60.287,656.171],[-17.284,555.774],[-17.284,648.203]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[60.287,663.769],[60.287,762.957],[-17.284,655.283],[-17.284,747.711]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[60.287,773.493],[60.287,872.681],[-17.284,757.529],[-17.284,849.957]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,433.687],[179.951,324.07],[85.8859,441.581],[85.8859,340.162]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,551.661],[179.951,442.045],[85.8859,550.733],[85.8859,449.314]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,558.847],[179.951,668.463],[85.8859,557.382],[85.8859,658.801]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,676.86],[179.951,786.477],[85.8859,666.569],[85.8859,767.988]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,798.12],[179.951,907.737],[85.8859,778.761],[85.8859,880.18]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,436.26],[179.951,326.644],[302.822,439.969],[302.822,334.3]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,554.235],[179.951,444.618],[302.822,553.695],[302.822,448.026]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,561.421],[179.951,671.037],[302.822,560.622],[302.822,666.291]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,679.434],[179.951,789.05],[302.822,674.386],[302.822,780.055]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[179.951,800.694],[179.951,910.31],[302.822,791.279],[302.822,896.948]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,439.051],[315.592,332.405],[302.821,439.969],[302.821,334.3]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,553.829],[315.592,447.182],[302.821,553.695],[302.821,448.026]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,560.82],[315.592,667.466],[302.821,560.622],[302.821,666.291]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,675.636],[315.592,782.282],[302.821,674.386],[302.821,780.055]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,793.61],[315.592,900.257],[302.821,791.279],[302.821,896.948]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,439.051],[315.592,332.405],[462.236,443.536],[462.236,341.663]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,553.829],[315.592,447.182],[462.236,553.176],[462.236,451.303]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,560.82],[315.592,667.466],[462.236,559.855],[462.236,661.728]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,675.636],[315.592,782.282],[462.236,669.531],[462.236,771.404]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[315.592,793.61],[315.592,900.257],[462.236,782.226],[462.236,884.099]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[448.275,444.403],[448.275,343.454],[552.36,447.544],[552.36,349.937]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[448.275,553.05],[448.275,452.1],[552.36,552.593],[552.36,454.986]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[448.275,559.668],[448.275,660.618],[552.36,558.992],[552.36,656.599]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[448.275,668.35],[448.275,769.3],[552.36,664.076],[552.36,761.683]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[448.275,780.023],[448.275,880.973],[552.36,772.051],[552.36,869.658]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[551.339,448.27],[551.339,350.633],[648.43,451.175],[648.43,356.656]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[551.339,553.351],[551.339,455.714],[648.43,552.901],[648.43,458.381]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[551.339,772.876],[551.339,870.512],[648.43,765.416],[648.43,859.935]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[551.339,559.752],[551.339,657.388],[648.43,559.097],[648.43,653.616]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[551.339,664.867],[551.339,762.504],[648.43,660.856],[648.43,755.375]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,450.421],[663.208,355.093],[648.431,451.175],[648.431,356.656]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,553.017],[663.208,457.689],[648.431,552.901],[648.431,458.382]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,559.267],[663.208,654.595],[648.431,559.097],[648.431,653.616]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,661.897],[663.208,757.225],[648.431,660.856],[648.431,755.375]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,767.351],[663.208,862.68],[648.431,765.416],[648.431,859.935]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,450.421],[663.208,355.093],[780.939,453.992],[780.939,362.496]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,553.017],[663.208,457.689],[780.939,552.464],[780.939,460.968]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,559.267],[663.208,654.595],[780.939,558.462],[780.939,649.958]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,661.897],[663.208,757.225],[780.939,656.967],[780.939,748.463]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[663.208,767.351],[663.208,862.68],[780.939,758.182],[780.939,849.678]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[766.305,454.663],[766.305,363.887],[851.095,457.201],[851.095,369.15]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[766.305,552.36],[766.305,461.584],[851.095,551.967],[851.095,463.915]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[766.305,558.311],[766.305,649.087],[851.095,557.739],[851.095,645.791]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[766.305,656.04],[766.305,746.816],[851.095,652.536],[851.095,740.587]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[766.305,756.458],[766.305,847.234],[851.095,749.941],[851.095,837.992]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.003,460.854],[971.003,376.723],[906.721,463.314],[906.721,381.822]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.003,551.401],[971.003,467.269],[906.721,551.02],[906.721,469.528]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.003,556.916],[971.003,641.048],[906.721,556.362],[906.721,637.854]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.003,647.492],[971.003,731.624],[906.721,644.096],[906.721,725.588]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.003,740.56],[971.003,824.692],[906.721,734.245],[906.721,815.736]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.395,460.839],[971.395,376.691],[1044.46,463.025],[1044.46,381.223]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.395,551.403],[971.395,467.255],[1044.46,551.064],[1044.46,469.262]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.395,556.92],[971.395,641.068],[1044.46,556.427],[1044.46,638.229]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.395,647.514],[971.395,731.662],[1044.46,644.495],[1044.46,726.297]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[971.395,740.601],[971.395,824.749],[1044.46,734.987],[1044.46,816.789]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,462.461],[1060.16,380.054],[1044.46,463.025],[1044.46,381.223]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,551.152],[1060.16,468.744],[1044.46,551.064],[1044.46,469.262]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,556.554],[1060.16,638.962],[1044.46,556.427],[1044.46,638.229]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,645.274],[1060.16,727.681],[1044.46,644.495],[1044.46,726.297]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,736.435],[1060.16,818.842],[1044.46,734.987],[1044.46,816.789]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,462.461],[1060.16,380.054],[1148.62,465.144],[1148.62,385.616]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,551.152],[1060.16,468.744],[1148.62,550.736],[1148.62,471.208]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,556.554],[1060.16,638.962],[1148.62,555.95],[1148.62,635.478]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,645.274],[1060.16,727.682],[1148.62,641.57],[1148.62,721.098]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1060.16,736.435],[1060.16,818.843],[1148.62,729.545],[1148.62,809.073]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1133.37,728.242],[1133.37,807.225],[1197.82,723.288],[1197.82,800.201]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1133.37,465.652],[1133.37,386.669],[1197.82,467.581],[1197.82,390.668]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1133.37,550.657],[1133.37,471.674],[1197.82,550.358],[1197.82,473.445]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1133.37,555.835],[1133.37,634.818],[1197.82,555.401],[1197.82,632.313]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1133.37,640.869],[1133.37,719.852],[1197.82,638.205],[1197.82,715.118]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1195.63,467.549],[1195.63,390.601],[1256.35,469.365],[1256.35,394.367]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1195.63,550.363],[1195.63,473.416],[1256.35,550.082],[1256.35,475.084]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1195.63,555.408],[1195.63,632.356],[1256.35,554.998],[1256.35,629.997]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1195.63,638.25],[1195.63,715.198],[1256.35,635.742],[1256.35,710.74]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1195.63,723.371],[1195.63,800.319],[1256.35,718.706],[1256.35,793.704]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,468.892],[1272.17,393.385],[1256.35,469.365],[1256.35,394.367]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,550.155],[1272.17,474.649],[1256.35,550.082],[1256.35,475.084]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,555.105],[1272.17,630.612],[1256.35,554.998],[1256.35,629.997]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,636.396],[1272.17,711.902],[1256.35,635.742],[1256.35,710.74]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,719.923],[1272.17,795.43],[1256.35,718.706],[1256.35,793.704]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,468.892],[1272.17,393.385],[1346.66,471.151],[1346.66,398.069]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,550.155],[1272.17,474.649],[1346.66,549.805],[1346.66,476.723]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,555.105],[1272.17,630.612],[1346.66,554.596],[1346.66,627.678]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,636.396],[1272.17,711.902],[1346.66,633.277],[1346.66,706.359]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1272.17,719.923],[1272.17,795.43],[1346.66,714.122],[1346.66,787.204]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1331.39,713.02],[1331.39,785.642],[1385.98,708.824],[1385.98,779.692]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1331.39,471.58],[1331.39,398.958],[1385.98,473.214],[1385.98,402.346]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1331.39,549.739],[1331.39,477.117],[1385.98,549.485],[1385.98,478.617]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1331.39,554.5],[1331.39,627.122],[1385.98,554.131],[1385.98,624.999]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1331.39,632.684],[1331.39,705.306],[1385.98,630.428],[1385.98,701.296]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1386.49,471.048],[1386.49,400.227],[1436.38,472.591],[1436.38,403.372]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1386.49,547.269],[1386.49,476.448],[1436.38,547.088],[1436.38,477.869]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1386.49,551.912],[1386.49,622.733],[1436.38,551.626],[1436.38,620.845]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1386.49,628.158],[1386.49,698.979],[1436.38,626.147],[1436.38,695.366]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1386.49,706.502],[1386.49,777.323],[1436.38,702.719],[1436.38,771.938]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,472.174],[1452.11,402.522],[1436.38,472.591],[1436.38,403.372]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,547.137],[1452.11,477.485],[1436.38,547.088],[1436.38,477.869]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,551.703],[1452.11,621.355],[1436.38,551.626],[1436.38,620.845]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,626.691],[1452.11,696.343],[1436.38,626.147],[1436.38,695.366]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,703.741],[1452.11,773.393],[1436.38,702.719],[1436.38,771.938]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,472.174],[1452.11,402.522],[1515.64,474.166],[1515.64,406.582]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,547.137],[1452.11,477.485],[1515.64,546.903],[1515.64,479.319]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,551.703],[1452.11,621.355],[1515.64,551.333],[1515.64,618.917]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,626.691],[1452.11,696.343],[1515.64,624.094],[1515.64,691.678]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1452.11,703.741],[1452.11,773.393],[1515.64,698.857],[1515.64,766.441]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1500.53,474.545],[1500.53,407.355],[1547.35,475.994],[1547.35,410.308]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1500.53,546.858],[1500.53,479.668],[1547.35,546.688],[1547.35,481.002]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1500.53,551.263],[1500.53,618.453],[1547.35,550.994],[1547.35,616.68]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1500.53,623.6],[1500.53,690.79],[1547.35,621.712],[1547.35,687.398]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:17,
                    verts:[[1500.53,697.927],[1500.53,765.117],[1547.35,694.375],[1547.35,760.061]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[84.5593,439.77],[84.5593,336.471],[-16.8681,446.286],[-16.8681,349.753]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[84.5593,550.946],[84.5593,447.646],[-16.8681,550.18],[-16.8681,453.647]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[84.5593,557.718],[84.5593,661.017],[-16.8681,556.508],[-16.8681,653.042]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[84.5593,668.93],[84.5593,772.229],[-16.8681,660.436],[-16.8681,756.97]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[84.5593,783.202],[84.5593,886.502],[-16.8681,767.224],[-16.8681,863.757]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.9,429.791],[239.9,316.129],[117.904,437.628],[117.904,332.104]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.9,552.119],[239.9,438.457],[117.904,551.198],[117.904,445.674]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.9,559.57],[239.9,673.232],[117.904,558.116],[117.904,663.639]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.9,681.939],[239.9,795.601],[117.904,671.723],[117.904,777.246]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.9,807.674],[239.9,921.336],[117.904,788.456],[117.904,893.979]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.899,432.459],[239.899,318.798],[359.18,436.803],[359.18,327.764]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.899,554.788],[239.899,441.126],[359.18,554.156],[359.18,445.117]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.899,562.239],[239.899,675.901],[359.18,561.304],[359.18,670.343]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.899,684.608],[239.899,798.269],[359.18,678.695],[359.18,787.734]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[239.899,810.343],[239.899,924.005],[359.18,799.317],[359.18,908.355]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,435.904],[375.184,325.908],[359.179,436.803],[359.179,327.764]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,554.286],[375.184,444.291],[359.179,554.156],[359.179,445.117]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,561.498],[375.184,671.493],[359.179,561.304],[359.179,670.343]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,679.919],[375.184,789.915],[359.179,678.695],[359.179,787.734]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,801.6],[375.184,911.595],[359.179,799.317],[359.179,908.355]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,435.904],[375.184,325.908],[515.719,441.096],[515.719,336.626]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,554.286],[375.184,444.291],[515.719,553.531],[515.719,449.061]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,561.498],[375.184,671.493],[515.719,560.38],[515.719,664.85]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,679.919],[375.184,789.915],[515.719,672.852],[515.719,777.322]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[375.184,801.599],[375.184,911.595],[515.719,788.419],[515.719,892.889]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[498.777,441.936],[498.777,338.36],[597.792,445.54],[597.792,345.8]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[498.777,553.409],[498.777,449.833],[597.792,552.885],[597.792,453.145]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[498.777,560.199],[498.777,663.775],[597.792,559.423],[597.792,659.163]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[498.777,671.709],[498.777,775.285],[597.792,666.804],[597.792,766.544]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[498.777,786.287],[498.777,889.863],[597.792,777.138],[597.792,876.878]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[596.816,446.278],[596.816,346.503],[688.462,449.586],[688.462,353.362]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[596.816,560.2],[596.816,659.975],[688.462,559.455],[688.462,655.679]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[596.816,777.99],[596.816,877.765],[688.462,769.495],[688.462,865.72]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[596.816,553.659],[596.816,453.885],[688.462,553.147],[688.462,456.923]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[596.816,667.618],[596.816,767.392],[688.462,663.05],[688.462,759.274]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,448.867],[705.714,351.872],[688.463,449.586],[688.463,353.362]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,553.258],[705.714,456.263],[688.463,553.147],[688.463,456.923]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,559.617],[705.714,656.612],[688.463,559.455],[688.463,655.679]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,664.042],[705.714,761.037],[688.463,663.05],[688.463,759.274]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,771.341],[705.714,868.336],[688.463,769.495],[688.463,865.72]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,448.867],[705.714,351.872],[815.648,452.896],[815.648,360.223]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,553.258],[705.714,456.263],[815.648,552.634],[815.648,459.961]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,559.617],[705.714,656.612],[815.648,558.709],[815.648,651.382]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,664.042],[705.714,761.037],[815.648,658.481],[815.648,751.153]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[705.714,771.341],[705.714,868.336],[815.648,760.997],[815.648,853.67]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[798.912,453.53],[798.912,361.537],[877.66,456.374],[877.66,367.433]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[798.912,552.536],[798.912,460.544],[877.66,552.095],[877.66,463.155]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[798.912,558.567],[798.912,650.559],[877.66,557.926],[877.66,646.866]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[798.912,657.605],[798.912,749.598],[877.66,653.679],[877.66,742.619]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[798.912,759.369],[798.912,851.362],[877.66,752.066],[877.66,841.007]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[987.971,460.428],[987.971,375.838],[916.631,462.721],[916.631,380.593]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[987.971,551.467],[987.971,466.877],[916.631,551.111],[916.631,468.983]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[987.971,557.012],[987.971,641.602],[916.631,556.496],[916.631,638.624]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[987.971,648.081],[987.971,732.671],[916.631,644.915],[916.631,727.043]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[987.971,741.656],[987.971,826.245],[916.631,735.767],[916.631,817.895]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[988.406,460.413],[988.406,375.808],[1055.23,462.825],[1055.23,380.809]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[988.406,551.469],[988.406,466.864],[1055.23,551.095],[1055.23,469.079]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[988.406,557.016],[988.406,641.621],[1055.23,556.472],[1055.23,638.488]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[988.406,648.101],[988.406,732.706],[1055.23,644.771],[1055.23,726.787]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[988.406,741.694],[988.406,826.299],[1055.23,735.499],[1055.23,817.516]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,462.304],[1072.42,379.728],[1055.23,462.826],[1055.23,380.809]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,551.176],[1072.42,468.6],[1055.23,551.095],[1055.23,469.079]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,556.589],[1072.42,639.165],[1055.23,556.472],[1055.23,638.488]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,645.491],[1072.42,728.067],[1055.23,644.771],[1055.23,726.787]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,736.838],[1072.42,819.414],[1055.23,735.499],[1055.23,817.516]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,462.304],[1072.42,379.728],[1152.63,465.243],[1152.63,385.821]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,551.176],[1072.42,468.6],[1152.63,550.721],[1152.63,471.299]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,556.589],[1072.42,639.165],[1152.63,555.927],[1152.63,635.349]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,645.491],[1072.42,728.067],[1152.63,641.433],[1152.63,720.855]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1072.42,736.838],[1072.42,819.414],[1152.63,729.292],[1152.63,808.714]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1136.15,555.822],[1136.15,634.744],[1194.39,555.348],[1194.39,632.013]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1136.15,465.709],[1136.15,386.787],[1194.39,467.812],[1194.39,391.148]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1136.15,550.648],[1136.15,471.727],[1194.39,550.322],[1194.39,473.658]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1136.15,640.79],[1136.15,719.711],[1194.39,637.886],[1194.39,714.551]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1136.15,728.095],[1136.15,807.016],[1194.39,722.694],[1194.39,799.359]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1192.33,467.774],[1192.33,391.068],[1246.94,469.746],[1246.94,395.156]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1192.33,550.328],[1192.33,473.623],[1246.94,550.023],[1246.94,475.433]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1192.33,555.357],[1192.33,632.063],[1246.94,554.913],[1246.94,629.503]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1192.33,637.939],[1192.33,714.644],[1246.94,635.216],[1246.94,709.807]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1192.33,722.792],[1192.33,799.498],[1246.94,717.73],[1246.94,792.32]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,469.315],[1263.75,394.262],[1246.94,469.746],[1246.94,395.156]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,550.09],[1263.75,475.037],[1246.94,550.023],[1246.94,475.433]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,555.01],[1263.75,630.063],[1246.94,554.913],[1246.94,629.503]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,635.812],[1263.75,710.864],[1246.94,635.216],[1246.94,709.807]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,718.837],[1263.75,793.889],[1246.94,717.73],[1246.94,792.32]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,469.315],[1263.75,394.262],[1330.24,471.751],[1330.24,399.313]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,550.09],[1263.75,475.037],[1330.24,549.712],[1330.24,477.274]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,555.01],[1263.75,630.063],[1330.24,554.461],[1330.24,626.899]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,635.812],[1263.75,710.864],[1330.24,632.448],[1330.24,704.886]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1263.75,718.837],[1263.75,793.889],[1330.24,712.581],[1330.24,785.019]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1314.18,711.584],[1314.18,783.606],[1362.8,707.076],[1362.8,777.213]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1314.18,472.139],[1314.18,400.117],[1362.8,473.895],[1362.8,403.757]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1314.18,549.652],[1314.18,477.63],[1362.8,549.38],[1362.8,479.243]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1314.18,554.374],[1314.18,626.395],[1362.8,553.978],[1362.8,624.115]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1314.18,631.912],[1314.18,703.934],[1362.8,629.488],[1362.8,699.625]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1363.18,471.753],[1363.18,401.663],[1407.43,473.404],[1407.43,405.028]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1363.18,547.186],[1363.18,477.097],[1407.43,546.992],[1407.43,478.617]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1363.18,551.781],[1363.18,621.871],[1407.43,551.475],[1407.43,619.85]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1363.18,627.24],[1363.18,697.33],[1407.43,625.088],[1407.43,693.463]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1363.18,704.775],[1363.18,774.865],[1407.43,700.727],[1407.43,769.102]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,473.03],[1423.75,404.266],[1407.43,473.404],[1407.43,405.028]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,547.036],[1423.75,478.272],[1407.43,546.992],[1407.43,478.617]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,551.544],[1423.75,620.308],[1407.43,551.475],[1407.43,619.85]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,625.576],[1423.75,694.34],[1407.43,625.088],[1407.43,693.463]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,701.644],[1423.75,770.408],[1407.43,700.727],[1407.43,769.102]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,473.029],[1423.75,404.266],[1479.72,475.149],[1479.72,408.587]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,547.036],[1423.75,478.272],[1479.72,546.787],[1479.72,480.224]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,551.544],[1423.75,620.308],[1479.72,551.151],[1479.72,617.714]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,625.576],[1423.75,694.34],[1479.72,622.813],[1479.72,689.375]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1423.75,701.644],[1423.75,770.408],[1479.72,696.446],[1479.72,763.009]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1464.17,475.488],[1464.17,409.277],[1505.34,477.025],[1505.34,412.41]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1464.17,546.747],[1464.17,480.536],[1505.34,546.567],[1505.34,481.952]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1464.17,551.088],[1464.17,617.299],[1505.34,550.803],[1505.34,615.418]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1464.17,622.371],[1464.17,688.582],[1505.34,620.367],[1505.34,684.983]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:18,
                    verts:[[1464.17,695.615],[1464.17,761.826],[1505.34,691.846],[1505.34,756.461]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[120.51,435.678],[120.51,328.13],[-6.70835,442.091],[-6.70835,341.201]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[120.51,551.427],[120.51,443.879],[-6.70835,550.673],[-6.70835,449.783]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[120.51,558.477],[120.51,666.026],[-6.70835,557.287],[-6.70835,658.177]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[120.51,674.264],[120.51,781.812],[-6.70835,665.905],[-6.70835,766.795]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[120.51,793.236],[120.51,900.784],[-6.70835,777.512],[-6.70835,878.402]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.475,425.952],[313.475,308.305],[162.122,433.581],[162.122,323.855]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.475,552.57],[313.475,434.923],[162.122,551.673],[162.122,441.947]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.475,560.283],[313.475,677.93],[162.122,558.867],[162.122,668.593]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.475,686.942],[313.475,804.589],[162.122,676.998],[162.122,786.724]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.475,817.086],[313.475,934.734],[162.122,798.379],[162.122,908.105]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.474,428.715],[313.474,311.067],[426.563,433.717],[426.563,321.393]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.474,555.332],[313.474,437.685],[426.563,554.605],[426.563,442.281]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.474,563.045],[313.474,680.692],[426.563,561.968],[426.563,674.292]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.474,689.704],[313.474,807.352],[426.563,682.896],[426.563,795.22]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[313.474,819.849],[313.474,937.496],[426.563,807.152],[426.563,919.476]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,432.854],[445.859,319.612],[426.562,433.716],[426.562,321.393]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,554.73],[445.859,441.488],[426.562,554.605],[426.562,442.281]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,562.154],[445.859,675.396],[426.562,561.968],[426.562,674.292]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,684.071],[445.859,797.313],[426.562,682.896],[426.562,795.22]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,809.342],[445.859,922.583],[426.562,807.152],[426.562,919.476]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,432.854],[445.859,319.612],[577.326,438.764],[577.326,331.812]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,554.73],[445.859,441.488],[577.326,553.87],[577.326,446.919]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,562.154],[445.859,675.396],[577.326,560.882],[577.326,667.834]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,684.07],[445.859,797.312],[577.326,676.026],[577.326,782.978]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[445.859,809.341],[445.859,922.583],[577.326,794.339],[577.326,901.291]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[557.411,439.561],[557.411,333.457],[649.447,443.629],[649.447,341.855]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[557.411,553.755],[557.411,447.651],[649.447,553.163],[649.447,451.389]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[557.411,560.71],[557.411,666.814],[649.447,559.835],[649.447,661.609]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[557.411,674.942],[557.411,781.046],[649.447,669.405],[649.447,771.178]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[557.411,792.317],[557.411,898.421],[649.447,781.989],[649.447,883.763]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[648.534,444.378],[648.534,342.565],[733.087,448.085],[733.087,350.25]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[648.534,553.954],[648.534,452.141],[733.087,553.379],[733.087,455.544]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[648.534,670.24],[648.534,772.053],[733.087,665.122],[733.087,762.957]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[648.534,782.868],[648.534,884.681],[733.087,773.35],[733.087,871.185]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[648.534,560.628],[648.534,662.441],[733.087,559.793],[733.087,657.628]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,447.414],[752.733,348.858],[733.088,448.085],[733.088,350.25]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,553.483],[752.733,454.928],[733.088,553.379],[733.088,455.544]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,559.944],[752.733,658.5],[733.088,559.793],[733.088,657.628]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,666.049],[752.733,764.605],[733.088,665.122],[733.088,762.957]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,775.074],[752.733,873.629],[733.088,773.35],[733.088,871.185]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,447.414],[752.733,348.858],[853.037,451.885],[853.037,358.129]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,553.483],[752.733,454.928],[853.037,552.79],[853.037,459.034]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,559.944],[752.733,658.5],[853.037,558.937],[853.037,652.693]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,666.049],[752.733,764.605],[853.037,659.875],[853.037,753.632]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[752.733,775.074],[752.733,873.629],[853.037,763.591],[853.037,857.347]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[834.301,452.473],[834.301,359.346],[905.838,455.611],[905.838,365.852]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[834.301,552.699],[834.301,459.573],[905.838,552.213],[905.838,462.454]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[834.301,558.805],[834.301,651.931],[905.838,558.098],[905.838,647.856]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[834.301,659.064],[834.301,752.191],[905.838,654.732],[905.838,744.491]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[834.301,762.083],[834.301,855.209],[905.838,754.025],[905.838,843.784]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.11,460.045],[1005.11,375.044],[927.181,462.145],[927.181,379.397]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.11,551.526],[1005.11,466.526],[927.181,551.201],[927.181,468.454]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.11,557.099],[1005.11,642.099],[927.181,556.625],[927.181,639.372]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.11,648.61],[1005.11,733.611],[927.181,645.711],[927.181,728.458]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.11,742.64],[1005.11,827.641],[927.181,737.248],[927.181,819.995]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.59,460.031],[1005.59,375.016],[1065.43,462.655],[1065.43,380.455]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.59,551.528],[1005.59,466.513],[1065.43,551.122],[1065.43,468.922]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.59,557.102],[1005.59,642.117],[1065.43,556.51],[1065.43,638.71]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.59,648.629],[1005.59,733.644],[1065.43,645.007],[1065.43,727.206]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1005.59,742.674],[1005.59,827.689],[1065.43,735.938],[1065.43,818.137]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.98,462.181],[1083.98,379.474],[1065.44,462.655],[1065.44,380.455]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.98,551.195],[1083.98,468.488],[1065.44,551.122],[1065.44,468.922]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.98,556.617],[1083.98,639.325],[1065.44,556.51],[1065.44,638.71]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.98,645.66],[1083.98,728.368],[1065.44,645.006],[1065.44,727.206]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.98,737.153],[1083.98,819.861],[1065.44,735.938],[1065.44,818.137]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.97,462.181],[1083.97,379.474],[1155.17,465.356],[1155.17,386.054]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.97,551.195],[1083.97,468.488],[1155.17,550.703],[1155.17,471.402]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.97,556.617],[1083.97,639.325],[1155.17,555.902],[1155.17,635.203]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.97,645.66],[1083.97,728.368],[1155.17,641.278],[1155.17,720.579]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1083.97,737.153],[1083.97,819.861],[1155.17,729.003],[1155.17,808.304]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1137.59,555.807],[1137.59,634.657],[1189.16,555.298],[1189.16,631.72]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1137.59,465.776],[1137.59,386.926],[1189.16,468.038],[1189.16,391.616]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1137.59,550.638],[1137.59,471.788],[1189.16,550.288],[1189.16,473.865]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1137.59,640.697],[1137.59,719.547],[1189.16,637.574],[1189.16,713.996]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1137.59,727.923],[1137.59,806.772],[1189.16,722.114],[1189.16,798.536]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1187.24,637.634],[1187.24,714.103],[1235.4,634.719],[1235.4,708.922]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1187.24,467.995],[1187.24,391.525],[1235.4,470.106],[1235.4,395.903]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1187.24,550.294],[1187.24,473.825],[1235.4,549.967],[1235.4,475.764]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1187.24,555.307],[1187.24,631.777],[1235.4,554.832],[1235.4,629.035]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1187.24,722.226],[1187.24,798.695],[1235.4,716.804],[1235.4,791.007]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,469.721],[1253.08,395.104],[1235.4,470.106],[1235.4,395.903]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,550.027],[1253.08,475.41],[1235.4,549.967],[1235.4,475.764]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,554.918],[1253.08,629.535],[1235.4,554.832],[1235.4,629.035]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,635.251],[1253.08,709.868],[1235.4,634.719],[1235.4,708.922]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,717.794],[1253.08,792.411],[1235.4,716.804],[1235.4,791.007]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,469.721],[1253.08,395.104],[1311.26,472.315],[1311.26,400.481]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,550.027],[1253.08,475.41],[1311.26,549.625],[1311.26,477.792]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,554.918],[1253.08,629.535],[1311.26,554.334],[1311.26,626.167]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,635.251],[1253.08,709.868],[1311.26,631.67],[1311.26,703.503]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1253.08,717.794],[1253.08,792.411],[1311.26,711.133],[1311.26,782.967]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1294.52,472.66],[1294.52,401.197],[1337,474.523],[1337,405.06]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1294.52,549.571],[1294.52,478.109],[1337,549.283],[1337,479.82]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1294.52,554.256],[1294.52,625.719],[1337,553.836],[1337,623.299]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1294.52,631.193],[1294.52,702.656],[1337,628.62],[1337,698.083]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1294.52,710.247],[1294.52,781.709],[1337,705.462],[1337,774.925]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1337.25,472.403],[1337.25,402.988],[1375.78,474.149],[1375.78,406.547]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1337.25,547.11],[1337.25,477.695],[1375.78,546.905],[1375.78,479.303]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1337.25,551.661],[1337.25,621.075],[1375.78,551.337],[1375.78,618.938]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1337.25,626.393],[1337.25,695.807],[1375.78,624.117],[1375.78,691.719]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1337.25,703.181],[1337.25,772.595],[1375.78,698.9],[1375.78,766.502]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,473.818],[1392.58,405.873],[1375.78,474.149],[1375.78,406.547]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,546.944],[1392.58,478.999],[1375.78,546.905],[1375.78,479.303]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,551.398],[1392.58,619.343],[1375.78,551.337],[1375.78,618.938]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,624.548],[1392.58,692.493],[1375.78,624.117],[1375.78,691.719]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,699.71],[1392.58,767.655],[1375.78,698.9],[1375.78,766.502]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,473.818],[1392.58,405.873],[1440.99,476.048],[1440.99,410.419]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,546.944],[1392.58,478.999],[1440.99,546.682],[1440.99,481.052]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,551.398],[1392.58,619.343],[1440.99,550.984],[1440.99,616.613]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,624.548],[1392.58,692.493],[1440.99,621.641],[1440.99,687.27]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1392.58,699.71],[1392.58,767.655],[1440.99,694.241],[1440.99,759.87]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1425.07,476.346],[1425.07,411.027],[1460.65,477.959],[1460.65,414.314]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1425.07,546.646],[1425.07,481.327],[1460.65,546.457],[1460.65,482.812]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1425.07,550.929],[1425.07,616.249],[1460.65,550.629],[1460.65,614.274]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1425.07,621.252],[1425.07,686.572],[1460.65,619.15],[1460.65,682.795]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:19,
                    verts:[[1425.07,693.51],[1425.07,758.83],[1460.65,689.555],[1460.65,753.2]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[169.698,431.54],[169.698,319.695],[15.0989,437.707],[15.0989,332.266]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[169.698,551.913],[169.698,440.068],[15.0989,551.188],[15.0989,445.747]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[169.698,559.246],[169.698,671.091],[15.0989,558.101],[15.0989,663.542]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[169.698,679.659],[169.698,791.504],[15.0989,671.619],[15.0989,777.06]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[169.698,803.385],[169.698,915.23],[15.0989,788.261],[15.0989,893.702]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.303,422.301],[401.303,300.861],[219.935,429.536],[219.935,315.609]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.303,552.999],[401.303,431.56],[219.935,552.149],[219.935,438.222]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.303,560.961],[401.303,682.4],[219.935,559.618],[219.935,673.544]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.303,691.702],[401.303,813.142],[219.935,682.271],[219.935,796.197]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.303,826.042],[401.303,947.481],[219.935,808.299],[219.935,922.226]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.302,425.152],[401.302,303.712],[505.247,430.813],[505.247,315.4]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.302,555.851],[401.302,434.411],[505.247,555.027],[505.247,439.613]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.302,563.812],[401.302,685.251],[505.247,562.593],[505.247,678.007]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.302,694.554],[401.302,815.993],[505.247,686.848],[505.247,802.262]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[401.302,828.893],[401.302,950.333],[505.247,814.521],[505.247,929.935]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,430.008],[527.79,313.737],[505.246,430.813],[505.246,315.4]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,555.144],[527.79,438.873],[505.246,555.027],[505.246,439.613]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,562.767],[527.79,679.037],[505.246,562.593],[505.246,678.007]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,687.944],[527.79,804.215],[505.246,686.848],[505.246,802.262]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,816.566],[527.79,932.837],[505.246,814.521],[505.246,929.935]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,430.008],[527.79,313.737],[646.958,436.622],[646.958,327.39]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,555.144],[527.79,438.873],[646.958,554.182],[646.958,444.95]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,562.767],[527.79,679.037],[646.958,561.343],[646.958,670.575]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,687.944],[527.79,804.215],[646.958,678.942],[646.958,788.174]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[527.79,816.566],[527.79,932.836],[646.958,799.776],[646.958,909.008]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[624.172,437.358],[624.172,328.91],[707.194,441.877],[707.194,338.238]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[624.172,554.075],[624.172,445.627],[707.194,553.418],[707.194,449.779]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[624.172,561.185],[624.172,669.633],[707.194,560.212],[707.194,663.85]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[624.172,677.94],[624.172,786.388],[707.194,671.789],[707.194,775.428]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[624.172,797.908],[624.172,906.356],[707.194,786.437],[707.194,890.075]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[706.363,442.636],[706.363,338.954],[782.102,446.725],[782.102,347.43]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[706.363,554.224],[706.363,450.542],[782.102,553.59],[782.102,454.296]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[706.363,561.021],[706.363,664.703],[782.102,560.1],[782.102,659.394]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[706.363,787.341],[706.363,891.023],[782.102,776.842],[782.102,876.137]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[706.363,672.645],[706.363,776.327],[782.102,667],[782.102,766.295]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,446.113],[803.997,346.163],[782.103,446.725],[782.103,347.43]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,553.685],[803.997,453.734],[782.103,553.59],[782.103,454.296]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,560.237],[803.997,660.188],[782.103,560.1],[782.103,659.394]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,667.844],[803.997,767.795],[782.103,667],[782.103,766.294]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,778.412],[803.997,878.363],[782.103,776.842],[782.103,876.136]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,446.113],[803.997,346.163],[892.818,451.002],[892.818,356.298]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,553.685],[803.997,453.734],[892.818,552.927],[892.818,458.223]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,560.237],[803.997,660.188],[892.818,559.136],[892.818,653.84]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,667.844],[803.997,767.795],[892.818,661.095],[892.818,755.799]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[803.997,778.412],[803.997,878.363],[892.818,765.859],[892.818,860.563]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[872.236,451.533],[872.236,357.398],[935.4,454.945],[935.4,364.471]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[872.236,552.845],[872.236,458.71],[935.4,552.316],[935.4,461.843]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[872.236,559.016],[872.236,653.151],[935.4,558.248],[935.4,648.721]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[872.236,660.362],[872.236,754.497],[935.4,655.651],[935.4,746.125]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[872.236,764.496],[872.236,858.631],[935.4,755.735],[935.4,846.208]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.24,459.728],[1022.24,374.387],[938.309,461.606],[938.309,378.282]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.24,551.575],[1022.24,466.235],[938.309,551.284],[938.309,467.96]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.24,557.17],[1022.24,642.511],[938.309,556.747],[938.309,640.071]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.24,649.048],[1022.24,734.389],[938.309,646.454],[938.309,729.779]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.24,743.454],[1022.24,828.795],[938.309,738.63],[938.309,821.954]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.75,459.716],[1022.75,374.362],[1074.91,462.531],[1074.91,380.199]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.75,551.577],[1022.75,466.224],[1074.91,551.141],[1074.91,468.809]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.75,557.173],[1022.75,642.526],[1074.91,556.538],[1074.91,638.87]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.75,649.065],[1022.75,734.418],[1074.91,645.177],[1074.91,727.509]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1022.75,743.485],[1022.75,828.838],[1074.91,736.255],[1074.91,818.587]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,462.111],[1094.65,379.328],[1074.91,462.531],[1074.91,380.199]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,551.206],[1094.65,468.423],[1074.91,551.141],[1074.91,468.809]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,556.633],[1094.65,639.416],[1074.91,556.538],[1074.91,638.87]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,645.757],[1094.65,728.54],[1074.91,645.177],[1074.91,727.509]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,737.333],[1094.65,820.116],[1074.91,736.255],[1074.91,818.587]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,462.111],[1094.65,379.328],[1156.13,465.495],[1156.13,386.344]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,551.206],[1094.65,468.423],[1156.13,550.681],[1156.13,471.53]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,556.633],[1094.65,639.416],[1156.13,555.87],[1156.13,635.022]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,645.757],[1094.65,728.54],[1156.13,641.085],[1156.13,720.236]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1094.65,737.333],[1094.65,820.116],[1156.13,728.644],[1156.13,807.795]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1137.59,555.787],[1137.59,634.54],[1182.08,555.245],[1182.08,631.419]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1137.59,465.866],[1137.59,387.113],[1182.08,468.27],[1182.08,392.096]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1137.59,550.624],[1137.59,471.871],[1182.08,550.252],[1182.08,474.078]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1137.59,640.572],[1137.59,719.325],[1182.08,637.254],[1182.08,713.428]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1137.59,727.691],[1137.59,806.444],[1182.08,721.52],[1182.08,797.694]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1180.31,468.221],[1180.31,391.995],[1221.71,470.456],[1221.71,396.628]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1180.31,550.259],[1180.31,474.033],[1221.71,549.913],[1221.71,476.085]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1180.31,555.256],[1180.31,631.483],[1221.71,554.753],[1221.71,628.581]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1180.31,637.322],[1180.31,713.548],[1221.71,634.236],[1221.71,708.064]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1180.31,721.645],[1180.31,797.871],[1221.71,715.906],[1221.71,789.734]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,470.118],[1240.12,395.928],[1221.71,470.456],[1221.71,396.628]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,549.965],[1240.12,475.775],[1221.71,549.913],[1221.71,476.085]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,554.829],[1240.12,629.019],[1221.71,554.753],[1221.71,628.581]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,634.702],[1240.12,708.892],[1221.71,634.236],[1221.71,708.064]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,716.773],[1240.12,790.963],[1221.71,715.906],[1221.71,789.734]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,470.118],[1240.12,395.928],[1289.73,472.849],[1289.73,401.589]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,549.965],[1240.12,475.775],[1289.73,549.542],[1289.73,478.282]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,554.829],[1240.12,629.019],[1289.73,554.214],[1289.73,625.474]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,634.702],[1240.12,708.892],[1289.73,630.932],[1289.73,702.192]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1240.12,716.773],[1240.12,790.963],[1289.73,709.762],[1289.73,781.021]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1272.42,473.15],[1272.42,402.213],[1308.64,475.106],[1308.64,406.268]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1272.42,549.495],[1272.42,478.558],[1308.64,549.192],[1308.64,480.355]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1272.42,554.146],[1272.42,625.083],[1308.64,553.705],[1308.64,622.543]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1272.42,630.517],[1272.42,701.454],[1308.64,627.816],[1308.64,696.654]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1272.42,708.989],[1272.42,779.926],[1308.64,703.966],[1308.64,772.803]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1308.75,473.005],[1308.75,404.216],[1341.49,474.832],[1341.49,407.94]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1308.75,547.039],[1308.75,478.25],[1341.49,546.825],[1341.49,479.932]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1308.75,551.549],[1308.75,620.338],[1341.49,551.21],[1341.49,618.102]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1308.75,625.607],[1308.75,694.396],[1341.49,623.226],[1341.49,690.118]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1308.75,701.703],[1308.75,770.493],[1341.49,697.224],[1341.49,764.116]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,474.546],[1358.7,407.357],[1341.49,474.832],[1341.49,407.94]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,546.858],[1358.7,479.669],[1341.49,546.825],[1341.49,479.932]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,551.263],[1358.7,618.452],[1341.49,551.21],[1341.49,618.102]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,623.599],[1358.7,690.788],[1341.49,623.226],[1341.49,690.118]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,697.925],[1358.7,765.115],[1341.49,697.224],[1341.49,764.116]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,474.546],[1358.7,407.357],[1399.53,476.869],[1399.53,412.092]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,546.858],[1358.7,479.669],[1399.53,546.585],[1399.53,481.808]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,551.263],[1358.7,618.452],[1399.53,550.832],[1399.53,615.609]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,623.599],[1358.7,690.788],[1399.53,620.571],[1399.53,685.348]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1358.7,697.925],[1358.7,765.115],[1399.53,692.229],[1399.53,757.006]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1383.34,477.126],[1383.34,412.616],[1413.37,478.803],[1413.37,416.033]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1383.34,546.555],[1383.34,482.045],[1413.37,546.358],[1413.37,483.589]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1383.34,550.784],[1383.34,615.294],[1413.37,550.473],[1413.37,613.242]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1383.34,620.236],[1383.34,684.746],[1413.37,618.05],[1413.37,680.82]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:20,
                    verts:[[1383.34,691.598],[1383.34,756.108],[1413.37,687.487],[1413.37,750.256]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[233.45,427.469],[233.45,311.397],[50.5112,433.218],[50.5112,323.116]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[233.45,552.392],[233.45,436.319],[50.5112,551.716],[50.5112,441.613]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[233.45,560.001],[233.45,676.073],[50.5112,558.934],[50.5112,669.037]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[233.45,684.965],[233.45,801.037],[50.5112,677.471],[50.5112,787.573]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[233.45,813.367],[233.45,929.439],[50.5112,799.269],[50.5112,909.372]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,418.988],[503.344,294.109],[292.414,425.616],[292.414,307.62]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,553.389],[503.344,428.509],[292.414,552.609],[292.414,434.613]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,561.575],[503.344,686.455],[292.414,560.345],[292.414,678.341]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,696.021],[503.344,820.9],[292.414,687.38],[292.414,805.376]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,834.165],[503.344,959.044],[292.414,817.91],[292.414,935.907]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,421.92],[503.344,297.041],[594.967,428.214],[594.967,310.033]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,556.321],[503.344,431.441],[594.967,555.405],[594.967,437.224]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,564.508],[503.344,689.387],[594.967,563.153],[594.967,681.334]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,698.953],[503.344,823.832],[594.967,690.386],[594.967,808.567]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[503.344,837.097],[503.344,961.976],[594.967,821.121],[594.967,939.302]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.576,427.488],[620.576,308.535],[594.967,428.214],[594.967,310.033]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.576,555.511],[620.576,436.558],[594.967,555.405],[594.967,437.224]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.576,563.309],[620.576,682.262],[594.967,563.153],[594.967,681.334]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.576,691.374],[620.576,810.327],[594.967,690.386],[594.967,808.567]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.576,822.963],[620.576,941.916],[594.967,821.121],[594.967,939.302]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.577,427.488],[620.577,308.535],[724.104,434.761],[724.104,323.549]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.577,555.511],[620.577,436.558],[724.104,554.453],[724.104,443.24]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.577,563.309],[620.577,682.262],[724.104,561.744],[724.104,672.956]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.577,691.374],[620.577,810.327],[724.104,681.475],[724.104,792.687]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[620.577,822.963],[620.577,941.916],[724.104,804.501],[724.104,915.713]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[698.659,435.418],[698.659,324.905],[770.598,440.355],[770.598,335.097]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[698.659,554.357],[698.659,443.844],[770.598,553.639],[770.598,448.381]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[698.659,561.602],[698.659,672.115],[770.598,560.539],[770.598,665.797]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[698.659,680.581],[698.659,791.094],[770.598,673.86],[770.598,779.118]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[698.659,802.833],[698.659,913.346],[770.598,790.299],[770.598,895.557]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[769.867,441.123],[769.867,335.818],[835.081,445.562],[835.081,345.02]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[769.867,554.458],[769.867,449.152],[835.081,553.77],[835.081,453.228]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[769.867,561.362],[769.867,666.667],[835.081,560.362],[835.081,660.903]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[769.867,674.734],[769.867,780.039],[835.081,668.605],[835.081,769.147]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[769.867,791.225],[769.867,896.531],[835.081,779.827],[835.081,880.369]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,445.024],[859.002,343.903],[835.082,445.562],[835.082,345.021]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,553.854],[859.002,452.734],[835.082,553.77],[835.082,453.228]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,560.483],[859.002,661.603],[835.082,560.362],[835.082,660.903]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,669.349],[859.002,770.469],[835.082,668.605],[835.082,769.147]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,781.211],[859.002,882.331],[835.082,779.827],[835.082,880.369]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,445.024],[859.002,343.903],[934.556,450.288],[934.556,354.816]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,553.854],[859.002,452.734],[934.556,553.038],[934.556,457.567]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,560.483],[859.002,661.603],[934.556,559.297],[934.556,654.768]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,669.349],[859.002,770.469],[934.556,662.081],[934.556,757.553]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[859.002,781.211],[859.002,882.331],[934.556,767.694],[934.556,863.165]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[912.337,450.752],[912.337,355.779],[966.024,454.409],[966.024,363.361]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[912.337,552.966],[912.337,457.993],[966.024,552.399],[966.024,461.351]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[912.337,559.192],[912.337,654.165],[966.024,558.368],[966.024,649.417]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[912.337,661.44],[912.337,756.414],[966.024,656.391],[966.024,747.439]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[912.337,766.502],[912.337,861.475],[966.024,757.111],[966.024,848.159]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.13,459.499],[1039.13,373.914],[949.927,461.13],[949.927,377.294]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.13,551.611],[1039.13,466.025],[949.927,551.358],[949.927,467.522]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.13,557.221],[1039.13,642.807],[949.927,556.854],[949.927,640.69]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.13,649.363],[1039.13,734.949],[949.927,647.112],[949.927,730.947]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.13,744.04],[1039.13,829.626],[949.927,739.853],[949.927,823.688]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.67,459.489],[1039.67,373.892],[1083.5,462.472],[1083.5,380.077]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.67,551.612],[1039.67,466.015],[1083.5,551.15],[1083.5,468.755]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.67,557.224],[1039.67,642.821],[1083.5,556.552],[1083.5,638.947]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.67,649.378],[1039.67,734.974],[1083.5,645.259],[1083.5,727.654]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1039.67,744.067],[1039.67,829.664],[1083.5,736.406],[1083.5,818.802]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,462.111],[1104.25,379.327],[1083.5,462.472],[1083.5,380.077]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,551.206],[1104.25,468.423],[1083.5,551.15],[1083.5,468.755]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,556.633],[1104.25,639.416],[1083.5,556.552],[1083.5,638.947]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,645.758],[1104.25,728.541],[1083.5,645.259],[1083.5,727.654]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,737.335],[1104.25,820.118],[1083.5,736.406],[1083.5,818.802]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,462.111],[1104.25,379.327],[1155.41,465.675],[1155.41,386.716]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,551.206],[1104.25,468.423],[1155.41,550.654],[1155.41,471.695]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,556.633],[1104.25,639.416],[1155.41,555.83],[1155.41,634.789]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,645.758],[1104.25,728.541],[1155.41,640.837],[1155.41,719.796]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1104.25,737.335],[1104.25,820.118],[1155.41,728.183],[1155.41,807.142]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1136.06,465.993],[1136.06,387.375],[1173.11,468.517],[1173.11,392.608]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1136.06,550.604],[1136.06,471.987],[1173.11,550.213],[1173.11,474.304]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1136.06,555.758],[1136.06,634.376],[1173.11,555.19],[1173.11,631.099]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1136.06,640.398],[1136.06,719.016],[1173.11,636.913],[1173.11,712.822]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1136.06,727.367],[1136.06,805.984],[1173.11,720.886],[1173.11,796.795]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1171.51,468.463],[1171.51,392.497],[1205.88,470.803],[1205.88,397.347]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1171.51,550.222],[1171.51,474.255],[1205.88,549.859],[1205.88,476.403]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1171.51,555.202],[1171.51,631.168],[1205.88,554.675],[1205.88,628.13]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1171.51,636.987],[1171.51,712.954],[1205.88,633.757],[1205.88,707.213]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1171.51,721.023],[1171.51,796.99],[1205.88,715.016],[1205.88,788.471]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,470.515],[1224.89,396.751],[1205.88,470.803],[1205.88,397.347]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,549.904],[1224.89,476.14],[1205.88,549.859],[1205.88,476.403]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,554.739],[1224.89,628.503],[1205.88,554.675],[1205.88,628.13]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,634.154],[1224.89,707.918],[1205.88,633.757],[1205.88,707.213]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,715.753],[1224.89,789.517],[1205.88,715.016],[1205.88,788.471]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,470.515],[1224.89,396.751],[1265.71,473.359],[1265.71,402.648]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,549.904],[1224.89,476.14],[1265.71,549.463],[1265.71,478.751]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,554.739],[1224.89,628.503],[1265.71,554.099],[1265.71,624.81]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,634.154],[1224.89,707.918],[1265.71,630.227],[1265.71,700.939]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1224.89,715.753],[1224.89,789.517],[1265.71,708.45],[1265.71,779.162]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1247.95,473.615],[1247.95,403.176],[1277.8,475.648],[1277.8,407.392]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1247.95,549.423],[1247.95,478.985],[1277.8,549.108],[1277.8,480.852]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1247.95,554.041],[1247.95,624.479],[1277.8,553.583],[1277.8,621.839]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1247.95,629.875],[1247.95,700.313],[1277.8,627.068],[1277.8,695.324]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1247.95,707.795],[1247.95,778.234],[1277.8,702.574],[1277.8,770.83]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1277.78,473.565],[1277.78,405.358],[1304.7,475.459],[1304.7,409.218]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1277.78,546.973],[1277.78,478.766],[1304.7,546.751],[1304.7,480.51]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1277.78,551.445],[1277.78,619.652],[1304.7,551.093],[1304.7,617.335]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1277.78,624.877],[1277.78,693.085],[1304.7,622.409],[1304.7,688.65]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1277.78,700.33],[1277.78,768.538],[1304.7,695.686],[1304.7,761.927]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,475.218],[1322.2,408.726],[1304.7,475.459],[1304.7,409.218]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,546.779],[1322.2,480.288],[1304.7,546.751],[1304.7,480.51]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,551.138],[1322.2,617.63],[1304.7,551.093],[1304.7,617.335]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,622.723],[1322.2,689.215],[1304.7,622.409],[1304.7,688.65]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,696.278],[1322.2,762.769],[1304.7,695.686],[1304.7,761.927]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,475.218],[1322.2,408.726],[1355.51,477.616],[1355.51,413.614]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,546.779],[1322.2,480.288],[1355.51,546.497],[1355.51,482.496]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,551.138],[1322.2,617.63],[1355.51,550.693],[1355.51,614.695]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,622.723],[1322.2,689.215],[1355.51,619.597],[1355.51,683.599]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1322.2,696.278],[1322.2,762.769],[1355.51,690.397],[1355.51,754.399]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1339.11,477.832],[1339.11,414.055],[1363.65,479.56],[1363.65,417.577]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1339.11,546.472],[1339.11,482.695],[1363.65,546.269],[1363.65,484.286]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1339.11,550.653],[1339.11,614.43],[1363.65,550.332],[1363.65,612.315]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1339.11,619.316],[1339.11,683.093],[1363.65,617.063],[1363.65,679.046]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:21,
                    verts:[[1339.11,689.868],[1339.11,753.645],[1363.65,685.63],[1363.65,747.613]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[312.618,423.61],[312.618,303.53],[101.349,428.737],[101.349,313.981]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[312.618,552.845],[312.618,432.765],[101.349,552.243],[101.349,437.487]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[312.618,560.718],[312.618,680.798],[101.349,559.766],[101.349,674.522]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[312.618,689.996],[312.618,810.076],[101.349,683.312],[101.349,798.068]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[312.618,822.831],[312.618,942.912],[101.349,810.258],[101.349,925.014]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.646,416.182],[618.646,288.39],[380.047,421.973],[380.047,300.194]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.646,553.718],[618.646,425.926],[380.047,553.038],[380.047,431.258]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.646,562.096],[618.646,689.888],[380.047,561.021],[380.047,682.801]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.646,699.678],[618.646,827.47],[380.047,692.129],[380.047,813.909]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.646,841.044],[618.646,968.837],[380.047,826.844],[380.047,948.624]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.645,419.183],[618.645,291.391],[694.758,426.046],[694.758,305.557]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.645,556.719],[618.645,428.927],[694.758,555.721],[694.758,435.232]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.645,565.097],[618.645,692.889],[694.758,563.62],[694.758,684.108]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.645,702.678],[618.645,830.471],[694.758,693.337],[694.758,813.826]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[618.645,844.045],[618.645,971.837],[694.758,826.624],[694.758,947.112]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,425.422],[723.096,304.271],[694.757,426.046],[694.757,305.557]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,555.811],[723.096,434.66],[694.757,555.721],[694.757,435.232]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,563.754],[723.096,684.905],[694.757,563.62],[694.757,684.108]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,694.186],[723.096,815.337],[694.757,693.337],[694.757,813.826]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,828.207],[694.757,826.624],[723.096,949.358],[694.757,947.113]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,425.422],[723.096,304.271],[807.749,433.274],[807.749,320.48]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,555.811],[723.096,434.66],[807.749,554.669],[807.749,441.874]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,563.754],[723.096,684.905],[807.749,562.064],[807.749,674.858]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,694.186],[723.096,815.337],[807.749,683.498],[807.749,796.293]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[723.096,828.206],[723.096,949.358],[807.749,808.274],[807.749,921.069]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[779.981,433.834],[779.981,321.635],[838.862,439.138],[838.862,332.583]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[779.981,554.588],[779.981,442.388],[838.862,553.816],[838.862,447.262]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[779.981,561.943],[779.981,674.142],[838.862,560.802],[838.862,667.356]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[779.981,682.737],[779.981,794.936],[838.862,675.518],[838.862,782.072]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[779.981,806.854],[779.981,919.053],[838.862,793.391],[838.862,899.945]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[838.251,794.336],[838.251,900.942],[891.338,782.159],[891.338,883.675]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[838.251,439.912],[838.251,333.306],[891.338,444.654],[891.338,343.138]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[838.251,554.646],[838.251,448.04],[891.338,553.911],[891.338,452.395]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[838.251,561.635],[838.251,668.24],[891.338,560.566],[891.338,662.083]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[838.251,676.406],[838.251,783.012],[891.338,669.859],[891.338,771.375]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,444.2],[916.984,342.197],[891.338,444.654],[891.338,343.138]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,553.981],[916.984,451.978],[891.338,553.911],[891.338,452.395]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,560.668],[916.984,662.672],[891.338,560.566],[891.338,662.083]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,670.486],[916.984,772.489],[891.338,669.859],[891.338,771.375]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,783.325],[891.338,782.159],[916.984,885.328],[891.338,883.675]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,444.2],[916.984,342.197],[977.658,449.782],[977.658,353.767]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,553.981],[916.984,451.978],[977.658,553.116],[977.658,457.102]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,560.668],[916.984,662.672],[977.658,559.411],[977.658,655.425]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,670.486],[916.984,772.489],[977.658,662.78],[977.658,758.794]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[916.984,783.325],[916.984,885.328],[977.658,768.993],[977.658,865.008]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[954.068,450.17],[954.068,354.573],[997.286,454.035],[997.286,362.585]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[954.068,553.056],[954.068,457.459],[997.286,552.457],[997.286,461.007]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[954.068,559.323],[954.068,654.92],[997.286,558.453],[997.286,649.903]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[954.068,662.243],[954.068,757.84],[997.286,656.908],[997.286,748.358]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[954.068,767.995],[954.068,863.592],[997.286,758.072],[997.286,849.522]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1055.52,459.381],[1055.52,373.668],[961.906,460.738],[961.906,376.483]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1055.52,551.629],[1055.52,465.916],[961.906,551.419],[961.906,467.163]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1055.52,557.248],[1055.52,642.961],[961.906,556.942],[961.906,641.198]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1055.52,649.527],[1055.52,735.24],[961.906,647.652],[961.906,731.908]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1055.52,744.344],[1055.52,830.057],[961.906,740.858],[961.906,825.114]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1056.1,459.372],[1056.1,373.65],[1091.04,462.494],[1091.04,380.122]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1056.1,551.63],[1056.1,465.908],[1091.04,551.147],[1091.04,468.774]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1056.1,557.25],[1056.1,642.972],[1091.04,556.547],[1091.04,638.919]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1056.1,649.539],[1056.1,735.261],[1091.04,645.229],[1091.04,727.601]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1056.1,744.367],[1056.1,830.089],[1091.04,736.351],[1091.04,818.723]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,462.195],[1112.61,379.503],[1091.04,462.494],[1091.04,380.122]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,551.193],[1112.61,468.5],[1091.04,551.147],[1091.04,468.774]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,556.614],[1112.61,639.307],[1091.04,556.547],[1091.04,638.919]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,645.641],[1112.61,728.334],[1091.04,645.229],[1091.04,727.601]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,737.118],[1091.04,736.351],[1112.61,819.81],[1091.04,818.723]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,462.195],[1112.61,379.502],[1152.93,465.904],[1152.93,387.192]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,551.193],[1112.61,468.5],[1152.93,550.618],[1152.93,471.906]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,556.614],[1112.61,639.307],[1152.93,555.778],[1152.93,634.491]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,645.641],[1112.61,728.334],[1152.93,640.52],[1152.93,719.232]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1112.61,737.118],[1112.61,819.811],[1152.93,727.593],[1152.93,806.305]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1132.95,555.719],[1132.95,634.151],[1162.27,555.129],[1162.27,630.747]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1132.95,466.166],[1132.95,387.734],[1162.27,468.788],[1162.27,393.169]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1132.95,550.578],[1132.95,472.146],[1162.27,550.171],[1162.27,474.553]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1132.95,640.159],[1132.95,718.591],[1162.27,636.539],[1162.27,712.158]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1132.95,726.922],[1132.95,805.354],[1162.27,720.19],[1162.27,795.808]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1160.85,468.73],[1160.85,393.05],[1187.98,471.153],[1187.98,398.074]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1160.85,550.18],[1160.85,474.5],[1187.98,549.805],[1187.98,476.725]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1160.85,555.142],[1160.85,630.822],[1187.98,554.596],[1187.98,627.675]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1160.85,636.619],[1160.85,712.299],[1187.98,633.273],[1187.98,706.353]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1160.85,720.339],[1160.85,796.019],[1187.98,714.115],[1187.98,787.195]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,470.918],[1207.44,397.587],[1187.98,471.153],[1187.98,398.074]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,549.841],[1207.44,476.51],[1187.98,549.805],[1187.98,476.725]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,554.649],[1207.44,627.98],[1187.98,554.596],[1187.98,627.675]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,633.598],[1207.44,706.929],[1187.98,633.273],[1187.98,706.353]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,714.719],[1187.98,714.115],[1207.44,788.05],[1187.98,787.195]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,470.918],[1207.44,397.587],[1239.32,473.851],[1239.32,403.667]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,549.841],[1207.44,476.51],[1239.32,549.387],[1239.32,479.203]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,554.649],[1207.44,627.98],[1239.32,553.988],[1239.32,624.172]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,633.598],[1207.44,706.929],[1239.32,629.548],[1239.32,699.732]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1207.44,714.719],[1207.44,788.05],[1239.32,707.188],[1239.32,777.372]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1221.23,553.941],[1221.23,623.902],[1244.65,553.469],[1244.65,621.183]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1221.23,474.059],[1221.23,404.098],[1244.65,476.153],[1244.65,408.44]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1221.23,549.354],[1221.23,479.393],[1244.65,549.03],[1244.65,481.316]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1221.23,629.261],[1221.23,699.222],[1244.65,626.37],[1244.65,694.084]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1221.23,706.654],[1221.23,776.615],[1244.65,701.276],[1244.65,768.99]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1244.5,474.087],[1244.5,406.422],[1265.58,476.033],[1265.58,410.388]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1244.5,546.912],[1244.5,479.246],[1265.58,546.683],[1265.58,481.038]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1244.5,551.348],[1244.5,619.014],[1265.58,550.987],[1265.58,616.632]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1244.5,624.197],[1244.5,691.863],[1265.58,621.66],[1265.58,687.306]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1244.5,699.05],[1244.5,766.716],[1265.58,694.279],[1265.58,759.924]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,475.837],[1283.29,409.989],[1265.58,476.033],[1265.58,410.388]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,546.706],[1283.29,480.858],[1265.58,546.683],[1265.58,481.038]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,551.023],[1283.29,616.872],[1265.58,550.987],[1265.58,616.632]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,621.916],[1283.29,687.764],[1265.58,621.66],[1265.58,687.306]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,694.759],[1265.58,694.279],[1283.29,760.607],[1265.58,759.924]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,475.837],[1283.29,409.989],[1309.11,478.292],[1309.11,414.993]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,546.706],[1283.29,480.858],[1309.11,546.418],[1309.11,483.118]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,551.023],[1283.29,616.872],[1309.11,550.568],[1309.11,613.867]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,621.916],[1283.29,687.764],[1309.11,618.716],[1309.11,682.015]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1283.29,694.759],[1283.29,760.607],[1309.11,688.739],[1309.11,752.039]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1292.59,478.467],[1292.59,415.349],[1311.71,480.234],[1311.71,418.951]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1292.59,546.397],[1292.59,483.279],[1311.71,546.19],[1311.71,484.907]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1292.59,550.535],[1292.59,613.653],[1311.71,550.207],[1311.71,611.49]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1292.59,618.488],[1292.59,681.606],[1311.71,616.185],[1311.71,677.467]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:22,
                    verts:[[1292.59,688.31],[1292.59,751.428],[1311.71,683.977],[1311.71,745.26]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[407.303,420.126],[407.303,296.429],[169.039,424.409],[169.039,305.16]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[407.303,553.255],[407.303,429.558],[169.039,552.751],[169.039,433.502]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[407.303,561.364],[407.303,685.061],[169.039,560.569],[169.039,679.819]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[407.303,694.536],[407.303,818.234],[169.039,688.953],[169.039,808.203]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[407.303,831.373],[407.303,955.07],[169.039,820.87],[169.039,940.12]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,414.053],[745.176,284.049],[482.478,418.775],[482.478,293.675]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,553.969],[745.176,423.965],[482.478,553.414],[482.478,428.313]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,562.491],[745.176,692.495],[482.478,561.615],[482.478,686.715]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,702.454],[745.176,832.458],[482.478,696.298],[482.478,821.398]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,846.267],[745.176,976.271],[482.478,834.687],[482.478,959.787]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,417.105],[745.176,287.101],[802.854,424.435],[802.854,302.233]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,557.021],[745.176,427.017],[802.854,555.955],[802.854,433.752]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,565.544],[745.176,695.548],[802.854,563.966],[802.854,686.169]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,705.506],[745.176,835.51],[802.854,695.529],[802.854,817.732]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[745.176,849.32],[745.176,979.323],[802.854,830.713],[802.854,952.915]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,423.935],[833.419,301.201],[802.854,424.435],[802.854,302.233]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,556.028],[833.419,433.293],[802.854,555.955],[802.854,433.752]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,564.074],[833.419,686.808],[802.854,563.966],[802.854,686.169]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,696.21],[833.419,818.944],[802.854,695.53],[802.854,817.732]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,831.981],[802.854,830.713],[833.419,954.716],[802.854,952.915]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,423.935],[833.419,301.201],[896.354,432.249],[896.354,318.364]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,556.028],[833.419,433.293],[896.354,554.818],[896.354,440.933]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,564.074],[833.419,686.808],[896.354,562.284],[896.354,676.17]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,696.21],[833.419,818.944],[896.354,684.893],[896.354,798.779]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[833.419,831.981],[833.419,954.715],[896.354,810.876],[896.354,924.761]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[866.724,432.695],[866.724,319.284],[910.822,438.292],[910.822,330.837]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[866.724,554.753],[866.724,441.342],[910.822,553.939],[910.822,446.485]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[866.724,562.188],[866.724,675.599],[910.822,560.984],[910.822,668.438]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[866.724,684.287],[866.724,797.698],[910.822,676.669],[910.822,784.124]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[866.724,809.745],[866.724,923.156],[910.822,795.538],[910.822,902.993]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[910.345,796.497],[910.345,904.007],[949.931,783.704],[949.931,885.867]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[910.345,439.07],[910.345,331.561],[949.931,444.052],[949.931,341.89]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[910.345,554.776],[910.345,447.267],[949.931,554.004],[949.931,451.842]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[910.345,561.824],[910.345,669.333],[949.931,560.702],[949.931,662.864]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[910.345,677.569],[910.345,785.078],[949.931,670.69],[949.931,772.852]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,443.694],[976.925,341.147],[949.931,444.052],[949.931,341.89]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,554.06],[976.925,451.513],[949.931,554.004],[949.931,451.842]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,560.783],[976.925,663.329],[949.931,560.702],[949.931,662.864]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,671.185],[976.925,773.732],[949.931,670.69],[949.931,772.852]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,784.625],[949.931,783.704],[976.925,887.171],[949.931,885.866]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,443.694],[976.925,341.147],[1021.39,449.519],[1021.39,353.224]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,554.06],[976.925,451.513],[1021.39,553.157],[1021.39,456.862]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,560.783],[976.925,663.329],[1021.39,559.47],[1021.39,655.765]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,671.185],[976.925,773.732],[1021.39,663.142],[1021.39,759.437]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[976.925,784.625],[976.925,887.171],[1021.39,769.666],[1021.39,865.962]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[996.748,449.825],[996.748,353.857],[1028.68,453.85],[1028.68,362.201]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[996.748,553.11],[996.748,457.142],[1028.68,552.486],[1028.68,460.837]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[996.748,559.401],[996.748,655.369],[1028.68,558.494],[1028.68,650.143]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[996.748,662.72],[996.748,758.688],[1028.68,657.163],[1028.68,748.812]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[996.748,768.882],[996.748,864.85],[1028.68,758.547],[1028.68,850.196]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.15,459.39],[1071.15,373.687],[974.093,460.453],[974.093,375.891]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.15,551.628],[1071.15,465.925],[974.093,551.463],[974.093,466.901]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.15,557.246],[1071.15,642.949],[974.093,557.007],[974.093,641.569]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.15,649.514],[1071.15,735.217],[974.093,648.046],[974.093,732.608]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.15,744.321],[1071.15,830.024],[974.093,741.591],[974.093,826.153]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.74,459.383],[1071.74,373.673],[1097.37,462.609],[1097.37,380.361]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.74,551.629],[1071.74,465.918],[1097.37,551.129],[1097.37,468.88]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.74,557.248],[1071.74,642.958],[1097.37,556.521],[1097.37,638.769]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.74,649.524],[1071.74,735.234],[1097.37,645.069],[1097.37,727.318]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1071.74,744.339],[1071.74,830.049],[1097.37,736.055],[1097.37,818.303]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,462.377],[1119.53,379.88],[1097.37,462.609],[1097.37,380.361]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,551.165],[1119.53,468.667],[1097.37,551.129],[1097.37,468.88]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,556.573],[1119.53,639.07],[1097.37,556.521],[1097.37,638.769]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,645.39],[1119.53,727.887],[1097.37,645.069],[1097.37,727.318]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,736.651],[1097.37,736.055],[1119.53,819.148],[1097.37,818.303]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,462.377],[1119.53,379.88],[1148.66,466.193],[1148.66,387.79]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,551.165],[1119.53,468.667],[1148.66,550.573],[1148.66,472.171]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,556.573],[1119.53,639.07],[1148.66,555.713],[1148.66,634.116]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,645.39],[1119.53,727.887],[1148.66,640.122],[1148.66,718.525]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1119.53,736.651],[1119.53,819.148],[1148.66,726.853],[1148.66,805.256]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1128.23,466.395],[1128.23,388.21],[1149.61,469.089],[1149.61,393.795]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1128.23,550.542],[1128.23,472.357],[1149.61,550.125],[1149.61,474.83]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1128.23,555.668],[1128.23,633.853],[1149.61,555.061],[1149.61,630.355]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1128.23,639.842],[1128.23,718.028],[1149.61,636.123],[1149.61,711.417]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1128.23,726.333],[1128.23,804.518],[1149.61,719.415],[1149.61,794.71]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1148.37,469.028],[1148.37,393.667],[1168.11,471.513],[1168.11,398.819]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1148.37,550.134],[1148.37,474.774],[1168.11,549.749],[1168.11,477.055]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1148.37,555.075],[1148.37,630.435],[1168.11,554.515],[1168.11,627.208]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1148.37,636.208],[1148.37,711.568],[1168.11,632.777],[1168.11,705.471]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1148.37,719.573],[1148.37,794.934],[1168.11,713.192],[1168.11,785.886]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,471.331],[1187.88,398.443],[1168.11,471.513],[1168.11,398.819]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,549.777],[1187.88,476.889],[1168.11,549.749],[1168.11,477.055]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,554.556],[1187.88,627.444],[1168.11,554.515],[1168.11,627.208]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,633.027],[1187.88,705.915],[1168.11,632.777],[1168.11,705.471]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,713.658],[1168.11,713.192],[1187.88,786.546],[1168.11,785.886]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,471.331],[1187.88,398.443],[1210.75,474.327],[1210.75,404.654]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,549.777],[1187.88,476.889],[1210.75,549.313],[1210.75,479.64]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,554.556],[1187.88,627.444],[1210.75,553.881],[1210.75,623.554]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,633.027],[1187.88,705.915],[1210.75,628.891],[1210.75,698.564]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1187.88,713.658],[1187.88,786.546],[1210.75,705.965],[1210.75,775.639]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1192.44,553.844],[1192.44,623.346],[1209.4,553.363],[1209.4,620.571]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1209.13,551.258],[1209.13,618.418],[1224.37,550.89],[1224.37,615.991]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1209.13,474.574],[1209.13,407.413],[1224.37,476.556],[1224.37,411.455]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1209.13,546.855],[1209.13,479.694],[1224.37,546.622],[1224.37,481.52]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1209.13,623.563],[1209.13,690.723],[1224.37,620.978],[1224.37,686.08]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1209.13,697.857],[1209.13,765.018],[1224.37,692.995],[1224.37,758.097]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,476.406],[1242.2,411.149],[1224.37,476.556],[1224.37,411.455]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,546.639],[1242.2,481.382],[1224.37,546.622],[1224.37,481.52]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,550.918],[1242.2,616.175],[1224.37,550.89],[1224.37,615.991]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,621.174],[1242.2,686.432],[1224.37,620.978],[1224.37,686.08]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,693.364],[1224.37,692.995],[1242.2,758.621],[1224.37,758.097]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,476.406],[1242.2,411.149],[1260.62,478.9],[1260.62,416.231]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,546.639],[1242.2,481.382],[1260.62,546.346],[1260.62,483.678]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,550.918],[1242.2,616.175],[1260.62,550.455],[1260.62,613.123]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,621.174],[1242.2,686.432],[1260.62,617.924],[1260.62,680.592]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:23,
                    verts:[[1242.2,693.364],[1242.2,758.621],[1260.62,687.249],[1260.62,749.918]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[516.599,417.196],[516.599,290.457],[254.295,420.409],[254.295,297.005]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[516.599,553.599],[516.599,426.86],[254.295,553.222],[254.295,429.818]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[516.599,561.908],[516.599,688.648],[254.295,561.312],[254.295,684.715]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[516.599,698.356],[516.599,825.095],[254.295,694.168],[254.295,817.572]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[516.599,838.558],[516.599,965.298],[254.295,830.68],[254.295,954.084]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,412.748],[879.787,281.389],[598.285,416.196],[598.285,288.417]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,554.122],[879.787,422.764],[598.285,553.717],[598.285,425.938]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,562.734],[879.787,694.092],[598.285,562.094],[598.285,689.872]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,704.154],[879.787,835.513],[598.285,699.66],[598.285,827.438]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,849.466],[879.787,980.825],[598.285,841.012],[598.285,968.79]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,415.832],[879.787,284.474],[916.694,423.491],[916.694,300.284]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,557.206],[879.787,425.848],[916.694,556.092],[916.694,432.885]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,565.818],[879.787,697.176],[916.694,564.169],[916.694,687.376]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,707.239],[879.787,838.597],[916.694,696.814],[916.694,820.021]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[879.787,852.551],[879.787,983.909],[916.694,833.109],[916.694,956.316]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,423.132],[916.694,423.491],[948.833,299.543],[916.694,300.284]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,556.144],[948.833,432.555],[916.694,556.092],[916.694,432.885]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,564.247],[948.833,687.836],[916.694,564.169],[916.694,687.376]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,697.303],[916.694,696.814],[948.833,820.892],[916.694,820.021]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,834.02],[916.694,833.109],[948.833,957.609],[916.694,956.316]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,423.132],[948.833,299.543],[987.886,431.758],[987.886,317.35]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,556.144],[948.833,432.555],[987.886,554.89],[987.886,440.482]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,564.247],[948.833,687.836],[987.886,562.39],[987.886,676.798]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,697.303],[948.833,820.892],[987.886,685.562],[987.886,799.97]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[948.833,834.02],[948.833,957.609],[987.886,812.122],[987.886,926.53]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[984.631,438.654],[984.631,330.699],[1009.69,443.799],[1009.69,341.365]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[984.631,554.841],[984.631,446.885],[1009.69,554.044],[1009.69,451.609]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[984.631,561.918],[984.631,669.873],[1009.69,560.759],[1009.69,663.193]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[984.631,678.143],[984.631,786.098],[1009.69,671.039],[1009.69,773.473]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[984.631,797.565],[984.631,905.521],[1009.69,784.354],[1009.69,886.788]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,443.545],[1009.69,443.799],[1037.59,340.838],[1009.69,341.365]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,554.083],[1037.59,451.376],[1009.69,554.044],[1009.69,451.609]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,560.816],[1037.59,663.523],[1009.69,560.759],[1009.69,663.193]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,671.391],[1009.69,671.039],[1037.59,774.098],[1009.69,773.473]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,785.008],[1009.69,784.354],[1037.59,887.715],[1009.69,886.788]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,443.545],[1037.59,340.838],[1064.91,449.528],[1064.91,353.242]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,554.083],[1037.59,451.376],[1064.91,553.156],[1064.91,456.87]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,560.816],[1037.59,663.523],[1064.91,559.468],[1064.91,655.754]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,671.391],[1037.59,774.098],[1064.91,663.13],[1064.91,759.415]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1037.59,785.008],[1037.59,887.715],[1064.91,769.643],[1064.91,865.929]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1085.71,459.54],[1085.71,373.998],[986.303,460.292],[986.303,375.558]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1085.71,551.604],[1085.71,466.062],[986.303,551.488],[986.303,466.753]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1085.71,557.212],[1085.71,642.754],[986.303,557.043],[986.303,641.777]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1085.71,649.307],[1085.71,734.849],[986.303,648.268],[986.303,733.003]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1085.71,743.935],[1085.71,829.477],[986.303,742.004],[986.303,826.738]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1086.32,459.535],[1086.32,373.988],[1102.36,462.828],[1102.36,380.815]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1086.32,551.605],[1086.32,466.058],[1102.36,551.095],[1102.36,469.082]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1086.32,557.213],[1086.32,642.761],[1102.36,556.471],[1102.36,638.485]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1086.32,649.314],[1086.32,734.861],[1102.36,644.767],[1102.36,726.78]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1086.32,743.948],[1086.32,829.495],[1102.36,735.492],[1102.36,817.505]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,462.665],[1102.36,462.828],[1124.88,380.477],[1102.36,380.815]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,551.12],[1124.88,468.932],[1102.36,551.095],[1102.36,469.082]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,556.508],[1124.88,638.696],[1102.36,556.471],[1102.36,638.484]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,644.992],[1102.36,644.767],[1124.88,727.18],[1102.36,726.78]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,735.911],[1102.36,735.492],[1124.88,818.099],[1102.36,817.505]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,462.665],[1124.88,380.477],[1142.6,466.545],[1142.6,388.521]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,551.12],[1124.88,468.932],[1142.6,550.519],[1142.6,472.494]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,556.508],[1124.88,638.696],[1142.6,555.634],[1142.6,633.658]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,644.992],[1124.88,727.18],[1142.6,639.635],[1142.6,717.659]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1124.88,735.911],[1124.88,818.099],[1142.6,725.947],[1142.6,803.972]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1134.17,469.362],[1134.17,394.359],[1146.46,471.884],[1146.46,399.589]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1134.17,550.082],[1134.17,475.08],[1146.46,549.691],[1146.46,477.397]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1134.17,554.999],[1134.17,630.002],[1146.46,554.431],[1146.46,626.726]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1134.17,635.747],[1134.17,710.749],[1146.46,632.264],[1146.46,704.559]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1134.17,718.716],[1134.17,793.718],[1146.46,712.238],[1146.46,784.533]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,471.758],[1146.46,471.884],[1166.39,399.327],[1146.46,399.589]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,549.711],[1166.39,477.28],[1146.46,549.691],[1146.46,477.397]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,554.46],[1166.39,626.891],[1146.46,554.431],[1146.46,626.726]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,632.439],[1146.46,632.264],[1166.39,704.87],[1146.46,704.559]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,712.564],[1146.46,712.238],[1166.39,784.995],[1146.46,784.533]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,471.758],[1166.39,399.327],[1180.23,474.789],[1180.23,405.612]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,549.711],[1166.39,477.28],[1180.23,549.241],[1180.23,480.064]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,554.46],[1166.39,626.891],[1180.23,553.776],[1180.23,622.954]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,632.439],[1166.39,704.87],[1180.23,628.253],[1180.23,697.431]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1166.39,712.564],[1166.39,784.995],[1180.23,704.779],[1180.23,773.956]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1171.94,551.174],[1171.94,617.864],[1181.38,550.802],[1181.38,615.411]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1171.94,475.027],[1171.94,408.336],[1181.38,477.031],[1181.38,412.422]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1171.94,546.802],[1171.94,480.112],[1181.38,546.566],[1181.38,481.957]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1171.94,622.973],[1171.94,689.663],[1181.38,620.36],[1181.38,684.969]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1171.94,696.747],[1171.94,763.437],[1181.38,691.832],[1181.38,756.441]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,476.926],[1181.38,477.031],[1199.25,412.208],[1181.38,412.422]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,546.578],[1199.25,481.861],[1181.38,546.566],[1181.38,481.957]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,550.821],[1199.25,615.539],[1181.38,550.802],[1181.38,615.411]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,620.496],[1181.38,620.36],[1199.25,685.214],[1181.38,684.969]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,692.089],[1181.38,691.832],[1199.25,756.806],[1181.38,756.441]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,476.926],[1199.25,412.208],[1210.35,479.44],[1210.35,417.332]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,546.578],[1199.25,481.861],[1210.35,546.283],[1210.35,484.175]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,550.821],[1199.25,615.539],[1210.35,550.355],[1210.35,612.462]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,620.496],[1199.25,685.214],[1210.35,617.22],[1210.35,679.328]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:24,
                    verts:[[1199.25,692.089],[1199.25,756.806],[1210.35,685.925],[1210.35,748.033]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[638.434,414.989],[638.434,285.957],[356.81,416.925],[356.81,289.903]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[638.434,553.859],[638.434,424.827],[356.81,553.631],[356.81,426.61]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[638.434,562.318],[638.434,691.35],[356.81,561.958],[356.81,688.98]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[638.434,701.234],[638.434,830.265],[356.81,698.71],[356.81,825.732]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[638.434,843.972],[638.434,973.003],[356.81,839.224],[356.81,966.246]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,412.377],[1018.38,280.633],[724.885,414.394],[724.885,284.746]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,554.166],[1018.38,422.422],[724.885,553.929],[724.885,424.28]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,562.803],[1018.38,694.546],[724.885,562.428],[724.885,692.077]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,704.638],[1018.38,836.382],[724.885,702.008],[724.885,831.657]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,850.376],[1018.38,982.12],[724.885,845.429],[724.885,975.078]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,415.47],[1018.38,283.726],[1033.06,423.291],[1033.06,299.871]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,557.259],[1018.38,425.515],[1033.06,556.121],[1033.06,432.701]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,565.896],[1018.38,697.64],[1033.06,564.212],[1033.06,687.632]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,707.731],[1018.38,839.475],[1033.06,697.086],[1033.06,820.506]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1018.38,853.47],[1018.38,985.214],[1033.06,833.616],[1033.06,957.036]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,423.084],[1033.06,423.291],[1066,299.444],[1033.06,299.871]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,556.151],[1066,432.511],[1033.06,556.121],[1033.06,432.701]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,564.257],[1033.06,564.212],[1066,687.897],[1033.06,687.632]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,697.368],[1033.06,697.086],[1066,821.008],[1033.06,820.506]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,834.141],[1033.06,833.616],[1066,957.781],[1033.06,957.036]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,423.084],[1066,299.444],[1079.94,431.849],[1079.94,317.537]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,556.151],[1066,432.512],[1079.94,554.876],[1079.94,440.565]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,564.257],[1066,687.897],[1079.94,562.37],[1079.94,676.682]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,697.368],[1066,821.008],[1079.94,685.439],[1079.94,799.751]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1066,834.141],[1066,957.781],[1079.94,811.893],[1079.94,926.205]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,443.777],[1069.27,443.923],[1097.59,341.319],[1069.27,341.621]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,554.047],[1097.59,451.589],[1069.27,554.024],[1069.27,451.723]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,560.764],[1069.27,560.731],[1097.59,663.222],[1069.27,663.032]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,671.07],[1069.27,670.869],[1097.59,773.528],[1069.27,773.17]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,784.412],[1069.27,784.037],[1097.59,886.87],[1069.27,886.339]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,443.777],[1097.59,341.319],[1107.29,449.824],[1107.29,353.856]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,554.047],[1097.59,451.589],[1107.29,553.11],[1107.29,457.141]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,560.764],[1097.59,663.222],[1107.29,559.401],[1107.29,655.37]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,671.07],[1097.59,773.528],[1107.29,662.721],[1107.29,758.69]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1097.59,784.412],[1097.59,886.87],[1107.29,768.884],[1107.29,864.852]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,463.064],[1105.89,463.157],[1128.53,381.303],[1105.89,381.496]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,551.058],[1128.53,469.298],[1105.89,551.044],[1105.89,469.383]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,556.418],[1105.89,556.397],[1128.53,638.179],[1105.89,638.058]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,644.442],[1105.89,644.314],[1128.53,726.203],[1105.89,725.975]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,463.064],[1128.53,381.303],[1134.79,466.964],[1134.79,389.39]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,551.058],[1128.53,469.298],[1134.79,550.454],[1134.79,472.879]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,556.418],[1128.53,638.179],[1134.79,555.539],[1134.79,633.114]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,644.442],[1128.53,726.203],[1134.79,639.057],[1134.79,716.631]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1128.53,734.888],[1128.53,816.648],[1134.79,724.871],[1134.79,802.446]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,472.197],[1123.24,472.269],[1143.19,400.238],[1123.24,400.388]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,549.643],[1143.19,477.684],[1123.24,549.632],[1123.24,477.75]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,554.36],[1123.24,554.344],[1143.19,626.319],[1123.24,626.226]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,631.832],[1123.24,631.732],[1143.19,703.791],[1123.24,703.614]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,711.434],[1123.24,711.249],[1143.19,783.393],[1123.24,783.131]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,472.197],[1143.19,400.238],[1148.06,475.238],[1148.06,406.541]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,549.643],[1143.19,477.684],[1148.06,549.172],[1148.06,480.475]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,554.36],[1143.19,626.319],[1148.06,553.675],[1148.06,622.372]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1143.19,631.832],[1143.19,703.791],[1148.06,627.634],[1148.06,696.331]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,546.523],[1154.78,482.294],[1136.96,546.516],[1136.96,482.349]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,550.734],[1136.96,550.723],[1154.78,614.963],[1136.96,614.89]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,619.883],[1136.96,619.805],[1154.78,684.111],[1136.96,683.973]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,477.397],[1136.96,477.456],[1154.78,413.168],[1136.96,413.289]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,690.934],[1136.96,690.789],[1154.78,755.163],[1136.96,754.956]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,477.397],[1154.78,413.168],[1158.69,479.912],[1158.69,418.296]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,546.523],[1154.78,482.294],[1158.69,546.227],[1158.69,484.611]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,550.734],[1154.78,614.963],[1158.69,550.267],[1158.69,611.884]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,619.883],[1154.78,684.111],[1158.69,616.604],[1158.69,678.22]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:25,
                    verts:[[1154.78,690.934],[1154.78,755.163],[1158.69,684.766],[1158.69,746.382]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[769.572,413.644],[769.572,283.216],[475.016,414.143],[475.016,284.233]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[769.572,554.017],[769.572,423.589],[475.016,553.958],[475.016,424.048]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[769.572,562.567],[769.572,692.995],[475.016,562.475],[475.016,692.384]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[769.572,702.986],[769.572,833.414],[475.016,702.336],[475.016,832.246]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[769.572,847.269],[769.572,977.696],[475.016,846.045],[475.016,975.955]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[509.952,421.999],[477.609,422.05],[509.952,300.246],[477.609,300.351]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[509.952,561.016],[509.952,682.769],[477.609,561.007],[477.609,682.706]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[509.952,692.095],[477.609,692.029],[509.952,813.848],[477.609,813.728]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[509.952,826.781],[477.609,826.655],[509.952,948.534],[477.609,948.354]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1156.25,412.989],[858.62,413.493],[1156.25,281.881],[858.62,282.909]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1156.25,554.094],[1156.25,422.986],[858.62,554.034],[858.62,423.45]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1156.25,562.689],[858.62,562.595],[1156.25,693.797],[858.62,693.18]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1156.25,703.84],[858.62,703.183],[1156.25,834.948],[858.62,833.767]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1156.25,848.875],[858.62,847.638],[1156.25,979.983],[858.62,978.223]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1148.34,423.869],[1181.27,423.818],[1148.34,301.065],[1181.27,300.96]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1148.34,556.037],[1181.27,556.044],[1148.34,433.233],[1181.27,433.186]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1148.34,696.299],[1181.27,696.369],[1148.34,819.104],[1181.27,819.227]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1148.34,832.148],[1181.27,832.278],[1148.34,954.953],[1181.27,955.137]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:26,
                    verts:[[1148.34,564.088],[1181.27,564.099],[1148.34,686.892],[1181.27,686.958]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[619.183,420.305],[585.873,420.198],[619.183,296.794],[585.873,296.576]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[619.183,553.234],[619.183,429.723],[585.873,553.246],[585.873,429.624]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[619.183,561.331],[585.873,561.351],[619.183,684.842],[585.873,684.973]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[619.183,694.303],[585.873,694.443],[619.183,817.815],[585.873,818.065]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[619.183,830.934],[585.873,831.197],[619.183,954.446],[585.873,954.819]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[905.832,413.254],[606.012,412.226],[905.832,282.421],[606.012,280.326]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[905.832,554.063],[905.832,423.23],[606.012,554.183],[606.012,422.283]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[905.832,562.64],[905.832,693.473],[606.012,562.831],[606.012,694.731]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[905.832,703.495],[606.012,704.835],[905.832,834.328],[606.012,836.735]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[905.832,848.225],[606.012,850.746],[905.832,979.058],[606.012,982.647]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[995.057,413.56],[995.057,283.045],[1288.64,414.567],[1288.64,285.097]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[995.057,554.027],[995.057,423.511],[1288.64,553.908],[1288.64,424.438]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[995.057,562.583],[995.057,693.098],[1288.64,562.396],[1288.64,691.866]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[995.057,703.096],[995.057,833.611],[1288.64,701.784],[1288.64,831.253]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[995.057,847.475],[995.057,977.99],[1288.64,845.006],[1288.64,974.476]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[1258.91,425.21],[1291.02,425.311],[1258.91,303.832],[1291.02,304.04]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[1258.91,555.842],[1258.91,434.465],[1291.02,555.827],[1291.02,434.557]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[1258.91,694.475],[1291.02,694.338],[1258.91,815.852],[1291.02,815.608]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[1258.91,828.745],[1291.02,828.49],[1258.91,950.123],[1291.02,949.76]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:27,
                    verts:[[1258.91,563.799],[1258.91,685.177],[1291.02,563.778],[1291.02,685.048]]
                },
                ],
                [
                {
                    num:"407",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[649.59,546.572],[649.59,481.91],[647.266,546.274],[647.266,484.246]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[649.59,550.811],[649.59,615.474],[647.266,550.34],[647.266,612.367]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[649.59,476.979],[667.63,477.055],[649.59,412.317],[667.63,412.47]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[649.59,546.572],[667.63,546.563],[649.59,481.91],[667.63,481.979]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[649.59,550.811],[667.63,550.797],[649.59,615.474],[667.63,615.382]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[656.467,547.455],[656.467,474.993],[653.563,547.082],[653.563,477.913]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[656.467,552.205],[656.467,624.667],[653.563,551.617],[653.563,620.786]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[656.467,469.468],[676.671,469.563],[656.467,397.006],[676.671,397.199]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[656.467,547.455],[676.671,547.444],[656.467,474.993],[676.671,475.08]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[656.467,552.205],[676.671,552.188],[656.467,624.667],[676.671,624.552]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,548.575],[665.194,466.216],[661.466,548.097],[661.466,469.965]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,553.975],[665.194,636.334],[661.466,553.219],[661.466,631.351]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,459.936],[688.141,460.058],[665.194,377.576],[688.141,377.825]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,548.575],[688.141,548.561],[665.194,466.216],[688.141,466.328]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,553.975],[688.141,553.952],[665.194,636.334],[688.141,636.185]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[665.194,642.643],[688.141,642.484],[665.194,725.003],[688.141,724.717]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,439.897],[683.541,336.73],[677.767,446.204],[677.767,349.586]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,550.931],[683.541,447.763],[677.767,550.19],[677.767,453.571]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,557.694],[683.541,660.862],[677.767,556.524],[677.767,653.142]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,668.765],[683.541,771.932],[677.767,660.543],[677.767,757.162]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,782.891],[683.541,886.058],[677.767,767.425],[677.767,864.043]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,439.897],[712.239,440.089],[683.541,336.73],[712.239,337.12]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,550.931],[712.239,550.908],[683.541,447.763],[712.239,447.94]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,557.694],[712.239,557.659],[683.541,660.862],[712.239,660.628]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,668.765],[712.239,668.515],[683.541,771.932],[712.239,771.484]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[683.541,782.891],[712.239,782.422],[683.541,886.058],[712.239,885.39]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,419.132],[702.554,294.401],[694.224,428.23],[694.224,312.947]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,553.372],[702.554,428.642],[694.224,552.302],[694.224,437.02]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,561.549],[702.554,686.279],[694.224,559.86],[694.224,675.143]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,695.833],[702.554,820.563],[694.224,683.974],[694.224,799.256]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,833.813],[702.554,958.543],[694.224,811.502],[694.224,926.785]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,419.132],[736.012,419.401],[702.554,294.401],[736.012,294.952]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,553.372],[736.012,553.34],[702.554,428.642],[736.012,428.89]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,561.549],[736.012,561.499],[702.554,686.279],[736.012,685.948]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,695.833],[736.012,695.481],[702.554,820.563],[736.012,819.931]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[702.554,833.813],[736.012,833.151],[702.554,958.543],[736.012,957.6]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,411.285],[745.726,278.408],[736.012,419.402],[736.012,294.952]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,554.294],[745.726,421.417],[736.012,553.34],[736.012,428.89]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,563.005],[745.726,695.883],[736.012,561.499],[736.012,685.948]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,706.061],[745.726,838.938],[736.012,695.481],[736.012,819.931]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,853.053],[745.726,985.93],[736.012,833.151],[736.012,957.6]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,411.285],[745.726,278.408],[1042.51,413.845],[1042.51,283.625]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,554.294],[745.726,421.417],[1042.51,553.993],[1042.51,423.773]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,563.005],[745.726,695.882],[1042.51,562.53],[1042.51,692.75]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,706.061],[745.726,838.938],[1042.51,702.725],[1042.51,832.945]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[745.726,853.053],[745.726,985.93],[1042.51,846.777],[1042.51,976.997]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[1129.46,414.594],[1129.46,285.153],[1411.24,417.024],[1411.24,290.106]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[1129.46,553.905],[1129.46,424.464],[1411.24,553.619],[1411.24,426.701]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[1129.46,562.391],[1129.46,691.832],[1411.24,561.94],[1411.24,688.858]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[1129.46,701.748],[1129.46,831.189],[1411.24,698.58],[1411.24,825.498]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:28,
                    verts:[[1129.46,844.938],[1129.46,974.38],[1411.24,838.98],[1411.24,965.898]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,476.335],[605.653,411.004],[595.99,478.877],[595.99,416.185]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,546.648],[605.653,481.317],[595.99,546.349],[595.99,483.657]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,550.931],[605.653,616.262],[595.99,550.459],[595.99,613.151]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,621.266],[605.653,686.598],[595.99,617.953],[595.99,680.645]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,693.537],[605.653,758.869],[595.99,687.304],[595.99,749.996]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,476.335],[623.831,476.457],[605.653,411.004],[623.831,411.252]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,546.648],[605.653,481.317],[623.831,546.633],[623.831,481.429]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,550.931],[605.653,616.262],[623.831,550.908],[623.831,616.113]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,621.266],[623.831,621.108],[605.653,686.598],[623.831,686.313]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[605.653,693.537],[623.831,693.239],[605.653,758.869],[623.831,758.444]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,468.823],[634.212,395.691],[622.162,471.993],[622.162,402.153]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,547.531],[634.212,474.399],[622.162,547.158],[622.162,477.318]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,552.325],[634.212,625.457],[622.162,551.737],[622.162,621.577]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,631.059],[634.212,704.191],[622.162,626.927],[622.162,696.767]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,711.959],[634.212,785.091],[622.162,704.186],[622.162,774.026]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[632.425,474.36],[632.425,406.978],[623.831,476.457],[623.831,411.252]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,468.823],[654.494,468.976],[634.212,395.691],[654.494,396.002]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,547.531],[634.212,474.399],[654.494,547.513],[654.494,474.539]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,552.325],[634.212,625.457],[654.494,552.297],[654.494,625.27]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,631.059],[654.494,630.86],[634.212,704.191],[654.494,703.834]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[634.212,711.959],[654.494,711.585],[634.212,785.091],[654.494,784.559]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,459.313],[670.365,376.307],[654.934,463.372],[654.934,384.58]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[665.3,466.339],[665.3,390.628],[654.494,468.976],[654.494,396.002]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,548.649],[670.365,465.642],[654.934,548.172],[654.934,469.38]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[665.3,552.786],[665.3,628.497],[654.494,552.297],[654.494,625.27]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,554.09],[670.365,637.097],[654.934,553.337],[654.934,632.129]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,643.455],[670.365,726.462],[654.934,638.164],[654.934,716.956]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,735.279],[670.365,818.285],[654.934,725.326],[654.934,804.117]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,459.313],[693.29,459.51],[670.365,376.307],[693.29,376.707]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,548.649],[670.365,465.642],[693.29,548.626],[693.29,465.823]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,554.09],[670.365,637.097],[693.29,554.054],[693.29,636.857]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,643.455],[693.29,643.199],[670.365,726.462],[693.29,726.002]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[670.365,735.279],[693.29,734.798],[670.365,818.285],[693.29,817.6]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[707.403,456.066],[707.403,369.688],[693.29,459.51],[693.29,376.707]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[707.403,549.03],[707.403,462.652],[693.29,548.626],[693.29,465.823]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[707.403,554.693],[707.403,641.071],[693.29,554.054],[693.29,636.857]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[707.403,647.688],[707.403,734.066],[693.29,643.199],[693.29,726.002]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[707.403,743.241],[707.403,829.62],[693.29,734.797],[693.29,817.6]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[708.019,456.072],[708.019,369.7],[760.198,456.539],[760.198,370.651]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[708.019,549.03],[708.019,462.658],[760.198,548.975],[760.198,463.087]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[708.019,554.692],[708.019,641.064],[760.198,554.605],[760.198,640.493]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[708.019,647.68],[708.019,734.052],[760.198,647.072],[760.198,732.959]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[708.019,743.227],[760.198,742.082],[708.019,829.599],[760.198,827.97]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,439.406],[746.044,335.729],[722.271,445.659],[722.271,348.475]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,550.989],[746.044,447.311],[722.271,550.254],[722.271,453.069]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,557.785],[746.044,661.463],[722.271,556.625],[722.271,653.809]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,669.405],[746.044,773.082],[722.271,661.253],[722.271,758.438]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,784.095],[746.044,887.772],[722.271,768.761],[722.271,865.945]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,439.406],[774.429,439.712],[746.044,335.729],[774.429,336.353]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,550.989],[746.044,447.311],[774.429,550.953],[774.429,447.593]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,557.785],[746.044,661.463],[774.429,557.729],[774.429,661.088]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,669.404],[774.429,669.006],[746.044,773.082],[774.429,772.365]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[746.044,784.095],[774.429,783.344],[746.044,887.772],[774.429,886.704]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[796.451,434.339],[796.451,325.4],[774.429,439.712],[774.429,336.353]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[796.451,551.584],[796.451,442.645],[774.429,550.953],[774.429,447.593]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[796.451,558.726],[796.451,667.665],[774.429,557.729],[774.429,661.088]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[796.451,676.01],[796.451,784.949],[774.429,669.006],[774.429,772.365]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[796.451,796.521],[796.451,905.46],[774.429,783.344],[774.429,886.704]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,418.898],[824.008,293.926],[789.906,427.868],[789.906,312.21]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,553.399],[824.008,428.427],[789.906,552.345],[789.906,436.687]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,561.592],[824.008,686.565],[789.906,559.927],[789.906,675.585]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,696.138],[824.008,821.11],[789.906,684.445],[789.906,800.103]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,834.385],[824.008,959.358],[789.906,812.388],[789.906,928.046]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,418.898],[856.761,419.327],[824.008,293.925],[856.761,294.8]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,553.399],[824.008,428.427],[856.761,553.349],[856.761,428.822]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,561.592],[824.008,686.565],[856.761,561.512],[856.761,686.039]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,696.138],[856.761,695.578],[824.008,821.11],[856.761,820.105]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[824.008,834.385],[856.761,833.333],[824.008,959.358],[856.761,957.859]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,411.367],[889.306,278.574],[856.761,419.327],[856.761,294.801]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,554.284],[889.306,421.492],[856.761,553.349],[856.761,428.822]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,562.99],[889.306,695.783],[856.761,561.512],[856.761,686.039]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,705.955],[889.306,838.747],[856.761,695.578],[856.761,820.105]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,852.853],[889.306,985.646],[856.761,833.333],[856.761,957.859]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,411.367],[889.306,278.574],[1174.91,415.373],[1174.91,286.74]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,554.284],[889.306,421.492],[1174.91,553.814],[1174.91,425.181]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,562.99],[889.306,695.783],[1174.91,562.246],[1174.91,690.879]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,705.955],[889.306,838.747],[1174.91,700.733],[1174.91,829.366]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[889.306,852.853],[889.306,985.646],[1174.91,843.029],[1174.91,971.662]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[1257.34,416.529],[1257.34,289.097],[1520.68,420.223],[1520.68,296.626]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[1257.34,553.678],[1257.34,426.245],[1520.68,553.243],[1520.68,429.647]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[1257.34,562.032],[1257.34,689.464],[1520.68,561.346],[1520.68,684.943]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[1257.34,699.226],[1257.34,826.658],[1520.68,694.411],[1520.68,818.007]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:29,
                    verts:[[1257.34,840.194],[1257.34,967.626],[1520.68,831.136],[1520.68,954.733]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,475.649],[564.011,409.605],[546.812,478.175],[546.812,414.755]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,546.728],[564.011,480.685],[546.812,546.432],[546.812,483.011]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,551.058],[564.011,617.102],[546.812,550.589],[546.812,614.01]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,622.161],[564.011,688.205],[546.812,618.868],[546.812,682.288]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,695.221],[564.011,761.265],[546.812,689.025],[546.812,752.446]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,475.649],[564.011,409.605],[582.237,475.818],[582.237,409.949]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,546.728],[564.011,480.685],[582.237,546.709],[582.237,480.84]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,551.058],[564.011,617.102],[582.237,551.027],[582.237,616.896]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,622.161],[582.237,621.941],[564.011,688.205],[582.237,687.81]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[564.011,695.221],[582.237,694.807],[564.011,761.265],[582.237,760.676]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[597.019,473.739],[597.019,405.712],[582.237,475.818],[582.237,409.949]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[597.019,546.953],[597.019,478.926],[582.237,546.709],[582.237,480.84]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[597.019,551.413],[597.019,619.44],[582.237,551.027],[582.237,616.896]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[597.019,624.651],[597.019,692.677],[582.237,621.941],[582.237,687.81]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[597.019,699.903],[597.019,767.93],[582.237,694.807],[582.237,760.676]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,468.203],[614.701,394.427],[593.338,471.341],[593.338,400.823]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,547.604],[614.701,473.828],[593.338,547.235],[593.338,476.718]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,552.44],[614.701,626.216],[593.338,551.858],[593.338,622.375]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,631.868],[614.701,705.644],[593.338,627.777],[593.338,698.294]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,713.48],[614.701,787.256],[593.338,705.785],[593.338,776.302]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[612.052,551.823],[612.052,622.148],[596.161,551.408],[596.161,619.409]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,468.203],[614.701,394.427],[634.904,468.413],[634.904,394.856]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,547.604],[614.701,473.828],[634.904,547.579],[634.904,474.022]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,552.44],[614.701,626.216],[634.904,552.401],[634.904,625.959]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,631.868],[634.904,631.593],[614.701,705.644],[634.904,705.151]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[614.701,713.48],[634.904,712.964],[614.701,787.256],[634.904,786.522]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[653.41,465.811],[653.41,389.552],[634.904,468.413],[634.904,394.856]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[653.41,547.885],[653.41,471.626],[634.904,547.579],[634.904,474.022]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[653.41,552.884],[653.41,629.143],[634.904,552.401],[634.904,625.959]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[653.41,634.985],[653.41,711.244],[634.904,631.593],[634.904,705.151]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[653.41,719.344],[653.41,795.603],[634.904,712.964],[634.904,786.522]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,458.821],[678.569,375.303],[651.35,462.819],[651.35,383.453]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,548.707],[678.569,465.189],[651.35,548.237],[651.35,468.87]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,554.182],[678.569,637.7],[651.35,553.44],[651.35,632.806]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,644.097],[678.569,727.615],[651.35,638.885],[651.35,718.252]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,736.487],[678.569,820.005],[651.35,726.682],[651.35,806.048]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,458.821],[678.569,375.303],[701.216,459.09],[701.216,375.852]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,548.707],[678.569,465.189],[701.216,548.675],[701.216,465.437]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,554.182],[678.569,637.7],[701.216,554.132],[701.216,637.37]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,644.097],[701.216,643.746],[678.569,727.615],[701.216,726.984]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[678.569,736.487],[701.216,735.826],[678.569,820.005],[701.216,819.064]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.249,455.712],[725.249,368.965],[701.216,459.09],[701.216,375.852]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.249,549.072],[725.249,462.326],[701.216,548.675],[701.216,465.437]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.249,554.759],[725.249,641.505],[701.216,554.132],[701.216,637.37]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.249,648.15],[725.249,734.897],[701.216,643.746],[701.216,726.984]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.249,744.111],[725.249,830.858],[701.216,735.826],[701.216,819.064]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.855,455.72],[725.855,368.981],[777.09,456.357],[777.09,370.282]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.855,549.071],[725.855,462.333],[777.09,548.996],[777.09,462.92]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.855,554.757],[725.855,641.496],[777.09,554.639],[777.09,640.715]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.855,648.14],[725.855,734.878],[777.09,647.308],[777.09,733.384]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[725.855,744.092],[725.855,830.83],[777.09,742.527],[777.09,828.603]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[794.844,445.79],[794.844,348.742],[764.954,449.999],[764.954,357.32]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[794.844,550.238],[794.844,453.19],[764.954,549.744],[764.954,457.065]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[794.844,556.6],[794.844,653.649],[764.954,555.819],[764.954,648.498]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[794.844,661.083],[794.844,758.131],[764.954,655.597],[764.954,748.276]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[794.844,768.44],[794.844,865.488],[764.954,758.12],[764.954,850.799]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,439.34],[811.184,335.594],[769.684,445.436],[769.684,348.02]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,550.996],[811.184,447.25],[769.684,550.28],[769.684,452.864]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,557.798],[811.184,661.544],[769.684,556.666],[769.684,654.082]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,669.491],[811.184,773.238],[769.684,661.544],[769.684,758.961]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,784.258],[811.184,888.004],[769.684,769.308],[769.684,866.725]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,439.34],[811.184,335.594],[838.742,439.756],[838.742,336.441]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,550.996],[811.184,447.25],[838.742,550.948],[838.742,447.633]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,557.798],[811.184,661.544],[838.742,557.721],[838.742,661.035]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,669.491],[838.742,668.949],[811.184,773.237],[838.742,772.264]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[811.184,784.258],[838.742,783.238],[811.184,888.004],[838.742,886.553]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[875.801,434.545],[875.801,325.821],[838.742,439.756],[838.742,336.441]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[875.801,551.56],[875.801,442.835],[838.742,550.948],[838.742,447.633]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[875.801,558.688],[875.801,667.412],[838.742,557.721],[838.742,661.035]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[875.801,675.741],[875.801,784.465],[838.742,668.949],[838.742,772.264]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[875.801,796.015],[875.801,904.739],[838.742,783.238],[838.742,886.553]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[917.665,428.66],[917.665,313.824],[876.576,434.436],[876.576,325.599]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[917.665,552.252],[917.665,437.416],[876.576,551.573],[876.576,442.735]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[917.665,559.78],[917.665,674.616],[876.576,558.708],[876.576,667.546]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[917.665,683.413],[917.665,798.249],[876.576,675.883],[876.576,784.721]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[917.665,810.447],[917.665,925.283],[876.576,796.282],[876.576,905.12]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.298,419.492],[946.298,295.136],[887.386,428.146],[887.386,312.776]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.298,553.329],[946.298,428.974],[887.386,552.312],[887.386,436.943]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.298,561.482],[946.298,685.838],[887.386,559.875],[887.386,675.245]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.298,695.363],[946.298,819.719],[887.386,684.083],[887.386,799.452]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.298,832.929],[946.298,957.284],[887.386,811.707],[887.386,927.077]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.299,419.492],[946.299,295.136],[977.533,420.068],[977.533,296.311]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.299,553.329],[946.299,428.974],[977.533,553.262],[977.533,429.504]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.299,561.482],[946.299,685.838],[977.533,561.375],[977.533,685.132]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.299,695.364],[977.533,694.612],[946.299,819.719],[977.533,818.369]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[946.299,832.929],[977.533,831.515],[946.299,957.285],[977.533,955.272]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,412.444],[1031.69,280.769],[977.533,420.068],[977.533,296.311]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,554.158],[1031.69,422.483],[977.533,553.262],[977.533,429.505]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,562.79],[1031.69,694.464],[977.533,561.375],[977.533,685.132]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,704.551],[1031.69,836.225],[977.533,694.612],[977.533,818.369]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,850.212],[1031.69,981.887],[977.533,831.515],[977.533,955.272]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,412.444],[1031.69,280.769],[1298.87,417.735],[1298.87,291.556]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,554.158],[1031.69,422.484],[1298.87,553.536],[1298.87,427.356]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,562.79],[1031.69,694.464],[1298.87,561.808],[1298.87,687.988]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,704.551],[1031.69,836.225],[1298.87,697.653],[1298.87,823.833]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1031.69,850.212],[1031.69,981.887],[1298.87,837.236],[1298.87,963.416]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1374.92,419.241],[1374.92,294.626],[1614.77,423.991],[1614.77,304.308]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1374.92,553.359],[1374.92,428.743],[1614.77,552.801],[1614.77,433.117]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1374.92,561.528],[1374.92,686.144],[1614.77,560.647],[1614.77,680.33]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1374.92,695.69],[1374.92,820.306],[1614.77,689.498],[1614.77,809.182]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:30,
                    verts:[[1374.92,833.543],[1374.92,958.159],[1614.77,821.895],[1614.77,941.579]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[517.11,477.608],[517.11,413.598],[498.642,479.4],[498.642,417.251]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[517.11,546.498],[517.11,482.488],[498.642,546.288],[498.642,484.139]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[517.11,550.695],[517.11,614.704],[498.642,550.362],[498.642,612.511]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[517.11,619.608],[517.11,683.618],[498.642,617.271],[498.642,679.42]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[517.11,690.417],[517.11,754.427],[498.642,686.022],[498.642,748.17]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,474.924],[525.059,408.127],[500.153,477.415],[500.153,413.205]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,546.814],[525.059,480.017],[500.153,546.521],[500.153,482.311]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,551.193],[525.059,617.99],[500.153,550.73],[500.153,614.94]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,623.107],[525.059,689.904],[500.153,619.859],[500.153,684.069]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,696.999],[525.059,763.796],[500.153,690.89],[500.153,755.1]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,474.924],[525.059,408.127],[543.234,475.14],[543.234,408.567]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,546.814],[525.059,480.017],[543.234,546.788],[543.234,480.216]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,551.193],[525.059,617.99],[543.234,551.153],[543.234,617.725]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,623.106],[525.059,689.904],[543.234,622.825],[543.234,689.398]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[525.059,696.999],[543.234,696.469],[525.059,763.796],[543.234,763.042]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[564.301,473.097],[564.301,404.404],[543.234,475.14],[543.234,408.567]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[564.301,547.028],[564.301,478.335],[543.234,546.788],[543.234,480.216]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[564.301,551.532],[564.301,620.225],[543.234,551.153],[543.234,617.725]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[564.301,625.487],[564.301,694.181],[543.234,622.825],[543.234,689.398]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[564.301,701.478],[564.301,770.171],[543.234,696.469],[543.234,763.042]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[585.971,470.925],[585.971,399.975],[563.353,473.12],[563.353,404.45]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[585.971,547.284],[585.971,476.334],[563.353,547.026],[563.353,478.356]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[585.971,551.935],[585.971,622.885],[563.353,551.528],[563.353,620.198]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[585.971,628.319],[585.971,699.269],[563.353,625.458],[563.353,694.128]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[585.971,706.805],[585.971,777.755],[563.353,701.422],[563.353,770.092]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,467.611],[598.163,393.221],[567.408,470.688],[567.408,399.492]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,547.673],[598.163,473.283],[567.408,547.312],[567.408,476.116]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,552.55],[598.163,626.94],[567.408,551.979],[567.408,623.175]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,632.638],[598.163,707.028],[567.408,628.628],[567.408,699.824]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,714.93],[598.163,789.32],[567.408,707.387],[567.408,778.582]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,467.611],[598.163,393.221],[618.123,467.879],[618.123,393.767]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,547.673],[598.163,473.283],[618.123,547.642],[618.123,473.53]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,552.55],[598.163,626.94],[618.123,552.5],[618.123,626.612]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,632.638],[598.163,707.028],[618.123,632.289],[618.123,706.401]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[598.163,714.93],[618.123,714.273],[598.163,789.32],[618.123,788.385]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[644.327,465.339],[644.327,388.589],[618.123,467.879],[618.123,393.767]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[644.327,547.94],[644.327,471.191],[618.123,547.642],[618.123,473.53]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[644.327,552.972],[644.327,629.722],[618.123,552.5],[618.123,626.612]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[644.327,635.601],[644.327,712.351],[618.123,632.289],[618.123,706.401]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[644.327,720.503],[644.327,797.253],[618.123,714.273],[618.123,788.385]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[671.229,462.65],[671.229,383.109],[642.911,465.399],[642.911,388.711]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[671.229,548.256],[671.229,468.715],[642.911,547.933],[642.911,471.246]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[671.229,553.471],[671.229,633.012],[642.911,552.961],[642.911,629.648]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[671.229,639.105],[671.229,718.647],[642.911,635.523],[642.911,712.21]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[671.229,727.096],[671.229,806.637],[642.911,720.357],[642.911,797.044]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,458.461],[689.64,374.57],[650.741,462.352],[650.741,382.501]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,548.749],[689.64,464.858],[650.741,548.291],[650.741,468.441]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,554.248],[689.64,638.14],[650.741,553.526],[650.741,633.377]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,644.566],[689.64,728.457],[650.741,639.494],[650.741,719.345]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,737.368],[689.64,821.259],[650.741,727.827],[650.741,807.677]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,458.461],[689.64,374.57],[711.753,458.802],[711.753,375.264]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,548.749],[689.64,464.858],[711.753,548.709],[711.753,465.171]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,554.249],[689.64,638.14],[711.753,554.185],[711.753,637.723]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,644.566],[689.64,728.457],[711.753,644.122],[711.753,727.659]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[689.64,737.368],[711.753,736.533],[689.64,821.259],[711.753,820.071]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[745.507,455.529],[745.507,368.594],[711.753,458.802],[711.753,375.264]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[745.507,549.093],[745.507,462.158],[711.753,548.709],[711.753,465.171]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[745.507,554.793],[745.507,641.728],[711.753,554.185],[711.753,637.723]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[745.507,648.388],[745.507,735.323],[711.753,644.122],[711.753,727.659]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[745.507,744.558],[745.507,831.493],[711.753,736.533],[711.753,820.071]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[746.094,455.539],[746.094,368.614],[795.763,456.34],[795.763,370.247]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[746.094,549.092],[746.094,462.167],[795.763,548.998],[795.763,462.905]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[746.094,554.791],[746.094,641.716],[795.763,554.642],[795.763,640.736]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[746.094,648.375],[746.094,735.3],[795.763,647.331],[795.763,733.424]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[746.094,744.534],[746.094,831.459],[795.763,742.57],[795.763,828.663]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[843.095,445.97],[843.095,349.109],[801.428,450.014],[801.428,357.352]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[843.095,550.217],[843.095,453.356],[801.428,549.742],[801.428,457.079]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[843.095,556.567],[843.095,653.429],[801.428,555.816],[801.428,648.479]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[843.095,660.848],[843.095,757.71],[801.428,655.577],[801.428,748.239]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[843.095,767.999],[843.095,864.86],[801.428,758.082],[801.428,850.745]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,439.683],[877.369,336.294],[818.94,445.528],[818.94,348.207]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,550.956],[877.369,447.567],[818.94,550.269],[818.94,452.948]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,557.734],[877.369,661.123],[818.94,556.649],[818.94,653.97]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,669.043],[877.369,772.433],[818.94,661.425],[818.94,758.746]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,783.415],[877.369,886.805],[818.94,769.083],[818.94,866.404]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,439.683],[877.369,336.294],[903.621,440.2],[903.621,337.347]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,550.956],[877.369,447.567],[903.621,550.895],[903.621,448.042]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,557.734],[877.369,661.123],[903.621,557.638],[903.621,660.491]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,669.043],[877.369,772.433],[903.621,668.37],[903.621,771.223]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[877.369,783.415],[903.621,782.148],[877.369,886.805],[903.621,885.001]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[954.797,435.239],[954.797,327.234],[903.621,440.2],[903.621,337.347]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[954.797,551.478],[954.797,443.474],[903.621,550.895],[903.621,448.042]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[954.797,558.559],[954.797,666.564],[903.621,557.638],[903.621,660.491]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[954.797,674.837],[954.797,782.842],[903.621,668.37],[903.621,771.223]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[954.797,794.315],[954.797,902.32],[903.621,782.148],[903.621,885.001]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1012.34,429.66],[1012.34,315.862],[955.865,435.135],[955.865,327.023]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1012.34,552.134],[1012.34,438.336],[955.865,551.491],[955.865,443.378]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1012.34,559.595],[1012.34,673.393],[955.865,558.578],[955.865,666.691]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1012.34,682.11],[1012.34,795.908],[955.865,674.972],[955.865,783.085]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1012.34,807.996],[1012.34,921.794],[955.865,794.569],[955.865,902.681]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,420.854],[1065.62,297.912],[983.908,429.027],[983.908,314.572]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,553.169],[1065.62,430.227],[983.908,552.209],[983.908,437.754]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,561.229],[1065.62,684.171],[983.908,559.712],[983.908,674.167]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,693.589],[1065.62,816.53],[983.908,682.934],[983.908,797.389]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,829.59],[1065.62,952.532],[983.908,809.547],[983.908,924.002]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,420.854],[1065.62,297.912],[1094.63,421.558],[1094.63,299.349]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,553.169],[1065.62,430.227],[1094.63,553.086],[1094.63,430.877]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,561.229],[1065.62,684.171],[1094.63,561.098],[1094.63,683.308]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,693.589],[1065.62,816.531],[1094.63,692.67],[1094.63,814.88]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1065.62,829.59],[1094.63,827.861],[1065.62,952.532],[1094.63,950.071]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,414.421],[1168.17,284.8],[1094.63,421.559],[1094.63,299.349]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,553.925],[1168.17,424.305],[1094.63,553.086],[1094.63,430.877]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,562.423],[1168.17,692.044],[1094.63,561.098],[1094.63,683.308]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,701.973],[1168.17,831.594],[1094.63,692.67],[1094.63,814.879]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,845.363],[1168.17,974.984],[1094.63,827.861],[1094.63,950.071]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,414.421],[1168.17,284.801],[1411.19,420.782],[1411.19,297.766]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,553.925],[1168.17,424.305],[1411.19,553.178],[1411.19,430.162]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,562.423],[1168.17,692.044],[1411.19,561.242],[1411.19,684.258]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,701.973],[1168.17,831.594],[1411.19,693.682],[1411.19,816.698]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1168.17,845.363],[1168.17,974.984],[1411.19,829.765],[1411.19,952.781]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1479.51,422.57],[1479.51,301.411],[1692.55,428.146],[1692.55,312.777]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1479.51,552.967],[1479.51,431.808],[1692.55,552.312],[1692.55,436.943]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1479.51,560.91],[1479.51,682.07],[1692.55,559.875],[1692.55,675.245]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1479.51,691.351],[1479.51,812.51],[1692.55,684.082],[1692.55,799.451]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:31,
                    verts:[[1479.51,825.38],[1479.51,946.539],[1692.55,811.706],[1692.55,927.076]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[473.261,476.834],[473.261,412.021],[449.11,478.588],[449.11,415.596]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[473.261,546.589],[473.261,481.776],[449.11,546.383],[449.11,483.391]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[473.261,550.838],[473.261,615.652],[449.11,550.513],[449.11,613.504]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[473.261,620.616],[473.261,685.43],[449.11,618.33],[449.11,681.322]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[473.261,692.315],[473.261,757.128],[449.11,688.013],[449.11,751.005]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,474.163],[489.129,406.575],[456.378,476.598],[456.378,411.54]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,546.903],[489.129,479.316],[456.378,546.617],[456.378,481.559]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,551.334],[489.129,618.921],[456.378,550.882],[456.378,615.94]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,624.099],[489.129,691.686],[456.378,620.924],[456.378,685.982]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,698.865],[489.129,766.452],[456.378,692.892],[456.378,757.95]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,474.163],[489.129,406.575],[507.15,474.426],[507.15,407.112]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,546.903],[489.129,479.316],[507.15,546.872],[507.15,479.558]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,551.334],[489.129,618.921],[507.15,551.285],[507.15,618.599]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,624.099],[489.129,691.686],[507.15,623.755],[507.15,691.069]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[489.129,698.865],[489.129,766.452],[507.15,698.22],[507.15,765.534]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[534.559,472.437],[534.559,403.057],[507.15,474.426],[507.15,407.112]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[534.559,547.106],[534.559,477.727],[507.15,546.872],[507.15,479.558]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[534.559,551.654],[534.559,621.034],[507.15,551.285],[507.15,618.599]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[534.559,626.349],[534.559,695.728],[507.15,623.755],[507.15,691.069]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[534.559,703.098],[534.559,772.477],[507.15,698.22],[507.15,765.534]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[562.891,470.324],[562.891,398.75],[533.525,472.457],[533.525,403.098]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[562.891,547.354],[562.891,475.781],[533.525,547.104],[533.525,477.745]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[562.891,552.047],[562.891,623.62],[533.525,551.651],[533.525,621.009]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[562.891,629.103],[562.891,700.676],[533.525,626.322],[533.525,695.681]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[562.891,708.279],[562.891,779.852],[533.525,703.048],[533.525,772.407]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,467.052],[584.747,392.08],[544.613,470.036],[544.613,398.164]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,547.739],[584.747,472.768],[544.613,547.388],[544.613,475.516]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,552.654],[584.747,627.625],[544.613,552.1],[544.613,623.972]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,633.368],[584.747,708.339],[544.613,629.477],[544.613,701.349]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,716.303],[584.747,791.274],[544.613,708.984],[544.613,780.856]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,467.052],[584.747,392.08],[604.3,467.375],[604.3,392.74]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,547.739],[584.747,472.768],[604.3,547.701],[604.3,473.066]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,552.654],[584.747,627.625],[604.3,552.594],[604.3,627.229]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,633.368],[584.747,708.339],[604.3,632.946],[604.3,707.581]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[584.747,716.303],[584.747,791.274],[604.3,715.509],[604.3,790.144]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[638.108,464.922],[638.108,387.739],[604.3,467.375],[604.3,392.74]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[638.108,547.989],[638.108,470.807],[604.3,547.701],[604.3,473.066]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[638.108,553.049],[638.108,630.232],[604.3,552.594],[604.3,627.229]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[638.108,636.145],[638.108,713.327],[604.3,632.946],[604.3,707.581]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[638.108,721.526],[638.108,798.709],[604.3,715.509],[604.3,790.144]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[672.944,462.33],[672.944,382.456],[636.502,464.977],[636.502,387.852]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[672.944,548.294],[672.944,468.42],[636.502,547.983],[636.502,470.858]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[672.944,553.53],[672.944,633.404],[636.502,553.039],[636.502,630.164]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[672.944,639.523],[672.944,719.397],[636.502,636.072],[636.502,713.198]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[672.944,727.881],[672.944,807.755],[636.502,721.39],[636.502,798.516]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,458.232],[703.333,374.103],[653.05,461.972],[653.05,381.726]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,548.776],[703.333,464.647],[653.05,548.336],[653.05,468.09]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,554.291],[703.333,638.42],[653.05,553.597],[653.05,633.843]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,644.864],[703.333,728.993],[653.05,639.99],[653.05,720.235]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,737.93],[703.333,822.059],[653.05,728.76],[653.05,809.005]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,458.232],[703.333,374.103],[724.665,458.64],[724.665,374.934]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,548.776],[703.333,464.647],[724.665,548.728],[724.665,465.022]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,554.291],[703.333,638.42],[724.665,554.215],[724.665,637.921]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,644.864],[703.333,728.993],[724.665,644.333],[724.665,728.039]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[703.333,737.93],[703.333,822.059],[724.665,736.931],[724.665,820.636]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[767.761,455.512],[767.761,368.558],[724.665,458.64],[724.665,374.934]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[767.761,549.095],[767.761,462.142],[724.665,548.728],[724.665,465.022]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[767.761,554.796],[767.761,641.75],[724.665,554.215],[724.665,637.921]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[767.761,648.41],[767.761,735.364],[724.665,644.333],[724.665,728.039]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[767.761,744.6],[767.761,831.554],[724.665,736.931],[724.665,820.636]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[768.323,455.524],[768.323,368.582],[815.843,456.476],[815.843,370.524]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[768.323,549.094],[768.323,462.153],[815.843,548.982],[815.843,463.03]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[768.323,554.794],[768.323,641.735],[815.843,554.617],[815.843,640.569]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[768.323,648.395],[768.323,735.336],[815.843,647.154],[815.843,733.106]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[768.323,744.572],[768.323,831.513],[815.843,742.236],[815.843,828.189]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[891.763,446.436],[891.763,350.058],[839.08,450.263],[839.08,357.858]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[891.763,550.162],[891.763,453.785],[839.08,549.712],[839.08,457.308]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[891.763,556.481],[891.763,652.858],[839.08,555.77],[839.08,648.175]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[891.763,660.241],[891.763,756.619],[839.08,655.253],[839.08,747.657]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[891.763,766.856],[891.763,863.234],[839.08,757.473],[839.08,849.877]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,440.404],[943.061,337.762],[868.965,445.914],[868.965,348.994]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,550.871],[943.061,448.23],[868.965,550.224],[868.965,453.304]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,557.6],[943.061,660.242],[868.965,556.577],[868.965,653.497]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,668.104],[943.061,770.746],[868.965,660.921],[868.965,757.841]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,781.649],[943.061,884.291],[868.965,768.136],[868.965,865.056]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,440.404],[943.061,337.762],[967.589,441.009],[967.589,338.997]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,550.871],[943.061,448.23],[967.589,550.8],[967.589,448.788]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,557.6],[943.061,660.242],[967.589,557.488],[967.589,659.501]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,668.104],[943.061,770.746],[967.589,667.315],[967.589,769.328]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[943.061,781.649],[943.061,884.291],[967.589,780.164],[967.589,882.176]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1031.55,436.367],[1031.55,329.535],[967.589,441.009],[967.589,338.997]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1031.55,551.346],[1031.55,444.513],[967.589,550.8],[967.589,448.788]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1031.55,558.349],[1031.55,665.182],[967.589,557.488],[967.589,659.501]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1031.55,673.366],[1031.55,780.199],[967.589,667.315],[967.589,769.328]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1031.55,791.547],[1031.55,898.38],[967.589,780.164],[967.589,882.176]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1103.06,431.178],[1103.06,318.956],[1032.88,436.271],[1032.88,329.338]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1103.06,551.956],[1103.06,439.734],[1032.88,551.357],[1032.88,444.424]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1103.06,559.313],[1103.06,671.535],[1032.88,558.367],[1032.88,665.301]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1103.06,680.131],[1103.06,792.353],[1032.88,673.492],[1032.88,780.425]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1103.06,804.273],[1103.06,916.495],[1032.88,791.784],[1032.88,898.717]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,422.881],[1178.67,302.045],[1076.98,430.444],[1076.98,317.461]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,552.931],[1178.67,432.095],[1076.98,552.042],[1076.98,439.059]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,560.853],[1178.67,681.689],[1076.98,559.449],[1076.98,672.432]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,690.945],[1178.67,811.781],[1076.98,681.087],[1076.98,794.071]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,824.617],[1178.67,945.453],[1076.98,806.072],[1076.98,919.056]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,422.881],[1178.67,302.045],[1204.9,423.692],[1204.9,303.697]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,552.931],[1178.67,432.095],[1204.9,552.836],[1204.9,432.841]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,560.853],[1178.67,681.689],[1204.9,560.702],[1204.9,680.697]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,690.945],[1178.67,811.781],[1204.9,689.889],[1204.9,809.884]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1178.67,824.617],[1178.67,945.453],[1204.9,822.63],[1204.9,942.625]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,417.155],[1294.89,290.372],[1204.9,423.692],[1204.9,303.697]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,553.604],[1294.89,426.822],[1204.9,552.836],[1204.9,432.841]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,561.916],[1294.89,688.698],[1204.9,560.702],[1204.9,680.697]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,698.41],[1294.89,825.192],[1204.9,689.889],[1204.9,809.884]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,838.66],[1294.89,965.442],[1204.9,822.63],[1204.9,942.625]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,417.155],[1294.89,290.372],[1509.78,424.342],[1509.78,305.022]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,553.604],[1294.89,426.822],[1509.78,552.759],[1509.78,433.439]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,561.916],[1294.89,688.698],[1509.78,560.582],[1509.78,679.902]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,698.41],[1294.89,825.192],[1509.78,689.042],[1509.78,808.362]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1294.89,838.66],[1294.89,965.442],[1509.78,821.036],[1509.78,940.356]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1569.55,426.341],[1569.55,309.096],[1754.14,432.514],[1754.14,321.68]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1569.55,552.524],[1569.55,435.28],[1754.14,551.799],[1754.14,440.965]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1569.55,560.211],[1569.55,677.455],[1754.14,559.065],[1754.14,669.899]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1569.55,686.436],[1569.55,803.681],[1754.14,678.389],[1754.14,789.223]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:32,
                    verts:[[1569.55,816.135],[1569.55,933.379],[1754.14,800.996],[1754.14,911.83]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[432.51,476.005],[432.51,410.331],[402.572,477.708],[402.572,413.801]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[432.51,546.687],[432.51,481.013],[402.572,546.487],[402.572,482.58]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[432.51,550.992],[432.51,616.666],[402.572,550.676],[402.572,614.582]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[432.51,621.697],[432.51,687.371],[402.572,619.478],[402.572,683.384]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[432.51,694.347],[432.51,760.021],[402.572,690.172],[402.572,754.079]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,473.367],[456.483,404.954],[415.788,475.727],[415.788,409.764]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,546.997],[456.483,478.583],[415.788,546.719],[415.788,480.756]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,551.482],[456.483,619.895],[415.788,551.044],[415.788,617.007]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,625.136],[456.483,693.549],[415.788,622.06],[415.788,688.023]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,700.816],[456.483,769.229],[415.788,695.03],[415.788,760.993]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,473.367],[456.483,404.954],[474.241,473.677],[474.241,405.585]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,546.997],[456.483,478.583],[474.241,546.96],[474.241,478.869]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,551.482],[456.483,619.895],[474.241,551.424],[474.241,619.516]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,625.136],[456.483,693.549],[474.241,624.732],[474.241,692.823]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[456.483,700.816],[456.483,769.229],[474.241,700.056],[474.241,768.148]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[508.008,471.758],[508.008,401.674],[474.241,473.677],[474.241,405.585]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[508.008,547.186],[508.008,477.102],[474.241,546.96],[474.241,478.869]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[508.008,551.78],[508.008,621.864],[474.241,551.424],[474.241,619.516]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[508.008,627.233],[508.008,697.317],[474.241,624.732],[474.241,692.823]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[508.008,704.761],[508.008,774.845],[474.241,700.056],[474.241,768.148]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[542.974,469.724],[542.974,397.527],[506.891,471.776],[506.891,401.71]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[542.974,547.425],[542.974,475.229],[506.891,547.184],[506.891,477.118]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[542.974,552.158],[542.974,624.354],[506.891,551.777],[506.891,621.843]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[542.974,629.885],[542.974,702.081],[506.891,627.21],[506.891,697.276]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[542.974,709.75],[542.974,781.947],[506.891,704.719],[506.891,774.785]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,466.522],[574.525,391.002],[525.119,469.387],[525.119,396.841]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,547.801],[574.525,472.281],[525.119,547.464],[525.119,474.919]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,552.752],[574.525,628.273],[525.119,552.22],[525.119,624.766]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,634.058],[574.525,709.579],[525.119,630.324],[525.119,702.869]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,717.601],[574.525,793.121],[525.119,710.576],[525.119,783.121]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,466.522],[574.525,391.002],[593.506,466.9],[593.506,391.771]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,547.801],[574.525,472.281],[593.506,547.757],[593.506,472.628]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,552.752],[574.525,628.273],[593.506,552.682],[593.506,627.811]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,634.058],[574.525,709.579],[593.506,633.566],[593.506,708.695]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[574.525,717.601],[574.525,793.121],[593.506,716.675],[593.506,791.804]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[634.737,464.557],[634.737,386.995],[593.506,466.9],[593.506,391.771]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[634.737,548.032],[634.737,470.471],[593.506,547.757],[593.506,472.628]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[634.737,553.117],[634.737,630.679],[593.506,552.682],[593.506,627.811]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[634.737,636.62],[634.737,714.182],[593.506,633.566],[593.506,708.695]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[634.737,722.421],[634.737,799.982],[593.506,716.675],[593.506,791.804]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[677.254,462.088],[677.254,381.963],[632.954,464.607],[632.954,387.098]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[677.254,548.322],[677.254,468.197],[632.954,548.026],[632.954,470.517]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[677.254,553.575],[677.254,633.7],[632.954,553.108],[632.954,630.617]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[677.254,639.838],[677.254,719.963],[632.954,636.554],[632.954,714.064]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[677.254,728.474],[677.254,808.599],[632.954,722.297],[632.954,799.807]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,458.125],[719.344,373.885],[658.149,461.673],[658.149,381.118]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,548.788],[719.344,464.548],[658.149,548.371],[658.149,467.815]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,554.311],[719.344,638.551],[658.149,553.652],[658.149,634.208]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,645.004],[719.344,729.245],[658.149,640.379],[658.149,720.934]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,738.193],[719.344,822.433],[658.149,729.491],[658.149,810.047]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,458.125],[719.344,373.885],[739.666,458.594],[739.666,374.841]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,548.788],[719.344,464.548],[739.666,548.733],[739.666,464.98]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,554.311],[719.344,638.551],[739.666,554.224],[739.666,637.977]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,645.004],[719.344,729.245],[739.666,644.392],[739.666,728.145]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[719.344,738.193],[719.344,822.433],[739.666,737.042],[739.666,820.795]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[791.571,455.645],[791.571,368.829],[739.666,458.594],[739.666,374.841]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[791.571,549.08],[791.571,462.264],[739.666,548.733],[739.666,464.98]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[791.571,554.771],[791.571,641.587],[739.666,554.224],[739.666,637.977]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[791.571,648.237],[791.571,735.053],[739.666,644.392],[739.666,728.145]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[791.571,744.275],[791.571,831.09],[739.666,737.042],[739.666,820.795]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[792.101,455.658],[792.101,368.856],[836.948,456.748],[836.948,371.078]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[792.101,549.078],[792.101,462.276],[836.948,548.95],[836.948,463.28]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[792.101,554.769],[792.101,641.571],[836.948,554.566],[836.948,640.236]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[792.101,648.22],[792.101,735.022],[836.948,646.799],[836.948,732.469]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[792.101,744.242],[792.101,831.044],[836.948,741.569],[836.948,827.239]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[939.892,447.154],[939.892,351.521],[877.182,450.72],[877.182,358.79]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[939.892,550.078],[939.892,454.445],[877.182,549.659],[877.182,457.729]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[939.892,556.347],[939.892,651.98],[877.182,555.685],[877.182,647.615]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[939.892,659.306],[939.892,754.938],[877.182,654.657],[877.182,746.587]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[939.892,765.097],[939.892,860.729],[877.182,756.352],[877.182,848.282]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,441.451],[1006.9,339.897],[918.752,446.562],[918.752,350.315]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,550.748],[1006.9,449.194],[918.752,550.147],[918.752,453.901]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,557.406],[1006.9,658.96],[918.752,556.457],[918.752,652.704]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,666.739],[1006.9,768.293],[918.752,660.077],[918.752,756.324]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,779.081],[1006.9,880.635],[918.752,766.547],[918.752,862.794]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,441.451],[1006.9,339.897],[1029.36,442.132],[1029.36,341.286]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,550.748],[1006.9,449.194],[1029.36,550.668],[1029.36,449.822]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,557.406],[1006.9,658.96],[1029.36,557.279],[1029.36,658.126]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,666.739],[1006.9,768.293],[1029.36,665.851],[1029.36,766.697]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1006.9,779.081],[1006.9,880.635],[1029.36,777.41],[1029.36,878.256]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1104.49,437.864],[1104.49,332.584],[1029.36,442.132],[1029.36,341.286]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1104.49,551.17],[1104.49,445.891],[1029.36,550.668],[1029.36,449.822]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1104.49,558.072],[1104.49,663.351],[1029.36,557.279],[1029.36,658.126]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1104.49,671.416],[1104.49,776.695],[1029.36,665.851],[1029.36,766.697]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1104.49,787.878],[1104.49,893.157],[1029.36,777.41],[1029.36,878.256]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1187.92,433.122],[1187.92,322.92],[1106.04,437.775],[1106.04,332.404]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1187.92,551.727],[1187.92,441.525],[1106.04,551.18],[1106.04,445.809]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1187.92,558.952],[1187.92,669.154],[1106.04,558.088],[1106.04,663.459]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1187.92,677.596],[1187.92,787.798],[1106.04,671.531],[1106.04,776.902]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1187.92,799.504],[1187.92,909.706],[1106.04,788.095],[1106.04,893.466]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,425.446],[1282.91,307.273],[1164.57,432.308],[1164.57,321.261]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,552.629],[1282.91,434.456],[1164.57,551.823],[1164.57,440.775]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,560.377],[1282.91,678.55],[1164.57,559.103],[1164.57,670.151]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,687.602],[1282.91,805.775],[1164.57,678.657],[1164.57,789.705]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,818.328],[1282.91,936.501],[1164.57,801.501],[1164.57,912.548]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,425.446],[1282.91,307.273],[1305.98,426.337],[1305.98,309.088]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,552.63],[1282.91,434.456],[1305.98,552.525],[1305.98,435.276]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,560.377],[1282.91,678.55],[1305.98,560.211],[1305.98,677.46]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,687.602],[1282.91,805.775],[1305.98,686.441],[1305.98,803.69]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1282.91,818.328],[1282.91,936.501],[1305.98,816.144],[1305.98,933.393]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,420.471],[1409.13,297.132],[1305.98,426.337],[1305.98,309.088]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,553.214],[1409.13,429.875],[1305.98,552.525],[1305.98,435.276]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,561.3],[1409.13,684.639],[1305.98,560.211],[1305.98,677.46]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,694.087],[1409.13,817.426],[1305.98,686.441],[1305.98,803.69]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,830.528],[1409.13,953.867],[1305.98,816.144],[1305.98,933.393]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,420.471],[1409.13,297.132],[1593.7,428.239],[1593.7,312.966]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,553.214],[1409.13,429.875],[1593.7,552.301],[1593.7,437.028]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,561.3],[1409.13,684.639],[1593.7,559.858],[1593.7,675.131]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,694.087],[1409.13,817.426],[1593.7,683.961],[1593.7,799.234]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1409.13,830.528],[1409.13,953.867],[1593.7,811.479],[1593.7,926.752]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1644.58,430.38],[1644.58,317.331],[1800.49,436.942],[1800.49,330.706]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1644.58,552.05],[1644.58,439],[1800.49,551.278],[1800.49,445.042]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1644.58,559.461],[1644.58,672.51],[1800.49,558.243],[1800.49,664.479]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1644.58,681.17],[1644.58,794.22],[1800.49,672.617],[1800.49,778.853]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:33,
                    verts:[[1644.58,806.228],[1644.58,919.278],[1800.49,790.137],[1800.49,896.373]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[395.078,475.121],[395.078,408.529],[359.273,476.758],[359.273,411.865]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[395.078,546.791],[395.078,480.199],[359.273,546.598],[359.273,481.706]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[395.078,551.156],[395.078,617.748],[359.273,550.852],[359.273,615.745]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[395.078,622.849],[395.078,689.441],[359.273,620.716],[359.273,685.608]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[395.078,696.515],[395.078,763.106],[359.273,692.501],[359.273,757.394]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,472.537],[427.309,403.261],[378.611,474.8],[378.611,407.875]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,547.094],[427.309,477.819],[378.611,546.828],[378.611,479.903]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,551.636],[427.309,620.911],[378.611,551.216],[378.611,618.141]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,626.218],[427.309,695.494],[378.611,623.267],[378.611,690.193]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,702.852],[427.309,772.128],[378.611,697.302],[378.611,764.227]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,472.537],[427.309,403.261],[444.691,472.893],[444.691,403.987]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,547.094],[427.309,477.819],[444.691,547.052],[444.691,478.146]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,551.636],[427.309,620.911],[444.691,551.57],[444.691,620.476]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,626.218],[427.309,695.494],[444.691,625.754],[444.691,694.66]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[427.309,702.852],[427.309,772.128],[444.691,701.98],[444.691,770.886]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[484.789,471.061],[484.789,400.253],[444.691,472.893],[444.691,403.987]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[484.789,547.268],[484.789,476.46],[444.691,547.052],[444.691,478.146]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[484.789,551.91],[484.789,622.718],[444.691,551.57],[444.691,620.476]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[484.789,628.142],[484.789,698.95],[444.691,625.754],[444.691,694.66]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[484.789,706.471],[484.789,777.28],[444.691,701.98],[444.691,770.886]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[526.31,469.123],[526.31,396.303],[483.596,471.075],[483.596,400.282]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[526.31,547.496],[526.31,474.675],[483.596,547.266],[483.596,476.473]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[526.31,552.269],[526.31,625.09],[483.596,551.907],[483.596,622.7]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[526.31,630.668],[526.31,703.488],[483.596,628.123],[483.596,698.916]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[526.31,711.224],[526.31,784.044],[483.596,706.436],[483.596,777.229]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,466.021],[567.494,389.979],[509.012,468.739],[509.012,395.52]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,547.86],[567.494,471.818],[509.012,547.541],[509.012,474.322]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,552.845],[567.494,628.887],[509.012,552.341],[509.012,625.56]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,634.712],[567.494,710.754],[509.012,631.169],[509.012,704.388]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,718.831],[567.494,794.873],[509.012,712.165],[509.012,785.385]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,466.021],[567.494,389.979],[585.744,466.449],[585.744,390.852]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,547.86],[567.494,471.818],[585.744,547.81],[585.744,472.213]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,552.845],[567.494,628.887],[585.744,552.766],[585.744,628.363]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,634.712],[567.494,710.754],[585.744,634.153],[585.744,709.75]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[567.494,718.831],[567.494,794.873],[585.744,717.78],[585.744,793.377]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[634.136,464.238],[634.136,386.346],[585.744,466.449],[585.744,390.852]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[634.136,548.07],[634.136,470.178],[585.744,547.81],[585.744,472.213]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[634.136,553.176],[634.136,631.068],[585.744,552.766],[585.744,628.363]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[634.136,637.035],[634.136,714.927],[585.744,634.153],[585.744,709.75]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[634.136,723.201],[634.136,801.094],[585.744,717.78],[585.744,793.377]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[683.986,461.916],[683.986,381.612],[632.19,464.283],[632.19,386.438]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[683.986,548.343],[683.986,468.039],[632.19,548.064],[632.19,470.219]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[683.986,553.607],[683.986,633.911],[632.19,553.168],[632.19,631.014]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[683.986,640.063],[683.986,720.367],[632.19,636.977],[632.19,714.822]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[683.986,728.897],[683.986,809.201],[632.19,723.091],[632.19,800.937]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,458.126],[737.337,373.886],[665.852,461.449],[665.852,380.659]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,548.788],[737.337,464.549],[665.852,548.398],[665.852,467.608]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,554.311],[737.337,638.55],[665.852,553.694],[665.852,634.483]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,645.003],[737.337,729.243],[665.852,640.672],[665.852,721.461]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,738.191],[737.337,822.43],[665.852,730.043],[665.852,810.832]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,458.126],[737.337,373.886],[756.441,458.651],[756.441,374.958]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,548.788],[737.337,464.549],[756.441,548.726],[756.441,465.033]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,554.311],[737.337,638.55],[756.441,554.213],[756.441,637.907]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,645.003],[737.337,729.243],[756.441,644.318],[756.441,728.011]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[737.337,738.191],[737.337,822.43],[756.441,736.902],[756.441,820.595]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.495,455.908],[816.495,369.366],[756.441,458.651],[756.441,374.958]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.495,549.049],[816.495,462.507],[756.441,548.726],[756.441,465.033]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.495,554.722],[816.495,641.265],[756.441,554.213],[756.441,637.907]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.495,647.894],[816.495,734.436],[756.441,644.318],[756.441,728.011]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.495,743.629],[816.495,830.171],[756.441,736.902],[756.441,820.595]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.987,455.923],[816.987,369.396],[858.709,457.135],[858.709,371.867]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.987,549.047],[816.987,462.52],[858.709,548.905],[858.709,463.636]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.987,554.72],[816.987,641.247],[858.709,554.495],[858.709,639.763]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.987,647.875],[816.987,734.401],[858.709,646.295],[858.709,731.563]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[816.987,743.593],[816.987,830.12],[858.709,740.621],[858.709,825.889]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[986.665,448.081],[986.665,353.411],[915.072,451.353],[915.072,360.082]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[986.665,549.969],[986.665,455.299],[915.072,549.584],[915.072,458.313]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[986.665,556.175],[986.665,650.845],[915.072,555.568],[915.072,646.84]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[986.665,658.097],[986.665,752.767],[915.072,653.831],[915.072,745.103]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[986.665,762.823],[986.665,857.493],[915.072,754.798],[915.072,846.07]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,442.767],[1067.76,342.579],[967.422,447.431],[967.422,352.086]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,550.594],[1067.76,450.406],[967.422,550.045],[967.422,454.701]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,557.162],[1067.76,657.349],[967.422,556.296],[967.422,651.641]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,665.024],[1067.76,765.211],[967.422,658.944],[967.422,754.289]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,775.854],[1067.76,876.041],[967.422,764.417],[967.422,859.762]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,442.767],[1067.76,342.579],[1087.91,443.51],[1087.91,344.093]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,550.594],[1067.76,450.406],[1087.91,550.506],[1087.91,451.09]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,557.162],[1067.76,657.349],[1087.91,557.024],[1087.91,656.44]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,665.024],[1067.76,765.211],[1087.91,664.056],[1087.91,763.472]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1067.76,775.854],[1067.76,876.041],[1087.91,774.033],[1087.91,873.449]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1172.41,439.65],[1172.41,336.225],[1087.91,443.51],[1087.91,344.093]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1172.41,550.96],[1172.41,447.535],[1087.91,550.506],[1087.91,451.09]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1172.41,557.74],[1172.41,661.165],[1087.91,557.024],[1087.91,656.44]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1172.41,669.088],[1172.41,772.512],[1087.91,664.056],[1087.91,763.472]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1172.41,783.498],[1172.41,886.923],[1087.91,774.032],[1087.91,873.449]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1265.57,435.394],[1265.57,327.55],[1174.16,439.57],[1174.16,336.062]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1265.57,551.46],[1265.57,443.617],[1174.16,550.969],[1174.16,447.462]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1265.57,558.53],[1265.57,666.374],[1174.16,557.755],[1174.16,661.263]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1265.57,674.635],[1265.57,782.479],[1174.16,669.192],[1174.16,772.699]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1265.57,793.934],[1265.57,901.778],[1174.16,783.694],[1174.16,887.202]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,428.408],[1376.67,313.31],[1245.19,434.519],[1245.19,325.768]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,552.281],[1376.67,437.184],[1245.19,551.563],[1245.19,442.811]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,559.827],[1376.67,674.924],[1245.19,558.693],[1245.19,667.444]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,683.741],[1376.67,798.839],[1245.19,675.775],[1245.19,784.527]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,811.065],[1376.67,926.163],[1245.19,796.079],[1245.19,904.831]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,428.408],[1376.67,313.31],[1396.38,429.354],[1396.38,315.238]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,552.281],[1376.67,437.184],[1396.38,552.17],[1396.38,438.055]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,559.827],[1376.67,674.925],[1396.38,559.651],[1396.38,673.767]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,683.741],[1376.67,798.839],[1396.38,682.508],[1396.38,796.624]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1376.67,811.065],[1376.67,926.163],[1396.38,808.745],[1396.38,922.861]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,424.19],[1509.34,304.713],[1396.37,429.354],[1396.37,315.238]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,552.777],[1509.34,433.3],[1396.37,552.17],[1396.37,438.055]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,560.61],[1509.34,680.087],[1396.37,559.651],[1396.37,673.767]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,689.239],[1509.34,808.716],[1396.37,682.508],[1396.37,796.624]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,821.407],[1509.34,940.884],[1396.37,808.745],[1396.37,922.861]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,424.19],[1509.34,304.713],[1662.98,432.314],[1662.98,321.272]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,552.777],[1509.34,433.3],[1662.98,551.822],[1662.98,440.78]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,560.61],[1509.34,680.087],[1662.98,559.102],[1662.98,670.144]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,689.239],[1509.34,808.716],[1662.98,678.65],[1662.98,789.692]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1509.34,821.407],[1509.34,940.884],[1662.98,801.487],[1662.98,912.529]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1705.03,434.537],[1705.03,325.804],[1833.09,441.308],[1833.09,339.606]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1705.03,551.561],[1705.03,442.828],[1833.09,550.765],[1833.09,449.063]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1705.03,558.689],[1705.03,667.422],[1833.09,557.432],[1833.09,659.135]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1705.03,675.752],[1705.03,784.485],[1833.09,666.925],[1833.09,768.628]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:34,
                    verts:[[1705.03,796.035],[1705.03,904.768],[1833.09,779.431],[1833.09,881.133]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[361.121,474.18],[361.121,406.611],[319.39,475.737],[319.39,409.785]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[361.121,546.901],[361.121,479.332],[319.39,546.718],[319.39,480.766]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[361.121,551.331],[361.121,618.9],[319.39,551.042],[319.39,616.994]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[361.121,624.076],[361.121,691.645],[319.39,622.046],[319.39,687.999]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[361.121,698.822],[361.121,766.392],[319.39,695.005],[319.39,760.957]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,471.669],[401.72,401.493],[345.004,473.817],[345.004,405.871]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,547.196],[401.72,477.02],[345.004,546.944],[345.004,478.998]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,551.797],[401.72,621.973],[345.004,551.398],[345.004,619.344]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,627.349],[401.72,697.525],[345.004,624.549],[345.004,692.496]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,704.979],[401.72,775.156],[345.004,699.713],[345.004,767.659]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,471.669],[401.72,401.493],[418.611,472.07],[418.611,402.31]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,547.196],[401.72,477.02],[418.611,547.149],[418.611,477.389]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,551.797],[401.72,621.973],[418.611,551.722],[418.611,621.482]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,627.349],[401.72,697.525],[418.611,626.826],[418.611,696.586]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[401.72,704.979],[401.72,775.156],[418.611,703.996],[418.611,773.756]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[464.973,470.341],[464.973,398.786],[418.611,472.07],[418.611,402.31]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[464.973,547.352],[464.973,475.797],[418.611,547.149],[418.611,477.389]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[464.973,552.043],[464.973,623.598],[418.611,551.722],[418.611,621.482]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[464.973,629.08],[464.973,700.635],[418.611,626.826],[418.611,696.586]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[464.973,708.236],[464.973,779.791],[418.611,703.996],[418.611,773.756]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[512.918,468.517],[512.918,395.067],[463.709,470.353],[463.709,398.809]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[512.918,547.567],[512.918,474.117],[463.709,547.351],[463.709,475.808]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[512.918,552.382],[512.918,625.832],[463.709,552.041],[463.709,623.585]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[512.918,631.458],[512.918,704.908],[463.709,629.065],[463.709,700.608]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[512.918,712.71],[512.918,786.159],[463.709,708.208],[463.709,779.751]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,465.54],[563.586,388.999],[496.311,468.088],[496.311,394.192]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,547.917],[563.586,471.376],[496.311,547.617],[496.311,473.722]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,552.935],[563.586,629.475],[496.311,552.462],[496.311,626.357]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,635.339],[563.586,711.879],[496.311,632.018],[496.311,705.913]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,720.01],[563.586,796.55],[496.311,713.763],[496.311,787.658]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,465.54],[563.586,388.999],[580.953,466.017],[580.953,389.971]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,547.917],[563.586,471.376],[580.953,547.861],[580.953,471.815]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,552.935],[563.586,629.475],[580.953,552.846],[580.953,628.892]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,635.338],[563.586,711.879],[580.953,634.717],[580.953,710.763]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[563.586,720.01],[563.586,796.55],[580.953,718.841],[580.953,794.886]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[636.174,463.958],[636.174,385.774],[580.953,466.017],[580.953,389.971]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[636.174,548.103],[636.174,469.919],[580.953,547.861],[580.953,471.815]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[636.174,553.228],[636.174,631.412],[580.953,552.846],[580.953,628.892]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[636.174,637.401],[636.174,715.585],[580.953,634.717],[580.953,710.763]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[636.174,723.89],[636.174,802.074],[580.953,718.841],[580.953,794.886]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[692.932,461.801],[692.932,381.378],[634.08,463.997],[634.08,385.853]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[692.932,548.356],[692.932,467.933],[634.08,548.098],[634.08,469.955]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[692.932,553.629],[692.932,634.052],[634.08,553.221],[634.08,631.365]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[692.932,640.213],[692.932,720.636],[634.08,637.35],[634.08,715.494]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[692.932,729.179],[692.932,809.602],[634.08,723.795],[634.08,801.938]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,458.218],[756.962,374.073],[675.935,461.286],[675.935,380.328]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,548.777],[756.962,464.633],[675.935,548.417],[675.935,467.459]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,554.294],[756.962,638.438],[675.935,553.724],[675.935,634.682]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,644.883],[756.962,729.028],[675.935,640.884],[675.935,721.842]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,737.966],[756.962,822.11],[675.935,730.442],[675.935,811.4]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,458.218],[756.962,374.073],[774.667,458.793],[774.667,375.247]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,548.777],[756.962,464.633],[774.667,548.71],[774.667,465.164]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,554.294],[756.962,638.438],[774.667,554.187],[774.667,637.733]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,644.883],[756.962,729.028],[774.667,644.133],[774.667,727.679]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[756.962,737.966],[756.962,822.11],[774.667,736.554],[774.667,820.1]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.117,456.278],[842.117,370.12],[774.667,458.793],[774.667,375.247]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.117,549.005],[842.117,462.848],[774.667,548.71],[774.667,465.164]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.117,554.654],[842.117,640.812],[774.667,554.187],[774.667,637.733]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.117,647.411],[842.117,733.569],[774.667,644.133],[774.667,727.679]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.117,742.721],[842.117,828.879],[774.667,736.554],[774.667,820.1]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.567,456.294],[842.567,370.153],[880.787,457.612],[880.787,372.839]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.567,549.003],[842.567,462.862],[880.787,548.849],[880.787,464.076]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.567,554.651],[842.567,640.792],[880.787,554.406],[880.787,639.179]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.567,647.39],[842.567,733.532],[880.787,645.673],[880.787,730.446]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[842.567,742.682],[842.567,828.823],[880.787,739.451],[880.787,824.224]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1031.43,449.172],[1031.43,355.636],[952.188,452.129],[952.188,361.662]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1031.43,549.841],[1031.43,456.304],[952.188,549.493],[952.188,459.026]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1031.43,555.973],[1031.43,649.509],[952.188,555.424],[952.188,645.891]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1031.43,656.674],[1031.43,750.211],[952.188,652.821],[952.188,743.288]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1031.43,760.147],[1031.43,853.683],[952.188,752.897],[952.188,843.364]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,444.288],[1124.82,345.68],[1014.26,448.475],[1014.26,354.214]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,550.415],[1124.82,451.807],[1014.26,549.923],[1014.26,455.662]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,556.879],[1124.82,655.487],[1014.26,556.102],[1014.26,650.363]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,663.041],[1124.82,761.649],[1014.26,657.584],[1014.26,751.844]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,772.123],[1124.82,870.731],[1014.26,761.857],[1014.26,856.118]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,444.288],[1124.82,345.68],[1142.48,445.078],[1142.48,347.29]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,550.415],[1124.82,451.807],[1142.48,550.322],[1142.48,452.534]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,556.879],[1124.82,655.487],[1142.48,556.733],[1142.48,654.521]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,663.041],[1124.82,761.649],[1142.48,662.011],[1142.48,759.799]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1124.82,772.123],[1124.82,870.731],[1142.48,770.187],[1142.48,867.975]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1234.54,441.646],[1234.54,340.293],[1142.48,445.078],[1142.48,347.29]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1234.54,550.725],[1234.54,449.373],[1142.48,550.322],[1142.48,452.534]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1234.54,557.37],[1234.54,658.722],[1142.48,556.733],[1142.48,654.521]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1234.54,666.486],[1234.54,767.838],[1142.48,662.011],[1142.48,759.799]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1234.54,778.604],[1234.54,879.956],[1142.48,770.187],[1142.48,867.975]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1335.23,437.891],[1335.23,332.64],[1236.43,441.575],[1236.43,340.149]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1335.23,551.167],[1335.23,445.916],[1236.43,550.734],[1236.43,449.308]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1335.23,558.067],[1335.23,663.318],[1236.43,557.383],[1236.43,658.808]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1335.23,671.38],[1335.23,776.631],[1236.43,666.578],[1236.43,768.003]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1335.23,787.811],[1335.23,893.062],[1236.43,778.777],[1236.43,880.203]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,431.63],[1459.11,319.878],[1317.95,436.975],[1317.95,330.774]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,551.903],[1459.11,440.151],[1317.95,551.274],[1317.95,445.073]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,559.229],[1459.11,670.981],[1317.95,558.237],[1317.95,664.438]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,679.541],[1459.11,791.294],[1317.95,672.573],[1317.95,778.775]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,803.164],[1459.11,914.916],[1317.95,790.056],[1317.95,896.257]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,431.63],[1459.11,319.878],[1475.39,432.609],[1475.39,321.873]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,551.903],[1459.11,440.151],[1475.39,551.788],[1475.39,441.052]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,559.229],[1459.11,670.981],[1475.39,559.047],[1475.39,669.783]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,679.541],[1459.11,791.294],[1475.39,678.265],[1475.39,789.001]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1459.11,803.164],[1459.11,914.916],[1475.39,800.764],[1475.39,911.499]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,428.145],[1595.03,312.775],[1475.39,432.609],[1475.39,321.873]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,552.312],[1595.03,436.942],[1475.39,551.788],[1475.39,441.052]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,559.876],[1595.03,675.246],[1475.39,559.047],[1475.39,669.783]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,684.083],[1595.03,799.454],[1475.39,678.265],[1475.39,789.001]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,811.709],[1595.03,927.079],[1475.39,800.764],[1475.39,911.499]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,428.145],[1595.03,312.775],[1718.35,436.43],[1718.35,329.662]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,552.312],[1595.03,436.942],[1718.35,551.338],[1718.35,444.57]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,559.876],[1595.03,675.246],[1718.35,558.338],[1718.35,665.106]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,684.083],[1595.03,799.454],[1718.35,673.285],[1718.35,780.053]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1595.03,811.709],[1595.03,927.079],[1718.35,791.394],[1718.35,898.162]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1751.92,438.685],[1751.92,334.259],[1853.67,445.521],[1853.67,348.192]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1751.92,551.073],[1751.92,446.647],[1853.67,550.27],[1853.67,452.941]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1751.92,557.919],[1751.92,662.346],[1853.67,556.651],[1853.67,653.979]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1751.92,670.345],[1751.92,774.771],[1853.67,661.435],[1853.67,758.763]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:35,
                    verts:[[1751.92,785.864],[1751.92,890.29],[1853.67,769.102],[1853.67,866.43]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[330.728,473.178],[330.728,404.568],[283.034,474.641],[283.034,407.551]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[330.728,547.019],[330.728,478.409],[283.034,546.847],[283.034,479.757]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[330.728,551.517],[330.728,620.127],[283.034,551.245],[283.034,618.335]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[330.728,625.382],[330.728,693.992],[283.034,623.475],[283.034,690.565]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[330.728,701.28],[330.728,769.89],[283.034,697.691],[283.034,764.781]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,470.761],[379.767,399.641],[315.062,472.773],[315.062,403.743]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,547.303],[379.767,476.184],[315.062,547.067],[315.062,478.036]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,551.965],[379.767,623.085],[315.062,551.592],[315.062,620.622]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,628.533],[379.767,699.652],[315.062,625.91],[315.062,694.94]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,707.207],[379.767,778.326],[315.062,702.273],[315.062,771.303]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,470.761],[379.767,399.641],[396.05,471.206],[396.05,400.548]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,547.303],[379.767,476.184],[396.05,547.251],[396.05,476.593]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,551.965],[379.767,623.085],[396.05,551.883],[396.05,622.541]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,628.533],[379.767,699.652],[396.05,627.953],[396.05,698.611]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[379.767,707.207],[379.767,778.326],[396.05,706.116],[396.05,776.774]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[448.567,469.595],[448.567,397.265],[396.05,471.206],[396.05,400.548]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[448.567,547.44],[448.567,475.11],[396.05,547.251],[396.05,476.593]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[448.567,552.182],[448.567,624.512],[396.05,551.883],[396.05,622.541]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[448.567,630.052],[448.567,702.383],[396.05,627.953],[396.05,698.611]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[448.567,710.066],[448.567,782.396],[396.05,706.116],[396.05,776.774]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[502.759,467.9],[502.759,393.809],[447.239,469.603],[447.239,397.281]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[502.759,547.639],[502.759,473.549],[447.239,547.439],[447.239,475.117]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[502.759,552.497],[502.759,626.587],[447.239,552.18],[447.239,624.502]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[502.759,632.263],[502.759,706.353],[447.239,630.042],[447.239,702.364]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[502.759,714.224],[502.759,788.314],[447.239,710.046],[447.239,782.368]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,465.073],[562.687,388.047],[486.973,467.427],[486.973,392.846]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,547.972],[562.687,470.946],[486.973,547.695],[486.973,473.114]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,553.021],[562.687,630.047],[486.973,552.584],[486.973,627.165]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,635.948],[562.687,712.974],[486.973,632.878],[486.973,707.46]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,721.156],[562.687,798.182],[486.973,715.382],[486.973,789.963]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,465.073],[562.687,388.047],[579.027,465.594],[579.027,389.11]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,547.972],[562.687,470.946],[579.027,547.91],[579.027,471.426]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,553.021],[562.687,630.047],[579.027,552.925],[579.027,629.409]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,635.948],[562.687,712.974],[579.027,635.268],[579.027,711.752]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[562.687,721.156],[562.687,798.182],[579.027,719.877],[579.027,796.361]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[640.684,463.703],[640.684,385.255],[579.027,465.594],[579.027,389.11]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[640.684,548.133],[640.684,469.685],[579.027,547.91],[579.027,471.426]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[640.684,553.276],[640.684,631.724],[579.027,552.925],[579.027,629.409]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[640.684,637.733],[640.684,716.181],[579.027,635.268],[579.027,711.752]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[640.684,724.514],[640.684,802.962],[579.027,719.877],[579.027,796.361]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[703.862,461.729],[703.862,381.231],[638.459,463.736],[638.459,385.322]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[703.862,548.365],[703.862,467.867],[638.459,548.129],[638.459,469.715]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[703.862,553.642],[703.862,634.14],[638.459,553.269],[638.459,631.683]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[703.862,640.306],[703.862,720.804],[638.459,637.69],[638.459,716.104]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[703.862,729.355],[703.862,809.852],[638.459,724.434],[638.459,802.848]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,458.381],[777.882,374.406],[688.148,461.171],[688.148,380.094]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,548.758],[777.882,464.784],[688.148,548.43],[688.148,467.353]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,554.263],[777.882,638.238],[688.148,553.745],[688.148,634.823]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,644.671],[777.882,728.645],[688.148,641.033],[688.148,722.11]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,737.566],[777.882,821.54],[688.148,730.723],[688.148,811.8]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,458.381],[777.882,374.406],[794.036,459],[794.036,375.669]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,548.758],[777.882,464.784],[794.036,548.685],[794.036,465.354]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,554.263],[777.882,638.238],[794.036,554.148],[794.036,637.48]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,644.671],[777.882,728.645],[794.036,643.863],[794.036,727.195]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[777.882,737.566],[777.882,821.54],[794.036,736.047],[794.036,819.378]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.066,456.73],[868.066,371.041],[794.036,459],[794.036,375.669]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.066,548.952],[868.066,463.263],[794.036,548.685],[794.036,465.354]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.066,554.57],[868.066,640.259],[794.036,554.148],[794.036,637.48]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.066,646.823],[868.066,732.512],[794.036,643.863],[794.036,727.195]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.066,741.614],[868.066,827.303],[794.036,736.047],[794.036,819.378]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.47,456.747],[868.47,371.076],[902.891,458.154],[902.891,373.944]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.47,548.95],[868.47,463.279],[902.891,548.785],[902.891,464.575]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.47,554.567],[868.47,640.238],[902.891,554.306],[902.891,638.516]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.47,646.8],[868.47,732.472],[902.891,644.966],[902.891,729.177]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[868.47,741.572],[868.47,827.243],[902.891,738.122],[902.891,822.332]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1073.71,450.381],[1073.71,358.1],[988.084,453.009],[988.084,363.455]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1073.71,549.699],[1073.71,457.417],[988.084,549.39],[988.084,459.837]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1073.71,555.748],[1073.71,648.029],[988.084,555.261],[988.084,644.814]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1073.71,655.098],[1073.71,747.38],[988.084,651.674],[988.084,741.227]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1073.71,757.182],[1073.71,849.463],[988.084,750.739],[988.084,840.293]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,445.953],[1177.54,349.073],[1058.73,449.647],[1058.73,356.604]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,550.219],[1177.54,453.339],[1058.73,549.785],[1058.73,456.741]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,556.57],[1177.54,653.45],[1058.73,555.885],[1058.73,648.928]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,660.871],[1177.54,757.751],[1058.73,656.055],[1058.73,749.099]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,768.042],[1177.54,864.921],[1058.73,758.982],[1058.73,852.026]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,445.953],[1177.54,349.073],[1192.63,446.776],[1192.63,350.752]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,550.219],[1177.54,453.339],[1192.63,550.122],[1192.63,454.098]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,556.57],[1177.54,653.45],[1192.63,556.417],[1192.63,652.442]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,660.871],[1177.54,757.751],[1192.63,659.798],[1192.63,755.822]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1177.54,768.042],[1177.54,864.921],[1192.63,766.022],[1192.63,862.047]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1290.45,443.776],[1290.45,344.636],[1192.63,446.776],[1192.63,350.752]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1290.45,550.475],[1290.45,451.335],[1192.63,550.122],[1192.63,454.098]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1290.45,556.974],[1290.45,656.114],[1192.63,556.417],[1192.63,652.442]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1290.45,663.709],[1290.45,762.848],[1192.63,659.798],[1192.63,755.822]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1290.45,773.379],[1290.45,872.519],[1192.63,766.022],[1192.63,862.047]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1396.6,440.521],[1396.6,338],[1292.46,443.714],[1292.46,344.511]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1396.6,550.858],[1396.6,448.337],[1292.46,550.482],[1292.46,451.278]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1396.6,557.579],[1396.6,660.099],[1292.46,556.986],[1292.46,656.19]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1396.6,667.952],[1396.6,770.472],[1292.46,663.789],[1292.46,762.993]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1396.6,781.362],[1396.6,883.883],[1292.46,773.53],[1292.46,872.734]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,434.989],[1530.1,326.725],[1382.42,439.581],[1382.42,336.086]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,551.508],[1530.1,443.244],[1382.42,550.968],[1382.42,447.472]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,558.605],[1530.1,666.869],[1382.42,557.753],[1382.42,661.248]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,675.163],[1530.1,783.427],[1382.42,669.176],[1382.42,772.672]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,794.927],[1530.1,903.191],[1382.42,783.666],[1382.42,887.161]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,434.989],[1530.1,326.725],[1543.02,435.982],[1543.02,328.748]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,551.508],[1530.1,443.244],[1543.02,551.391],[1543.02,444.158]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,558.605],[1530.1,666.869],[1543.02,558.421],[1543.02,665.655]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,675.163],[1530.1,783.427],[1543.02,673.869],[1543.02,781.102]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1530.1,794.927],[1530.1,903.191],[1543.02,792.493],[1543.02,899.726]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,432.192],[1666.54,321.023],[1543.02,435.982],[1543.02,328.748]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,551.837],[1666.54,440.668],[1543.02,551.391],[1543.02,444.158]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,559.125],[1666.54,670.293],[1543.02,558.421],[1543.02,665.655]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,678.809],[1666.54,789.978],[1543.02,673.869],[1543.02,781.102]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,801.786],[1666.54,912.955],[1543.02,792.493],[1543.02,899.726]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,432.192],[1666.54,321.023],[1761.02,440.479],[1761.02,337.916]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,551.837],[1666.54,440.668],[1761.02,550.862],[1761.02,448.299]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,559.125],[1666.54,670.293],[1761.02,557.586],[1761.02,660.149]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,678.809],[1666.54,789.978],[1761.02,668.006],[1761.02,770.569]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1666.54,801.786],[1666.54,912.955],[1761.02,781.463],[1761.02,884.026]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1786.64,442.727],[1786.64,342.497],[1864.03,449.515],[1864.03,356.335]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1786.64,550.598],[1786.64,450.369],[1864.03,549.8],[1864.03,456.62]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1786.64,557.169],[1786.64,657.399],[1864.03,555.909],[1864.03,649.089]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1786.64,665.076],[1786.64,765.306],[1864.03,656.227],[1864.03,749.407]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:36,
                    verts:[[1786.64,775.952],[1786.64,876.182],[1864.03,759.305],[1864.03,852.486]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[303.937,472.109],[303.937,402.39],[250.267,473.465],[250.267,405.154]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[303.937,547.145],[303.937,477.425],[250.267,546.985],[250.267,478.674]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[303.937,551.715],[303.937,621.435],[250.267,551.464],[250.267,619.775]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[303.937,626.775],[303.937,696.494],[250.267,625.008],[250.267,693.319]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[303.937,703.9],[303.937,773.62],[250.267,700.575],[250.267,768.887]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,469.806],[361.449,397.694],[288.826,471.663],[288.826,401.481]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,547.415],[361.449,475.304],[288.826,547.197],[288.826,477.014]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,552.143],[361.449,624.254],[288.826,551.798],[288.826,621.981]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,629.778],[361.449,701.889],[288.826,627.357],[288.826,697.539]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,709.549],[361.449,781.661],[288.826,704.994],[288.826,775.177]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,469.806],[361.449,397.694],[377.007,470.293],[377.007,398.688]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,547.415],[361.449,475.304],[377.007,547.358],[377.007,475.753]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,552.143],[361.449,624.254],[377.007,552.052],[377.007,623.657]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,629.778],[361.449,701.889],[377.007,629.143],[377.007,700.748]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[361.449,709.549],[361.449,781.661],[377.007,708.354],[377.007,779.959]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[435.536,468.815],[435.536,395.675],[377.007,470.293],[377.007,398.688]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[435.536,547.532],[435.536,474.392],[377.007,547.358],[377.007,475.753]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[435.536,552.327],[435.536,625.467],[377.007,552.052],[377.007,623.657]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[435.536,631.069],[435.536,704.209],[377.007,629.143],[377.007,700.748]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[435.536,711.978],[435.536,785.118],[377.007,708.354],[377.007,779.959]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[495.756,467.263],[495.756,392.512],[434.149,468.82],[434.149,395.684]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[495.756,547.714],[495.756,472.963],[434.149,547.531],[434.149,474.396]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[495.756,552.615],[495.756,627.366],[434.149,552.326],[434.149,625.461]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[495.756,633.092],[495.756,707.844],[434.149,631.063],[434.149,704.198]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[495.756,715.784],[495.756,790.535],[434.149,711.967],[434.149,785.103]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,464.609],[564.646,387.101],[480.914,466.75],[480.914,391.466]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,548.026],[564.646,470.518],[480.914,547.774],[480.914,472.49]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,553.107],[564.646,630.615],[480.914,552.71],[480.914,627.994]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,636.553],[564.646,714.061],[480.914,633.761],[480.914,709.045]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,722.294],[564.646,799.802],[480.914,717.042],[480.914,792.326]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,464.609],[564.646,387.101],[579.827,465.171],[579.827,388.248]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,548.026],[564.646,470.518],[579.827,547.96],[579.827,471.036]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,553.107],[564.646,630.615],[579.827,553.003],[579.827,629.927]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,636.553],[564.646,714.061],[579.827,635.819],[579.827,712.743]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[564.646,722.294],[564.646,799.802],[579.827,720.914],[579.827,797.837]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[647.481,463.463],[647.481,384.765],[579.827,465.171],[579.827,388.248]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[647.481,548.161],[647.481,469.463],[579.827,547.96],[579.827,471.036]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[647.481,553.32],[647.481,632.018],[579.827,553.003],[579.827,629.927]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[647.481,638.046],[647.481,716.744],[579.827,635.819],[579.827,712.743]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[647.481,725.103],[647.481,803.801],[579.827,720.914],[579.827,797.837]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[716.546,461.685],[716.546,381.142],[645.143,463.489],[645.143,384.819]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[716.546,548.37],[716.546,467.826],[645.143,548.158],[645.143,469.488]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[716.546,553.65],[716.546,634.193],[645.143,553.315],[645.143,631.985]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[716.546,640.363],[716.546,720.907],[645.143,638.012],[645.143,716.682]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[716.546,729.462],[716.546,810.006],[645.143,725.039],[645.143,803.709]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,458.594],[799.786,374.841],[702.242,461.089],[702.242,379.927]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,548.733],[799.786,464.98],[702.242,548.44],[702.242,467.278]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,554.224],[799.786,637.977],[702.242,553.761],[702.242,634.923]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,644.392],[799.786,728.145],[702.242,641.14],[702.242,722.302]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,737.042],[799.786,820.795],[702.242,730.924],[702.242,812.086]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,458.594],[799.786,374.841],[814.265,459.251],[814.265,376.18]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,548.733],[799.786,464.98],[814.265,548.656],[814.265,465.585]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,554.224],[799.786,637.977],[814.265,554.102],[814.265,637.173]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,644.392],[799.786,728.145],[814.265,643.536],[814.265,726.607]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[799.786,737.042],[799.786,820.795],[814.265,735.431],[814.265,818.502]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.03,457.237],[894.03,372.074],[814.265,459.251],[814.265,376.18]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.03,548.893],[894.03,463.73],[814.265,548.656],[814.265,465.585]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.03,554.476],[894.03,639.638],[814.265,554.102],[814.265,637.173]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.03,646.162],[894.03,731.324],[814.265,643.536],[814.265,726.607]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.03,740.371],[894.03,825.533],[814.265,735.431],[814.265,818.502]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.386,457.255],[894.386,372.111],[924.784,458.735],[924.784,375.129]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.386,548.891],[894.386,463.747],[924.784,548.717],[924.784,465.11]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.386,554.472],[894.386,639.616],[924.784,554.198],[924.784,637.804]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.386,646.138],[894.386,731.282],[924.784,644.209],[924.784,727.815]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[894.386,740.327],[894.386,825.471],[924.784,736.696],[924.784,820.303]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1113.21,451.664],[1113.21,360.715],[1022.43,453.957],[1022.43,365.39]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1113.21,549.548],[1113.21,458.599],[1022.43,549.278],[1022.43,460.71]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1113.21,555.51],[1113.21,646.459],[1022.43,555.085],[1022.43,643.652]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1113.21,653.426],[1113.21,744.375],[1022.43,650.437],[1022.43,739.005]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1113.21,754.036],[1113.21,844.985],[1022.43,748.413],[1022.43,836.98]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,447.703],[1225.63,352.64],[1100.48,450.903],[1100.48,359.164]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,550.013],[1225.63,454.951],[1100.48,549.637],[1100.48,457.898]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,556.245],[1225.63,651.308],[1100.48,555.651],[1100.48,647.39]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,658.59],[1225.63,753.653],[1100.48,654.418],[1100.48,746.157]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,763.751],[1225.63,858.813],[1100.48,755.902],[1100.48,847.641]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,447.703],[1225.63,352.64],[1238.11,448.548],[1238.11,354.363]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,550.013],[1225.63,454.951],[1238.11,549.914],[1238.11,455.729]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,556.245],[1225.63,651.308],[1238.11,556.089],[1238.11,650.274]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,658.59],[1225.63,753.653],[1238.11,657.488],[1238.11,751.673]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1225.63,763.751],[1225.63,858.813],[1238.11,761.678],[1238.11,855.863]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1340.06,445.973],[1340.06,349.115],[1238.11,448.548],[1238.11,354.363]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1340.06,550.217],[1340.06,453.358],[1238.11,549.914],[1238.11,455.729]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1340.06,556.567],[1340.06,653.425],[1238.11,556.089],[1238.11,650.274]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1340.06,660.844],[1340.06,757.703],[1238.11,657.488],[1238.11,751.673]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1340.06,767.991],[1340.06,864.85],[1238.11,761.678],[1238.11,855.863]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1449.78,443.202],[1449.78,343.467],[1342.15,445.921],[1342.15,349.008]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1449.78,550.542],[1449.78,450.807],[1342.15,550.223],[1342.15,453.31]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1449.78,557.081],[1449.78,656.816],[1342.15,556.576],[1342.15,653.489]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1449.78,664.456],[1449.78,764.192],[1342.15,660.913],[1342.15,757.826]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1449.78,774.786],[1449.78,874.521],[1342.15,768.12],[1342.15,865.034]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,438.382],[1590.03,333.642],[1438.64,442.254],[1438.64,341.534]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,551.109],[1590.03,446.368],[1438.64,550.654],[1438.64,449.934]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,557.976],[1590.03,662.716],[1438.64,557.257],[1438.64,657.977]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,670.739],[1590.03,775.48],[1438.64,665.692],[1438.64,766.412]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,786.606],[1590.03,891.347],[1438.64,777.111],[1438.64,877.831]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,438.382],[1590.03,333.642],[1599.73,439.373],[1599.73,335.66]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,551.109],[1590.03,446.368],[1599.73,550.993],[1599.73,447.28]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,557.976],[1590.03,662.716],[1599.73,557.792],[1599.73,661.504]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,670.74],[1590.03,775.48],[1599.73,669.448],[1599.73,773.161]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1590.03,786.606],[1590.03,891.347],[1599.73,784.177],[1599.73,887.89]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,436.214],[1724.77,329.221],[1599.73,439.373],[1599.73,335.66]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,551.364],[1724.77,444.371],[1599.73,550.993],[1599.73,447.28]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,558.378],[1724.77,665.371],[1599.73,557.792],[1599.73,661.504]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,673.566],[1724.77,780.559],[1599.73,669.448],[1599.73,773.161]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,791.924],[1724.77,898.917],[1599.73,784.177],[1599.73,887.89]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,436.214],[1724.77,329.221],[1792.43,444.384],[1792.43,345.875]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,551.364],[1724.77,444.371],[1792.43,550.404],[1792.43,451.895]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,558.378],[1724.77,665.37],[1792.43,556.862],[1792.43,655.371]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,673.566],[1724.77,780.559],[1792.43,662.917],[1792.43,761.426]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1724.77,791.924],[1724.77,898.916],[1792.43,771.89],[1792.43,870.399]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1810.73,446.593],[1810.73,350.379],[1865.88,453.253],[1865.88,363.954]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1810.73,550.144],[1810.73,453.929],[1865.88,549.361],[1865.88,460.062]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1810.73,556.451],[1810.73,652.666],[1865.88,555.215],[1865.88,644.514]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1810.73,660.036],[1810.73,756.251],[1865.88,651.355],[1865.88,740.654]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:37,
                    verts:[[1810.73,766.471],[1810.73,862.686],[1865.88,750.139],[1865.88,839.438]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[280.743,470.967],[280.743,400.061],[221.108,472.201],[221.108,402.577]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[280.743,547.279],[280.743,476.373],[221.108,547.134],[221.108,477.51]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[280.743,551.927],[280.743,622.833],[221.108,551.698],[221.108,621.322]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[280.743,628.264],[280.743,699.17],[221.108,626.655],[221.108,696.279]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[280.743,706.702],[280.743,777.607],[221.108,703.675],[221.108,773.299]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,468.796],[346.726,395.637],[266.294,470.48],[266.294,399.069]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,547.534],[346.726,474.374],[266.294,547.336],[266.294,475.925]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,552.33],[346.726,625.49],[266.294,552.018],[266.294,623.429]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,631.094],[346.726,704.253],[266.294,628.899],[266.294,700.31]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,712.025],[346.726,785.184],[266.294,707.895],[266.294,779.307]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,468.796],[346.726,395.637],[361.44,469.325],[361.44,396.714]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,547.534],[346.726,474.374],[361.44,547.472],[361.44,474.861]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,552.33],[346.726,625.49],[361.44,552.232],[361.44,624.843]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,631.094],[346.726,704.253],[361.44,630.405],[361.44,703.015]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[346.726,712.025],[346.726,785.184],[361.44,710.728],[361.44,783.339]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[425.803,467.993],[425.803,394],[361.44,469.325],[361.44,396.714]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[425.803,547.628],[425.803,473.635],[361.44,547.472],[361.44,474.861]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[425.803,552.479],[425.803,626.472],[361.44,552.232],[361.44,624.843]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[425.803,632.14],[425.803,706.134],[361.44,630.405],[361.44,703.015]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[425.803,713.993],[425.803,787.987],[361.44,710.728],[361.44,783.339]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[491.797,466.599],[491.797,391.158],[424.366,467.994],[424.366,394.002]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[491.797,547.792],[491.797,472.351],[424.366,547.628],[424.366,473.636]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[491.797,552.738],[491.797,628.179],[424.366,552.479],[424.366,626.471]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[491.797,633.958],[491.797,709.4],[424.366,632.139],[424.366,706.131]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[491.797,717.413],[491.797,792.854],[424.366,713.991],[424.366,787.983]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,464.137],[569.296,386.138],[478.018,466.048],[478.018,390.034]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,548.082],[569.296,470.084],[478.018,547.857],[478.018,471.843]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,553.195],[569.296,631.193],[478.018,552.84],[478.018,628.854]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,637.168],[569.296,715.166],[478.018,634.677],[478.018,710.691]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,723.451],[569.296,801.449],[478.018,718.765],[478.018,794.779]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,464.137],[569.296,386.138],[583.196,464.737],[583.196,387.363]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,548.082],[569.296,470.084],[583.196,548.011],[583.196,470.637]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,553.195],[569.296,631.193],[583.196,553.084],[583.196,630.458]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,637.168],[569.296,715.166],[583.196,636.385],[583.196,713.759]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[569.296,723.451],[569.296,801.449],[583.196,721.978],[583.196,799.353]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[656.373,463.223],[656.373,384.277],[583.196,464.737],[583.196,387.363]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[656.373,548.189],[656.373,469.243],[583.196,548.011],[583.196,470.637]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[656.373,553.365],[656.373,632.311],[583.196,553.084],[583.196,630.458]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[656.373,638.358],[656.373,717.305],[583.196,636.385],[583.196,713.759]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[656.373,725.691],[656.373,804.637],[583.196,721.978],[583.196,799.353]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[730.761,461.653],[730.761,381.076],[653.938,463.243],[653.938,384.317]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[730.761,548.374],[730.761,467.797],[653.938,548.187],[653.938,469.261]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[730.761,553.656],[730.761,634.233],[653.938,553.361],[653.938,632.287]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[730.761,640.405],[730.761,720.982],[653.938,638.333],[653.938,717.258]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[730.761,729.541],[730.761,810.118],[653.938,725.642],[653.938,804.568]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,458.838],[822.398,375.337],[717.976,461.024],[717.976,379.794]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,548.705],[822.398,465.204],[717.976,548.448],[717.976,467.217]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,554.179],[822.398,637.679],[717.976,553.773],[717.976,635.003]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,644.075],[822.398,727.576],[717.976,641.225],[717.976,722.456]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,736.445],[822.398,819.945],[717.976,731.084],[717.976,812.314]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,458.838],[822.398,375.337],[835.105,459.526],[835.105,376.74]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,548.705],[822.398,465.204],[835.105,548.624],[835.105,465.838]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,554.179],[822.398,637.679],[835.105,554.051],[835.105,636.837]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,644.075],[822.398,727.576],[835.105,643.178],[835.105,725.964]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[822.398,736.445],[822.398,819.945],[835.105,734.758],[835.105,817.544]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[919.756,457.774],[919.756,373.17],[835.105,459.526],[835.105,376.74]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[919.756,548.83],[919.756,464.225],[835.105,548.624],[835.105,465.838]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[919.756,554.376],[919.756,638.98],[835.105,554.051],[835.105,636.837]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[919.756,645.461],[919.756,730.065],[835.105,643.178],[835.105,725.964]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[919.756,739.052],[919.756,823.657],[835.105,734.758],[835.105,817.544]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[920.061,457.793],[920.061,373.208],[946.278,459.332],[946.278,376.346]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[920.061,548.827],[920.061,464.242],[946.278,548.646],[946.278,465.66]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[920.061,554.373],[920.061,638.957],[946.278,554.087],[946.278,637.073]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[920.061,645.437],[920.061,730.022],[946.278,643.43],[946.278,726.417]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[920.061,739.007],[920.061,823.592],[946.278,735.232],[946.278,818.219]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1149.75,452.981],[1149.75,363.4],[1055.01,454.942],[1055.01,367.397]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1149.75,549.393],[1149.75,459.812],[1055.01,549.162],[1055.01,461.617]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1149.75,555.266],[1149.75,644.847],[1055.01,554.902],[1055.01,642.447]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1149.75,651.709],[1149.75,741.29],[1055.01,649.153],[1055.01,736.698]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1149.75,750.806],[1149.75,840.387],[1055.01,745.998],[1055.01,833.543]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,449.488],[1269.01,356.278],[1139.3,452.203],[1139.3,361.814]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,549.804],[1269.01,456.594],[1139.3,549.484],[1139.3,459.095]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,555.914],[1269.01,649.123],[1139.3,555.41],[1139.3,645.8]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,656.263],[1269.01,749.473],[1139.3,652.724],[1139.3,743.113]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,759.374],[1269.01,852.583],[1139.3,752.715],[1139.3,843.104]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,449.488],[1269.01,356.278],[1278.92,450.344],[1278.92,358.024]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,549.804],[1269.01,456.594],[1278.92,549.703],[1278.92,457.383]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,555.914],[1269.01,649.123],[1278.92,555.755],[1278.92,648.075]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,656.263],[1269.01,749.473],[1278.92,655.147],[1278.92,747.467]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1269.01,759.374],[1269.01,852.583],[1278.92,757.273],[1278.92,849.593]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1383.5,448.18],[1383.5,353.614],[1278.92,450.344],[1278.92,358.024]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1383.5,549.957],[1383.5,455.391],[1278.92,549.703],[1278.92,457.383]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1383.5,556.157],[1383.5,650.723],[1278.92,555.755],[1278.92,648.075]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1383.5,657.967],[1383.5,752.534],[1278.92,655.147],[1278.92,747.467]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1383.5,762.579],[1383.5,857.146],[1278.92,757.273],[1278.92,849.593]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1495.15,445.871],[1495.15,348.906],[1385.63,448.136],[1385.63,353.524]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1495.15,550.229],[1495.15,453.264],[1385.63,549.962],[1385.63,455.35]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1495.15,556.586],[1495.15,653.55],[1385.63,556.165],[1385.63,650.777]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1495.15,660.978],[1495.15,757.943],[1385.63,658.025],[1385.63,752.637]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1495.15,768.243],[1495.15,865.208],[1385.63,762.687],[1385.63,857.3]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,441.728],[1639.62,340.462],[1486.92,444.925],[1486.92,346.979]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,550.716],[1639.62,449.45],[1486.92,550.34],[1486.92,452.393]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,557.354],[1639.62,658.62],[1486.92,556.761],[1486.92,654.708]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,666.378],[1639.62,767.644],[1486.92,662.21],[1486.92,760.157]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,778.401],[1639.62,879.667],[1486.92,770.561],[1486.92,868.508]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,441.728],[1639.62,340.462],[1646.31,442.704],[1646.31,342.452]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,550.716],[1639.62,449.449],[1646.31,550.601],[1646.31,450.348]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,557.354],[1639.62,658.62],[1646.31,557.173],[1646.31,657.426]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,666.378],[1639.62,767.644],[1646.31,665.105],[1646.31,765.358]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1639.62,778.401],[1639.62,879.667],[1646.31,776.007],[1646.31,876.26]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,440.124],[1770.96,337.193],[1646.31,442.704],[1646.31,342.452]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,550.904],[1770.96,447.973],[1646.31,550.601],[1646.31,450.348]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,557.652],[1770.96,660.584],[1646.31,557.173],[1646.31,657.426]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,668.468],[1770.96,771.4],[1646.31,665.105],[1646.31,765.358]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,782.334],[1770.96,885.265],[1646.31,776.007],[1646.31,876.26]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,440.124],[1770.96,337.193],[1814.07,448.088],[1814.07,353.426]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,550.904],[1770.96,447.973],[1814.07,549.968],[1814.07,455.306]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,557.652],[1770.96,660.584],[1814.07,556.174],[1814.07,650.836]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,668.468],[1770.96,771.4],[1814.07,658.087],[1814.07,752.749]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1770.96,782.334],[1770.96,885.265],[1814.07,762.804],[1814.07,857.466]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1825.71,450.239],[1825.71,357.81],[1860.75,456.714],[1860.75,371.008]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1825.71,549.715],[1825.71,457.287],[1860.75,548.954],[1860.75,463.249]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1825.71,555.775],[1825.71,648.203],[1860.75,554.573],[1860.75,640.278]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1825.71,655.284],[1825.71,747.712],[1860.75,646.844],[1860.75,732.549]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:38,
                    verts:[[1825.71,757.53],[1825.71,849.959],[1860.75,741.653],[1860.75,827.359]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[261.121,469.742],[261.121,397.564],[195.55,470.84],[195.55,399.802]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[261.121,547.423],[261.121,475.245],[195.55,547.294],[195.55,476.256]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[261.121,552.155],[261.121,624.333],[195.55,551.951],[195.55,622.989]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[261.121,629.862],[261.121,702.04],[195.55,628.43],[195.55,699.468]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[261.121,709.707],[261.121,781.885],[195.55,707.014],[195.55,778.052]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,467.723],[335.537,393.45],[247.445,469.215],[247.445,396.49]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,547.66],[335.537,473.386],[247.445,547.485],[247.445,474.76]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,552.529],[335.537,626.803],[247.445,552.253],[247.445,624.978]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,632.492],[335.537,706.766],[247.445,630.548],[247.445,703.273]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,714.656],[335.537,788.929],[247.445,710.999],[247.445,783.724]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,467.723],[335.537,393.45],[349.291,468.292],[349.291,394.609]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,547.66],[335.537,473.386],[349.291,547.593],[349.291,473.91]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,552.529],[335.537,626.803],[349.291,552.424],[349.291,626.107]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,632.492],[335.537,706.766],[349.291,631.751],[349.291,705.434]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[335.537,714.656],[335.537,788.929],[349.291,713.261],[349.291,786.944]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[419.28,467.121],[419.28,392.221],[349.291,468.292],[349.291,394.609]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[419.28,547.731],[419.28,472.831],[349.291,547.593],[349.291,473.91]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[419.28,552.641],[419.28,627.541],[349.291,552.424],[349.291,626.107]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[419.28,633.278],[419.28,708.178],[349.291,631.751],[349.291,705.434]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[419.28,716.134],[419.28,791.033],[349.291,713.261],[349.291,786.944]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[490.762,465.896],[490.762,389.725],[417.799,467.118],[417.799,392.216]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[490.762,547.875],[490.762,471.704],[417.799,547.731],[417.799,472.829]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[490.762,552.868],[490.762,629.039],[417.799,552.642],[417.799,627.544]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[490.762,634.874],[490.762,711.045],[417.799,633.282],[417.799,708.184]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[490.762,719.136],[490.762,795.307],[417.799,716.14],[417.799,791.043]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,463.645],[576.468,385.136],[478.16,465.309],[478.16,388.528]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,548.14],[576.468,469.631],[478.16,547.944],[478.16,471.163]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,553.286],[576.468,631.795],[478.16,552.977],[478.16,629.758]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,637.809],[576.468,716.318],[478.16,635.64],[478.16,712.42]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,724.657],[576.468,803.166],[478.16,720.576],[478.16,797.357]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,463.645],[576.468,385.136],[588.975,464.28],[588.975,386.431]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,548.14],[576.468,469.631],[588.975,548.065],[588.975,470.216]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,553.286],[576.468,631.795],[588.975,553.168],[588.975,631.018]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,637.809],[576.468,716.318],[588.975,636.981],[588.975,714.83]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[576.468,724.657],[576.468,803.166],[588.975,723.099],[588.975,800.949]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[667.176,462.971],[667.176,383.763],[588.975,464.28],[588.975,386.431]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[667.176,548.219],[667.176,469.01],[588.975,548.065],[588.975,470.216]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[667.176,553.411],[667.176,632.62],[588.975,553.168],[588.975,631.018]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[667.176,638.687],[667.176,717.896],[588.975,636.981],[588.975,714.83]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[667.176,726.309],[667.176,805.518],[588.975,723.099],[588.975,800.948]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[746.307,461.617],[746.307,381.002],[664.663,462.984],[664.663,383.789]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[746.307,548.378],[746.307,467.763],[664.663,548.217],[664.663,469.022]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[746.307,553.663],[746.307,634.277],[664.663,553.409],[664.663,632.604]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[746.307,640.452],[746.307,721.067],[664.663,638.67],[664.663,717.865]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[746.307,729.63],[746.307,810.245],[664.663,726.278],[664.663,805.472]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,459.091],[845.491,375.853],[735.13,460.959],[735.13,379.661]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,548.675],[845.491,465.437],[735.13,548.455],[735.13,467.158]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,554.132],[845.491,637.369],[735.13,553.785],[735.13,635.082]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,643.745],[845.491,726.983],[735.13,641.31],[735.13,722.608]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,735.825],[845.491,819.062],[735.13,731.243],[735.13,812.541]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,459.091],[845.491,375.853],[856.35,459.804],[856.35,377.308]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,548.675],[845.491,465.437],[856.35,548.591],[856.35,466.094]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,554.132],[845.491,637.369],[856.35,553.999],[856.35,636.496]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,643.745],[845.491,726.983],[856.35,642.815],[856.35,725.312]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[845.491,735.825],[845.491,819.062],[856.35,734.075],[856.35,816.571]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.053,458.32],[945.053,374.281],[856.35,459.804],[856.35,377.308]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.053,548.765],[945.053,464.727],[856.35,548.591],[856.35,466.094]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.053,554.275],[945.053,638.313],[856.35,553.999],[856.35,636.496]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.053,644.751],[945.053,728.789],[856.35,642.815],[856.35,725.312]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.053,737.716],[945.053,821.754],[856.35,734.075],[856.35,816.571]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.306,458.339],[945.306,374.32],[967.24,459.923],[967.24,377.55]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.306,548.763],[945.306,464.745],[967.24,548.577],[967.24,466.204]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.306,554.271],[945.306,638.29],[967.24,553.977],[967.24,636.35]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.306,644.726],[945.306,728.744],[967.24,642.66],[967.24,725.033]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[945.306,737.669],[945.306,821.687],[967.24,733.783],[967.24,816.156]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1183.29,454.299],[1183.29,366.086],[1085.7,455.933],[1085.7,369.418]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1183.29,549.238],[1183.29,461.025],[1085.7,549.046],[1085.7,462.53]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1183.29,555.021],[1183.29,643.234],[1085.7,554.718],[1085.7,641.234]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1183.29,649.991],[1183.29,738.204],[1085.7,647.861],[1085.7,734.377]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1183.29,747.574],[1183.29,835.787],[1085.7,743.567],[1085.7,830.083]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,451.265],[1307.77,359.902],[1175.11,453.511],[1175.11,364.479]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,549.595],[1307.77,458.231],[1175.11,549.331],[1175.11,460.299]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,555.584],[1307.77,646.948],[1175.11,555.167],[1175.11,644.199]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,653.946],[1307.77,745.31],[1175.11,651.019],[1175.11,740.05]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,755.015],[1307.77,846.378],[1175.11,749.508],[1175.11,838.539]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,451.265],[1307.77,359.902],[1315.16,452.124],[1315.16,361.653]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,549.595],[1307.77,458.231],[1315.16,549.494],[1315.16,459.022]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,555.584],[1307.77,646.948],[1315.16,555.425],[1315.16,645.896]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,653.946],[1307.77,745.31],[1315.16,652.826],[1315.16,743.298]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1307.77,755.015],[1307.77,846.378],[1315.16,752.908],[1315.16,843.38]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1421.08,450.351],[1421.08,358.039],[1315.16,452.124],[1315.16,361.653]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1421.08,549.702],[1421.08,457.39],[1315.16,549.494],[1315.16,459.022]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1421.08,555.754],[1421.08,648.066],[1315.16,555.425],[1315.16,645.896]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1421.08,655.138],[1421.08,747.45],[1315.16,652.826],[1315.16,743.298]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1421.08,757.256],[1421.08,849.568],[1315.16,752.908],[1315.16,843.38]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1533.23,448.474],[1533.23,354.212],[1423.22,450.315],[1423.22,357.966]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1533.23,549.923],[1533.23,455.661],[1423.22,549.706],[1423.22,457.357]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1533.23,556.102],[1533.23,650.364],[1423.22,555.76],[1423.22,648.11]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1533.23,657.585],[1533.23,751.846],[1423.22,655.184],[1423.22,747.534]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1533.23,761.859],[1533.23,856.121],[1423.22,757.344],[1423.22,849.693]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.81,444.967],[1679.81,347.064],[1527.76,447.541],[1527.76,352.31]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.81,550.335],[1679.81,452.432],[1527.76,550.032],[1527.76,454.802]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.81,556.753],[1679.81,654.656],[1527.76,556.276],[1527.76,651.506]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.81,662.156],[1679.81,760.059],[1527.76,658.801],[1527.76,754.031]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.81,770.459],[1679.81,868.362],[1527.76,764.147],[1527.76,859.378]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.82,444.967],[1679.82,347.064],[1683.71,445.919],[1683.71,349.005]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.82,550.335],[1679.82,452.432],[1683.71,550.223],[1683.71,453.309]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.82,556.753],[1679.82,654.657],[1683.71,556.576],[1683.71,653.491]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.82,662.156],[1679.82,760.059],[1683.71,660.915],[1683.71,757.829]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1679.82,770.459],[1679.82,868.362],[1683.71,768.123],[1683.71,865.038]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,443.864],[1806.47,344.815],[1683.71,445.919],[1683.71,349.005]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,550.465],[1806.47,451.416],[1683.71,550.223],[1683.71,453.309]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,556.958],[1806.47,656.007],[1683.71,556.576],[1683.71,653.491]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,663.594],[1806.47,762.643],[1683.71,660.915],[1683.71,757.829]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,773.164],[1806.47,872.213],[1683.71,768.123],[1683.71,865.038]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,443.864],[1806.47,344.815],[1827.35,451.561],[1827.35,360.505]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,550.465],[1806.47,451.416],[1827.35,549.56],[1827.35,458.504]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,556.958],[1806.47,656.007],[1827.35,555.529],[1827.35,646.586]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,663.594],[1806.47,762.643],[1827.35,653.561],[1827.35,744.617]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1806.47,773.164],[1806.47,872.213],[1827.35,754.289],[1827.35,845.346]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1832.99,453.639],[1832.99,364.74],[1849.95,459.891],[1849.95,377.484]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1832.99,549.316],[1832.99,460.417],[1849.95,548.581],[1849.95,466.174]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1832.99,555.144],[1832.99,644.043],[1849.95,553.983],[1849.95,636.39]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1832.99,650.852],[1832.99,739.751],[1849.95,642.703],[1849.95,725.109]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:39,
                    verts:[[1832.99,749.194],[1832.99,838.093],[1849.95,733.863],[1849.95,816.27]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[245.037,468.423],[245.037,394.876],[173.582,469.369],[173.582,396.805]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[245.037,547.578],[245.037,474.031],[173.582,547.467],[173.582,474.902]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[245.037,552.399],[245.037,625.947],[173.582,552.224],[173.582,624.788]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[245.037,631.581],[245.037,705.128],[173.582,630.347],[173.582,702.911]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[245.037,712.94],[245.037,786.488],[173.582,710.619],[173.582,783.184]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,466.577],[327.815,391.113],[232.245,467.856],[232.245,393.721]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,547.795],[327.815,472.331],[232.245,547.644],[232.245,473.509]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,552.742],[327.815,628.206],[232.245,552.505],[232.245,626.64]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,633.987],[327.815,709.451],[232.245,632.319],[232.245,706.455]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,717.467],[327.815,792.93],[232.245,714.33],[232.245,788.466]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,466.577],[327.815,391.113],[340.491,467.185],[340.491,392.352]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,547.795],[327.815,472.331],[340.491,547.723],[340.491,472.89]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,552.742],[327.815,628.206],[340.491,552.629],[340.491,627.462]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,633.987],[327.815,709.451],[340.491,633.195],[340.491,708.028]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[327.815,717.467],[327.815,792.93],[340.491,715.977],[340.491,790.81]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[415.873,466.186],[415.873,390.317],[340.491,467.185],[340.491,392.352]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[415.873,547.841],[415.873,471.971],[340.491,547.723],[340.491,472.89]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[415.873,552.815],[415.873,628.684],[340.491,552.629],[340.491,627.462]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[415.873,634.496],[415.873,710.365],[340.491,633.195],[340.491,708.028]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[415.873,718.424],[415.873,794.294],[340.491,715.977],[340.491,790.81]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[492.531,465.144],[492.531,388.193],[414.357,466.18],[414.357,390.304]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[492.531,547.963],[492.531,471.012],[414.357,547.842],[414.357,471.965]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[492.531,553.008],[492.531,629.959],[414.357,552.816],[414.357,628.692]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[492.531,635.854],[492.531,712.806],[414.357,634.504],[414.357,710.38]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[492.531,720.98],[492.531,797.931],[414.357,718.44],[414.357,794.317]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,463.121],[586.003,384.069],[481.215,464.524],[481.215,386.928]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,548.201],[586.003,469.149],[481.215,548.036],[481.215,470.44]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,553.383],[586.003,632.436],[481.215,553.123],[481.215,630.719]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,638.491],[586.003,717.543],[481.215,636.663],[481.215,714.259]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,725.94],[586.003,804.992],[481.215,722.501],[481.215,800.097]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,463.121],[586.003,384.069],[597.016,463.788],[597.016,385.428]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,548.201],[586.003,469.149],[597.016,548.123],[597.016,469.763]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,553.383],[586.003,632.436],[597.016,553.26],[597.016,631.62]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,638.491],[586.003,717.543],[597.016,637.622],[597.016,715.982]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[586.003,725.94],[586.003,804.992],[597.016,724.306],[597.016,802.666]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[679.724,462.693],[679.724,383.195],[597.016,463.788],[597.016,385.428]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[679.724,548.251],[679.724,468.754],[597.016,548.123],[597.016,469.763]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[679.724,553.463],[679.724,632.96],[597.016,553.26],[597.016,631.62]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[679.724,639.05],[679.724,718.547],[597.016,637.622],[597.016,715.982]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[679.724,726.992],[679.724,806.489],[597.016,724.306],[597.016,802.666]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[763.01,461.562],[763.01,380.89],[677.151,462.699],[677.151,383.208]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[763.01,548.384],[763.01,467.713],[677.151,548.251],[677.151,468.76]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[763.01,553.673],[763.01,634.345],[677.151,553.462],[677.151,632.953]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[763.01,640.524],[763.01,721.196],[677.151,639.042],[677.151,718.533]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[763.01,729.766],[763.01,810.437],[677.151,726.977],[677.151,806.467]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,459.335],[868.88,376.352],[753.516,460.879],[753.516,379.499]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,548.646],[868.88,465.663],[753.516,548.465],[753.516,467.084]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,554.086],[868.88,637.07],[753.516,553.8],[753.516,635.18]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,643.426],[868.88,726.41],[753.516,641.414],[753.516,722.794]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,735.225],[868.88,818.208],[753.516,731.438],[753.516,812.819]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,459.335],[868.88,376.352],[877.837,460.069],[877.837,377.848]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,548.646],[868.88,465.663],[877.837,548.56],[877.837,466.339]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,554.086],[868.88,637.07],[877.837,553.95],[877.837,636.171]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,643.426],[868.88,726.41],[877.837,642.47],[877.837,724.691]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[868.88,735.225],[868.88,818.208],[877.837,733.425],[877.837,815.646]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.784,458.852],[969.784,375.366],[877.837,460.069],[877.837,377.848]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.784,548.703],[969.784,465.217],[877.837,548.56],[877.837,466.339]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.784,554.176],[969.784,637.661],[877.837,553.95],[877.837,636.171]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.784,644.057],[969.784,727.542],[877.837,642.47],[877.837,724.691]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.784,736.41],[969.784,819.896],[877.837,733.425],[877.837,815.646]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.986,458.872],[969.986,375.406],[987.58,460.49],[987.58,378.704]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.986,548.701],[969.986,465.235],[987.58,548.51],[987.58,466.725]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.986,554.172],[969.986,637.638],[987.58,553.872],[987.58,635.657]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.986,644.031],[969.986,727.496],[987.58,641.922],[987.58,723.707]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[969.986,736.362],[969.986,819.827],[987.58,732.394],[987.58,814.18]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1213.89,455.589],[1213.89,368.716],[1114.43,456.907],[1114.43,371.401]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1213.89,549.086],[1213.89,462.213],[1114.43,548.932],[1114.43,463.426]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1213.89,554.782],[1213.89,641.655],[1114.43,554.537],[1114.43,640.043]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1213.89,648.31],[1213.89,735.183],[1114.43,646.592],[1114.43,732.098]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1213.89,744.411],[1213.89,831.284],[1114.43,741.181],[1114.43,826.686]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,453.002],[1342.09,363.442],[1207.92,454.798],[1207.92,367.102]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,549.391],[1342.09,459.83],[1207.92,549.179],[1207.92,461.484]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,555.262],[1342.09,644.822],[1207.92,554.929],[1207.92,642.624]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,651.682],[1342.09,741.243],[1207.92,649.342],[1207.92,737.037]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,750.756],[1342.09,840.316],[1207.92,746.352],[1207.92,834.048]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,453.002],[1342.09,363.442],[1347.07,453.856],[1347.07,365.183]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,549.391],[1342.09,459.83],[1347.07,549.29],[1347.07,460.617]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,555.262],[1342.09,644.822],[1347.07,555.103],[1347.07,643.776]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,651.682],[1342.09,741.243],[1347.07,650.569],[1347.07,739.242]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1342.09,750.756],[1342.09,840.316],[1347.07,748.661],[1347.07,837.334]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1453.18,452.451],[1453.18,362.319],[1347.07,453.856],[1347.07,365.183]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1453.18,549.455],[1453.18,459.323],[1347.07,549.29],[1347.07,460.617]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1453.18,555.364],[1453.18,645.496],[1347.07,555.103],[1347.07,643.776]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1453.18,652.4],[1453.18,742.532],[1347.07,650.569],[1347.07,739.242]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1453.18,752.106],[1453.18,842.238],[1347.07,748.661],[1347.07,837.334]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1564.67,450.975],[1564.67,359.31],[1455.32,452.423],[1455.32,362.261]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1564.67,549.629],[1564.67,457.964],[1455.32,549.459],[1455.32,459.297]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1564.67,555.638],[1564.67,647.303],[1455.32,555.369],[1455.32,645.531]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1564.67,654.325],[1564.67,745.989],[1455.32,652.437],[1455.32,742.599]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1564.67,755.726],[1564.67,847.391],[1455.32,752.176],[1455.32,842.337]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,448.056],[1711.59,353.361],[1561.78,450.062],[1561.78,357.448]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,549.972],[1711.59,455.276],[1561.78,549.736],[1561.78,457.123]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,556.18],[1711.59,650.875],[1561.78,555.808],[1561.78,648.421]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,658.129],[1711.59,752.824],[1561.78,655.515],[1561.78,748.128]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,762.883],[1711.59,857.578],[1561.78,757.966],[1561.78,850.579]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,448.056],[1711.59,353.361],[1712.93,448.979],[1712.93,355.241]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,549.972],[1711.59,455.276],[1712.93,549.863],[1712.93,456.126]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,556.18],[1711.59,650.875],[1712.93,556.009],[1712.93,649.746]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,658.129],[1711.59,752.824],[1712.93,656.927],[1712.93,750.664]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1711.59,762.883],[1711.59,857.579],[1712.93,760.621],[1712.93,854.359]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,447.393],[1712.93,448.979],[1832.64,352.009],[1712.93,355.241]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,550.05],[1832.64,454.666],[1712.93,549.863],[1712.93,456.126]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,556.303],[1832.64,651.687],[1712.93,556.009],[1712.93,649.746]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,658.994],[1712.93,656.927],[1832.64,754.378],[1712.93,750.664]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,764.51],[1712.93,760.621],[1832.64,859.894],[1712.93,854.359]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,447.393],[1832.64,352.009],[1833.56,454.784],[1833.56,367.075]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,550.05],[1832.64,454.666],[1833.56,549.181],[1833.56,461.472]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,556.303],[1832.64,651.687],[1833.56,554.931],[1833.56,642.64]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,658.994],[1832.64,754.378],[1833.56,649.359],[1833.56,737.068]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1832.64,764.51],[1832.64,859.894],[1833.56,746.385],[1833.56,834.094]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1833.81,456.78],[1833.81,371.143],[1834.55,462.787],[1834.55,383.388]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1833.81,548.946],[1833.81,463.31],[1834.55,548.24],[1834.55,468.841]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1833.81,554.561],[1833.81,640.197],[1834.55,553.446],[1834.55,632.845]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1833.81,646.757],[1833.81,732.394],[1834.55,638.927],[1834.55,718.326]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:40,
                    verts:[[1833.81,741.491],[1833.81,827.128],[1834.55,726.76],[1834.55,806.159]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[232.464,466.999],[232.464,391.973],[155.195,467.778],[155.195,393.56]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[232.464,547.745],[232.464,472.719],[155.195,547.654],[155.195,473.436]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[232.464,552.664],[232.464,627.69],[155.195,552.519],[155.195,626.737]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[232.464,633.437],[232.464,708.463],[155.195,632.422],[155.195,706.639]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[232.464,716.432],[232.464,791.458],[155.195,714.523],[155.195,788.74]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,465.346],[323.508,388.604],[220.674,466.393],[220.674,390.738]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,547.94],[323.508,471.198],[220.674,547.816],[220.674,472.161]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,552.971],[323.508,629.712],[220.674,552.776],[220.674,628.431]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,635.591],[323.508,712.333],[220.674,634.227],[220.674,709.882]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,720.485],[323.508,797.227],[220.674,717.918],[220.674,793.573]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,465.346],[323.508,388.604],[334.986,465.991],[334.986,389.919]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,547.94],[323.508,471.198],[334.986,547.864],[334.986,471.792]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,552.971],[323.508,629.712],[334.986,552.851],[334.986,628.923]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,635.591],[323.508,712.333],[334.986,634.75],[334.986,710.822]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[323.508,720.485],[323.508,797.227],[334.986,718.903],[334.986,794.975]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[415.501,465.18],[415.501,388.266],[334.986,465.991],[334.986,389.919]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[415.501,547.959],[415.501,471.045],[334.986,547.864],[334.986,471.792]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[415.501,553.001],[415.501,629.915],[334.986,552.851],[334.986,628.923]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[415.501,635.807],[415.501,712.721],[334.986,634.75],[334.986,710.822]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[415.501,720.892],[415.501,797.806],[334.986,718.903],[334.986,794.975]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[497,464.333],[497,386.539],[413.957,465.17],[413.957,388.245]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[497,548.059],[497,470.265],[413.957,547.96],[413.957,471.035]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[497,553.159],[497,630.953],[413.957,553.003],[413.957,629.928]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[497,636.912],[497,714.706],[413.957,635.821],[413.957,712.746]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[497,722.969],[497,800.763],[413.957,720.917],[413.957,797.842]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,462.555],[597.761,382.914],[487.072,463.682],[487.072,385.211]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,548.268],[597.761,468.627],[487.072,548.135],[487.072,469.665]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,553.489],[597.761,633.129],[487.072,553.279],[487.072,631.75]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,639.23],[597.761,718.87],[487.072,637.761],[487.072,716.232]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,727.33],[597.761,806.97],[487.072,724.567],[487.072,803.038]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,462.555],[597.761,382.914],[607.185,463.25],[607.185,384.33]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,548.268],[597.761,468.627],[607.185,548.186],[607.185,469.267]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,553.489],[597.761,633.129],[607.185,553.36],[607.185,632.279]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,639.23],[597.761,718.87],[607.185,638.324],[607.185,717.244]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[597.761,727.33],[597.761,806.97],[607.185,725.627],[607.185,804.546]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[693.876,462.376],[693.876,382.55],[607.185,463.25],[607.185,384.33]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[693.876,548.289],[693.876,468.463],[607.185,548.186],[607.185,469.267]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[693.876,553.522],[693.876,633.348],[607.185,553.36],[607.185,632.279]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[693.876,639.463],[693.876,719.289],[607.185,638.324],[607.185,717.244]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[693.876,727.768],[693.876,807.594],[607.185,725.627],[607.185,804.546]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[780.724,461.474],[780.724,380.711],[691.26,462.376],[691.26,382.549]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[780.724,548.395],[780.724,467.632],[691.26,548.289],[691.26,468.462]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[780.724,553.689],[780.724,634.452],[691.26,553.522],[691.26,633.349]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[780.724,640.639],[780.724,721.401],[691.26,639.463],[691.26,719.29]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[780.724,729.98],[780.724,810.743],[691.26,727.77],[691.26,807.596]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,459.556],[892.423,376.801],[772.977,460.771],[772.977,379.279]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,548.62],[892.423,465.865],[772.977,548.477],[772.977,466.985]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,554.045],[892.423,636.8],[772.977,553.82],[772.977,635.312]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,643.139],[892.423,725.894],[772.977,641.554],[772.977,723.047]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,734.684],[892.423,817.439],[772.977,731.703],[772.977,813.195]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,459.556],[892.423,376.801],[899.441,460.305],[899.441,378.329]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,548.62],[892.423,465.865],[899.441,548.532],[899.441,466.556]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,554.045],[892.423,636.8],[899.441,553.906],[899.441,635.882]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,643.139],[892.423,725.894],[899.441,642.162],[899.441,724.138]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[892.423,734.684],[892.423,817.439],[899.441,732.846],[899.441,814.822]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[993.859,459.354],[993.859,376.39],[899.441,460.305],[899.441,378.329]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[993.859,548.644],[993.859,465.68],[899.441,548.532],[899.441,466.556]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[993.859,554.083],[993.859,637.047],[899.441,553.906],[899.441,635.882]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[993.859,643.402],[993.859,726.366],[899.441,642.162],[899.441,724.138]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[993.859,735.178],[993.859,818.142],[899.441,732.846],[899.441,814.822]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[994.008,459.374],[994.008,376.431],[1007.24,461.015],[1007.24,379.775]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[994.008,548.641],[994.008,465.698],[1007.24,548.449],[1007.24,467.209]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[994.008,554.079],[994.008,637.022],[1007.24,553.774],[1007.24,635.014]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[994.008,643.376],[994.008,726.319],[1007.24,641.237],[1007.24,722.477]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[994.008,735.13],[994.008,818.073],[1007.24,731.106],[1007.24,812.346]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1241.63,456.83],[1241.63,371.244],[1141.23,457.841],[1141.23,373.306]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1241.63,548.941],[1241.63,463.355],[1141.23,548.822],[1141.23,464.287]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1241.63,554.551],[1241.63,640.137],[1141.23,554.364],[1141.23,638.899]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1241.63,646.693],[1241.63,732.278],[1141.23,645.374],[1141.23,729.909]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1241.63,741.37],[1241.63,826.955],[1141.23,738.889],[1141.23,823.424]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,454.672],[1372.23,366.846],[1237.83,456.04],[1237.83,369.635]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,549.194],[1372.23,461.368],[1237.83,549.033],[1237.83,462.628]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,554.952],[1372.23,642.778],[1237.83,554.698],[1237.83,641.103]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,649.505],[1372.23,737.331],[1237.83,647.722],[1237.83,734.127]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,746.66],[1372.23,834.486],[1237.83,743.305],[1237.83,829.711]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,454.672],[1372.23,366.846],[1374.89,455.516],[1374.89,368.567]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,549.194],[1372.23,461.368],[1374.89,549.095],[1374.89,462.146]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,554.952],[1372.23,642.778],[1374.89,554.795],[1374.89,641.745]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,649.505],[1372.23,737.331],[1374.89,648.405],[1374.89,735.354]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1372.23,746.66],[1372.23,834.486],[1374.89,744.591],[1374.89,831.54]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1480.24,454.455],[1480.24,366.403],[1374.89,455.516],[1374.89,368.567]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1480.24,549.22],[1480.24,461.168],[1374.89,549.095],[1374.89,462.146]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1480.24,554.992],[1480.24,643.044],[1374.89,554.795],[1374.89,641.745]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1480.24,649.788],[1480.24,737.84],[1374.89,648.405],[1374.89,735.354]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1480.24,747.193],[1374.89,744.591],[1480.24,835.244],[1374.89,831.54]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1590.09,453.348],[1482.36,454.433],[1590.09,364.148],[1482.36,366.36]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1590.09,549.35],[1590.09,460.149],[1482.36,549.222],[1482.36,461.149]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1590.09,555.198],[1590.09,644.398],[1482.36,554.996],[1482.36,643.07]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1590.09,651.231],[1482.36,649.816],[1590.09,740.431],[1482.36,737.89]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1590.09,749.906],[1482.36,747.245],[1590.09,839.107],[1482.36,835.319]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1589.59,452.46],[1735.91,450.97],[1589.59,362.337],[1735.91,359.301]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1589.59,549.454],[1735.91,549.629],[1589.59,459.331],[1735.91,457.96]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1589.59,555.362],[1735.91,555.639],[1589.59,645.485],[1735.91,647.308]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1589.59,652.389],[1735.91,654.33],[1589.59,742.512],[1735.91,746]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1589.59,752.085],[1735.91,755.737],[1589.59,842.208],[1735.91,847.407]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1734.93,451.858],[1734.93,361.111],[1850.73,450.692],[1850.73,358.732]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1734.93,549.525],[1734.93,458.778],[1850.73,549.662],[1850.73,457.703]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1734.93,555.474],[1734.93,646.221],[1850.73,555.691],[1850.73,647.65]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1734.93,653.173],[1734.93,743.92],[1850.73,654.694],[1850.73,746.653]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:41,
                    verts:[[1734.93,753.56],[1850.73,756.421],[1734.93,844.307],[1850.73,848.38]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[223.406,465.457],[223.406,388.83],[140.415,466.05],[140.415,390.038]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[223.406,547.927],[223.406,471.299],[140.415,547.857],[140.415,471.845]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[223.406,552.95],[223.406,629.577],[140.415,552.84],[140.415,628.852]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[223.406,635.447],[223.406,712.074],[140.415,634.674],[140.415,710.686]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[223.406,720.214],[223.406,796.841],[140.415,718.76],[140.415,794.771]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,464.019],[322.584,385.9],[212.739,464.812],[212.739,387.515]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,548.095],[322.584,469.976],[212.739,548.002],[212.739,470.705]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,553.217],[322.584,631.336],[212.739,553.07],[212.739,630.367]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,637.321],[322.584,715.44],[212.739,636.288],[212.739,713.585]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,723.739],[322.584,801.858],[212.739,721.795],[212.739,799.092]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,464.019],[322.584,385.9],[332.745,464.701],[332.745,387.289]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,548.095],[322.584,469.976],[332.745,548.015],[332.745,470.604]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,553.217],[322.584,631.337],[332.745,553.09],[332.745,630.502]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,637.321],[322.584,715.44],[332.745,636.432],[332.745,713.844]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[322.584,723.739],[322.584,801.858],[332.745,722.067],[332.745,799.479]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[418.108,464.091],[418.108,386.047],[332.745,464.701],[332.745,387.289]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[418.108,548.087],[418.108,470.042],[332.745,548.015],[332.745,470.604]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[418.108,553.203],[418.108,631.248],[332.745,553.09],[332.745,630.502]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[418.108,637.227],[418.108,715.272],[332.745,636.432],[332.745,713.844]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[418.108,723.562],[418.108,801.607],[332.745,722.067],[332.745,799.479]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[504.089,463.452],[504.089,384.742],[416.546,464.077],[416.546,386.017]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[504.089,548.162],[504.089,469.453],[416.546,548.089],[416.546,470.029]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[504.089,553.322],[504.089,632.032],[416.546,553.206],[416.546,631.266]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[504.089,638.061],[504.089,716.77],[416.546,637.246],[416.546,715.306]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[504.089,725.131],[504.089,803.841],[416.546,723.598],[416.546,801.658]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,461.934],[611.634,381.649],[495.65,462.771],[495.65,383.355]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,548.341],[611.634,468.056],[495.65,548.242],[495.65,468.826]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,553.604],[611.634,633.889],[495.65,553.449],[495.65,632.865]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,640.039],[611.634,720.324],[495.65,638.948],[495.65,718.364]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,728.852],[611.634,809.137],[495.65,726.8],[495.65,806.216]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,461.934],[611.634,381.649],[619.383,462.654],[619.383,383.116]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,548.341],[611.634,468.056],[619.383,548.256],[619.383,468.718]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,553.604],[611.634,633.889],[619.383,553.47],[619.383,633.008]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,640.039],[611.634,720.324],[619.383,639.101],[619.383,718.638]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[611.634,728.852],[611.634,809.137],[619.383,727.087],[619.383,806.624]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[709.519,462.01],[709.519,381.804],[619.383,462.654],[619.383,383.116]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[709.519,548.332],[709.519,468.126],[619.383,548.256],[619.383,468.718]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[709.519,553.59],[709.519,633.796],[619.383,553.47],[619.383,633.008]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[709.519,639.94],[709.519,720.146],[619.383,639.101],[619.383,718.638]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[709.519,728.665],[709.519,808.871],[619.383,727.087],[619.383,806.624]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[799.34,461.342],[799.34,380.442],[706.878,462.003],[706.878,381.789]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[799.34,548.41],[799.34,467.51],[706.878,548.333],[706.878,468.119]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[799.34,553.714],[799.34,634.614],[706.878,553.591],[706.878,633.805]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[799.34,640.811],[799.34,721.71],[706.878,639.949],[706.878,720.163]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[799.34,730.304],[799.34,811.203],[706.878,728.684],[706.878,808.898]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,459.738],[916.017,377.173],[793.389,460.623],[793.389,378.976]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,548.599],[916.017,466.034],[793.389,548.495],[793.389,466.848]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,554.011],[916.017,636.577],[793.389,553.847],[793.389,635.494]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,642.901],[916.017,725.466],[793.389,641.748],[793.389,723.395]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,734.237],[916.017,816.802],[793.389,732.067],[793.389,813.714]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,459.738],[916.017,377.173],[921.071,460.499],[921.071,378.725]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,548.599],[916.017,466.034],[921.071,548.509],[921.071,466.734]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,554.011],[916.017,636.577],[921.071,553.87],[921.071,635.645]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,642.901],[916.017,725.466],[921.071,641.909],[921.071,723.684]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[916.017,734.237],[916.017,816.802],[921.071,732.37],[921.071,814.145]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.23,459.813],[1017.23,377.325],[921.071,460.499],[921.071,378.725]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.23,548.59],[1017.23,466.102],[921.071,548.509],[921.071,466.734]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.23,553.998],[1017.23,636.486],[921.071,553.87],[921.071,635.645]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.23,642.804],[1017.23,725.292],[921.071,641.909],[921.071,723.684]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.23,734.054],[1017.23,816.542],[921.071,732.37],[921.071,814.145]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.32,459.833],[1017.32,377.366],[1026.21,461.487],[1026.21,380.737]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.32,548.588],[1017.32,466.121],[1026.21,548.393],[1026.21,467.643]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.32,553.994],[1017.32,636.461],[1026.21,553.687],[1026.21,634.437]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.32,642.778],[1017.32,725.245],[1026.21,640.622],[1026.21,721.372]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1017.32,734.005],[1017.32,816.473],[1026.21,729.95],[1026.21,810.699]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1266.64,458.004],[1266.64,373.637],[1166.12,458.722],[1166.12,375.101]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1266.64,548.803],[1266.64,464.436],[1166.12,548.718],[1166.12,465.098]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1266.64,554.333],[1266.64,638.7],[1166.12,554.2],[1166.12,637.821]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1266.64,645.162],[1266.64,729.529],[1166.12,644.226],[1166.12,727.847]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1266.64,738.49],[1266.64,822.857],[1166.12,736.729],[1166.12,820.35]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.46,456.258],[1398.46,370.079],[1264.93,457.221],[1264.93,372.042]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.46,549.008],[1398.46,462.829],[1264.93,548.895],[1264.93,463.716]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.46,554.657],[1398.46,640.837],[1264.93,554.479],[1264.93,639.657]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.46,647.438],[1398.46,733.617],[1264.93,646.182],[1264.93,731.361]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.46,742.771],[1264.93,740.409],[1398.46,828.951],[1264.93,825.588]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.92,457.087],[1502.69,456.346],[1398.92,371.768],[1502.69,370.257]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.92,548.91],[1502.69,548.997],[1398.92,463.592],[1502.69,462.909]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.92,554.504],[1502.69,554.641],[1398.92,639.822],[1502.69,640.729]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.92,646.358],[1502.69,647.324],[1398.92,731.676],[1502.69,733.412]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1398.92,740.739],[1502.69,742.556],[1398.92,826.057],[1502.69,828.644]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1504.77,456.331],[1504.77,370.227],[1610.1,455.578],[1610.1,368.694]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1504.77,548.999],[1504.77,462.896],[1610.1,549.088],[1610.1,462.203]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1504.77,554.644],[1504.77,640.747],[1610.1,554.784],[1610.1,641.668]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1504.77,647.343],[1610.1,648.324],[1504.77,733.447],[1610.1,735.208]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1504.77,742.593],[1610.1,744.438],[1504.77,828.696],[1610.1,831.322]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1611.81,454.719],[1611.81,366.941],[1753.66,453.695],[1753.66,364.855]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1611.81,549.189],[1611.81,461.411],[1753.66,549.309],[1753.66,460.469]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1611.81,554.943],[1611.81,642.72],[1753.66,555.133],[1753.66,643.973]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1611.81,649.444],[1611.81,737.222],[1753.66,650.778],[1753.66,739.618]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1611.81,746.546],[1611.81,834.323],[1753.66,749.055],[1753.66,837.895]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1750.58,454.546],[1750.58,366.59],[1861.85,453.751],[1861.85,364.969]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1750.58,549.209],[1750.58,461.253],[1861.85,549.302],[1861.85,460.521]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1750.58,554.975],[1750.58,642.932],[1861.85,555.123],[1861.85,643.905]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1750.58,649.669],[1750.58,737.626],[1861.85,650.706],[1861.85,739.487]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:42,
                    verts:[[1750.58,746.969],[1750.58,834.925],[1861.85,748.918],[1861.85,837.7]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[217.908,463.783],[217.908,385.418],[129.313,464.17],[129.313,386.208]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[217.908,548.123],[217.908,469.758],[129.313,548.078],[129.313,470.115]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[217.908,553.261],[217.908,631.626],[129.313,553.189],[129.313,631.152]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[217.908,637.629],[217.908,715.994],[129.313,637.124],[129.313,715.087]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[217.908,724.318],[217.908,802.683],[129.313,723.368],[129.313,801.331]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,462.585],[325.057,382.976],[208.494,463.099],[208.494,384.024]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,548.264],[325.057,468.655],[208.494,548.204],[208.494,469.129]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,553.483],[325.057,633.092],[208.494,553.388],[208.494,632.463]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,639.19],[325.057,718.8],[208.494,638.52],[208.494,717.595]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,727.256],[325.057,806.865],[208.494,725.994],[208.494,805.069]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,462.585],[325.057,382.976],[333.776,463.302],[333.776,384.438]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,548.264],[325.057,468.655],[333.776,548.18],[333.776,469.315]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,553.483],[325.057,633.092],[333.776,553.35],[333.776,632.215]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,639.19],[325.057,718.8],[333.776,638.256],[333.776,717.12]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[325.057,727.256],[325.057,806.865],[333.776,725.497],[333.776,804.362]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[423.674,462.909],[423.674,383.637],[333.776,463.302],[333.776,384.438]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[423.674,548.226],[423.674,468.954],[333.776,548.18],[333.776,469.315]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[423.674,553.423],[423.674,632.695],[333.776,553.35],[333.776,632.215]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[423.674,638.768],[423.674,718.04],[333.776,638.256],[333.776,717.12]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[423.674,726.461],[423.674,805.733],[333.776,725.497],[333.776,804.362]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[513.752,462.49],[513.752,382.782],[422.102,462.891],[422.102,383.598]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[513.752,548.275],[513.752,468.567],[422.102,548.228],[422.102,468.936]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[513.752,553.501],[513.752,633.209],[422.102,553.426],[422.102,632.718]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[513.752,639.315],[513.752,719.023],[422.102,638.792],[422.102,718.084]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[513.752,727.49],[513.752,807.198],[422.102,726.507],[422.102,805.799]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,461.25],[627.545,380.254],[506.901,461.782],[506.901,381.34]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,548.421],[627.545,467.425],[506.901,548.358],[506.901,467.916]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,553.731],[627.545,634.727],[506.901,553.632],[506.901,634.075]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,640.931],[627.545,721.926],[506.901,640.237],[506.901,720.679]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,730.53],[627.545,811.526],[506.901,729.224],[506.901,809.667]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,461.25],[627.545,380.254],[633.536,461.992],[633.536,381.767]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,548.421],[627.545,467.425],[633.536,548.334],[633.536,468.109]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,553.731],[627.545,634.727],[633.536,553.593],[633.536,633.818]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,640.931],[627.545,721.926],[633.536,639.963],[633.536,720.188]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[627.545,730.53],[627.545,811.526],[633.536,728.71],[633.536,808.935]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[726.571,461.585],[726.571,380.938],[633.536,461.992],[633.536,381.767]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[726.571,548.382],[726.571,467.735],[633.536,548.334],[633.536,468.109]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[726.571,553.669],[726.571,634.316],[633.536,553.593],[633.536,633.818]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[726.571,640.493],[726.571,721.14],[633.536,639.963],[633.536,720.188]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[726.571,729.707],[726.571,810.354],[633.536,728.71],[633.536,808.935]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[818.775,461.156],[818.775,380.064],[723.922,461.571],[723.922,380.909]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[818.775,548.432],[818.775,467.339],[723.922,548.383],[723.922,467.721]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[818.775,553.748],[818.775,634.841],[723.922,553.671],[723.922,634.333]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[818.775,641.053],[818.775,722.146],[723.922,640.512],[723.922,721.174]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[818.775,730.76],[818.775,811.852],[723.922,729.743],[723.922,810.405]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,459.872],[939.592,377.447],[814.664,460.424],[814.664,378.571]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,548.583],[939.592,466.157],[814.664,548.518],[814.664,466.665]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,553.987],[939.592,636.412],[814.664,553.884],[814.664,635.737]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,642.726],[939.592,725.152],[814.664,642.008],[814.664,723.861]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,733.908],[939.592,816.333],[814.664,732.555],[814.664,814.409]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,459.872],[939.592,377.447],[942.666,460.641],[942.666,379.013]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,548.583],[939.592,466.157],[942.666,548.493],[942.666,466.865]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,553.987],[939.592,636.412],[942.666,553.844],[942.666,635.472]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,642.726],[939.592,725.152],[942.666,641.724],[942.666,723.352]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[939.592,733.908],[939.592,816.333],[942.666,732.023],[942.666,813.651]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.85,460.216],[1039.85,378.148],[942.666,460.641],[942.666,379.013]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.85,548.542],[1039.85,466.474],[942.666,548.493],[942.666,466.865]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.85,553.923],[1039.85,635.992],[942.666,553.844],[942.666,635.472]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.85,642.278],[1039.85,724.347],[942.666,641.724],[942.666,723.352]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.85,733.064],[1039.85,815.133],[942.666,732.023],[942.666,813.651]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.9,460.236],[1039.9,378.188],[1044.46,461.895],[1044.46,381.569]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.9,548.54],[1039.9,466.492],[1044.46,548.345],[1044.46,468.02]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.9,553.919],[1039.9,635.967],[1044.46,553.611],[1044.46,633.937]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.9,642.252],[1039.9,724.3],[1044.46,640.09],[1044.46,720.416]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1039.9,733.015],[1039.9,815.063],[1044.46,728.948],[1044.46,809.274]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.05,459.1],[1189.16,459.537],[1289.05,375.873],[1189.16,376.763]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.05,548.674],[1189.16,548.622],[1289.05,465.446],[1189.16,465.848]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.05,554.13],[1189.16,554.049],[1289.05,637.358],[1189.16,636.823]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.05,643.733],[1189.16,643.164],[1289.05,726.961],[1189.16,725.938]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.05,735.801],[1189.16,734.73],[1289.05,819.029],[1189.16,817.504]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.36,458.329],[1289.36,374.3],[1421.04,457.747],[1421.04,373.115]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.36,548.764],[1289.36,464.736],[1421.04,548.833],[1421.04,464.2]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.36,554.273],[1289.36,638.302],[1421.04,554.381],[1421.04,639.013]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.36,644.739],[1289.36,728.768],[1421.04,645.496],[1421.04,730.129]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1289.36,737.693],[1421.04,739.119],[1289.36,821.722],[1421.04,823.751]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1419.41,458.558],[1419.41,374.766],[1520.93,458.114],[1520.93,373.862]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1419.41,548.737],[1419.41,464.946],[1520.93,548.79],[1520.93,464.538]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1419.41,554.231],[1419.41,638.022],[1520.93,554.313],[1520.93,638.565]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1419.41,644.44],[1419.41,728.232],[1520.93,645.019],[1520.93,729.271]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1419.41,737.132],[1419.41,820.923],[1520.93,738.22],[1520.93,822.472]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1522.96,458.105],[1522.96,373.844],[1625.25,457.658],[1625.25,372.933]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1522.96,548.791],[1522.96,464.53],[1625.25,548.843],[1625.25,464.118]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1522.96,554.315],[1522.96,638.576],[1625.25,554.398],[1625.25,639.123]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1522.96,645.03],[1522.96,729.291],[1625.25,645.613],[1625.25,730.338]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1522.96,738.242],[1522.96,822.503],[1625.25,739.338],[1625.25,824.063]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1628.99,456.83],[1628.99,371.244],[1765.61,456.227],[1765.61,370.015]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1628.99,548.941],[1628.99,463.355],[1765.61,549.011],[1765.61,462.8]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1628.99,554.551],[1628.99,640.137],[1765.61,554.663],[1765.61,640.875]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1628.99,646.693],[1628.99,732.278],[1765.61,647.479],[1765.61,733.69]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1628.99,741.369],[1628.99,826.955],[1765.61,742.848],[1765.61,829.06]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1760.64,457.039],[1760.64,371.67],[1866.91,456.574],[1866.91,370.723]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1760.64,548.916],[1760.64,463.548],[1866.91,548.971],[1866.91,463.12]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1760.64,554.513],[1760.64,639.881],[1866.91,554.599],[1866.91,640.45]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1760.64,646.42],[1760.64,731.789],[1866.91,647.026],[1866.91,732.877]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:43,
                    verts:[[1760.64,740.857],[1760.64,826.225],[1866.91,741.996],[1866.91,827.847]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[216.078,461.964],[216.078,381.71],[122.028,462.124],[122.028,382.035]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[216.078,548.337],[216.078,468.083],[122.028,548.318],[122.028,468.23]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[216.078,553.598],[216.078,633.852],[122.028,553.569],[122.028,633.657]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[216.078,640],[216.078,720.253],[122.028,639.792],[122.028,719.88]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[216.078,728.778],[216.078,809.032],[122.028,728.388],[122.028,808.476]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,461.032],[330.993,379.81],[208.052,461.242],[208.052,380.238]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,548.447],[330.993,467.225],[208.052,548.422],[208.052,467.418]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,553.771],[330.993,634.993],[208.052,553.732],[208.052,634.736]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,641.215],[330.993,722.437],[208.052,640.941],[208.052,721.945]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,731.065],[330.993,812.287],[208.052,730.549],[208.052,811.553]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,461.032],[330.993,379.81],[338.141,461.783],[338.141,381.341]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,548.447],[330.993,467.225],[338.141,548.358],[338.141,467.917]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,553.771],[330.993,634.994],[338.141,553.632],[338.141,634.074]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,641.215],[330.993,722.437],[338.141,640.236],[338.141,720.677]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[330.993,731.065],[330.993,812.287],[338.141,729.222],[338.141,809.664]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[432.227,461.624],[432.227,381.017],[338.141,461.783],[338.141,381.341]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[432.227,548.377],[432.227,467.77],[338.141,548.358],[338.141,467.917]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[432.227,553.661],[432.227,634.269],[338.141,553.632],[338.141,634.074]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[432.227,640.443],[432.227,721.05],[338.141,640.236],[338.141,720.677]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[432.227,729.613],[432.227,810.22],[338.141,729.222],[338.141,809.664]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[525.984,461.439],[525.984,380.64],[430.654,461.601],[430.654,380.969]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[525.984,548.399],[525.984,467.6],[430.654,548.38],[430.654,467.749]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[525.984,553.696],[525.984,634.495],[430.654,553.666],[430.654,634.297]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[525.984,640.684],[525.984,721.483],[430.654,640.474],[430.654,721.105]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[525.984,730.066],[525.984,810.865],[430.654,729.67],[430.654,810.301]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,460.494],[645.455,378.713],[520.819,460.707],[520.819,379.148]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,548.51],[645.455,466.729],[520.819,548.485],[520.819,466.926]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,553.871],[645.455,635.652],[520.819,553.832],[520.819,635.391]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,641.916],[645.455,723.697],[520.819,641.638],[520.819,723.198]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,732.384],[645.455,814.165],[520.819,731.861],[520.819,813.42]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,460.494],[645.455,378.713],[649.61,461.256],[649.61,380.266]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,548.51],[645.455,466.729],[649.61,548.42],[649.61,467.431]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,553.871],[645.455,635.652],[649.61,553.73],[649.61,634.719]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,641.916],[645.455,723.697],[649.61,640.923],[649.61,721.913]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[645.455,732.384],[645.455,814.165],[649.61,730.516],[649.61,811.505]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[744.983,461.094],[744.983,379.937],[649.61,461.256],[649.61,380.266]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[744.983,548.439],[744.983,467.282],[649.61,548.42],[649.61,467.431]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[744.983,553.76],[744.983,634.917],[649.61,553.73],[649.61,634.719]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[744.983,641.134],[744.983,722.291],[649.61,640.923],[649.61,721.913]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[744.983,730.912],[744.983,812.069],[649.61,730.516],[649.61,811.505]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[838.976,460.909],[838.976,379.559],[742.344,461.073],[742.344,379.893]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[838.976,548.461],[838.976,467.112],[742.344,548.442],[742.344,467.262]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[838.976,553.794],[838.976,635.144],[742.344,553.764],[742.344,634.943]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[838.976,641.375],[838.976,722.725],[742.344,641.162],[742.344,722.341]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[838.976,731.366],[838.976,812.716],[742.344,730.965],[742.344,812.144]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,459.951],[963.1,377.606],[836.741,460.167],[836.741,378.046]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,548.574],[963.1,466.229],[836.741,548.548],[836.741,466.428]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,553.972],[963.1,636.317],[836.741,553.932],[836.741,636.052]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,642.625],[963.1,724.969],[836.741,642.343],[836.741,724.463]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,733.716],[963.1,816.061],[836.741,733.186],[836.741,815.306]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,459.951],[963.1,377.606],[964.189,460.723],[964.189,379.18]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,548.574],[963.1,466.229],[964.189,548.483],[964.189,466.94]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,553.972],[963.1,636.317],[964.189,553.829],[964.189,635.371]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,642.625],[963.1,724.969],[964.189,641.618],[964.189,723.16]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[963.1,733.716],[963.1,816.061],[964.189,731.822],[964.189,813.365]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1061.73,460.558],[964.189,460.723],[1061.73,378.843],[964.189,379.18]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1061.73,548.502],[1061.73,466.788],[964.189,548.483],[964.189,466.94]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1061.73,553.859],[1061.73,635.574],[964.189,553.829],[964.189,635.371]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1061.73,641.833],[964.189,641.618],[1061.73,723.547],[964.189,723.16]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1061.73,732.227],[964.189,731.822],[1061.73,813.941],[964.189,813.365]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1210.41,460.28],[1210.41,378.277],[1309.01,460.113],[1309.01,377.936]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1210.41,548.535],[1210.41,466.532],[1309.01,548.555],[1309.01,466.378]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1210.41,553.911],[1210.41,635.914],[1309.01,553.942],[1309.01,636.119]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1210.41,642.196],[1210.41,724.199],[1309.01,642.413],[1309.01,724.59]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1210.41,732.909],[1309.01,733.319],[1210.41,814.912],[1309.01,815.495]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1311.25,459.355],[1311.25,376.392],[1440.22,459.135],[1440.22,375.942]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1311.25,548.644],[1311.25,465.681],[1440.22,548.67],[1440.22,465.478]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1311.25,554.083],[1311.25,637.046],[1440.22,554.123],[1440.22,637.316]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1311.25,643.401],[1311.25,726.364],[1440.22,643.688],[1440.22,726.88]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1311.25,735.176],[1311.25,818.139],[1440.22,735.717],[1440.22,818.909]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1436.63,459.923],[1436.63,377.549],[1535.29,459.756],[1535.29,377.209]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1436.63,548.577],[1436.63,466.203],[1535.29,548.597],[1535.29,466.05]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1436.63,553.977],[1436.63,636.351],[1535.29,554.008],[1535.29,636.555]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1436.63,642.661],[1436.63,725.034],[1535.29,642.878],[1535.29,725.426]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1436.63,733.784],[1436.63,816.158],[1535.29,734.194],[1535.29,816.741]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1537.26,459.752],[1537.26,377.202],[1635.99,459.585],[1635.99,376.861]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1537.26,548.597],[1537.26,466.047],[1635.99,548.617],[1635.99,465.893]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1537.26,554.009],[1537.26,636.559],[1635.99,554.04],[1635.99,636.764]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1537.26,642.883],[1537.26,725.433],[1635.99,643.101],[1635.99,725.825]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1537.26,734.202],[1537.26,816.753],[1635.99,734.612],[1635.99,817.336]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1641.59,458.79],[1641.59,375.24],[1772.4,458.566],[1772.4,374.784]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1641.59,548.71],[1641.59,465.16],[1772.4,548.736],[1772.4,464.954]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1641.59,554.187],[1641.59,637.737],[1772.4,554.229],[1772.4,638.011]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1641.59,644.137],[1641.59,727.687],[1772.4,644.429],[1772.4,728.211]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1641.59,736.562],[1641.59,820.112],[1772.4,737.11],[1772.4,820.892]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1765.72,459.339],[1765.72,376.359],[1866.69,459.168],[1866.69,376.01]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1765.72,548.646],[1765.72,465.666],[1866.69,548.666],[1866.69,465.508]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1765.72,554.086],[1765.72,637.066],[1866.69,554.117],[1866.69,637.275]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1765.72,643.422],[1765.72,726.402],[1866.69,643.645],[1866.69,726.802]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:44,
                    verts:[[1765.72,735.216],[1765.72,818.196],[1866.69,735.636],[1866.69,818.793]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[218.094,459.987],[218.094,377.679],[118.783,459.892],[118.783,377.487]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[218.094,548.57],[218.094,466.262],[118.783,548.581],[118.783,466.176]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[218.094,553.965],[218.094,636.273],[118.783,553.983],[118.783,636.388]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[218.094,642.578],[218.094,724.885],[118.783,642.7],[118.783,725.105]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[218.094,733.628],[218.094,815.935],[118.783,733.859],[118.783,816.264]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[340.52,459.349],[340.52,376.38],[211.604,459.226],[211.604,376.129]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[340.52,548.644],[340.52,465.675],[211.604,548.659],[211.604,465.562]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[340.52,554.084],[340.52,637.053],[211.604,554.107],[211.604,637.204]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[340.52,643.408],[340.52,726.377],[211.604,643.569],[211.604,726.666]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[340.52,735.19],[340.52,818.159],[211.604,735.493],[211.604,818.59]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[443.842,460.227],[443.842,378.169],[345.961,460.134],[345.961,377.98]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[443.842,548.541],[443.842,466.483],[345.961,548.552],[345.961,466.398]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[443.842,553.921],[443.842,635.979],[345.961,553.938],[345.961,636.092]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[443.842,642.264],[443.842,724.322],[345.961,642.385],[345.961,724.539]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[443.842,733.038],[443.842,815.096],[345.961,733.266],[345.961,815.42]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[540.825,460.293],[540.825,378.303],[442.28,460.199],[442.28,378.112]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[540.825,548.534],[540.825,466.544],[442.28,548.544],[442.28,466.458]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[540.825,553.909],[540.825,635.898],[442.28,553.926],[442.28,636.013]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[540.825,642.179],[540.825,724.168],[442.28,642.3],[442.28,724.387]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[540.825,732.878],[540.825,814.867],[442.28,733.107],[442.28,815.193]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[665.359,459.66],[665.359,377.014],[537.445,459.538],[537.445,376.765]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[665.359,548.608],[665.359,465.962],[537.445,548.622],[537.445,465.849]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[665.359,554.026],[665.359,636.672],[537.445,554.049],[537.445,636.822]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[665.359,643.003],[665.359,725.649],[537.445,643.162],[537.445,725.936]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[665.359,734.428],[665.359,817.074],[537.445,734.728],[537.445,817.501]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[764.73,460.531],[764.73,378.789],[667.601,460.439],[667.601,378.601]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[764.73,548.505],[764.73,466.764],[667.601,548.516],[667.601,466.679]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[764.73,553.864],[764.73,635.606],[667.601,553.881],[667.601,635.719]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[764.73,641.868],[764.73,723.61],[667.601,641.988],[667.601,723.825]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[764.73,732.293],[667.601,732.518],[764.73,814.035],[667.601,814.356]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.91,460.595],[762.119,460.502],[859.91,378.919],[762.119,378.73]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.91,548.498],[859.91,466.823],[762.119,548.509],[762.119,466.737]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.91,553.852],[859.91,635.528],[762.119,553.87],[762.119,635.641]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.91,641.784],[762.119,641.905],[859.91,723.46],[762.119,723.677]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.91,732.136],[762.119,732.363],[859.91,813.811],[762.119,814.135]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.58,459.846],[986.508,459.968],[859.58,377.393],[986.508,377.641]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.58,548.586],[859.58,466.133],[986.508,548.572],[986.508,466.245]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.58,553.991],[986.508,553.969],[859.58,636.445],[986.508,636.296]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.58,642.761],[986.508,642.602],[859.58,725.214],[986.508,724.929]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[859.58,733.972],[986.508,733.674],[859.58,816.425],[986.508,816.001]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[985.612,731.779],[1082.85,731.553],[985.612,813.304],[1082.85,812.982]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[985.612,460.74],[985.612,379.216],[1082.85,460.832],[1082.85,379.404]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[985.612,548.481],[985.612,466.956],[1082.85,548.47],[1082.85,467.041]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[985.612,553.825],[985.612,635.35],[1082.85,553.808],[1082.85,635.237]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[985.612,641.595],[985.612,723.12],[1082.85,641.475],[1082.85,722.904]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1230.63,460.973],[1230.63,379.69],[1224.04,462.509],[1224.04,382.821]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1230.63,548.454],[1230.63,467.171],[1224.04,548.273],[1224.04,468.585]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1230.63,553.782],[1230.63,635.065],[1224.04,553.497],[1224.04,633.185]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1230.63,641.292],[1230.63,722.575],[1224.04,639.289],[1224.04,718.978]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1230.63,731.209],[1230.63,812.492],[1224.04,727.442],[1224.04,807.13]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1229.93,460.946],[1229.93,379.635],[1326.62,461.037],[1326.62,379.821]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1229.93,548.457],[1229.93,467.146],[1326.62,548.446],[1326.62,467.23]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1229.93,553.787],[1229.93,635.099],[1326.62,553.77],[1326.62,634.986]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1229.93,641.327],[1229.93,722.638],[1326.62,641.208],[1326.62,722.424]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1229.93,731.276],[1229.93,812.587],[1326.62,731.051],[1326.62,812.267]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,460.297],[1330.71,378.312],[1326.62,461.037],[1326.62,379.821]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,548.533],[1330.71,466.548],[1326.62,548.446],[1326.62,467.23]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,553.908],[1330.71,635.893],[1326.62,553.77],[1326.62,634.986]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,642.173],[1330.71,724.158],[1326.62,641.208],[1326.62,722.424]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,732.866],[1330.71,814.851],[1326.62,731.051],[1326.62,812.267]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,460.297],[1330.71,378.312],[1456.2,460.417],[1456.2,378.557]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,548.533],[1330.71,466.548],[1456.2,548.519],[1456.2,466.659]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,553.908],[1330.71,635.893],[1456.2,553.885],[1456.2,635.746]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,642.173],[1330.71,724.158],[1456.2,642.016],[1456.2,723.876]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1330.71,732.866],[1330.71,814.851],[1456.2,732.572],[1456.2,814.432]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1450.76,461.181],[1450.76,380.114],[1546.07,461.271],[1546.07,380.298]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1450.76,548.429],[1450.76,467.362],[1546.07,548.418],[1546.07,467.445]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1450.76,553.744],[1450.76,634.81],[1546.07,553.727],[1546.07,634.7]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1450.76,641.02],[1450.76,722.087],[1546.07,640.903],[1546.07,721.876]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1450.76,730.698],[1450.76,811.765],[1546.07,730.477],[1546.07,811.45]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1547.96,461.273],[1547.96,380.302],[1642.71,461.363],[1642.71,380.485]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1547.96,548.418],[1547.96,467.447],[1642.71,548.408],[1642.71,467.53]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1547.96,553.727],[1547.96,634.698],[1642.71,553.71],[1642.71,634.588]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1547.96,640.9],[1547.96,721.872],[1642.71,640.783],[1642.71,721.661]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1547.96,730.473],[1547.96,811.444],[1642.71,730.252],[1642.71,811.13]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,460.603],[1650.01,378.935],[1642.71,461.363],[1642.71,380.485]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,548.497],[1650.01,466.829],[1642.71,548.408],[1642.71,467.53]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,553.851],[1650.01,635.519],[1642.71,553.71],[1642.71,634.588]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,641.774],[1650.01,723.442],[1642.71,640.783],[1642.71,721.661]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,732.117],[1650.01,813.785],[1642.71,730.252],[1642.71,811.13]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,460.603],[1650.01,378.935],[1774.53,460.722],[1774.53,379.178]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,548.497],[1650.01,466.829],[1774.53,548.483],[1774.53,466.939]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,553.851],[1650.01,635.519],[1774.53,553.829],[1774.53,635.373]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,641.774],[1650.01,723.442],[1774.53,641.619],[1774.53,723.163]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1650.01,732.117],[1650.01,813.785],[1774.53,731.825],[1774.53,813.369]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1766.33,461.454],[1766.33,380.671],[1861.77,461.545],[1861.77,380.856]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1766.33,548.397],[1766.33,467.614],[1861.77,548.386],[1861.77,467.697]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1766.33,553.693],[1766.33,634.476],[1861.77,553.676],[1861.77,634.365]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1766.33,640.664],[1766.33,721.448],[1861.77,640.546],[1861.77,721.236]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:45,
                    verts:[[1766.33,730.029],[1766.33,810.812],[1861.77,729.807],[1861.77,810.496]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[224.23,457.838],[224.23,373.299],[119.91,457.461],[119.91,372.531]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[224.23,548.822],[224.23,464.284],[119.91,548.866],[119.91,463.936]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[224.23,554.364],[224.23,638.903],[119.91,554.434],[119.91,639.364]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[224.23,645.379],[224.23,729.917],[119.91,645.87],[119.91,730.8]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[224.23,738.897],[224.23,823.436],[119.91,739.821],[119.91,824.751]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[353.839,457.53],[353.839,372.671],[219.435,457.039],[219.435,371.672]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[353.839,548.858],[353.839,464],[219.435,548.916],[219.435,463.548]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[353.839,554.421],[353.839,639.28],[219.435,554.512],[219.435,639.88]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[353.839,645.78],[353.839,730.639],[219.435,646.419],[219.435,731.787]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[353.839,739.653],[353.839,824.511],[219.435,740.855],[219.435,826.222]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[458.659,458.712],[458.659,375.08],[357.429,458.346],[357.429,374.335]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[458.659,548.719],[458.659,465.088],[357.429,548.762],[357.429,464.752]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[458.659,554.202],[458.659,637.833],[357.429,554.27],[357.429,638.281]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[458.659,644.24],[458.659,727.871],[357.429,644.716],[357.429,728.727]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[458.659,736.754],[458.659,820.385],[357.429,737.651],[357.429,821.661]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[558.361,459.045],[558.361,375.759],[457.118,458.679],[457.118,375.014]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[558.361,548.68],[558.361,465.395],[457.118,548.723],[457.118,465.058]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[558.361,554.14],[558.361,637.425],[457.118,554.208],[457.118,637.873]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[558.361,643.805],[558.361,727.091],[457.118,644.282],[457.118,727.947]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[558.361,735.937],[558.361,819.223],[457.118,736.834],[457.118,820.499]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.287,458.746],[687.287,375.15],[556.865,458.27],[556.865,374.18]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.287,548.715],[687.287,465.12],[556.865,548.771],[556.865,464.682]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.287,554.196],[687.287,637.792],[556.865,554.284],[556.865,638.374]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.287,644.195],[556.865,644.815],[687.287,727.791],[556.865,728.905]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.287,736.671],[556.865,737.837],[687.287,820.267],[556.865,821.927]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.542,459.538],[785.817,459.893],[687.542,376.765],[785.817,377.489]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.542,548.622],[785.817,548.581],[687.542,465.849],[785.817,466.176]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.542,554.049],[785.817,553.983],[687.542,636.822],[785.817,636.387]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.542,643.162],[785.817,642.699],[687.542,725.935],[785.817,725.104]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[687.542,734.728],[785.817,733.857],[687.542,817.5],[785.817,816.262]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[783.252,459.857],[783.252,377.415],[881.563,460.212],[881.563,378.139]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[783.252,548.585],[783.252,466.143],[881.563,548.543],[881.563,466.47]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[783.252,553.989],[783.252,636.431],[881.563,553.924],[881.563,635.996]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[783.252,642.746],[881.563,642.283],[783.252,725.188],[881.563,724.356]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[783.252,733.945],[881.563,733.074],[783.252,816.387],[881.563,815.147]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.163,459.46],[883.163,376.606],[881.561,460.212],[881.561,378.139]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.163,548.631],[883.163,465.777],[881.561,548.543],[881.561,466.47]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.163,554.063],[883.163,636.917],[881.561,553.924],[881.561,635.996]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.163,643.264],[883.163,726.118],[881.561,642.283],[881.561,724.356]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.163,734.919],[883.163,817.773],[881.561,733.074],[881.561,815.147]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.164,459.46],[883.164,376.606],[1009.79,459.922],[1009.79,377.547]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.164,548.631],[883.164,465.777],[1009.79,548.577],[1009.79,466.203]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.164,554.063],[883.164,636.917],[1009.79,553.977],[1009.79,636.352]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.164,643.264],[883.164,726.118],[1009.79,642.662],[1009.79,725.036]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[883.164,734.919],[883.164,817.773],[1009.79,733.787],[1009.79,816.161]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1006.92,731.899],[1006.92,813.475],[1103.22,731.047],[1103.22,812.261]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1006.92,460.691],[1006.92,379.116],[1103.22,461.039],[1103.22,379.825]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1006.92,548.487],[1006.92,466.911],[1103.22,548.446],[1103.22,467.231]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1006.92,553.835],[1006.92,635.41],[1103.22,553.77],[1103.22,634.984]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1006.92,641.659],[1006.92,723.234],[1103.22,641.205],[1103.22,722.42]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1248.37,461.564],[1248.37,380.894],[1238,463.069],[1238,383.963]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1248.37,548.384],[1248.37,467.714],[1238,548.207],[1238,469.101]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1248.37,553.673],[1248.37,634.342],[1238,553.393],[1238,632.5]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1248.37,640.522],[1248.37,721.191],[1238,638.559],[1238,717.666]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1248.37,729.76],[1248.37,810.43],[1238,726.069],[1238,805.175]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1247.75,461.535],[1247.75,380.836],[1341.95,461.875],[1341.95,381.529]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1247.75,548.388],[1247.75,467.688],[1341.95,548.347],[1341.95,468.001]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1247.75,553.678],[1247.75,634.377],[1341.95,553.615],[1341.95,633.961]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1247.75,640.559],[1247.75,721.259],[1341.95,640.115],[1341.95,720.462]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1247.75,729.831],[1247.75,810.53],[1341.95,728.996],[1341.95,809.342]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,461.155],[1347.81,380.06],[1341.95,461.875],[1341.95,381.529]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,548.432],[1347.81,467.338],[1341.95,548.347],[1341.95,468.001]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,553.749],[1347.81,634.843],[1341.95,553.615],[1341.95,633.961]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,641.055],[1347.81,722.149],[1341.95,640.115],[1341.95,720.462]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,730.764],[1347.81,811.858],[1341.95,728.996],[1341.95,809.342]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,461.155],[1347.81,380.06],[1469.13,461.597],[1469.13,380.962]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,548.432],[1347.81,467.338],[1469.13,548.38],[1469.13,467.745]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,553.749],[1347.81,634.843],[1469.13,553.666],[1469.13,634.302]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,641.055],[1347.81,722.149],[1469.13,640.478],[1469.13,721.113]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1347.81,730.764],[1347.81,811.858],[1469.13,729.679],[1469.13,810.314]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1461.95,462.335],[1461.95,382.465],[1553.47,462.665],[1553.47,383.139]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1461.95,548.294],[1461.95,468.424],[1553.47,548.255],[1553.47,468.729]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1461.95,553.53],[1461.95,633.399],[1553.47,553.468],[1553.47,632.994]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1461.95,639.517],[1461.95,719.386],[1553.47,639.086],[1553.47,718.612]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1461.95,727.87],[1461.95,807.739],[1553.47,727.06],[1553.47,806.586]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1555.28,462.672],[1555.28,383.152],[1645.67,462.998],[1645.67,383.818]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1555.28,548.254],[1555.28,468.735],[1645.67,548.216],[1645.67,469.035]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1555.28,553.467],[1555.28,632.986],[1645.67,553.406],[1645.67,632.587]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1555.28,639.078],[1555.28,718.597],[1645.67,638.652],[1645.67,717.832]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1555.28,727.044],[1555.28,806.563],[1645.67,726.243],[1645.67,805.423]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,462.273],[1654.54,382.34],[1645.67,462.998],[1645.67,383.818]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,548.301],[1654.54,468.368],[1645.67,548.216],[1645.67,469.035]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,553.541],[1654.54,633.474],[1645.67,553.406],[1645.67,632.587]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,639.597],[1654.54,719.53],[1645.67,638.652],[1645.67,717.832]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,728.021],[1654.54,807.953],[1645.67,726.243],[1645.67,805.423]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,462.273],[1654.54,382.34],[1772.42,462.703],[1772.42,383.217]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,548.301],[1654.54,468.368],[1772.42,548.25],[1772.42,468.764]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,553.541],[1654.54,633.474],[1772.42,553.461],[1772.42,632.948]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,639.597],[1654.54,719.53],[1772.42,639.036],[1772.42,718.523]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1654.54,728.021],[1654.54,807.953],[1772.42,726.966],[1772.42,806.453]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1762.84,463.396],[1762.84,384.628],[1852.6,463.72],[1852.6,385.289]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1762.84,548.169],[1762.84,469.401],[1852.6,548.131],[1852.6,469.7]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1762.84,553.333],[1762.84,632.1],[1852.6,553.272],[1852.6,631.703]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1762.84,638.134],[1762.84,716.901],[1852.6,637.711],[1852.6,716.142]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:46,
                    verts:[[1762.84,725.268],[1762.84,804.035],[1852.6,724.473],[1852.6,802.904]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[234.856,455.507],[234.856,368.549],[125.859,454.814],[125.859,367.136]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[234.856,549.096],[234.856,462.138],[125.859,549.177],[125.859,461.499]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[234.856,554.797],[234.856,641.755],[125.859,554.925],[125.859,642.604]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[234.856,648.416],[234.856,735.375],[125.859,649.32],[125.859,736.998]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[234.856,744.612],[234.856,831.571],[125.859,746.311],[125.859,833.989]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[371.224,455.566],[371.224,368.669],[231.928,454.672],[231.928,366.846]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[371.224,549.089],[371.224,462.192],[231.928,549.194],[231.928,461.368]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[371.224,554.786],[371.224,641.683],[231.928,554.952],[231.928,642.778]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[371.224,648.34],[371.224,735.237],[231.928,649.505],[231.928,737.331]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[371.224,744.467],[371.224,831.365],[231.928,746.66],[231.928,834.486]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[476.87,457.074],[372.814,456.413],[476.87,371.742],[372.814,370.394]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[476.87,548.912],[476.87,463.58],[372.814,548.99],[372.814,462.971]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[476.87,554.506],[476.87,639.838],[372.814,554.629],[372.814,640.647]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[476.87,646.374],[372.814,647.236],[476.87,731.706],[372.814,733.255]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[476.87,740.77],[372.814,742.392],[476.87,826.102],[372.814,828.41]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[578.719,457.693],[475.361,457.036],[578.719,373.005],[475.361,371.666]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[578.719,548.839],[475.361,548.916],[578.719,464.151],[475.361,463.546]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[578.719,554.391],[475.361,554.513],[578.719,639.079],[475.361,639.884]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[578.719,645.567],[475.361,646.423],[578.719,730.255],[475.361,731.794]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[578.719,739.251],[475.361,740.862],[578.719,823.939],[475.361,826.233]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,456.901],[579.208,371.391],[578.719,457.693],[578.719,373.005]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,548.932],[579.208,463.421],[578.719,548.839],[578.719,464.151]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,554.538],[579.208,640.049],[578.719,554.391],[578.719,639.079]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,646.599],[579.208,732.11],[578.719,645.567],[578.719,730.255]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,741.193],[579.208,826.704],[578.719,739.251],[578.719,823.939]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,456.901],[579.208,371.391],[711.294,457.749],[711.294,373.119]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,548.932],[579.208,463.421],[711.294,548.832],[711.294,464.202]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,554.538],[579.208,640.049],[711.294,554.381],[711.294,639.011]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,646.599],[579.208,732.11],[711.294,645.494],[711.294,730.124]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[579.208,741.193],[711.294,739.114],[579.208,826.704],[711.294,823.744]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[709.492,737.145],[709.492,820.941],[808.262,735.605],[808.262,818.75]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[709.492,458.552],[709.492,374.756],[808.262,459.18],[808.262,376.035]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[709.492,548.738],[709.492,464.942],[808.262,548.664],[808.262,465.52]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[709.492,554.232],[709.492,638.028],[808.262,554.115],[808.262,637.26]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[709.492,644.447],[709.492,728.244],[808.262,643.629],[808.262,726.773]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[805.76,459.137],[805.76,375.947],[903.924,459.761],[903.924,377.22]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[805.76,548.669],[805.76,465.48],[903.924,548.596],[903.924,466.055]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[805.76,554.123],[805.76,637.313],[903.924,554.007],[903.924,636.549]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[805.76,643.685],[805.76,726.875],[903.924,642.872],[903.924,725.413]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[805.76,735.711],[805.76,818.901],[903.924,734.181],[903.924,816.722]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.476,459.009],[907.476,375.686],[903.923,459.761],[903.923,377.22]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.476,548.684],[907.476,465.362],[903.923,548.596],[903.923,466.055]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.476,554.147],[907.476,637.469],[903.923,554.007],[903.923,636.549]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.476,643.852],[907.476,727.175],[903.923,642.872],[903.923,725.413]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.476,736.026],[907.476,819.348],[903.923,734.181],[903.923,816.722]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.477,459.009],[907.477,375.686],[1032.92,459.814],[1032.92,377.328]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.477,548.684],[907.477,465.362],[1032.92,548.59],[1032.92,466.103]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.477,554.147],[907.477,637.469],[1032.92,553.997],[1032.92,636.484]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.477,643.852],[907.477,727.175],[1032.92,642.802],[1032.92,725.289]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[907.477,736.026],[907.477,819.348],[1032.92,734.051],[1032.92,816.537]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1028.08,732.18],[1028.08,813.874],[1122.8,730.703],[1122.8,811.772]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1028.08,460.577],[1028.08,378.883],[1122.8,461.179],[1122.8,380.11]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1028.08,548.5],[1028.08,466.806],[1122.8,548.429],[1122.8,467.36]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1028.08,553.856],[1028.08,635.55],[1122.8,553.744],[1122.8,634.813]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1028.08,641.808],[1028.08,723.502],[1122.8,641.023],[1122.8,722.092]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1264.41,462.08],[1264.41,381.946],[1250.4,463.549],[1250.4,384.94]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1264.41,548.323],[1264.41,468.19],[1250.4,548.151],[1250.4,469.542]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1264.41,553.577],[1264.41,633.711],[1250.4,553.304],[1250.4,631.913]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1264.41,639.849],[1264.41,719.983],[1250.4,637.934],[1250.4,716.542]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1264.41,728.495],[1264.41,808.629],[1250.4,724.893],[1250.4,803.501]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1263.87,462.049],[1263.87,381.884],[1355.06,462.629],[1355.06,383.066]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1263.87,548.327],[1263.87,468.162],[1355.06,548.259],[1355.06,468.696]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1263.87,553.582],[1263.87,633.748],[1355.06,553.475],[1355.06,633.038]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1263.87,639.888],[1263.87,720.054],[1355.06,639.133],[1355.06,718.696]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1263.87,728.569],[1263.87,808.734],[1355.06,727.148],[1355.06,806.711]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,461.931],[1362.59,381.642],[1355.06,462.629],[1355.06,383.066]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,548.341],[1362.59,468.052],[1355.06,548.259],[1355.06,468.696]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,553.605],[1362.59,633.893],[1355.06,553.475],[1355.06,633.038]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,640.044],[1362.59,720.332],[1355.06,639.133],[1355.06,718.696]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,728.861],[1362.59,809.149],[1355.06,727.148],[1355.06,806.711]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,461.931],[1362.59,381.642],[1479.11,462.679],[1479.11,383.167]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,548.341],[1362.59,468.052],[1479.11,548.253],[1479.11,468.741]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,553.605],[1362.59,633.893],[1479.11,553.466],[1479.11,632.978]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,640.044],[1362.59,720.332],[1479.11,639.068],[1479.11,718.58]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1362.59,728.861],[1362.59,809.149],[1479.11,727.027],[1479.11,806.538]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1470.31,463.388],[1470.31,384.612],[1557.64,463.943],[1557.64,385.744]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1470.31,548.17],[1470.31,469.394],[1557.64,548.104],[1557.64,469.905]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1470.31,553.334],[1470.31,632.11],[1557.64,553.231],[1557.64,631.43]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1470.31,638.144],[1470.31,716.919],[1557.64,637.42],[1557.64,715.62]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1470.31,725.287],[1470.31,804.063],[1557.64,723.926],[1557.64,802.125]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1559.36,463.954],[1559.36,385.766],[1645.09,464.499],[1645.09,386.877]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1559.36,548.103],[1559.36,469.915],[1645.09,548.039],[1645.09,470.417]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1559.36,553.229],[1559.36,631.417],[1645.09,553.128],[1645.09,630.75]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1559.36,637.406],[1559.36,715.594],[1645.09,636.696],[1645.09,714.318]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1559.36,723.899],[1559.36,802.087],[1645.09,722.563],[1645.09,800.185]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,463.81],[1655.38,385.473],[1645.09,464.499],[1645.09,386.877]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,548.12],[1655.38,469.783],[1645.09,548.039],[1645.09,470.417]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,553.256],[1655.38,631.593],[1645.09,553.128],[1645.09,630.75]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,637.593],[1655.38,715.93],[1645.09,636.696],[1645.09,714.318]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,724.252],[1655.38,802.589],[1645.09,722.563],[1645.09,800.185]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,463.81],[1655.38,385.473],[1766.32,464.522],[1766.32,386.925]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,548.12],[1655.38,469.783],[1766.32,548.036],[1766.32,470.439]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,553.256],[1655.38,631.593],[1766.32,553.123],[1766.32,630.721]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,637.593],[1655.38,715.93],[1766.32,636.665],[1766.32,714.262]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1655.38,724.252],[1655.38,802.589],[1766.32,722.505],[1766.32,800.102]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1755.51,465.175],[1755.51,388.256],[1839.49,465.709],[1839.49,389.344]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1755.51,547.96],[1755.51,471.04],[1839.49,547.897],[1839.49,471.532]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1755.51,553.002],[1755.51,629.922],[1839.49,552.903],[1839.49,629.268]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1755.51,635.814],[1755.51,712.734],[1839.49,635.118],[1839.49,711.483]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:47,
                    verts:[[1755.51,720.904],[1755.51,797.824],[1839.49,719.595],[1839.49,795.96]]
                },
                ],
                [
                {
                    num:"507",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[250.457,452.988],[250.457,363.413],[137.228,451.94],[137.228,361.278]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[250.457,549.392],[250.457,459.817],[137.228,549.515],[137.228,458.853]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[250.457,555.265],[250.457,644.839],[137.228,555.459],[137.228,646.121]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[250.457,651.701],[250.457,741.276],[137.228,653.066],[137.228,743.728]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[250.457,750.791],[137.228,753.359],[250.457,840.365],[137.228,844.021]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[393.034,453.457],[249.584,452.117],[393.034,364.37],[249.584,361.638]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[393.034,549.337],[249.584,549.495],[393.034,460.25],[249.584,459.016]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[393.034,555.177],[249.584,555.426],[393.034,644.265],[249.584,645.905]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[393.034,651.089],[249.584,652.836],[393.034,740.176],[249.584,743.315]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[393.034,749.64],[249.584,752.926],[393.034,838.727],[249.584,843.404]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[392.463,454.331],[498.728,455.313],[392.463,366.151],[498.728,368.153]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[392.463,549.234],[392.463,461.054],[498.728,549.119],[498.728,461.959]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[392.463,555.015],[392.463,643.195],[498.728,554.833],[498.728,641.993]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[392.463,649.95],[498.728,648.669],[392.463,738.13],[498.728,735.829]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[392.463,747.497],[498.728,745.088],[392.463,835.677],[498.728,832.248]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[497.267,455.27],[497.267,368.066],[602.072,456.24],[602.072,370.042]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[497.267,549.124],[497.267,461.919],[602.072,549.01],[602.072,462.812]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[497.267,554.841],[497.267,642.045],[602.072,554.661],[602.072,640.859]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[497.267,648.725],[497.267,735.93],[602.072,647.462],[602.072,733.66]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[497.267,745.193],[602.072,742.816],[497.267,832.397],[602.072,829.014]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,455.434],[604.646,368.399],[602.072,456.24],[602.072,370.042]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,549.105],[604.646,462.07],[602.072,549.01],[602.072,462.812]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,554.81],[604.646,641.845],[602.072,554.661],[602.072,640.859]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,648.512],[604.646,735.547],[602.072,647.462],[602.072,733.66]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,744.792],[604.646,831.827],[602.072,742.816],[602.072,829.014]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,455.434],[604.646,368.399],[737.461,456.674],[737.461,370.928]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,549.105],[604.646,462.07],[737.461,548.959],[737.461,463.212]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,554.81],[604.646,641.845],[737.461,554.58],[737.461,640.327]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,648.512],[604.646,735.547],[737.461,646.895],[737.461,732.642]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[604.646,744.792],[604.646,831.827],[737.461,741.75],[737.461,827.497]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[733.534,739.764],[733.534,824.67],[832.096,737.53],[832.096,821.489]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[733.534,457.484],[733.534,372.578],[832.096,458.395],[832.096,374.436]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[733.534,548.864],[733.534,463.958],[832.096,548.757],[832.096,464.797]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[733.534,554.43],[733.534,639.336],[832.096,554.261],[832.096,638.22]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[733.534,645.84],[733.534,730.745],[832.096,644.652],[832.096,728.611]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[829.679,458.345],[829.679,374.333],[926.992,459.245],[926.992,376.167]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[829.679,548.762],[829.679,464.75],[926.992,548.657],[926.992,465.579]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[829.679,554.27],[829.679,638.282],[926.992,554.103],[926.992,637.181]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[829.679,644.718],[829.679,728.73],[926.992,643.544],[926.992,726.622]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[829.679,737.654],[829.679,821.666],[926.992,735.447],[926.992,818.524]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.51,458.496],[932.51,374.642],[926.991,459.245],[926.991,376.167]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.51,548.745],[932.51,464.89],[926.991,548.657],[926.991,465.579]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.51,554.242],[932.51,638.097],[926.991,554.103],[926.991,637.181]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.51,644.52],[932.51,728.375],[926.991,643.544],[926.991,726.622]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.51,737.282],[932.51,821.137],[926.991,735.447],[926.991,818.524]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.511,458.496],[932.511,374.642],[1055.86,459.649],[1055.86,376.991]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.511,548.745],[932.511,464.89],[1055.86,548.609],[1055.86,465.951]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.511,554.242],[932.511,638.097],[1055.86,554.028],[1055.86,636.686]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.511,644.52],[932.511,728.375],[1055.86,643.018],[1055.86,725.676]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[932.511,737.282],[932.511,821.137],[1055.86,734.456],[1055.86,817.115]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1049.07,732.61],[1049.07,814.487],[1141.56,730.513],[1141.56,811.502]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1049.07,460.401],[1049.07,378.525],[1141.56,461.257],[1141.56,380.268]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1049.07,548.521],[1049.07,466.644],[1141.56,548.42],[1141.56,467.432]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1049.07,553.888],[1049.07,635.765],[1141.56,553.73],[1141.56,634.718]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1049.07,642.037],[1049.07,723.913],[1141.56,640.922],[1141.56,721.91]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.74,462.525],[1278.74,382.854],[1261.23,463.953],[1261.23,385.763]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.74,548.271],[1278.74,468.6],[1261.23,548.103],[1261.23,469.914]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.74,553.494],[1278.74,633.165],[1261.23,553.229],[1261.23,631.418]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.74,639.268],[1278.74,718.939],[1261.23,637.408],[1261.23,715.597]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.74,727.402],[1278.74,807.073],[1261.23,723.902],[1261.23,802.092]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.29,462.494],[1278.29,382.79],[1365.93,463.305],[1365.93,384.442]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.29,548.275],[1278.29,468.571],[1365.93,548.18],[1365.93,469.318]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.29,553.5],[1278.29,633.204],[1365.93,553.35],[1365.93,632.212]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.29,639.309],[1278.29,719.013],[1365.93,638.253],[1365.93,717.115]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1278.29,727.479],[1278.29,807.183],[1365.93,725.492],[1365.93,804.354]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,462.63],[1375.06,383.068],[1365.93,463.305],[1365.93,384.442]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,548.259],[1375.06,468.697],[1365.93,548.18],[1365.93,469.318]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,553.475],[1375.06,633.037],[1365.93,553.35],[1365.93,632.212]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,639.131],[1375.06,718.693],[1365.93,638.253],[1365.93,717.115]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,727.145],[1375.06,806.707],[1365.93,725.492],[1365.93,804.354]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,462.63],[1375.06,383.068],[1486.19,463.669],[1486.19,385.184]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,548.259],[1375.06,468.697],[1486.19,548.137],[1486.19,469.653]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,553.475],[1375.06,633.037],[1486.19,553.282],[1486.19,631.766]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,639.131],[1375.06,718.693],[1486.19,637.778],[1486.19,716.262]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1375.06,727.145],[1375.06,806.707],[1486.19,724.599],[1486.19,803.083]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1475.87,464.347],[1475.87,386.568],[1558.66,465.113],[1558.66,388.129]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1475.87,548.057],[1475.87,470.278],[1558.66,547.967],[1558.66,470.983]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1475.87,553.156],[1475.87,630.935],[1558.66,553.014],[1558.66,629.998]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1475.87,636.893],[1475.87,714.672],[1558.66,635.895],[1558.66,712.879]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1475.87,722.934],[1475.87,800.713],[1558.66,721.057],[1558.66,798.041]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1560.28,465.128],[1560.28,388.159],[1641.08,465.875],[1641.08,389.682]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1560.28,547.965],[1560.28,470.997],[1641.08,547.877],[1641.08,471.684]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1560.28,553.011],[1560.28,629.98],[1641.08,552.872],[1641.08,629.065]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1560.28,635.876],[1560.28,712.844],[1641.08,634.902],[1641.08,711.095]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1560.28,721.02],[1560.28,797.989],[1641.08,719.188],[1641.08,795.381]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,465.224],[1652.66,388.354],[1641.08,465.875],[1641.08,389.682]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,547.954],[1652.66,471.085],[1641.08,547.877],[1641.08,471.684]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,552.993],[1652.66,629.863],[1641.08,552.872],[1641.08,629.065]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,635.751],[1652.66,712.62],[1641.08,634.902],[1641.08,711.095]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,720.786],[1652.66,797.655],[1641.08,719.188],[1641.08,795.381]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,465.224],[1652.66,388.354],[1756.44,466.193],[1756.44,390.33]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,547.954],[1652.66,471.085],[1756.44,547.84],[1756.44,471.977]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,552.993],[1652.66,629.863],[1756.44,552.813],[1756.44,628.676]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,635.751],[1652.66,712.62],[1756.44,634.487],[1756.44,710.35]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1652.66,720.786],[1652.66,797.655],[1756.44,718.409],[1756.44,794.271]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1744.53,466.806],[1744.53,391.58],[1822.64,467.529],[1822.64,393.053]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1744.53,547.768],[1744.53,472.542],[1822.64,547.683],[1822.64,473.207]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1744.53,552.7],[1744.53,627.926],[1822.64,552.565],[1822.64,627.041]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1744.53,633.688],[1744.53,708.914],[1822.64,632.746],[1822.64,707.222]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:48,
                    verts:[[1744.53,716.905],[1744.53,792.131],[1822.64,715.133],[1822.64,789.609]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[152.816,458.012],[152.816,373.655],[151.566,463.894],[151.566,385.644]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[152.816,548.802],[152.816,464.444],[151.566,548.11],[151.566,469.86]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[152.816,554.332],[152.816,638.689],[151.566,553.24],[151.566,631.49]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[152.816,645.151],[152.816,729.509],[151.566,637.484],[151.566,715.734]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[152.816,738.469],[152.816,822.827],[151.566,724.046],[151.566,802.295]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.767,448.832],[154.767,354.942],[153.231,456.059],[153.231,369.674]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.767,549.881],[154.767,455.991],[153.231,549.031],[153.231,462.646]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.767,556.036],[154.767,649.926],[153.231,554.694],[153.231,641.08]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.767,657.118],[154.767,751.008],[153.231,647.697],[153.231,734.082]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.767,760.981],[154.767,854.871],[153.231,743.258],[153.231,829.644]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.766,448.832],[271.635,450.276],[154.766,354.942],[271.635,357.886]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.766,549.881],[154.766,455.991],[271.635,549.711],[271.635,457.321]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.766,556.036],[154.766,649.926],[271.635,555.768],[271.635,648.158]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.766,657.118],[271.635,655.235],[154.766,751.008],[271.635,747.625]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[154.766,760.981],[271.635,757.439],[154.766,854.871],[271.635,849.829]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.016,449.373],[273.016,356.044],[271.633,450.276],[271.633,357.886]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.016,549.817],[273.016,456.489],[271.633,549.711],[271.633,457.321]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.016,555.935],[273.016,649.264],[271.633,555.768],[271.633,648.158]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.016,656.413],[273.016,749.742],[271.633,655.235],[271.633,747.625]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.016,759.655],[273.016,852.984],[271.633,757.439],[271.633,849.829]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.017,449.373],[273.017,356.044],[419.701,451.204],[419.701,359.778]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.017,549.817],[273.017,456.489],[419.701,549.602],[419.701,458.175]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.017,555.935],[273.017,649.264],[419.701,555.595],[419.701,647.022]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.017,656.413],[273.017,749.742],[419.701,654.025],[419.701,745.452]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[273.017,759.655],[273.017,852.984],[419.701,755.163],[419.701,846.59]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[416.804,752.962],[416.804,843.456],[524.543,749.697],[524.543,838.809]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[416.804,452.102],[416.804,361.608],[524.543,453.433],[524.543,364.322]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[416.804,549.496],[416.804,459.002],[524.543,549.34],[524.543,460.228]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[416.804,555.429],[416.804,645.923],[524.543,555.182],[524.543,644.294]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[416.804,652.855],[416.804,743.349],[524.543,651.12],[524.543,740.232]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[523.143,453.385],[523.143,364.223],[628.623,454.689],[628.623,366.881]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[523.143,549.345],[523.143,460.183],[628.623,549.192],[628.623,461.384]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[523.143,555.191],[523.143,644.353],[628.623,554.949],[628.623,642.757]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[523.143,651.183],[523.143,740.345],[628.623,649.483],[628.623,737.292]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[523.143,749.816],[523.143,838.978],[628.623,746.619],[628.623,834.427]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,453.873],[633.381,365.217],[628.623,454.689],[628.623,366.881]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,549.288],[633.381,460.633],[628.623,549.192],[628.623,461.384]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,555.1],[633.381,643.756],[628.623,554.949],[628.623,642.757]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,650.547],[633.381,739.202],[628.623,649.483],[628.623,737.292]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,748.62],[633.381,837.275],[628.623,746.619],[628.623,834.427]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,453.873],[633.381,365.217],[765.879,455.528],[765.879,368.59]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,549.288],[633.381,460.633],[765.879,549.094],[765.879,462.156]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,555.1],[633.381,643.756],[765.879,554.793],[765.879,641.73]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,650.547],[633.381,739.202],[765.879,648.39],[765.879,735.327]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[633.381,748.62],[633.381,837.275],[765.879,744.562],[765.879,831.5]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[759.764,554.642],[759.764,640.736],[857.353,554.418],[857.353,639.26]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[759.764,742.57],[759.764,828.665],[857.353,739.614],[857.353,824.456]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[759.764,456.34],[759.764,370.246],[857.353,457.546],[857.353,372.704]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[759.764,548.998],[759.764,462.904],[857.353,548.856],[857.353,464.014]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[759.764,647.331],[759.764,733.425],[857.353,645.759],[857.353,730.602]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[855.042,457.487],[855.042,372.585],[950.753,458.67],[950.753,374.996]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[855.042,548.863],[855.042,463.961],[950.753,548.724],[950.753,465.05]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[855.042,554.429],[855.042,639.332],[950.753,554.21],[950.753,637.884]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[855.042,645.835],[855.042,730.738],[950.753,644.293],[950.753,727.967]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[855.042,739.756],[855.042,824.659],[950.753,736.855],[950.753,820.529]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.244,457.93],[958.244,373.487],[950.752,458.67],[950.752,374.996]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.244,548.811],[958.244,464.368],[950.752,548.724],[950.752,465.05]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.244,554.347],[958.244,638.79],[950.752,554.21],[950.752,637.884]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.244,645.258],[958.244,729.701],[950.752,644.293],[950.752,727.967]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.244,738.671],[958.244,823.114],[950.752,736.855],[950.752,820.529]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.245,457.93],[958.245,373.487],[1078.56,459.432],[1078.56,376.55]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.245,548.811],[958.245,464.368],[1078.56,548.635],[1078.56,465.752]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.245,554.347],[958.245,638.79],[1078.56,554.068],[1078.56,636.951]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.245,645.258],[958.245,729.701],[1078.56,643.3],[1078.56,726.183]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[958.245,738.671],[958.245,823.114],[1078.56,734.987],[1078.56,817.869]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1069.84,733.176],[1069.84,815.292],[1159.45,730.461],[1159.45,811.427]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1069.84,460.171],[1069.84,378.055],[1159.45,461.278],[1159.45,380.312]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1069.84,548.548],[1069.84,466.432],[1159.45,548.418],[1159.45,467.452]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1069.84,553.931],[1069.84,636.047],[1159.45,553.726],[1159.45,634.692]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1069.84,642.337],[1069.84,724.453],[1159.45,640.894],[1159.45,721.86]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1291.31,462.908],[1291.31,383.634],[1270.43,464.287],[1270.43,386.445]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1291.31,548.226],[1291.31,468.952],[1270.43,548.064],[1270.43,470.222]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1291.31,553.423],[1291.31,632.697],[1270.43,553.167],[1270.43,631.009]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1291.31,638.77],[1291.31,718.044],[1270.43,636.972],[1270.43,714.813]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1291.31,726.464],[1291.31,805.738],[1270.43,723.082],[1270.43,800.924]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1290.95,462.875],[1290.95,383.568],[1374.55,463.909],[1374.55,385.674]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1290.95,548.23],[1290.95,468.922],[1374.55,548.108],[1374.55,469.874]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1290.95,553.429],[1290.95,632.737],[1374.55,553.237],[1374.55,631.472]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1290.95,638.812],[1290.95,718.12],[1374.55,637.465],[1374.55,715.7]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1290.95,726.544],[1290.95,805.852],[1374.55,724.01],[1374.55,802.245]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,463.262],[1385.19,384.355],[1374.55,463.909],[1374.55,385.674]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,548.185],[1385.19,469.278],[1374.55,548.108],[1374.55,469.874]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,553.358],[1385.19,632.264],[1374.55,553.237],[1374.55,631.472]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,638.309],[1385.19,717.215],[1374.55,637.465],[1374.55,715.7]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,725.597],[1385.19,804.504],[1374.55,724.01],[1374.55,802.245]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,463.262],[1385.19,384.355],[1490.37,464.575],[1490.37,387.032]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,548.185],[1385.19,469.278],[1490.37,548.03],[1490.37,470.487]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,553.357],[1385.19,632.264],[1490.37,553.114],[1490.37,630.656]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,638.309],[1385.19,717.215],[1490.37,636.596],[1490.37,714.139]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1385.19,725.597],[1385.19,804.504],[1490.37,722.376],[1490.37,799.919]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1478.64,465.222],[1478.64,388.351],[1556.56,466.185],[1556.56,390.313]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1478.64,547.954],[1478.64,471.083],[1556.56,547.841],[1556.56,471.97]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1478.64,552.994],[1478.64,629.865],[1556.56,552.815],[1556.56,628.686]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1478.64,635.753],[1478.64,712.624],[1556.56,634.498],[1556.56,710.37]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1478.64,720.79],[1478.64,797.661],[1556.56,718.429],[1556.56,794.3]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1558.08,466.204],[1558.08,390.352],[1633.7,467.138],[1633.7,392.256]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1558.08,547.839],[1558.08,471.987],[1633.7,547.729],[1633.7,472.847]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1558.08,552.811],[1558.08,628.663],[1633.7,552.638],[1633.7,627.52]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1558.08,634.474],[1558.08,710.325],[1633.7,633.256],[1633.7,708.137]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1558.08,718.383],[1558.08,794.234],[1633.7,716.091],[1633.7,790.973]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,466.524],[1646.45,391.005],[1633.7,467.138],[1633.7,392.256]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,547.801],[1646.45,472.282],[1633.7,547.729],[1633.7,472.847]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,552.752],[1646.45,628.271],[1633.7,552.638],[1633.7,627.52]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,634.056],[1646.45,709.574],[1633.7,633.256],[1633.7,708.137]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,717.596],[1646.45,793.115],[1633.7,716.091],[1633.7,790.973]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,466.524],[1646.45,391.005],[1742.87,467.728],[1742.87,393.46]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,547.801],[1646.45,472.282],[1742.87,547.659],[1742.87,473.391]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,552.752],[1646.45,628.271],[1742.87,552.528],[1742.87,626.797]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,634.056],[1646.45,709.574],[1742.87,632.486],[1742.87,706.755]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1646.45,717.596],[1646.45,793.115],[1742.87,714.644],[1742.87,788.912]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1729.98,468.302],[1729.98,394.629],[1802.18,469.194],[1802.18,396.448]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1729.98,547.592],[1729.98,473.919],[1802.18,547.487],[1802.18,474.741]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1729.98,552.422],[1729.98,626.095],[1802.18,552.256],[1802.18,625.003]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1729.98,631.738],[1729.98,705.411],[1802.18,630.575],[1802.18,703.321]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:49,
                    verts:[[1729.98,713.237],[1729.98,786.91],[1802.18,711.049],[1802.18,783.795]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[152.96,455.044],[152.96,367.604],[136.042,461.162],[136.042,380.074]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[152.96,549.151],[152.96,461.711],[136.042,548.431],[136.042,467.344]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[152.96,554.883],[152.96,642.323],[136.042,553.747],[136.042,634.834]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[152.96,649.021],[152.96,736.461],[136.042,641.046],[136.042,722.133]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[152.96,745.749],[152.96,833.189],[136.042,730.746],[136.042,811.834]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,445.488],[179.384,348.126],[158.58,453.011],[158.58,363.462]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,550.274],[179.384,452.912],[158.58,549.389],[158.58,459.839]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,556.656],[179.384,654.018],[158.58,555.26],[158.58,644.81]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,661.476],[179.384,758.838],[158.58,651.67],[158.58,741.22]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,769.181],[179.384,866.542],[158.58,750.732],[158.58,840.282]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,445.488],[179.384,348.126],[299.106,447.378],[299.106,351.978]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,550.274],[179.384,452.912],[299.106,550.052],[299.106,454.652]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,556.656],[179.384,654.018],[299.106,556.306],[299.106,651.706]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,661.477],[179.384,758.839],[299.106,659.013],[299.106,754.413]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[179.384,769.181],[179.384,866.543],[299.106,764.547],[299.106,859.947]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.953,446.445],[302.953,350.076],[299.104,447.378],[299.104,351.978]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.953,550.161],[302.953,453.792],[299.104,550.052],[299.104,454.652]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.953,556.479],[302.953,652.848],[299.104,556.306],[299.104,651.706]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.953,660.23],[302.953,756.599],[299.104,659.013],[299.104,754.413]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.953,766.835],[302.953,863.204],[299.104,764.547],[299.104,859.947]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.955,446.445],[302.955,350.076],[451.719,448.818],[451.719,354.914]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.955,550.161],[302.955,453.792],[451.719,549.882],[451.719,455.978]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.955,556.479],[302.955,652.848],[451.719,556.038],[451.719,649.943]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.955,660.23],[302.955,756.598],[451.719,657.136],[451.719,751.04]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[302.955,766.835],[302.955,863.204],[451.719,761.015],[451.719,854.919]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[446.328,758.766],[446.328,851.718],[554.657,754.575],[554.657,845.752]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[446.328,449.735],[446.328,356.783],[554.657,451.444],[554.657,360.267]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[446.328,549.774],[446.328,456.823],[554.657,549.574],[554.657,458.396]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[446.328,555.868],[446.328,648.82],[554.657,555.551],[554.657,646.728]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[446.328,655.94],[446.328,748.892],[554.657,653.713],[554.657,744.89]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[553.339,451.39],[553.339,360.157],[658.597,453.052],[658.597,363.543]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[553.339,549.58],[553.339,458.347],[658.597,549.385],[658.597,459.876]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[553.339,555.561],[553.339,646.794],[658.597,555.253],[658.597,644.761]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[553.339,653.783],[553.339,745.016],[658.597,651.617],[658.597,741.126]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[553.339,754.708],[553.339,845.941],[658.597,750.634],[658.597,840.142]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,452.231],[665.629,361.87],[658.597,453.052],[658.597,363.543]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,549.481],[665.629,459.12],[658.597,549.385],[658.597,459.876]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,555.405],[665.629,645.766],[658.597,555.253],[658.597,644.761]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,652.688],[665.629,743.048],[658.597,651.617],[658.597,741.126]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,752.647],[665.629,843.007],[658.597,750.634],[658.597,840.142]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,452.231],[665.629,361.87],[796.632,454.321],[796.632,366.13]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,549.481],[665.629,459.12],[796.632,549.235],[796.632,461.045]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,555.405],[665.629,645.766],[796.632,555.017],[796.632,643.208]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,652.688],[665.629,743.048],[796.632,649.963],[796.632,738.154]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[665.629,752.647],[665.629,843.007],[796.632,747.522],[796.632,835.712]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[788.278,745.537],[788.278,832.887],[884.055,741.831],[884.055,827.612]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[788.278,455.13],[788.278,367.78],[884.055,456.641],[884.055,370.86]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[788.278,549.14],[788.278,461.79],[884.055,548.963],[884.055,463.182]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[788.278,554.867],[788.278,642.217],[884.055,554.586],[884.055,640.367]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[788.278,648.908],[788.278,736.258],[884.055,646.938],[884.055,732.719]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[881.872,456.576],[881.872,370.726],[975.177,458.048],[975.177,373.728]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[881.872,548.97],[881.872,463.121],[975.177,548.797],[975.177,464.477]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[881.872,554.599],[881.872,640.448],[975.177,554.325],[975.177,638.645]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[881.872,647.024],[881.872,732.873],[975.177,645.104],[975.177,729.424]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[881.872,741.992],[881.872,827.842],[975.177,738.381],[975.177,822.701]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.635,457.32],[984.635,372.244],[975.176,458.048],[975.176,373.728]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.635,548.883],[984.635,463.807],[975.176,548.797],[975.176,464.477]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.635,554.46],[984.635,639.536],[975.176,554.325],[975.176,638.645]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.635,646.053],[984.635,731.13],[975.176,645.104],[975.176,729.424]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.635,740.167],[984.635,825.243],[975.176,738.381],[975.176,822.701]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.636,457.32],[984.636,372.244],[1100.93,459.175],[1100.93,376.026]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.636,548.883],[984.636,463.807],[1100.93,548.665],[1100.93,465.515]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.636,554.46],[984.636,639.536],[1100.93,554.116],[1100.93,637.266]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.636,646.053],[984.636,731.13],[1100.93,643.635],[1100.93,726.785]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[984.636,740.167],[984.636,825.243],[1100.93,735.617],[1100.93,818.767]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1090.31,733.852],[1090.31,816.254],[1176.38,730.522],[1176.38,811.514]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1090.31,459.895],[1090.31,377.493],[1176.38,461.253],[1176.38,380.261]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1090.31,548.58],[1090.31,466.178],[1176.38,548.421],[1176.38,467.429]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1090.31,553.982],[1090.31,636.384],[1176.38,553.73],[1176.38,634.722]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1090.31,642.697],[1090.31,725.099],[1176.38,640.927],[1176.38,721.919]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1302.03,463.236],[1302.03,384.303],[1277.94,464.561],[1277.94,387.004]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1302.03,548.188],[1302.03,469.254],[1277.94,548.032],[1277.94,470.475]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1302.03,553.362],[1302.03,632.295],[1277.94,553.116],[1277.94,630.674]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1302.03,638.342],[1302.03,717.275],[1277.94,636.615],[1277.94,714.172]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1302.03,725.66],[1302.03,804.593],[1277.94,722.41],[1277.94,799.968]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1301.76,463.203],[1301.76,384.235],[1380.82,464.45],[1380.82,386.778]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1301.76,548.191],[1301.76,469.224],[1380.82,548.045],[1380.82,470.373]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1301.76,553.368],[1301.76,632.336],[1380.82,553.137],[1380.82,630.809]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1301.76,638.385],[1301.76,717.353],[1380.82,636.759],[1380.82,714.431]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1301.76,725.742],[1301.76,804.71],[1380.82,722.682],[1380.82,800.354]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,463.833],[1392.87,385.52],[1380.82,464.45],[1380.82,386.778]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,548.117],[1392.87,469.804],[1380.82,548.045],[1380.82,470.373]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,553.251],[1392.87,631.565],[1380.82,553.137],[1380.82,630.809]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,637.564],[1392.87,715.877],[1380.82,636.759],[1380.82,714.431]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,724.196],[1392.87,802.509],[1380.82,722.682],[1380.82,800.354]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,463.833],[1392.87,385.52],[1491.59,465.408],[1491.59,388.73]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,548.117],[1392.87,469.804],[1491.59,547.932],[1491.59,471.254]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,553.251],[1392.87,631.565],[1491.59,552.959],[1491.59,629.637]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,637.564],[1392.87,715.877],[1491.59,635.511],[1491.59,712.189]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1392.87,724.196],[1392.87,802.509],[1491.59,720.334],[1491.59,797.012]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1478.55,466.021],[1478.55,389.979],[1551.3,467.168],[1551.3,392.318]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1478.55,547.86],[1478.55,471.818],[1551.3,547.725],[1551.3,472.875]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1478.55,552.845],[1478.55,628.887],[1551.3,552.632],[1551.3,627.482]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1478.55,634.712],[1478.55,710.754],[1551.3,633.216],[1551.3,708.066]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1478.55,718.831],[1478.55,794.873],[1551.3,716.017],[1551.3,790.867]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1552.73,467.191],[1552.73,392.364],[1622.94,468.299],[1622.94,394.622]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1552.73,547.723],[1552.73,472.896],[1622.94,547.592],[1622.94,473.916]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1552.73,552.628],[1552.73,627.455],[1622.94,552.422],[1622.94,626.099]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1552.73,633.187],[1552.73,708.013],[1622.94,631.743],[1622.94,705.419]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1552.73,715.962],[1552.73,790.788],[1622.94,713.245],[1622.94,786.921]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,467.724],[1636.74,393.45],[1622.94,468.299],[1622.94,394.622]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,547.66],[1636.74,473.387],[1622.94,547.592],[1622.94,473.916]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,552.529],[1636.74,626.803],[1622.94,552.422],[1622.94,626.099]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,632.492],[1636.74,706.765],[1622.94,631.743],[1622.94,705.419]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,714.655],[1636.74,788.928],[1622.94,713.245],[1622.94,786.921]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,467.724],[1636.74,393.45],[1725.63,469.142],[1725.63,396.341]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,547.66],[1636.74,473.387],[1725.63,547.493],[1725.63,474.693]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,552.529],[1636.74,626.803],[1725.63,552.266],[1725.63,625.067]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,632.492],[1636.74,706.765],[1725.63,630.643],[1725.63,703.444]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1636.74,714.655],[1636.74,788.928],[1725.63,711.178],[1725.63,783.978]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1711.89,469.676],[1711.89,397.429],[1778.15,470.721],[1778.15,399.561]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1711.89,547.431],[1711.89,475.184],[1778.15,547.308],[1778.15,476.147]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1711.89,552.167],[1711.89,624.414],[1778.15,551.973],[1778.15,623.133]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1711.89,629.948],[1711.89,702.194],[1778.15,628.584],[1778.15,699.745]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:50,
                    verts:[[1711.89,709.869],[1711.89,782.115],[1778.15,707.304],[1778.15,778.464]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[158.617,451.811],[158.617,361.014],[124.327,458.147],[124.327,373.93]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[158.617,549.531],[158.617,458.734],[124.327,548.786],[124.327,464.569]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[158.617,555.483],[158.617,646.28],[124.327,554.307],[124.327,638.524]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[158.617,653.235],[158.617,744.032],[124.327,644.975],[124.327,729.192]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[158.617,753.677],[158.617,844.473],[124.327,738.138],[124.327,822.355]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.145,441.919],[212.145,340.851],[170.003,449.707],[170.003,356.725]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.145,550.693],[212.145,449.625],[170.003,549.778],[170.003,456.796]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.145,557.319],[212.145,658.387],[170.003,555.873],[170.003,648.855]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.145,666.129],[212.145,767.197],[170.003,655.978],[170.003,748.959]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.145,777.933],[212.145,879.001],[170.003,758.836],[170.003,851.818]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.144,441.919],[212.144,340.851],[333.685,444.306],[333.685,345.715]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.144,550.693],[212.144,449.625],[333.685,550.413],[333.685,451.823]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.144,557.319],[212.144,658.387],[333.685,556.876],[333.685,655.466]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.144,666.129],[212.144,767.197],[333.685,663.018],[333.685,761.608]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[212.144,777.933],[212.144,879.001],[333.685,772.081],[333.685,870.671]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.218,443.349],[340.218,343.765],[333.684,444.306],[333.684,345.715]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.218,550.525],[340.218,450.941],[333.684,550.413],[333.684,451.823]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.218,557.054],[340.218,656.637],[333.684,556.876],[333.684,655.466]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.218,664.266],[340.218,763.849],[333.684,663.018],[333.684,761.608]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.218,774.428],[340.218,874.011],[333.684,772.081],[333.684,870.671]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.219,443.349],[340.219,343.765],[489.628,446.316],[489.628,349.813]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.219,550.525],[340.219,450.941],[489.628,550.176],[489.628,453.674]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.219,557.054],[340.219,656.637],[489.628,556.503],[489.628,653.006]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.219,664.266],[340.219,763.849],[489.628,660.398],[489.628,756.901]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[340.219,774.428],[340.219,874.011],[489.628,767.152],[489.628,863.654]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[481.578,447.246],[481.578,351.709],[589.444,449.363],[589.444,356.025]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[481.578,550.067],[481.578,454.53],[589.444,549.818],[589.444,456.48]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[481.578,556.33],[481.578,651.867],[589.444,555.937],[589.444,649.276]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[481.578,659.185],[481.578,754.722],[589.444,656.426],[589.444,749.764]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[481.578,764.87],[481.578,860.407],[589.444,759.679],[589.444,853.017]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[588.224,449.303],[588.224,355.902],[692.217,451.345],[692.217,360.064]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[588.224,549.825],[588.224,456.425],[692.217,549.585],[692.217,458.305]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[588.224,555.948],[588.224,649.349],[692.217,555.569],[692.217,646.85]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[588.224,656.504],[588.224,749.904],[692.217,653.842],[692.217,745.123]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[588.224,759.826],[588.224,853.226],[692.217,754.819],[692.217,846.099]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,450.525],[701.604,358.394],[692.217,451.345],[692.217,360.064]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,549.682],[701.604,457.55],[692.217,549.585],[692.217,458.305]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,555.722],[701.604,647.853],[692.217,555.569],[692.217,646.85]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,654.911],[701.604,747.042],[692.217,653.842],[692.217,745.123]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,756.829],[701.604,848.961],[692.217,754.819],[692.217,846.099]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,450.525],[701.604,358.394],[829.786,453.071],[829.786,363.582]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,549.682],[701.604,457.55],[829.786,549.382],[829.786,459.894]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,555.722],[701.604,647.853],[829.786,555.249],[829.786,644.738]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,654.911],[701.604,747.042],[829.786,651.593],[829.786,741.081]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[701.604,756.829],[701.604,848.961],[829.786,750.587],[829.786,840.075]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[819.156,748.623],[819.156,837.281],[912.2,744.145],[912.2,830.906]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[819.156,453.871],[819.156,365.214],[912.2,455.698],[912.2,368.937]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[819.156,549.288],[819.156,460.631],[912.2,549.074],[912.2,462.313]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[819.156,555.1],[819.156,643.758],[912.2,554.761],[912.2,641.522]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[819.156,650.549],[819.156,739.206],[912.2,648.169],[912.2,734.93]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[910.169,455.624],[910.169,368.787],[1000.2,457.392],[1000.2,372.391]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[910.169,549.082],[910.169,462.245],[1000.2,548.874],[1000.2,463.873]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[910.169,554.775],[910.169,641.612],[1000.2,554.447],[1000.2,639.448]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[910.169,648.264],[910.169,735.101],[1000.2,645.96],[1000.2,730.961]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[910.169,744.325],[910.169,831.162],[1000.2,739.99],[1000.2,824.992]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,456.682],[1011.61,370.943],[1000.2,457.392],[1000.2,372.39]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,548.958],[1011.61,463.219],[1000.2,548.874],[1000.2,463.873]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,554.579],[1011.61,640.318],[1000.2,554.447],[1000.2,639.448]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,646.886],[1011.61,732.625],[1000.2,645.96],[1000.2,730.961]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,741.732],[1011.61,827.471],[1000.2,739.99],[1000.2,824.992]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,456.682],[1011.61,370.943],[1122.84,458.891],[1122.84,375.445]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,548.958],[1011.61,463.219],[1122.84,548.698],[1122.84,465.253]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,554.579],[1011.61,640.318],[1122.84,554.169],[1122.84,637.614]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,646.886],[1011.61,732.625],[1122.84,644.006],[1122.84,727.452]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1011.61,741.732],[1011.61,827.471],[1122.84,736.316],[1122.84,819.761]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1110.39,734.607],[1110.39,817.329],[1192.21,730.669],[1192.21,811.724]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1110.39,459.587],[1110.39,376.865],[1192.21,461.193],[1192.21,380.138]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1110.39,548.616],[1110.39,465.894],[1192.21,548.428],[1192.21,467.373]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1110.39,554.039],[1110.39,636.762],[1192.21,553.741],[1192.21,634.796]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1110.39,643.098],[1110.39,725.82],[1192.21,641.005],[1192.21,722.059]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.77,463.52],[1310.77,384.882],[1283.64,464.784],[1283.64,387.459]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.77,548.154],[1310.77,469.516],[1283.64,548.006],[1283.64,470.68]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.77,553.309],[1310.77,631.947],[1283.64,553.075],[1283.64,630.4]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.77,637.971],[1310.77,716.609],[1283.64,636.324],[1283.64,713.649]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.77,724.962],[1310.77,803.6],[1283.64,721.863],[1283.64,799.188]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.59,463.486],[1310.59,384.813],[1384.64,464.94],[1384.64,387.776]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.59,548.158],[1310.59,469.485],[1384.64,547.987],[1384.64,470.823]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.59,553.316],[1310.59,631.989],[1384.64,553.046],[1384.64,630.21]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.59,638.016],[1310.59,716.689],[1384.64,636.121],[1384.64,713.284]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1310.59,725.046],[1310.59,803.72],[1384.64,721.481],[1384.64,798.645]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,464.355],[1398.02,386.584],[1384.64,464.94],[1384.64,387.776]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,548.056],[1398.02,470.285],[1384.64,547.987],[1384.64,470.823]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,553.154],[1398.02,630.926],[1384.64,553.046],[1384.64,630.21]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,636.883],[1398.02,714.654],[1384.64,636.121],[1384.64,713.284]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,722.915],[1398.02,800.687],[1384.64,721.481],[1384.64,798.645]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,464.355],[1398.02,386.584],[1489.76,466.177],[1489.76,390.298]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,548.056],[1398.02,470.285],[1489.76,547.842],[1489.76,471.963]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,553.154],[1398.02,630.926],[1489.76,552.816],[1489.76,628.696]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,636.883],[1398.02,714.654],[1489.76,634.508],[1489.76,710.387]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1398.02,722.915],[1398.02,800.687],[1489.76,718.448],[1489.76,794.327]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1475.53,466.753],[1475.53,391.473],[1542.83,468.074],[1542.83,394.165]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1475.53,547.774],[1475.53,472.493],[1542.83,547.619],[1542.83,473.71]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1475.53,552.709],[1475.53,627.99],[1542.83,552.464],[1542.83,626.373]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1475.53,633.757],[1475.53,709.037],[1542.83,632.035],[1542.83,705.944]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1475.53,717.034],[1475.53,792.315],[1542.83,713.795],[1542.83,787.704]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1544.14,468.1],[1544.14,394.218],[1608.77,469.368],[1608.77,396.803]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1544.14,547.616],[1544.14,473.733],[1608.77,547.467],[1608.77,474.901]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1544.14,552.459],[1544.14,626.342],[1608.77,552.224],[1608.77,624.789]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1544.14,632.001],[1544.14,705.884],[1608.77,630.348],[1608.77,702.913]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1544.14,713.732],[1544.14,787.614],[1608.77,710.622],[1608.77,783.187]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,468.833],[1623.5,395.712],[1608.77,469.368],[1608.77,396.803]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,547.53],[1623.5,474.408],[1608.77,547.467],[1608.77,474.901]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,552.323],[1623.5,625.445],[1608.77,552.224],[1608.77,624.789]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,631.046],[1623.5,704.167],[1608.77,630.348],[1608.77,702.913]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,711.935],[1623.5,785.056],[1608.77,710.622],[1608.77,783.187]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,468.833],[1623.5,395.712],[1704.73,470.446],[1704.73,398.999]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,547.53],[1623.5,474.408],[1704.73,547.34],[1704.73,475.894]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,552.323],[1623.5,625.445],[1704.73,552.024],[1704.73,623.47]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,631.046],[1623.5,704.167],[1704.73,628.943],[1704.73,700.39]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1623.5,711.935],[1623.5,785.056],[1704.73,707.979],[1704.73,779.426]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1690.23,470.94],[1690.23,400.006],[1750.54,472.124],[1750.54,402.42]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1690.23,547.282],[1690.23,476.348],[1750.54,547.143],[1750.54,477.439]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1690.23,551.932],[1690.23,622.866],[1750.54,551.712],[1750.54,621.417]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1690.23,628.299],[1690.23,699.233],[1750.54,626.756],[1750.54,696.46]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:51,
                    verts:[[1690.23,706.768],[1690.23,777.702],[1750.54,703.864],[1750.54,773.568]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[170.843,448.315],[170.843,353.888],[117.311,454.84],[117.311,367.189]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[170.843,549.941],[170.843,455.515],[117.311,549.174],[117.311,461.523]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[170.843,556.132],[170.843,650.559],[117.311,554.921],[117.311,642.572]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[170.843,657.792],[170.843,752.219],[117.311,649.286],[117.311,736.937]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[170.843,762.249],[170.843,856.676],[117.311,746.248],[117.311,833.899]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.245,438.149],[254.245,333.166],[188.601,446.15],[188.601,349.476]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.245,551.136],[254.245,446.153],[188.601,550.196],[188.601,453.522]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.245,558.019],[254.245,663.002],[188.601,556.534],[188.601,653.208]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.245,671.044],[254.245,776.027],[188.601,660.613],[188.601,757.288]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.245,787.179],[254.245,892.162],[188.601,767.557],[188.601,864.231]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.244,438.149],[254.244,333.166],[376.263,441.086],[376.263,339.153]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.244,551.136],[254.244,446.153],[376.263,550.791],[376.263,448.858]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.244,558.019],[254.244,663.002],[376.263,557.474],[376.263,659.407]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.244,671.044],[254.244,776.027],[376.263,667.215],[376.263,769.148]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[254.244,787.179],[254.244,892.162],[376.263,779.976],[376.263,881.909]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.693,440.113],[385.693,337.169],[376.261,441.086],[376.261,339.153]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.693,550.906],[385.693,447.962],[376.261,550.791],[376.261,448.858]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.693,557.654],[385.693,660.598],[376.261,557.474],[376.261,659.407]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.693,668.484],[385.693,771.427],[376.261,667.215],[376.261,769.148]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.693,782.362],[385.693,885.306],[376.261,779.976],[376.261,881.909]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.694,440.113],[385.694,337.169],[533.978,443.726],[533.978,344.534]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.694,550.906],[385.694,447.962],[533.978,550.481],[533.978,451.289]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.694,557.654],[385.694,660.598],[533.978,556.984],[533.978,656.175]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.694,668.484],[385.694,771.427],[533.978,663.774],[533.978,762.966]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[385.694,782.362],[385.694,885.306],[533.978,773.502],[533.978,872.694]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[523.117,444.661],[523.117,346.441],[629.262,447.215],[629.262,351.647]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[523.117,550.371],[523.117,452.15],[629.262,550.071],[629.262,454.502]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[523.117,556.81],[523.117,655.031],[629.262,556.336],[629.262,651.905]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[523.117,662.555],[523.117,760.775],[629.262,659.225],[629.262,754.794]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[523.117,771.209],[523.117,869.429],[629.262,764.946],[629.262,860.514]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[628.163,447.149],[628.163,351.512],[729.686,449.593],[729.686,356.494]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[628.163,550.078],[628.163,454.441],[729.686,549.791],[729.686,456.692]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[628.163,556.348],[628.163,651.985],[729.686,555.895],[729.686,648.994]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[628.163,659.311],[628.163,754.948],[729.686,656.126],[729.686,749.225]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[628.163,765.107],[628.163,860.744],[729.686,759.114],[729.686,852.214]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,448.782],[741.489,354.841],[729.686,449.593],[729.686,356.494]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,549.887],[741.489,455.945],[729.686,549.791],[729.686,456.692]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,556.045],[741.489,649.987],[729.686,555.895],[729.686,648.994]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,657.183],[741.489,751.124],[729.686,656.126],[729.686,749.225]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,761.103],[741.489,855.045],[729.686,759.114],[729.686,852.214]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,448.782],[741.489,354.841],[865.368,451.801],[865.368,360.993]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,549.887],[741.489,455.945],[865.368,549.532],[865.368,458.724]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,556.045],[741.489,649.987],[865.368,555.485],[865.368,646.292]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,657.183],[741.489,751.124],[865.368,653.248],[865.368,744.055]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[741.489,761.103],[741.489,855.045],[865.368,753.701],[865.368,844.509]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[852.444,452.585],[852.444,362.593],[941.753,454.734],[941.753,366.973]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[852.444,549.439],[852.444,459.447],[941.753,549.187],[941.753,461.426]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[852.444,555.339],[852.444,645.332],[941.753,554.94],[941.753,642.702]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[852.444,652.225],[852.444,742.218],[941.753,649.424],[941.753,737.186]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[852.444,751.777],[852.444,841.77],[941.753,746.508],[941.753,834.269]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[939.898,454.653],[939.898,366.808],[1025.74,456.72],[1025.74,371.02]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[939.898,549.196],[939.898,461.351],[1025.74,548.953],[1025.74,463.254]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[939.898,554.955],[939.898,642.8],[1025.74,554.572],[1025.74,640.271]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[939.898,649.53],[939.898,737.375],[1025.74,646.836],[1025.74,732.536]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[939.898,746.706],[939.898,834.551],[1025.74,741.639],[1025.74,827.339]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,456.033],[1039.06,369.62],[1025.74,456.72],[1025.74,371.02]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,549.034],[1039.06,462.622],[1025.74,548.953],[1025.74,463.254]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,554.699],[1039.06,641.112],[1025.74,554.572],[1025.74,640.271]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,647.731],[1039.06,734.144],[1025.74,646.836],[1025.74,732.536]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,743.323],[1039.06,829.736],[1025.74,741.639],[1025.74,827.339]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,456.033],[1039.06,369.62],[1144.16,458.594],[1144.16,374.84]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,549.034],[1039.06,462.622],[1144.16,548.733],[1144.16,464.98]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,554.699],[1039.06,641.112],[1144.16,554.224],[1144.16,637.977]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,647.731],[1039.06,734.144],[1144.16,644.393],[1144.16,728.147]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1039.06,743.323],[1039.06,829.736],[1144.16,737.043],[1144.16,820.797]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1129.92,459.262],[1129.92,376.202],[1206.81,461.112],[1206.81,379.972]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1129.92,548.655],[1129.92,465.595],[1206.81,548.437],[1206.81,467.298]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1129.92,554.1],[1129.92,637.16],[1206.81,553.757],[1206.81,634.896]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1129.92,643.523],[1129.92,726.583],[1206.81,641.111],[1206.81,722.25]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1129.92,735.406],[1129.92,818.466],[1206.81,730.869],[1206.81,812.008]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.38,463.773],[1317.38,385.397],[1287.4,464.968],[1287.4,387.834]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.38,548.125],[1317.38,469.748],[1287.4,547.984],[1287.4,470.849]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.38,553.263],[1317.38,631.639],[1287.4,553.041],[1287.4,630.175]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.38,637.642],[1317.38,716.018],[1287.4,636.084],[1287.4,713.218]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.38,724.344],[1317.38,802.72],[1287.4,721.412],[1287.4,798.547]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.3,463.738],[1317.3,385.326],[1385.87,465.389],[1385.87,388.69]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.3,548.129],[1317.3,469.717],[1385.87,547.935],[1385.87,471.237]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.3,553.269],[1317.3,631.681],[1385.87,552.963],[1385.87,629.661]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.3,637.688],[1317.3,716.1],[1385.87,635.536],[1385.87,712.234]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1317.3,724.429],[1317.3,802.841],[1385.87,720.381],[1385.87,797.079]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,464.839],[1400.46,387.57],[1385.87,465.389],[1385.87,388.69]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,547.999],[1400.46,470.73],[1385.87,547.935],[1385.87,471.237]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,553.065],[1400.46,630.333],[1385.87,552.963],[1385.87,629.661]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,636.252],[1400.46,713.521],[1385.87,635.536],[1385.87,712.234]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,721.729],[1400.46,798.997],[1385.87,720.381],[1385.87,797.079]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,464.839],[1400.46,387.57],[1484.77,466.893],[1484.77,391.758]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,547.999],[1400.46,470.73],[1484.77,547.758],[1484.77,472.622]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,553.065],[1400.46,630.333],[1484.77,552.683],[1484.77,627.819]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,636.252],[1400.46,713.521],[1484.77,633.575],[1484.77,708.71]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1400.46,721.729],[1400.46,798.997],[1484.77,716.691],[1484.77,791.827]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1469.46,467.431],[1469.46,392.854],[1531.05,468.913],[1531.05,395.875]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1469.46,547.694],[1469.46,473.117],[1531.05,547.52],[1531.05,474.482]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1469.46,552.583],[1469.46,627.161],[1531.05,552.308],[1531.05,625.347]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1469.46,632.873],[1469.46,707.45],[1531.05,630.941],[1531.05,703.98]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1469.46,715.372],[1469.46,789.949],[1531.05,711.738],[1531.05,784.776]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1532.25,468.942],[1532.25,395.934],[1591.1,470.358],[1591.1,398.82]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1532.25,547.517],[1532.25,474.509],[1591.1,547.35],[1591.1,475.813]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1532.25,552.303],[1532.25,625.311],[1591.1,552.04],[1591.1,623.578]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1532.25,630.904],[1532.25,703.912],[1591.1,629.058],[1591.1,700.596]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1532.25,711.667],[1532.25,784.675],[1591.1,708.195],[1591.1,779.733]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,469.863],[1606.66,397.811],[1591.1,470.358],[1591.1,398.82]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,547.409],[1606.66,475.357],[1591.1,547.35],[1591.1,475.813]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,552.132],[1606.66,624.184],[1591.1,552.04],[1591.1,623.578]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,629.703],[1606.66,701.755],[1591.1,629.058],[1591.1,700.596]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,709.408],[1606.66,781.46],[1591.1,708.195],[1591.1,779.733]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,469.863],[1606.66,397.811],[1680.1,471.653],[1680.1,401.459]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,547.409],[1606.66,475.357],[1680.1,547.198],[1680.1,477.005]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,552.132],[1606.66,624.184],[1680.1,551.8],[1680.1,621.993]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,629.703],[1606.66,701.755],[1680.1,627.37],[1680.1,697.564]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1606.66,709.408],[1606.66,781.46],[1680.1,705.02],[1680.1,775.214]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1664.96,472.107],[1664.96,402.384],[1719.31,473.415],[1719.31,405.051]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1664.96,547.145],[1664.96,477.423],[1719.31,546.991],[1719.31,478.627]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1664.96,551.716],[1664.96,621.438],[1719.31,551.473],[1719.31,619.837]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1664.96,626.779],[1664.96,696.501],[1719.31,625.073],[1719.31,693.437]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:52,
                    verts:[[1664.96,703.907],[1664.96,773.629],[1719.31,700.699],[1719.31,769.063]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[190.87,444.569],[190.87,346.252],[116.094,451.236],[116.094,359.843]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[190.87,550.382],[190.87,452.065],[116.094,549.598],[116.094,458.205]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[190.87,556.827],[190.87,655.144],[116.094,555.59],[116.094,646.983]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[190.87,662.675],[190.87,760.992],[116.094,653.984],[116.094,745.377]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[190.87,771.435],[190.87,869.752],[116.094,755.086],[116.094,846.479]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.939,434.22],[306.939,325.157],[215.627,442.362],[215.627,341.753]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.939,551.598],[306.939,442.535],[215.627,550.641],[215.627,450.033]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.939,558.748],[306.939,667.811],[215.627,557.237],[215.627,657.846]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.939,676.165],[306.939,785.228],[215.627,665.552],[215.627,766.161]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.939,796.813],[306.939,905.876],[215.627,776.848],[215.627,877.457]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.938,434.22],[306.938,325.157],[427.731,437.761],[427.731,332.376]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.938,551.598],[306.938,442.535],[427.731,551.182],[427.731,445.796]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.938,558.748],[306.938,667.811],[427.731,558.091],[427.731,663.476]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.938,676.165],[306.938,785.228],[427.731,671.549],[427.731,776.935]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[306.938,796.813],[306.938,905.876],[427.731,788.129],[427.731,893.515]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.253,436.783],[440.253,330.381],[427.73,437.761],[427.73,332.375]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.253,551.297],[440.253,444.895],[427.73,551.182],[427.73,445.796]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.253,558.272],[440.253,664.674],[427.73,558.091],[427.73,663.476]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.253,672.825],[440.253,779.227],[427.73,671.549],[427.73,776.935]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.253,790.529],[440.253,896.931],[427.73,788.129],[427.73,893.515]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.254,436.783],[440.254,330.381],[585.265,441.091],[585.265,339.162]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.254,551.297],[440.254,444.895],[585.265,550.791],[585.265,448.862]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.254,558.272],[440.254,664.674],[585.265,557.473],[585.265,659.401]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.254,672.825],[440.254,779.227],[585.265,667.209],[585.265,769.138]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[440.254,790.529],[440.254,896.931],[585.265,779.965],[585.265,881.893]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[571.47,442.02],[571.47,341.057],[674.419,445.037],[674.419,347.207]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[571.47,550.681],[571.47,449.718],[674.419,550.327],[674.419,452.496]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[571.47,557.3],[571.47,658.263],[674.419,556.74],[674.419,654.57]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[571.47,665.997],[571.47,766.96],[674.419,662.065],[674.419,759.895]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[571.47,777.685],[571.47,878.647],[674.419,770.287],[674.419,868.117]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[673.462,444.966],[673.462,347.061],[771.14,447.829],[771.14,352.898]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[673.462,550.335],[673.462,452.43],[771.14,549.998],[771.14,455.067]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[673.462,556.754],[673.462,654.658],[771.14,556.222],[771.14,651.153]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[673.462,662.158],[673.462,760.063],[771.14,658.425],[771.14,753.356]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[673.462,770.463],[673.462,868.367],[771.14,763.44],[771.14,858.371]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,447.036],[785.39,351.281],[771.14,447.829],[771.14,352.898]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,550.092],[785.39,454.337],[771.14,549.998],[771.14,455.067]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,556.369],[785.39,652.124],[771.14,556.222],[771.14,651.153]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,659.459],[785.39,755.214],[771.14,658.425],[771.14,753.356]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,765.386],[785.39,861.141],[771.14,763.44],[771.14,858.371]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,447.036],[785.39,351.281],[903.328,450.54],[903.328,358.423]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,550.092],[785.39,454.337],[903.328,549.68],[903.328,457.563]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,556.369],[785.39,652.124],[903.328,555.719],[903.328,647.836]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,659.459],[785.39,755.214],[903.328,654.892],[903.328,747.009]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[785.39,765.386],[785.39,861.141],[903.328,756.794],[903.328,848.91]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[888.125,451.3],[888.125,359.972],[972.611,453.776],[972.611,365.019]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[888.125,549.591],[888.125,458.263],[972.611,549.3],[972.611,460.543]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[888.125,555.578],[888.125,646.905],[972.611,555.118],[972.611,643.875]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[888.125,653.901],[888.125,745.228],[972.611,650.674],[972.611,739.43]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[888.125,754.93],[888.125,846.257],[972.611,748.858],[972.611,837.615]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[970.96,453.688],[970.96,364.84],[1051.63,456.053],[1051.63,369.66]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[970.96,549.31],[970.96,460.462],[1051.63,549.032],[1051.63,462.64]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[970.96,555.135],[970.96,643.983],[1051.63,554.696],[1051.63,641.088]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[970.96,650.788],[970.96,739.636],[1051.63,647.706],[1051.63,734.098]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[970.96,749.074],[970.96,837.922],[1051.63,743.275],[1051.63,829.667]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,455.396],[1066.8,368.322],[1051.63,456.053],[1051.63,369.66]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,549.109],[1066.8,462.035],[1051.63,549.032],[1051.63,462.64]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,554.817],[1066.8,641.891],[1051.63,554.696],[1051.63,641.088]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,648.561],[1066.8,735.635],[1051.63,647.706],[1051.63,734.098]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,744.885],[1066.8,831.959],[1051.63,743.275],[1051.63,829.667]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,455.396],[1066.8,368.322],[1164.66,458.303],[1164.66,374.248]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,549.109],[1066.8,462.035],[1164.66,548.767],[1164.66,464.712]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,554.817],[1066.8,641.891],[1164.66,554.278],[1164.66,638.333]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,648.561],[1066.8,735.635],[1164.66,644.772],[1164.66,728.827]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1066.8,744.885],[1066.8,831.959],[1164.66,737.755],[1164.66,821.811]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1148.73,458.937],[1148.73,375.539],[1219.97,461.024],[1219.97,379.795]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1148.73,548.693],[1148.73,465.296],[1219.97,548.448],[1219.97,467.218]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1148.73,554.16],[1148.73,637.558],[1219.97,553.773],[1219.97,635.003]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1148.73,643.946],[1148.73,727.343],[1219.97,641.225],[1219.97,722.455]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1148.73,736.202],[1148.73,819.6],[1219.97,731.083],[1219.97,812.313]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.68,464.006],[1321.68,385.871],[1289.06,465.125],[1289.06,388.153]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.68,548.097],[1321.68,469.963],[1289.06,547.966],[1289.06,470.994]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.68,553.219],[1321.68,631.354],[1289.06,553.012],[1289.06,629.983]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.68,637.339],[1321.68,715.473],[1289.06,635.88],[1289.06,712.851]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.68,723.773],[1321.68,801.907],[1289.06,721.028],[1289.06,797.999]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.7,463.971],[1321.7,385.8],[1384.35,465.807],[1384.35,389.544]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.7,548.101],[1321.7,469.931],[1384.35,547.885],[1384.35,471.622]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.7,553.226],[1321.7,631.396],[1384.35,552.885],[1384.35,629.148]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.7,637.384],[1321.7,715.555],[1384.35,634.99],[1384.35,711.253]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1321.7,723.858],[1321.7,802.029],[1384.35,719.354],[1384.35,795.617]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,465.296],[1400.05,388.502],[1384.35,465.807],[1384.35,389.544]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,547.945],[1400.05,471.151],[1384.35,547.885],[1384.35,471.622]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,552.98],[1400.05,629.774],[1384.35,552.885],[1384.35,629.148]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,635.656],[1400.05,712.45],[1384.35,634.99],[1384.35,711.253]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,720.608],[1400.05,797.401],[1384.35,719.354],[1384.35,795.617]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,465.296],[1400.05,388.502],[1476.48,467.567],[1476.48,393.131]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,547.945],[1400.05,471.151],[1476.48,547.678],[1476.48,473.242]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,552.98],[1400.05,629.774],[1476.48,552.558],[1476.48,626.995]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,635.656],[1400.05,712.45],[1476.48,632.696],[1476.48,707.133]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1400.05,720.608],[1400.05,797.401],[1476.48,715.039],[1476.48,789.476]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1460.19,468.064],[1460.19,394.144],[1515.84,469.695],[1515.84,397.468]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1460.19,547.62],[1460.19,473.7],[1515.84,547.428],[1515.84,475.202]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1460.19,552.466],[1460.19,626.386],[1515.84,552.163],[1515.84,624.39]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1460.19,632.048],[1460.19,705.968],[1515.84,629.923],[1515.84,702.149]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1460.19,713.82],[1460.19,787.74],[1515.84,709.821],[1515.84,782.048]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1516.92,469.726],[1516.92,397.533],[1569.85,471.277],[1569.85,400.694]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1516.92,547.425],[1516.92,475.231],[1569.85,547.242],[1569.85,476.659]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1516.92,552.157],[1516.92,624.351],[1569.85,551.87],[1569.85,622.453]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1516.92,629.881],[1516.92,702.075],[1569.85,627.86],[1569.85,698.443]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1516.92,709.744],[1516.92,781.938],[1569.85,705.941],[1569.85,776.524]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,470.824],[1586.12,399.77],[1569.85,471.277],[1569.85,400.694]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,547.296],[1586.12,476.242],[1569.85,547.242],[1569.85,476.659]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,551.954],[1586.12,623.008],[1569.85,551.87],[1569.85,622.453]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,628.451],[1586.12,699.504],[1569.85,627.86],[1569.85,698.443]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,707.052],[1586.12,778.106],[1569.85,705.941],[1569.85,776.524]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,470.824],[1586.12,399.77],[1651.7,472.772],[1651.7,403.742]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,547.296],[1586.12,476.242],[1651.7,547.067],[1651.7,478.036]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,551.954],[1586.12,623.008],[1651.7,551.592],[1651.7,620.623]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,628.451],[1586.12,699.504],[1651.7,625.911],[1651.7,694.942]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1586.12,707.052],[1586.12,778.106],[1651.7,702.274],[1651.7,771.305]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1636.02,473.186],[1636.02,404.584],[1684.41,474.605],[1684.41,407.476]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1636.02,547.018],[1636.02,478.416],[1684.41,546.851],[1684.41,479.723]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1636.02,551.515],[1636.02,620.117],[1684.41,551.252],[1684.41,618.38]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1636.02,625.372],[1636.02,693.974],[1684.41,623.522],[1684.41,690.651]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:53,
                    verts:[[1636.02,701.261],[1636.02,769.862],[1684.41,697.781],[1684.41,764.91]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[220.095,440.602],[220.095,338.166],[122.021,447.342],[122.021,351.905]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[220.095,550.848],[220.095,448.412],[122.021,550.056],[122.021,454.619]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[220.095,557.564],[220.095,660],[122.021,556.312],[122.021,651.75]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[220.095,667.846],[220.095,770.282],[122.021,659.06],[122.021,754.497]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[220.095,781.163],[220.095,883.599],[122.021,764.635],[122.021,860.072]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.459,430.199],[371.459,316.961],[252.468,438.377],[252.468,333.631]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.459,552.071],[371.459,438.833],[252.468,551.11],[252.468,446.363]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.459,559.494],[371.459,672.732],[252.468,557.977],[252.468,662.723]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.459,681.407],[371.459,794.644],[252.468,670.746],[252.468,775.493]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.459,806.673],[371.459,919.911],[252.468,786.619],[252.468,891.366]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.458,430.199],[371.458,316.961],[488.912,434.393],[488.912,325.51]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.458,552.071],[371.458,438.833],[488.912,551.578],[488.912,442.695]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.458,559.494],[371.458,672.732],[488.912,558.716],[488.912,667.599]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.458,681.407],[371.458,794.644],[488.912,675.94],[488.912,784.823]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[371.458,806.673],[371.458,919.911],[488.912,796.388],[488.912,905.272]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.68,433.423],[504.68,323.532],[488.91,434.393],[488.91,325.51]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.68,551.692],[504.68,441.801],[488.91,551.578],[488.91,442.695]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.68,558.896],[504.68,668.787],[488.91,558.716],[488.91,667.599]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.68,677.205],[504.68,787.095],[488.91,675.94],[488.91,784.823]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.68,798.768],[504.68,908.659],[488.91,796.389],[488.91,905.272]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.682,433.423],[504.682,323.532],[643.871,438.466],[643.871,333.812]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.682,551.692],[504.682,441.801],[643.871,551.099],[643.871,446.445]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.682,558.896],[504.682,668.787],[643.871,557.96],[643.871,662.614]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.682,677.204],[504.682,787.095],[643.871,670.631],[643.871,775.284]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[504.682,798.768],[504.682,908.659],[643.871,786.401],[643.871,891.055]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[627.061,557.791],[627.061,661.499],[725.116,557.141],[725.116,657.215]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[627.061,439.377],[627.061,335.669],[725.116,442.877],[725.116,342.803]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[627.061,550.992],[627.061,447.284],[725.116,550.581],[725.116,450.507]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[627.061,669.443],[627.061,773.15],[725.116,664.881],[725.116,764.955]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[627.061,784.167],[627.061,887.874],[725.116,775.585],[725.116,875.659]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[724.328,442.799],[724.328,342.645],[816.618,446.094],[816.618,349.362]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[724.328,550.59],[724.328,450.435],[816.618,550.202],[816.618,453.47]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[724.328,557.156],[724.328,657.31],[816.618,556.544],[816.618,653.276]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[724.328,664.982],[724.328,765.136],[816.618,660.686],[816.618,757.419]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[724.328,775.775],[724.328,875.93],[816.618,767.694],[816.618,864.427]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,445.329],[833.305,347.803],[816.618,446.094],[816.618,349.362]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,550.292],[833.305,452.765],[816.618,550.202],[816.618,453.47]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,556.686],[833.305,654.213],[816.618,556.544],[816.618,653.276]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,661.684],[833.305,759.21],[816.618,660.686],[816.618,757.419]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,769.57],[833.305,867.097],[816.618,767.694],[816.618,864.427]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,445.329],[833.305,347.803],[943.528,449.323],[943.528,355.943]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,550.292],[833.305,452.765],[943.528,549.823],[943.528,456.443]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,556.686],[833.305,654.213],[943.528,555.945],[943.528,649.325]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,661.684],[833.305,759.21],[943.528,656.478],[943.528,749.858]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[833.305,769.57],[833.305,867.097],[943.528,759.777],[943.528,853.157]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[926.094,555.81],[926.094,648.436],[1004.61,555.29],[1004.61,645.006]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[926.094,450.049],[926.094,357.423],[1004.61,452.851],[1004.61,363.135]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[926.094,549.738],[926.094,457.112],[1004.61,549.408],[1004.61,459.692]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[926.094,655.531],[926.094,748.157],[1004.61,651.879],[1004.61,741.595]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[926.094,757.996],[926.094,850.622],[1004.61,751.125],[1004.61,840.841]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1003.19,452.756],[1003.19,362.941],[1077.67,455.416],[1077.67,368.362]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1003.19,549.419],[1003.19,459.604],[1077.67,549.107],[1077.67,462.053]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1003.19,555.307],[1003.19,645.122],[1077.67,554.814],[1077.67,641.867]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1003.19,652.002],[1003.19,741.817],[1077.67,648.536],[1077.67,735.589]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1003.19,751.358],[1003.19,841.173],[1077.67,744.836],[1077.67,831.89]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,454.797],[1094.6,367.1],[1077.67,455.416],[1077.67,368.362]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,549.18],[1094.6,461.483],[1077.67,549.107],[1077.67,462.053]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,554.929],[1094.6,642.625],[1077.67,554.814],[1077.67,641.867]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,649.343],[1094.6,737.039],[1077.67,648.536],[1077.67,735.589]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,746.354],[1094.6,834.051],[1077.67,744.836],[1077.67,831.89]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,454.797],[1094.6,367.101],[1184.11,458.04],[1184.11,373.711]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,549.18],[1094.6,461.483],[1184.11,548.798],[1184.11,464.47]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,554.929],[1094.6,642.625],[1184.11,554.327],[1184.11,638.656]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,649.343],[1094.6,737.039],[1184.11,645.115],[1184.11,729.444]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1094.6,746.354],[1094.6,834.051],[1184.11,738.402],[1184.11,822.731]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1166.59,458.632],[1166.59,374.919],[1231.47,460.948],[1231.47,379.639]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1166.59,548.729],[1166.59,465.015],[1231.47,548.457],[1231.47,467.148]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1166.59,554.217],[1166.59,637.93],[1231.47,553.787],[1231.47,635.096]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1166.59,644.343],[1166.59,728.056],[1231.47,641.324],[1231.47,722.633]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1166.59,736.948],[1166.59,820.662],[1231.47,731.27],[1231.47,812.579]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.49,464.232],[1323.49,386.334],[1288.46,465.267],[1288.46,388.443]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.49,548.07],[1323.49,470.172],[1288.46,547.949],[1288.46,471.125]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.49,553.177],[1323.49,631.076],[1288.46,552.985],[1288.46,629.809]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.49,637.043],[1323.49,714.942],[1288.46,635.694],[1288.46,712.518]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.49,723.216],[1323.49,801.115],[1288.46,720.678],[1288.46,797.502]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.59,464.197],[1323.59,386.262],[1379.9,466.208],[1379.9,390.361]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.59,548.075],[1323.59,470.14],[1379.9,547.838],[1379.9,471.991]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.59,553.184],[1323.59,631.119],[1379.9,552.811],[1379.9,628.658]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.59,637.089],[1323.59,715.024],[1379.9,634.468],[1379.9,710.315]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1323.59,723.302],[1323.59,801.238],[1379.9,718.372],[1379.9,794.219]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,465.738],[1396.59,389.404],[1379.9,466.208],[1379.9,390.361]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,547.893],[1396.59,471.559],[1379.9,547.838],[1379.9,471.991]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,552.898],[1396.59,629.232],[1379.9,552.811],[1379.9,628.658]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,635.08],[1396.59,711.415],[1379.9,634.468],[1379.9,710.315]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,719.523],[1396.59,795.858],[1379.9,718.372],[1379.9,794.219]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,465.738],[1396.59,389.404],[1464.74,468.208],[1464.74,394.437]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,547.893],[1396.59,471.559],[1464.74,547.603],[1464.74,473.833]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,552.898],[1396.59,629.232],[1464.74,552.439],[1464.74,626.21]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,635.08],[1396.59,711.415],[1464.74,631.861],[1464.74,705.632]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1396.59,719.523],[1396.59,795.858],[1464.74,713.468],[1464.74,787.238]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1447.61,468.662],[1447.61,395.363],[1497.11,470.428],[1497.11,398.963]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1447.61,547.55],[1447.61,474.251],[1497.11,547.342],[1497.11,475.877]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1447.61,552.355],[1447.61,625.654],[1497.11,552.027],[1497.11,623.492]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1447.61,631.269],[1447.61,704.568],[1497.11,628.967],[1497.11,700.432]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1447.61,712.354],[1447.61,785.654],[1497.11,708.023],[1497.11,779.488]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1498.06,470.462],[1498.06,399.033],[1544.93,472.135],[1544.93,402.442]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1498.06,547.338],[1498.06,475.909],[1544.93,547.142],[1544.93,477.449]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1498.06,552.021],[1498.06,623.451],[1544.93,551.71],[1544.93,621.403]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1498.06,628.922],[1498.06,700.352],[1544.93,626.742],[1544.93,696.435]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1498.06,707.939],[1498.06,779.369],[1544.93,703.838],[1544.93,773.53]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,471.725],[1561.8,401.606],[1544.93,472.135],[1544.93,402.442]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,547.19],[1561.8,477.071],[1544.93,547.142],[1544.93,477.449]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,551.787],[1561.8,621.905],[1544.93,551.71],[1544.93,621.403]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,627.277],[1561.8,697.395],[1544.93,626.742],[1544.93,696.435]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,704.844],[1561.8,774.963],[1544.93,703.838],[1544.93,773.53]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,471.725],[1561.8,401.606],[1619.47,473.814],[1619.47,405.865]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,547.19],[1561.8,477.071],[1619.47,546.944],[1619.47,478.995]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,551.787],[1561.8,621.905],[1619.47,551.399],[1619.47,619.348]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,627.277],[1561.8,697.395],[1619.47,624.553],[1619.47,692.502]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1561.8,704.844],[1561.8,774.963],[1619.47,699.72],[1619.47,767.67]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1603.34,474.186],[1603.34,406.624],[1645.81,475.703],[1645.81,409.715]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1603.34,546.9],[1603.34,479.338],[1645.81,546.722],[1645.81,480.734]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1603.34,551.33],[1603.34,618.892],[1645.81,551.048],[1645.81,617.036]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1603.34,624.068],[1603.34,691.631],[1645.81,622.091],[1645.81,688.079]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:54,
                    verts:[[1603.34,698.807],[1603.34,766.37],[1645.81,695.089],[1645.81,761.077]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[260.004,436.464],[260.004,329.732],[136.652,443.181],[136.652,343.422]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[260.004,551.334],[260.004,444.602],[136.652,550.545],[136.652,450.787]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[260.004,558.332],[260.004,665.064],[136.652,557.085],[136.652,656.843]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[260.004,673.24],[260.004,779.972],[136.652,664.485],[136.652,764.243]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[260.004,791.31],[260.004,898.042],[136.652,774.84],[136.652,874.598]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,426.182],[448.843,308.773],[300.548,434.256],[300.548,325.232]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,552.543],[448.843,435.134],[300.548,551.594],[300.548,442.569]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,560.24],[448.843,677.649],[300.548,558.741],[300.548,667.766]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,686.643],[448.843,804.052],[300.548,676.117],[300.548,785.142]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,816.524],[448.843,933.933],[300.548,796.723],[300.548,905.748]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,426.182],[448.843,308.773],[560.42,431.065],[560.42,318.727]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,552.543],[448.843,435.134],[560.42,551.969],[560.42,439.631]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,560.24],[448.843,677.649],[560.42,559.334],[560.42,671.672]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,686.643],[448.843,804.052],[560.42,680.277],[560.42,792.616]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[448.843,816.524],[448.843,933.933],[560.42,804.549],[560.42,916.887]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.522,430.121],[579.522,316.801],[560.418,431.065],[560.418,318.727]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.522,552.08],[579.522,438.761],[560.418,551.969],[560.418,439.631]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.522,559.509],[579.522,672.828],[560.418,559.334],[560.418,671.672]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.522,681.509],[579.522,794.828],[560.418,680.277],[560.418,792.616]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.522,806.865],[579.522,920.184],[560.418,804.549],[560.418,916.888]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.524,430.121],[579.524,316.801],[709.958,435.924],[709.958,328.631]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.524,552.08],[579.524,438.761],[709.958,551.398],[709.958,444.105]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.524,559.509],[579.524,672.828],[709.958,558.432],[709.958,665.725]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.524,681.509],[579.524,794.828],[709.958,673.944],[709.958,781.237]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[579.524,806.865],[579.524,920.184],[709.958,792.634],[709.958,899.927]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[690.121,436.801],[690.121,330.418],[781.381,440.793],[781.381,338.555]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[690.121,551.295],[690.121,444.912],[781.381,550.826],[781.381,448.588]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[690.121,558.269],[690.121,664.652],[781.381,557.528],[781.381,659.766]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[690.121,672.801],[690.121,779.184],[781.381,667.597],[781.381,769.835]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[690.121,790.484],[690.121,896.867],[781.381,780.695],[781.381,882.933]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[780.785,440.71],[780.785,338.386],[866.005,444.44],[866.005,345.989]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[780.785,550.835],[780.785,448.512],[866.005,550.397],[866.005,451.946]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[780.785,557.544],[780.785,659.867],[866.005,556.851],[866.005,655.302]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[780.785,667.705],[780.785,770.029],[866.005,662.844],[866.005,761.294]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[780.785,780.898],[780.785,883.222],[866.005,771.752],[866.005,870.203]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,443.715],[885.064,344.512],[866.005,444.44],[866.005,345.989]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,550.482],[885.064,451.279],[866.005,550.397],[866.005,451.946]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,556.986],[885.064,656.189],[866.005,556.851],[866.005,655.302]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,663.788],[885.064,762.991],[866.005,662.844],[866.005,761.294]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,773.529],[885.064,872.733],[866.005,771.752],[866.005,870.203]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,443.715],[885.064,344.512],[985.694,448.192],[985.694,353.638]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,550.482],[885.064,451.279],[985.694,549.956],[985.694,455.402]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,556.986],[885.064,656.189],[985.694,556.155],[985.694,650.709]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,663.788],[885.064,762.991],[985.694,657.952],[985.694,752.506]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[885.064,773.529],[885.064,872.733],[985.694,762.55],[985.694,857.104]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[966.13,448.874],[966.13,355.027],[1037.48,451.995],[1037.48,361.389]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[966.13,549.876],[966.13,456.029],[1037.48,549.509],[1037.48,458.903]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[966.13,556.028],[966.13,649.875],[1037.48,555.449],[1037.48,646.055]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[966.13,657.063],[966.13,750.91],[1037.48,652.995],[1037.48,743.601]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[966.13,760.879],[966.13,854.725],[1037.48,753.226],[1037.48,843.832]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1036.31,451.893],[1036.31,361.182],[1103.57,454.837],[1103.57,367.183]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1036.31,549.521],[1036.31,458.81],[1103.57,549.175],[1103.57,461.52]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1036.31,555.468],[1036.31,646.179],[1103.57,554.921],[1103.57,642.576]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1036.31,653.127],[1036.31,743.839],[1103.57,649.29],[1103.57,736.944]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1036.31,753.474],[1036.31,844.186],[1103.57,746.255],[1103.57,833.91]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,454.263],[1122.14,366.013],[1103.57,454.837],[1103.57,367.183]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,549.242],[1122.14,460.992],[1103.57,549.175],[1103.57,461.52]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,555.028],[1122.14,643.278],[1103.57,554.921],[1103.57,642.576]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,650.038],[1122.14,738.289],[1103.57,649.29],[1103.57,736.944]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,747.663],[1122.14,835.913],[1103.57,746.255],[1103.57,833.91]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,454.263],[1122.14,366.013],[1202.19,457.825],[1202.19,373.273]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,549.242],[1122.14,460.992],[1202.19,548.824],[1202.19,464.271]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,555.028],[1122.14,643.278],[1202.19,554.367],[1202.19,638.919]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,650.038],[1122.14,738.289],[1202.19,645.396],[1202.19,729.948]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1122.14,747.663],[1122.14,835.913],[1202.19,738.929],[1202.19,823.481]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1183.23,458.37],[1183.23,374.385],[1241.08,460.9],[1241.08,379.542]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1183.23,548.76],[1183.23,464.774],[1241.08,548.462],[1241.08,467.104]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1183.23,554.265],[1183.23,638.251],[1241.08,553.796],[1241.08,635.154]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1183.23,644.685],[1183.23,728.67],[1241.08,641.386],[1241.08,722.745]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1183.23,737.591],[1183.23,821.577],[1241.08,731.387],[1241.08,812.746]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.59,464.466],[1322.59,386.811],[1285.42,465.408],[1285.42,388.731]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.59,548.043],[1322.59,470.387],[1285.42,547.932],[1285.42,471.255]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.59,553.134],[1322.59,630.79],[1285.42,552.959],[1285.42,629.636]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.59,636.738],[1322.59,714.394],[1285.42,635.51],[1285.42,712.187]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.59,722.643],[1322.59,800.298],[1285.42,720.332],[1285.42,797.01]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.79,464.431],[1322.79,386.739],[1372.37,466.601],[1372.37,391.163]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.79,548.047],[1322.79,470.355],[1372.37,547.792],[1372.37,472.353]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.79,553.14],[1322.79,630.832],[1372.37,552.738],[1372.37,628.176]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.79,636.784],[1322.79,714.476],[1372.37,633.955],[1372.37,709.394]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1322.79,722.728],[1322.79,800.42],[1372.37,717.407],[1372.37,792.846]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,466.177],[1389.91,390.297],[1372.37,466.601],[1372.37,391.163]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,547.842],[1389.91,471.962],[1372.37,547.792],[1372.37,472.353]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,552.816],[1389.91,628.696],[1372.37,552.738],[1372.37,628.176]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,634.509],[1389.91,710.388],[1372.37,633.955],[1372.37,709.394]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,718.449],[1389.91,794.328],[1372.37,717.407],[1372.37,792.846]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,466.177],[1389.91,390.297],[1449.44,468.825],[1449.44,395.696]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,547.842],[1389.91,471.962],[1449.44,547.531],[1449.44,474.401]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,552.816],[1389.91,628.696],[1449.44,552.325],[1449.44,625.454]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,634.509],[1389.91,710.388],[1449.44,631.056],[1449.44,704.186]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1389.91,718.449],[1389.91,794.328],[1449.44,711.954],[1449.44,785.083]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1431.59,469.234],[1431.59,396.528],[1474.75,471.121],[1474.75,400.376]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1431.59,547.483],[1431.59,474.777],[1474.75,547.261],[1474.75,476.516]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1431.59,552.249],[1431.59,624.954],[1474.75,551.898],[1474.75,622.644]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1431.59,630.524],[1431.59,703.229],[1474.75,628.063],[1474.75,698.808]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1431.59,710.952],[1431.59,783.658],[1474.75,706.323],[1474.75,777.068]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1475.58,471.158],[1475.58,400.451],[1516.29,472.939],[1516.29,404.08]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1475.58,547.256],[1475.58,476.549],[1516.29,547.047],[1516.29,478.189]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1475.58,551.892],[1475.58,622.599],[1516.29,551.561],[1516.29,620.42]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1475.58,628.015],[1475.58,698.723],[1516.29,625.694],[1516.29,694.553]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1475.58,706.234],[1475.58,776.941],[1516.29,701.867],[1516.29,770.725]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,472.572],[1533.65,403.334],[1516.29,472.939],[1516.29,404.08]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,547.09],[1533.65,477.851],[1516.29,547.047],[1516.29,478.189]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,551.629],[1533.65,620.868],[1516.29,551.561],[1516.29,620.42]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,626.172],[1533.65,695.41],[1516.29,625.694],[1516.29,694.553]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,702.765],[1533.65,772.004],[1516.29,701.867],[1516.29,770.726]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,472.572],[1533.65,403.334],[1583.38,474.785],[1583.38,407.843]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,547.09],[1533.65,477.851],[1583.38,546.83],[1583.38,479.889]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,551.629],[1533.65,620.868],[1583.38,551.219],[1583.38,618.16]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,626.172],[1533.65,695.41],[1583.38,623.288],[1583.38,690.229]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1533.65,702.765],[1533.65,772.004],[1583.38,697.34],[1583.38,764.282]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1566.9,475.115],[1566.9,408.517],[1603.49,476.717],[1603.49,411.781]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1566.9,546.791],[1566.9,480.193],[1603.49,546.603],[1603.49,481.668]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1566.9,551.157],[1566.9,617.755],[1603.49,550.86],[1603.49,615.795]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1566.9,622.857],[1566.9,689.455],[1603.49,620.77],[1603.49,685.705]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:55,
                    verts:[[1566.9,696.529],[1566.9,763.127],[1603.49,692.603],[1603.49,757.538]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[312.069,432.233],[312.069,321.108],[161.729,438.796],[161.729,334.486]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[312.069,551.832],[312.069,440.706],[161.729,551.06],[161.729,446.75]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[312.069,559.117],[312.069,670.242],[161.729,557.899],[161.729,662.209]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[312.069,678.755],[312.069,789.88],[161.729,670.2],[161.729,774.51]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[312.069,801.684],[312.069,912.809],[161.729,785.591],[161.729,889.901]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,422.295],[539.746,300.849],[361.203,430.089],[361.203,316.736]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,553],[539.746,431.554],[361.203,552.084],[361.203,438.731]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,560.962],[539.746,682.407],[361.203,559.515],[361.203,672.867]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,691.71],[539.746,813.156],[361.203,681.55],[361.203,794.903]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,826.056],[539.746,947.502],[361.203,806.944],[361.203,920.296]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,422.295],[539.746,300.849],[642.52,427.885],[642.52,312.244]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,553],[539.746,431.554],[642.52,552.343],[642.52,436.702]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,560.962],[539.746,682.407],[642.52,559.924],[642.52,675.565]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,691.71],[539.746,813.156],[642.52,684.423],[642.52,800.064]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[539.746,826.056],[539.746,947.502],[642.52,812.348],[642.52,927.989]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.943,426.987],[664.943,310.414],[642.518,427.885],[642.518,312.243]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.943,552.448],[664.943,435.875],[642.518,552.343],[642.518,436.702]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.943,560.091],[664.943,676.664],[642.518,559.924],[642.518,675.565]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.943,685.594],[664.943,802.167],[642.518,684.423],[642.518,800.065]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.943,814.55],[664.943,931.123],[642.518,812.349],[642.518,927.99]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.945,426.987],[664.945,310.414],[783.373,433.552],[783.373,323.797]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.945,552.448],[664.945,435.875],[783.373,551.677],[783.373,441.921]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.945,560.091],[664.945,676.664],[783.373,558.872],[783.373,668.628]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.945,685.594],[664.945,802.167],[783.373,677.035],[783.373,786.791]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[664.945,814.55],[664.945,931.123],[783.373,798.45],[783.373,908.206]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[760.586,558.719],[760.586,667.619],[842.996,557.888],[842.996,662.136]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[760.586,434.376],[760.586,325.476],[842.996,438.856],[842.996,334.607]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[760.586,551.58],[760.586,442.68],[842.996,551.053],[842.996,446.805]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[760.586,675.961],[760.586,784.861],[842.996,670.122],[842.996,774.371]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[760.586,796.429],[760.586,905.329],[842.996,785.444],[842.996,889.693]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[842.616,438.768],[842.616,334.429],[918.99,442.923],[918.99,342.897]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[842.616,551.064],[842.616,446.724],[918.99,550.575],[918.99,450.549]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[842.616,557.904],[842.616,662.243],[918.99,557.133],[918.99,657.159]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[842.616,670.236],[842.616,774.576],[918.99,664.821],[918.99,764.847]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[842.616,785.659],[842.616,889.999],[918.99,775.472],[918.99,875.498]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,442.252],[940.292,341.529],[918.99,442.923],[918.99,342.897]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,550.654],[940.292,449.931],[918.99,550.575],[918.99,450.549]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,557.257],[940.292,657.98],[918.99,557.133],[918.99,657.159]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,665.695],[940.292,766.418],[918.99,664.821],[918.99,764.847]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,777.117],[940.292,877.84],[918.99,775.472],[918.99,875.498]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,442.252],[940.292,341.529],[1029.41,447.192],[1029.41,351.6]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,550.654],[940.292,449.931],[1029.41,550.073],[1029.41,454.481]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,557.257],[940.292,657.98],[1029.41,556.34],[1029.41,651.932]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,665.695],[940.292,766.418],[1029.41,659.255],[1029.41,754.847]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[940.292,777.117],[940.292,877.84],[1029.41,765.002],[1029.41,860.594]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1007.87,447.818],[1007.87,352.876],[1070.86,451.242],[1070.86,359.854]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1007.87,550],[1007.87,455.057],[1070.86,549.597],[1070.86,458.21]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1007.87,556.224],[1007.87,651.167],[1070.86,555.589],[1070.86,646.976]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1007.87,658.439],[1007.87,753.382],[1070.86,653.977],[1070.86,745.364]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1007.87,763.467],[1007.87,858.41],[1070.86,755.072],[1070.86,846.459]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1069.97,451.135],[1069.97,359.636],[1129,454.346],[1129,366.181]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1069.97,549.61],[1069.97,458.111],[1129,549.232],[1129,461.068]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1069.97,555.608],[1069.97,647.107],[1129,555.012],[1129,643.177]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1069.97,654.116],[1069.97,745.615],[1129,649.931],[1129,738.095]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1069.97,755.334],[1069.97,846.833],[1129,747.46],[1129,835.625]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,453.825],[1149.05,365.12],[1129,454.346],[1129,366.181]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,549.294],[1149.05,460.588],[1129,549.232],[1129,461.068]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,555.109],[1149.05,643.815],[1129,555.012],[1129,643.177]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,650.609],[1149.05,739.315],[1129,649.931],[1129,738.095]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,748.737],[1149.05,837.443],[1129,747.46],[1129,835.625]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,453.825],[1149.05,365.12],[1218.6,457.68],[1218.6,372.979]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,549.294],[1149.05,460.588],[1218.6,548.841],[1218.6,464.139]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,555.109],[1149.05,643.814],[1218.6,554.393],[1218.6,639.095]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,650.609],[1149.05,739.315],[1218.6,645.584],[1218.6,730.285]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1149.05,748.737],[1149.05,837.443],[1218.6,739.283],[1218.6,823.985]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1198.36,458.172],[1198.36,373.981],[1248.52,460.899],[1248.52,379.539]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1198.36,548.783],[1198.36,464.591],[1248.52,548.462],[1248.52,467.102]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1198.36,554.302],[1198.36,638.494],[1248.52,553.796],[1248.52,635.156]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1198.36,644.943],[1198.36,729.134],[1248.52,641.388],[1248.52,722.748]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1198.36,738.077],[1198.36,822.269],[1248.52,731.391],[1248.52,812.751]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1318.8,464.72],[1318.8,387.327],[1279.77,465.561],[1279.77,389.041]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1318.8,548.013],[1318.8,470.621],[1279.77,547.914],[1279.77,471.395]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1318.8,553.087],[1318.8,630.479],[1279.77,552.931],[1279.77,629.45]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1318.8,636.408],[1318.8,713.8],[1279.77,635.312],[1279.77,711.831]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1318.8,722.021],[1318.8,799.414],[1279.77,719.959],[1279.77,796.478]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1319.09,464.685],[1319.09,387.257],[1361.6,466.997],[1361.6,391.97]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1319.09,548.017],[1319.09,470.589],[1361.6,547.745],[1361.6,472.718]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1319.09,553.093],[1319.09,630.522],[1361.6,552.664],[1361.6,627.691]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1319.09,636.453],[1319.09,713.881],[1361.6,633.439],[1361.6,708.466]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1319.09,722.106],[1319.09,799.534],[1361.6,716.436],[1361.6,791.463]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,466.621],[1379.86,391.202],[1361.6,466.997],[1361.6,391.97]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,547.79],[1379.86,472.371],[1361.6,547.745],[1361.6,472.718]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,552.734],[1379.86,628.153],[1361.6,552.664],[1361.6,627.691]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,633.93],[1379.86,709.349],[1361.6,633.439],[1361.6,708.466]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,717.36],[1379.86,792.779],[1361.6,716.436],[1361.6,791.463]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,466.621],[1379.86,391.202],[1430.47,469.427],[1430.47,396.922]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,547.79],[1379.86,472.371],[1430.47,547.46],[1430.47,474.955]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,552.734],[1379.86,628.153],[1430.47,552.213],[1430.47,624.718]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,633.93],[1379.86,709.349],[1430.47,630.272],[1430.47,702.777]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1379.86,717.36],[1379.86,792.779],[1430.47,710.479],[1430.47,782.984]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1412.04,469.787],[1412.04,397.657],[1448.72,471.781],[1448.72,401.721]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1412.04,547.417],[1412.04,475.287],[1448.72,547.183],[1448.72,477.123]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1412.04,552.146],[1412.04,624.277],[1448.72,551.776],[1448.72,621.836]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1412.04,629.802],[1412.04,701.933],[1448.72,627.203],[1448.72,697.263]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1412.04,709.595],[1412.04,781.725],[1448.72,704.705],[1448.72,774.765]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1449.43,471.82],[1449.43,401.799],[1483.91,473.694],[1483.91,405.62]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1449.43,547.179],[1449.43,477.158],[1483.91,546.958],[1483.91,478.884]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1449.43,551.769],[1449.43,621.789],[1483.91,551.421],[1483.91,619.495]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1449.43,627.153],[1449.43,697.173],[1483.91,624.71],[1483.91,692.784]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1449.43,704.611],[1449.43,774.631],[1483.91,700.015],[1483.91,768.089]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,473.373],[1501.65,404.965],[1483.91,473.694],[1483.91,405.62]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,546.996],[1501.65,478.589],[1483.91,546.958],[1483.91,478.884]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,551.481],[1501.65,619.888],[1483.91,551.421],[1483.91,619.495]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,625.128],[1501.65,693.536],[1483.91,624.71],[1483.91,692.784]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,700.802],[1501.65,769.21],[1483.91,700.015],[1483.91,768.089]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,473.373],[1501.65,404.965],[1543.45,475.69],[1543.45,409.688]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,546.996],[1501.65,478.589],[1543.45,546.724],[1543.45,480.722]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,551.481],[1501.65,619.888],[1543.45,551.051],[1543.45,617.052]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,625.128],[1501.65,693.536],[1543.45,622.108],[1543.45,688.11]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1501.65,700.802],[1501.65,769.21],[1543.45,695.121],[1543.45,761.123]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1526.71,475.978],[1526.71,410.276],[1557.47,477.651],[1557.47,413.686]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1526.71,546.69],[1526.71,480.988],[1557.47,546.493],[1557.47,482.528]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1526.71,550.997],[1526.71,616.699],[1557.47,550.687],[1557.47,614.651]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1526.71,621.732],[1526.71,687.434],[1557.47,619.551],[1557.47,683.516]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:56,
                    verts:[[1526.71,694.413],[1526.71,760.115],[1557.47,690.311],[1557.47,754.276]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[377.566,428.018],[377.566,312.516],[199.072,434.262],[199.072,325.242]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[377.566,552.327],[377.566,436.825],[199.072,551.593],[199.072,442.574]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[377.566,559.899],[377.566,675.401],[199.072,558.74],[199.072,667.76]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[377.566,684.249],[377.566,799.751],[199.072,676.111],[199.072,785.13]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[377.566,812.02],[377.566,927.522],[199.072,796.711],[199.072,905.73]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,418.694],[644.168,293.509],[435.476,425.993],[435.476,308.388]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,553.423],[644.168,428.238],[435.476,552.565],[435.476,434.96]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,561.63],[644.168,686.815],[435.476,560.275],[435.476,677.881]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,696.404],[644.168,821.589],[435.476,686.889],[435.476,804.495]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,834.887],[644.168,960.071],[435.476,816.987],[435.476,934.592]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,418.694],[644.168,293.509],[734.926,424.979],[734.926,306.321]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,553.423],[644.168,428.238],[734.926,552.684],[734.926,434.027]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,561.63],[644.168,686.815],[734.926,560.463],[734.926,679.121]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,696.404],[644.168,821.589],[734.926,688.211],[734.926,806.868]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[644.168,834.887],[644.168,960.071],[734.926,819.473],[734.926,938.131]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.527,424.152],[760.527,304.635],[734.925,424.979],[734.925,306.321]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.527,552.782],[760.527,433.265],[734.925,552.684],[734.925,434.026]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.527,560.617],[760.527,680.134],[734.925,560.463],[734.925,679.121]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.527,689.289],[760.527,808.805],[734.925,688.211],[734.925,806.869]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.527,821.501],[760.527,941.018],[734.925,819.473],[734.925,938.131]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.528,424.152],[760.528,304.636],[863.528,431.451],[863.528,319.512]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.528,552.782],[760.528,433.265],[863.528,551.924],[863.528,439.986]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.528,560.617],[760.528,680.133],[863.528,559.262],[863.528,671.2]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.528,689.289],[760.528,808.805],[863.528,679.775],[863.528,791.713]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[760.528,821.501],[760.528,941.017],[863.528,803.604],[863.528,915.542]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[837.979,432.202],[837.979,321.044],[909.418,437.146],[909.418,331.121]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[837.979,551.835],[837.979,440.677],[909.418,551.254],[909.418,445.23]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[837.979,559.123],[837.979,670.281],[909.418,558.205],[909.418,664.23]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[837.979,678.796],[837.979,789.954],[909.418,672.351],[909.418,778.376]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[837.979,801.761],[837.979,912.919],[909.418,789.638],[909.418,895.663]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[909.276,437.054],[909.276,330.935],[975.016,441.607],[975.016,340.216]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[909.276,551.265],[909.276,445.146],[975.016,550.73],[975.016,449.338]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[909.276,558.222],[909.276,664.341],[975.016,557.377],[975.016,658.768]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[909.276,672.47],[909.276,778.59],[975.016,666.535],[975.016,767.927]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[909.276,789.862],[909.276,895.982],[975.016,778.697],[975.016,880.089]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,441.004],[998.354,338.986],[975.016,441.607],[975.016,340.216]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,550.801],[998.354,448.783],[975.016,550.73],[975.016,449.338]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,557.489],[998.354,659.507],[975.016,557.377],[975.016,658.768]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,667.322],[998.354,769.34],[975.016,666.535],[975.016,767.927]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,780.176],[998.354,882.194],[975.016,778.697],[975.016,880.089]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,441.004],[998.354,338.986],[1074.1,446.372],[1074.1,349.927]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,550.801],[998.354,448.783],[1074.1,550.17],[1074.1,453.725]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,557.489],[998.354,659.507],[1074.1,556.492],[1074.1,652.937]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,667.322],[998.354,769.34],[1074.1,660.325],[1074.1,756.769]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[998.354,780.176],[998.354,882.194],[1074.1,767.014],[1074.1,863.458]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1050.8,446.93],[1050.8,351.065],[1104.28,450.631],[1104.28,358.608]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1050.8,550.104],[1050.8,454.239],[1104.28,549.669],[1104.28,457.647]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1050.8,556.389],[1050.8,652.254],[1104.28,555.702],[1104.28,647.724]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1050.8,659.597],[1050.8,755.462],[1104.28,654.773],[1104.28,746.796]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1050.8,765.645],[1050.8,861.51],[1104.28,756.571],[1104.28,848.593]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1103.69,450.519],[1103.69,358.381],[1153.54,453.972],[1153.54,365.419]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1103.69,549.682],[1103.69,457.544],[1153.54,549.277],[1153.54,460.724]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1103.69,555.723],[1103.69,647.861],[1153.54,555.082],[1153.54,643.635]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1103.69,654.919],[1103.69,747.057],[1153.54,650.418],[1153.54,738.971]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1103.69,756.844],[1103.69,848.982],[1153.54,748.378],[1153.54,836.931]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,453.512],[1174.87,364.481],[1153.54,453.972],[1153.54,365.418]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,549.331],[1174.87,460.3],[1153.54,549.277],[1153.54,460.723]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,555.167],[1174.87,644.198],[1153.54,555.082],[1153.54,643.635]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,651.018],[1174.87,740.048],[1153.54,650.418],[1153.54,738.971]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,749.505],[1174.87,838.536],[1153.54,748.378],[1153.54,836.931]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,453.512],[1174.87,364.481],[1232.96,457.628],[1232.96,372.872]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,549.331],[1174.87,460.3],[1232.96,548.847],[1232.96,464.091]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,555.167],[1174.87,644.198],[1232.96,554.403],[1232.96,639.159]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,651.018],[1174.87,740.048],[1232.96,645.651],[1232.96,730.407]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1174.87,749.505],[1174.87,838.536],[1232.96,739.411],[1232.96,824.167]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1211.63,458.06],[1211.63,373.752],[1253.55,460.96],[1253.55,379.664]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1211.63,548.796],[1211.63,464.488],[1253.55,548.455],[1253.55,467.159]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1211.63,554.323],[1211.63,638.631],[1253.55,553.785],[1253.55,635.081]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1211.63,645.089],[1211.63,729.397],[1253.55,641.308],[1253.55,722.604]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1211.63,738.353],[1211.63,822.661],[1253.55,731.24],[1253.55,812.536]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1311.96,465.004],[1311.96,387.906],[1271.4,465.736],[1271.4,389.398]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1311.96,547.98],[1311.96,470.882],[1271.4,547.894],[1271.4,471.556]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1311.96,553.034],[1311.96,630.132],[1271.4,552.898],[1271.4,629.236]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1311.96,636.038],[1311.96,713.135],[1271.4,635.084],[1271.4,711.421]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1311.96,721.325],[1311.96,798.423],[1271.4,719.53],[1271.4,795.868]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1312.34,464.97],[1312.34,387.837],[1347.5,467.405],[1347.5,392.801]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1312.34,547.984],[1312.34,470.851],[1347.5,547.698],[1347.5,473.093]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1312.34,553.04],[1312.34,630.173],[1347.5,552.588],[1347.5,627.193]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1312.34,636.082],[1312.34,713.214],[1347.5,632.908],[1347.5,707.512]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1312.34,721.408],[1312.34,798.541],[1347.5,715.437],[1347.5,790.041]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,467.079],[1366.33,392.136],[1347.5,467.405],[1347.5,392.801]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,547.736],[1366.33,472.793],[1347.5,547.698],[1347.5,473.093]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,552.649],[1366.33,627.592],[1347.5,552.588],[1347.5,627.193]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,633.333],[1366.33,708.275],[1347.5,632.908],[1347.5,707.512]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,716.236],[1366.33,791.179],[1347.5,715.437],[1347.5,790.041]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,467.079],[1366.33,392.136],[1407.81,470.018],[1407.81,398.127]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,547.736],[1366.33,472.793],[1407.81,547.39],[1407.81,475.499]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,552.649],[1366.33,627.592],[1407.81,552.103],[1407.81,623.994]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,633.333],[1366.33,708.275],[1407.81,629.501],[1407.81,701.392]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1366.33,716.236],[1366.33,791.179],[1407.81,709.029],[1407.81,780.919]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1388.92,470.329],[1388.92,398.76],[1419.03,472.412],[1419.03,403.008]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1388.92,547.354],[1388.92,475.786],[1419.03,547.109],[1419.03,477.704]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1388.92,552.046],[1388.92,623.614],[1419.03,551.659],[1419.03,621.064]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1388.92,629.096],[1388.92,700.665],[1419.03,626.38],[1419.03,695.785]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1388.92,708.267],[1388.92,779.835],[1419.03,703.157],[1419.03,772.562]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1419.61,472.452],[1419.61,403.089],[1447.82,474.405],[1447.82,407.069]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1419.61,547.104],[1419.61,477.741],[1447.82,546.875],[1447.82,479.539]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1419.61,551.651],[1419.61,621.015],[1447.82,551.289],[1447.82,618.625]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1419.61,626.328],[1419.61,695.691],[1447.82,623.783],[1447.82,691.119]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1419.61,703.059],[1419.61,772.422],[1447.82,698.272],[1447.82,765.607]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,474.13],[1465.84,406.508],[1447.82,474.405],[1447.82,407.069]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,546.907],[1465.84,479.286],[1447.82,546.875],[1447.82,479.539]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,551.34],[1465.84,618.961],[1447.82,551.289],[1447.82,618.625]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,624.141],[1465.84,691.763],[1447.82,623.783],[1447.82,691.119]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,698.946],[1465.84,766.567],[1447.82,698.272],[1447.82,765.607]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,474.13],[1465.84,406.509],[1499.75,476.532],[1499.75,411.406]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,546.907],[1465.84,479.286],[1499.75,546.625],[1499.75,481.498]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,551.34],[1465.84,618.961],[1499.75,550.894],[1499.75,616.021]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,624.141],[1465.84,691.763],[1499.75,621.01],[1499.75,686.136]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1465.84,698.946],[1465.84,766.567],[1499.75,693.054],[1499.75,758.181]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1482.85,476.779],[1482.85,411.908],[1507.85,478.51],[1507.85,415.437]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1482.85,546.596],[1482.85,481.725],[1507.85,546.392],[1507.85,483.319]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1482.85,550.848],[1482.85,615.719],[1507.85,550.527],[1507.85,613.6]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1482.85,620.688],[1482.85,685.559],[1507.85,618.432],[1507.85,681.505]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:57,
                    verts:[[1482.85,692.45],[1482.85,757.321],[1507.85,688.204],[1507.85,751.277]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[457.347,423.96],[457.347,304.244],[250.417,429.681],[250.417,315.906]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[457.347,552.804],[457.347,433.088],[250.417,552.132],[250.417,438.356]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[457.347,560.653],[457.347,680.369],[250.417,559.591],[250.417,673.366]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[457.347,689.539],[457.347,809.256],[250.417,682.081],[250.417,795.857]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[457.347,821.972],[457.347,941.689],[250.417,807.942],[250.417,921.718]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.204,415.559],[761.204,287.119],[523.876,422.12],[523.876,300.494]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.204,553.792],[761.204,425.352],[523.876,553.02],[523.876,431.394]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.204,562.212],[761.204,690.652],[523.876,560.994],[523.876,682.62]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.204,700.491],[761.204,828.931],[523.876,691.937],[523.876,813.563]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.204,842.574],[761.204,971.014],[523.876,826.483],[523.876,948.11]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.203,415.559],[761.203,287.118],[836.648,422.492],[836.648,301.251]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.203,553.792],[761.203,425.352],[836.648,552.977],[836.648,431.736]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.203,562.212],[761.203,690.652],[836.648,560.925],[836.648,682.166]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.203,700.491],[761.203,828.931],[836.648,691.453],[836.648,812.694]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[761.203,842.574],[761.203,971.014],[836.648,825.573],[836.648,946.814]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.12,421.761],[865.12,299.761],[836.647,422.491],[836.647,301.25]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.12,553.063],[865.12,431.063],[836.647,552.977],[836.647,431.736]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.12,561.061],[865.12,683.061],[836.647,560.925],[836.647,682.166]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.12,692.406],[865.12,814.406],[836.647,691.453],[836.647,812.695]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.12,827.365],[836.647,825.573],[865.12,949.365],[836.647,946.814]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.121,421.761],[865.121,299.761],[949.314,429.725],[949.314,315.994]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.121,553.063],[865.121,431.063],[949.314,552.127],[949.314,438.396]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.121,561.061],[865.121,683.061],[949.314,559.582],[949.314,673.313]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.121,692.406],[865.121,814.406],[949.314,682.025],[949.314,795.755]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[865.121,827.365],[865.121,949.365],[949.314,807.836],[949.314,921.567]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[921.323,559.46],[921.323,672.508],[979.735,558.465],[979.735,665.944]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[921.323,430.382],[921.323,317.335],[979.735,435.745],[979.735,328.265]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[921.323,552.049],[921.323,439.002],[979.735,551.419],[979.735,443.94]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[921.323,681.168],[921.323,794.215],[979.735,674.177],[979.735,781.657]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[921.323,806.223],[921.323,919.271],[979.735,793.074],[979.735,900.553]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[979.848,435.651],[979.848,328.074],[1033.26,440.559],[1033.26,338.079]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[979.848,551.43],[979.848,443.853],[1033.26,550.853],[1033.26,448.373]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[979.848,558.483],[979.848,666.059],[1033.26,557.571],[1033.26,660.052]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[979.848,674.3],[979.848,781.877],[1033.26,667.902],[1033.26,770.382]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[979.848,793.304],[979.848,900.88],[1033.26,781.268],[1033.26,883.748]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,440.038],[1058.34,337.016],[1033.26,440.559],[1033.26,338.079]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,550.914],[1058.34,447.893],[1033.26,550.853],[1033.26,448.373]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,557.668],[1058.34,660.69],[1033.26,557.571],[1033.26,660.052]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,668.582],[1058.34,771.603],[1033.26,667.902],[1033.26,770.382]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,782.547],[1033.26,781.268],[1058.34,885.569],[1033.26,883.748]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,440.038],[1058.34,337.016],[1119.02,445.777],[1119.02,348.715]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,550.914],[1058.34,447.893],[1119.02,550.24],[1119.02,453.178]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,557.668],[1058.34,660.69],[1119.02,556.603],[1119.02,653.665]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,668.582],[1058.34,771.603],[1119.02,661.1],[1119.02,758.162]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1058.34,782.547],[1058.34,885.569],[1119.02,768.473],[1119.02,865.535]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1094.24,446.256],[1094.24,349.692],[1137.17,450.197],[1137.17,357.725]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1094.24,550.183],[1094.24,453.619],[1137.17,549.72],[1137.17,457.248]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1094.24,556.514],[1094.24,653.078],[1137.17,555.782],[1137.17,648.255]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1094.24,660.475],[1094.24,757.039],[1137.17,655.338],[1137.17,747.81]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1094.24,767.297],[1094.24,863.861],[1137.17,757.633],[1137.17,850.105]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1136.89,450.083],[1136.89,357.491],[1176.72,453.743],[1176.72,364.952]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1136.89,549.734],[1136.89,457.142],[1176.72,549.303],[1176.72,460.513]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1136.89,555.804],[1136.89,648.395],[1176.72,555.124],[1176.72,643.915]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1136.89,655.488],[1136.89,748.079],[1176.72,650.717],[1176.72,739.507]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1136.89,757.915],[1136.89,850.506],[1176.72,748.939],[1176.72,837.73]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,453.351],[1199.09,364.154],[1176.72,453.743],[1176.72,364.952]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,549.349],[1199.09,460.152],[1176.72,549.303],[1176.72,460.513]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,555.197],[1199.09,644.394],[1176.72,555.124],[1176.72,643.915]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,651.227],[1199.09,740.424],[1176.72,650.717],[1176.72,739.507]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,749.899],[1176.72,748.939],[1199.09,839.096],[1176.72,837.73]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,453.351],[1199.09,364.154],[1244.94,457.687],[1244.94,372.993]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,549.349],[1199.09,460.152],[1244.94,548.84],[1244.94,464.145]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,555.197],[1199.09,644.394],[1244.94,554.392],[1244.94,639.087]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,651.227],[1199.09,740.424],[1244.94,645.575],[1244.94,730.269]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1199.09,749.899],[1199.09,839.096],[1244.94,739.266],[1244.94,823.96]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1222.73,458.053],[1222.73,373.737],[1255.92,461.099],[1255.92,379.948]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1222.73,548.797],[1222.73,464.482],[1255.92,548.439],[1255.92,467.287]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1222.73,554.324],[1222.73,638.64],[1255.92,553.759],[1255.92,634.911]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1222.73,645.098],[1222.73,729.414],[1255.92,641.127],[1255.92,722.279]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1222.73,738.37],[1222.73,822.685],[1255.92,730.899],[1255.92,812.051]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1301.96,465.327],[1301.96,388.565],[1260.2,465.943],[1260.2,389.82]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1301.96,547.942],[1301.96,471.18],[1260.2,547.869],[1260.2,471.747]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1301.96,552.974],[1301.96,629.736],[1260.2,552.86],[1260.2,628.982]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1301.96,635.616],[1301.96,712.378],[1260.2,634.813],[1260.2,710.936]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1301.96,720.532],[1301.96,797.293],[1260.2,719.022],[1260.2,795.144]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1302.43,465.295],[1302.43,388.499],[1330.02,467.83],[1330.02,393.668]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1302.43,547.946],[1302.43,471.15],[1330.02,547.648],[1330.02,473.485]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1302.43,552.98],[1302.43,629.776],[1330.02,552.509],[1330.02,626.672]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1302.43,635.659],[1302.43,712.454],[1330.02,632.353],[1330.02,706.516]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1302.43,720.612],[1302.43,797.407],[1330.02,714.394],[1330.02,788.556]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,467.557],[1349.28,393.112],[1330.02,467.83],[1330.02,393.668]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,547.68],[1349.28,473.234],[1330.02,547.648],[1330.02,473.485]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,552.56],[1349.28,627.006],[1330.02,552.509],[1330.02,626.672]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,632.709],[1349.28,707.155],[1330.02,632.353],[1330.02,706.516]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,715.063],[1330.02,714.394],[1349.28,789.508],[1330.02,788.556]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,467.557],[1349.28,393.112],[1381.48,470.603],[1381.48,399.32]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,547.68],[1349.28,473.234],[1381.48,547.322],[1381.48,476.038]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,552.56],[1349.28,627.006],[1381.48,551.995],[1381.48,623.278]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,632.709],[1349.28,707.155],[1381.48,628.738],[1381.48,700.021]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1349.28,715.063],[1349.28,789.508],[1381.48,707.593],[1381.48,778.876]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1362.27,470.862],[1362.27,399.848],[1385.75,473.018],[1385.75,404.242]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1362.27,547.291],[1362.27,476.277],[1385.75,547.038],[1385.75,478.262]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1362.27,551.947],[1362.27,622.961],[1385.75,551.547],[1385.75,620.323]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1362.27,628.401],[1362.27,699.415],[1385.75,625.591],[1385.75,694.367]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1362.27,706.958],[1362.27,777.973],[1385.75,701.673],[1385.75,770.449]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1386.2,473.059],[1386.2,404.326],[1408.14,475.074],[1408.14,408.432]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1386.2,547.033],[1386.2,478.3],[1408.14,546.796],[1408.14,480.155]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1386.2,551.539],[1386.2,620.272],[1408.14,551.165],[1408.14,617.806]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1386.2,625.537],[1386.2,694.27],[1408.14,622.911],[1408.14,689.552]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1386.2,701.571],[1386.2,770.304],[1408.14,696.631],[1408.14,763.272]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,474.846],[1426.33,407.968],[1408.14,475.074],[1408.14,408.432]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,546.823],[1426.33,479.945],[1408.14,546.796],[1408.14,480.155]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,551.207],[1426.33,618.085],[1408.14,551.165],[1408.14,617.806]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,623.208],[1426.33,690.086],[1408.14,622.911],[1408.14,689.552]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,697.19],[1408.14,696.631],[1426.33,764.068],[1408.14,763.273]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,474.846],[1426.33,407.968],[1452.43,477.314],[1452.43,413]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,546.823],[1426.33,479.945],[1452.43,546.533],[1452.43,482.218]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,551.207],[1426.33,618.085],[1452.43,550.749],[1452.43,615.064]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,623.208],[1426.33,690.086],[1452.43,619.99],[1452.43,684.305]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1426.33,697.19],[1426.33,764.068],[1452.43,691.136],[1452.43,755.451]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1435.44,477.518],[1435.44,413.415],[1454.78,479.295],[1454.78,417.037]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1435.44,546.509],[1435.44,482.406],[1454.78,546.3],[1454.78,484.042]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1435.44,550.711],[1435.44,614.814],[1454.78,550.381],[1454.78,612.639]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1435.44,619.725],[1435.44,683.828],[1454.78,617.409],[1454.78,679.666]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:58,
                    verts:[[1435.44,690.637],[1435.44,754.74],[1454.78,686.28],[1454.78,748.538]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[551.56,420.229],[551.56,296.638],[317.175,425.197],[317.175,306.765]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[551.56,553.243],[551.56,429.652],[317.175,552.659],[317.175,434.227]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[551.56,561.345],[551.56,684.936],[317.175,560.423],[317.175,678.855]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[551.56,694.403],[551.56,817.993],[317.175,687.927],[317.175,806.358]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[551.56,831.122],[551.56,954.712],[317.175,818.939],[317.175,937.37]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.829,413.08],[888.829,282.066],[626.1,418.649],[626.1,293.418]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.829,554.083],[888.829,423.069],[626.1,553.429],[626.1,428.197]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.829,562.672],[888.829,693.686],[626.1,561.638],[626.1,686.87]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.829,703.722],[888.829,834.736],[626.1,696.462],[626.1,821.694]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.829,848.653],[888.829,979.666],[626.1,834.996],[626.1,960.227]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.828,413.08],[888.828,282.066],[945.859,420.569],[945.859,297.331]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.828,554.083],[888.828,423.069],[945.859,553.203],[945.859,429.965]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.828,562.672],[888.828,693.686],[945.859,561.282],[945.859,684.52]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.828,703.722],[888.828,834.736],[945.859,693.96],[945.859,817.198]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[888.828,848.653],[888.828,979.667],[945.859,830.289],[945.859,953.527]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,419.959],[976.718,296.088],[945.858,420.568],[945.858,297.33]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,553.274],[976.718,429.404],[945.858,553.203],[945.858,429.965]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,561.395],[976.718,685.266],[945.858,561.282],[945.858,684.52]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,694.755],[976.718,818.626],[945.858,693.96],[945.858,817.198]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,831.784],[945.858,830.289],[976.718,955.654],[945.858,953.527]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,419.959],[976.718,296.088],[1039.06,428.479],[1039.06,313.454]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,553.274],[976.718,429.404],[1039.06,552.273],[1039.06,437.249]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,561.395],[976.718,685.266],[1039.06,559.814],[1039.06,674.838]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,694.755],[976.718,818.625],[1039.06,683.649],[1039.06,798.673]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[976.718,831.783],[976.718,955.654],[1039.06,810.892],[1039.06,925.916]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1009.08,559.713],[1009.08,674.172],[1052.64,558.653],[1052.64,667.181]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1009.08,429.023],[1009.08,314.564],[1052.64,434.734],[1052.64,326.205]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1009.08,552.209],[1009.08,437.75],[1052.64,551.538],[1052.64,443.009]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1009.08,682.94],[1009.08,797.399],[1052.64,675.495],[1052.64,784.024]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1009.08,809.557],[1009.08,924.017],[1052.64,795.552],[1052.64,904.081]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1053.02,434.639],[1053.02,326.012],[1092.62,439.84],[1092.62,336.613]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1053.02,551.549],[1053.02,442.922],[1092.62,550.938],[1092.62,447.711]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1053.02,558.67],[1053.02,667.297],[1092.62,557.705],[1092.62,660.932]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1053.02,675.618],[1053.02,784.246],[1092.62,668.839],[1092.62,772.066]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1053.02,795.784],[1053.02,904.412],[1092.62,783.031],[1092.62,886.258]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,439.413],[1119.08,335.742],[1092.62,439.84],[1092.62,336.613]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,550.988],[1119.08,447.317],[1092.62,550.938],[1092.62,447.711]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,557.784],[1119.08,661.455],[1092.62,557.705],[1092.62,660.932]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,669.396],[1119.08,773.066],[1092.62,668.839],[1092.62,772.066]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,784.079],[1092.62,783.031],[1119.08,887.749],[1092.62,886.258]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,439.413],[1119.08,335.742],[1163.27,445.451],[1163.27,348.05]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,550.988],[1119.08,447.317],[1163.27,550.278],[1163.27,452.877]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,557.784],[1119.08,661.455],[1163.27,556.663],[1163.27,654.064]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,669.396],[1119.08,773.066],[1163.27,661.526],[1163.27,758.927]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1119.08,784.079],[1119.08,887.749],[1163.27,769.273],[1163.27,866.674]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1137.34,445.841],[1137.34,348.846],[1168.87,449.975],[1168.87,357.273]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1137.34,550.232],[1137.34,453.237],[1168.87,549.746],[1168.87,457.044]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1137.34,556.591],[1137.34,653.586],[1168.87,555.824],[1168.87,648.526]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1137.34,661.016],[1137.34,758.012],[1168.87,655.628],[1168.87,748.33]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1137.34,768.315],[1137.34,865.311],[1168.87,758.177],[1168.87,850.88]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1168.92,449.858],[1168.92,357.034],[1198.05,453.684],[1198.05,364.832]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1168.92,549.76],[1168.92,456.936],[1198.05,549.31],[1198.05,460.458]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1168.92,555.845],[1168.92,648.669],[1198.05,555.135],[1198.05,643.987]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1168.92,655.78],[1168.92,748.604],[1198.05,650.793],[1198.05,739.645]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1168.92,758.464],[1168.92,851.288],[1198.05,749.083],[1198.05,837.935]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,453.367],[1221.2,364.187],[1198.05,453.684],[1198.05,364.832]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,549.348],[1221.2,460.167],[1198.05,549.31],[1198.05,460.458]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,555.194],[1221.2,644.374],[1198.05,555.135],[1198.05,643.987]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,651.206],[1221.2,740.386],[1198.05,650.794],[1198.05,739.645]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,749.859],[1198.05,749.084],[1221.2,839.04],[1198.05,837.935]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,453.367],[1221.2,364.187],[1254.18,457.873],[1254.18,373.372]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,549.348],[1221.2,460.167],[1254.18,548.818],[1254.18,464.316]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,555.194],[1221.2,644.374],[1254.18,554.358],[1254.18,638.859]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,651.206],[1221.2,740.386],[1254.18,645.332],[1254.18,729.833]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1221.2,749.859],[1221.2,839.04],[1254.18,738.81],[1254.18,823.311]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1231.35,458.168],[1231.35,373.971],[1255.45,461.328],[1255.45,380.413]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1231.35,548.783],[1231.35,464.587],[1255.45,548.412],[1255.45,467.497]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1231.35,554.303],[1231.35,638.499],[1255.45,553.716],[1255.45,634.631]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1231.35,644.949],[1231.35,729.145],[1255.45,640.829],[1255.45,721.744]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1231.35,738.089],[1231.35,822.285],[1255.45,730.339],[1255.45,811.254]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1288.76,465.697],[1288.76,389.32],[1246.15,466.191],[1246.15,390.325]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1288.76,547.898],[1288.76,471.521],[1246.15,547.84],[1246.15,471.975]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1288.76,552.905],[1288.76,629.283],[1246.15,552.814],[1246.15,628.679]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1288.76,635.134],[1288.76,711.511],[1246.15,634.491],[1246.15,710.356]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1288.76,719.624],[1288.76,796.002],[1246.15,718.414],[1246.15,794.28]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1289.3,465.666],[1289.3,389.256],[1309.2,468.278],[1309.2,394.58]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1289.3,547.902],[1289.3,471.492],[1309.2,547.595],[1309.2,473.897]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1289.3,552.911],[1289.3,629.321],[1309.2,552.426],[1309.2,626.124]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1289.3,635.174],[1289.3,711.584],[1309.2,631.77],[1309.2,705.468]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1289.3,719.701],[1289.3,796.111],[1309.2,713.296],[1309.2,786.994]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,468.06],[1328.73,394.136],[1309.2,468.278],[1309.2,394.58]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,547.62],[1328.73,473.697],[1309.2,547.595],[1309.2,473.897]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,552.467],[1328.73,626.391],[1309.2,552.426],[1309.2,626.124]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,632.053],[1328.73,705.977],[1309.2,631.77],[1309.2,705.468]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,713.83],[1309.2,713.296],[1328.73,787.753],[1309.2,786.994]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,468.06],[1328.73,394.136],[1351.59,471.184],[1351.59,400.505]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,547.62],[1328.73,473.697],[1351.59,547.253],[1351.59,476.573]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,552.467],[1328.73,626.391],[1351.59,551.887],[1351.59,622.567]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,632.053],[1328.73,705.977],[1351.59,627.981],[1351.59,698.661]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1328.73,713.83],[1328.73,787.753],[1351.59,706.168],[1351.59,776.848]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1349.35,473.641],[1349.35,405.513],[1365.06,475.701],[1365.06,409.711]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1349.35,546.964],[1349.35,478.836],[1365.06,546.722],[1365.06,480.733]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1349.35,551.431],[1349.35,619.559],[1365.06,551.048],[1365.06,617.038]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1349.35,624.778],[1349.35,692.907],[1365.06,622.093],[1365.06,688.083]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1349.35,700.143],[1349.35,768.272],[1365.06,695.093],[1365.06,761.082]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,475.521],[1383.32,409.343],[1365.06,475.701],[1365.06,409.711]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,546.744],[1383.32,480.566],[1365.06,546.722],[1365.06,480.733]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,551.082],[1383.32,617.259],[1365.06,551.048],[1365.06,617.038]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,622.328],[1383.32,688.506],[1365.06,622.093],[1365.06,688.083]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,695.535],[1365.06,695.093],[1383.32,761.712],[1365.06,761.082]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,475.521],[1383.32,409.344],[1401.73,478.036],[1401.73,414.471]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,546.744],[1383.32,480.566],[1401.73,546.448],[1401.73,482.883]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,551.082],[1383.32,617.259],[1401.73,550.615],[1401.73,614.18]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,622.328],[1383.32,688.506],[1401.73,619.05],[1401.73,682.615]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:59,
                    verts:[[1383.32,695.535],[1383.32,761.712],[1401.73,689.367],[1401.73,752.933]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[659.373,417.015],[659.373,290.087],[400.124,420.984],[400.124,298.177]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[659.373,553.621],[659.373,426.693],[400.124,553.154],[400.124,430.347]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[659.373,561.942],[659.373,688.87],[400.124,561.205],[400.124,684.012]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[659.373,698.592],[659.373,825.52],[400.124,693.419],[400.124,816.226]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[659.373,839.003],[659.373,965.931],[400.124,829.271],[400.124,952.077]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,411.436],[1023.82,278.715],[740.782,415.769],[740.782,287.547]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,554.276],[1023.82,421.555],[740.782,553.767],[740.782,425.545]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,562.977],[1023.82,695.698],[740.782,562.173],[740.782,690.395]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,705.865],[1023.82,838.586],[740.782,700.217],[740.782,828.439]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,852.684],[1023.82,985.405],[740.782,842.059],[740.782,970.281]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,411.436],[1023.82,278.715],[1059.88,419.344],[1059.88,294.835]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,554.276],[1023.82,421.555],[1059.88,553.347],[1059.88,428.838]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,562.977],[1023.82,695.698],[1059.88,561.509],[1059.88,686.019]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,705.865],[1023.82,838.586],[1059.88,695.556],[1059.88,820.065]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1023.82,852.684],[1023.82,985.405],[1059.88,833.291],[1059.88,957.801]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,418.878],[1059.88,419.344],[1092.47,293.885],[1059.88,294.835]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,553.402],[1092.47,428.408],[1059.88,553.347],[1059.88,428.837]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,561.596],[1092.47,686.589],[1059.88,561.509],[1059.88,686.019]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,696.164],[1059.88,695.556],[1092.47,821.157],[1059.88,820.066]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,834.434],[1059.88,833.291],[1092.47,959.428],[1059.88,957.801]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,418.878],[1092.47,293.885],[1130.59,427.802],[1130.59,312.076]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,553.402],[1092.47,428.408],[1130.59,552.353],[1130.59,436.626]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,561.596],[1092.47,686.589],[1130.59,559.939],[1130.59,675.666]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,696.164],[1092.47,821.157],[1130.59,684.531],[1130.59,800.257]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1092.47,834.434],[1092.47,959.427],[1130.59,812.55],[1130.59,928.276]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1099.2,559.862],[1099.2,675.159],[1126.47,558.755],[1126.47,667.855]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1099.2,428.216],[1099.2,312.919],[1126.47,434.184],[1126.47,325.083]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1127.11,434.09],[1127.11,324.891],[1151.79,439.502],[1151.79,335.925]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1127.11,558.772],[1127.11,667.97],[1151.79,557.768],[1151.79,661.345]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1127.11,551.614],[1127.11,442.415],[1151.79,550.977],[1151.79,447.4]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1127.11,676.335],[1127.11,785.533],[1151.79,669.279],[1151.79,772.857]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1127.11,797.133],[1127.11,906.331],[1151.79,783.859],[1151.79,887.437]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,439.18],[1151.79,439.502],[1179.18,335.268],[1151.79,335.925]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,551.015],[1179.18,447.103],[1151.79,550.977],[1151.79,447.4]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,557.827],[1179.18,661.74],[1151.79,557.768],[1151.79,661.345]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,669.7],[1151.79,669.279],[1179.18,773.612],[1151.79,772.857]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,784.65],[1151.79,783.859],[1179.18,888.562],[1151.79,887.437]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,439.18],[1179.18,335.268],[1205.86,445.426],[1205.86,348]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,551.015],[1179.18,447.103],[1205.86,550.281],[1205.86,452.854]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,557.827],[1179.18,661.74],[1205.86,556.668],[1205.86,654.095]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,669.7],[1179.18,773.612],[1205.86,661.558],[1205.86,758.984]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1179.18,784.65],[1179.18,888.562],[1205.86,769.333],[1205.86,866.76]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1199.07,449.873],[1199.07,357.064],[1217.04,453.813],[1217.04,365.096]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1199.07,549.758],[1199.07,456.949],[1217.04,549.295],[1217.04,460.578]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1199.07,555.843],[1199.07,648.652],[1217.04,555.111],[1217.04,643.829]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1199.07,655.761],[1199.07,748.57],[1217.04,650.624],[1217.04,739.342]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1199.07,758.428],[1199.07,851.237],[1217.04,748.766],[1217.04,837.483]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,453.577],[1217.04,453.813],[1240.67,364.614],[1217.04,365.096]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,549.323],[1240.67,460.36],[1217.04,549.295],[1217.04,460.578]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,555.155],[1240.67,644.118],[1217.04,555.111],[1217.04,643.829]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,650.933],[1217.04,650.625],[1240.67,739.895],[1217.04,739.342]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,749.345],[1217.04,748.766],[1240.67,838.308],[1217.04,837.483]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,453.577],[1240.67,364.614],[1260.4,458.197],[1260.4,374.031]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,549.323],[1240.67,460.36],[1260.4,548.78],[1260.4,464.614]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,555.155],[1240.67,644.118],[1260.4,554.298],[1260.4,638.464]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,650.933],[1240.67,739.895],[1260.4,644.911],[1260.4,729.077]]
                },{
                    num:"105",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1240.67,749.345],[1240.67,838.308],[1260.4,738.017],[1260.4,822.183]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1237.2,554.257],[1237.2,638.195],[1252,553.656],[1252,634.233]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1272.38,466.117],[1272.38,390.175],[1229.3,466.483],[1229.3,390.922]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1272.38,552.827],[1272.38,628.769],[1229.3,552.76],[1229.3,628.321]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1272.38,547.849],[1272.38,471.907],[1229.3,547.806],[1229.3,472.245]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1272.38,634.586],[1272.38,710.528],[1229.3,634.109],[1229.3,709.67]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1272.38,718.595],[1229.3,717.696],[1272.38,794.537],[1229.3,793.257]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1273,466.087],[1273,390.115],[1285.14,468.749],[1285.14,395.541]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1273,547.852],[1273,471.88],[1285.14,547.539],[1285.14,474.331]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1273,552.833],[1273,628.805],[1285.14,552.339],[1285.14,625.547]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1273,634.625],[1273,710.597],[1285.14,631.155],[1285.14,704.364]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1273,718.667],[1273,794.64],[1285.14,712.14],[1285.14,785.349]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,468.588],[1285.14,468.749],[1304.79,395.213],[1285.14,395.541]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,547.558],[1304.79,474.183],[1285.14,547.539],[1285.14,474.331]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,552.369],[1304.79,625.744],[1285.14,552.339],[1285.14,625.547]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,631.365],[1285.14,631.155],[1304.79,704.741],[1285.14,704.364]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,712.535],[1285.14,712.14],[1304.79,785.91],[1285.14,785.349]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,468.588],[1304.79,395.213],[1318.34,471.761],[1318.34,401.68]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,547.558],[1304.79,474.183],[1318.34,547.185],[1318.34,477.104]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,552.369],[1304.79,625.744],[1318.34,551.78],[1318.34,621.861]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,631.365],[1304.79,704.741],[1318.34,627.229],[1318.34,697.311]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1304.79,712.535],[1304.79,785.91],[1318.34,704.755],[1318.34,774.836]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1309.32,474.198],[1309.32,406.648],[1318.86,476.286],[1318.86,410.903]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1309.32,546.899],[1309.32,479.349],[1318.86,546.654],[1318.86,481.271]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1309.32,551.327],[1309.32,618.878],[1318.86,550.94],[1318.86,616.322]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1309.32,624.052],[1309.32,691.603],[1318.86,621.331],[1318.86,686.713]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1309.32,698.778],[1309.32,766.329],[1318.86,693.659],[1318.86,759.041]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,476.153],[1318.86,476.286],[1337.1,410.633],[1318.86,410.903]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,546.669],[1337.1,481.149],[1318.86,546.654],[1318.86,481.271]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,550.965],[1337.1,616.485],[1318.86,550.94],[1318.86,616.322]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,621.504],[1318.86,621.331],[1337.1,687.024],[1318.86,686.713]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,693.984],[1318.86,693.659],[1337.1,759.505],[1318.86,759.041]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,476.153],[1337.1,410.633],[1347.96,478.695],[1347.96,415.814]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,546.669],[1337.1,481.149],[1347.96,546.37],[1347.96,483.489]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,550.965],[1337.1,616.485],[1347.96,550.493],[1347.96,613.374]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,621.504],[1337.1,687.024],[1347.96,618.191],[1347.96,681.072]]
                },{
                    num:"103",
                    tipo:"TorreI",
                    frame:60,
                    verts:[[1337.1,693.984],[1337.1,759.505],[1347.96,687.751],[1347.96,750.632]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[778.773,414.51],[778.773,284.981],[499.084,417.241],[499.084,290.548]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[778.773,553.915],[778.773,424.386],[499.084,553.594],[499.084,426.901]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[778.773,562.407],[778.773,691.936],[499.084,561.9],[499.084,688.593]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[778.773,701.858],[778.773,831.387],[499.084,698.298],[499.084,824.99]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[778.773,845.146],[778.773,974.675],[499.084,838.448],[499.084,965.141]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,410.769],[1161.88,277.356],[865.356,413.665],[865.356,283.258]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,554.355],[1161.88,420.941],[865.356,554.014],[865.356,423.608]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,563.101],[1161.88,696.514],[865.356,562.564],[865.356,692.97]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,706.734],[1161.88,840.148],[865.356,702.96],[865.356,833.367]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,854.319],[1161.88,987.733],[865.356,847.219],[865.356,977.626]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,410.769],[1161.88,277.355],[1175.29,418.923],[1175.29,293.977]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,554.355],[1161.88,420.941],[1175.29,553.396],[1175.29,428.45]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,563.101],[1161.88,696.514],[1175.29,561.587],[1175.29,686.534]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,706.734],[1161.88,840.148],[1175.29,696.105],[1175.29,821.052]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1161.88,854.319],[1161.88,987.733],[1175.29,834.324],[1175.29,959.27]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,418.617],[1175.29,418.923],[1208.83,293.352],[1175.29,293.976]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,553.432],[1175.29,553.396],[1208.83,428.168],[1175.29,428.45]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,561.644],[1175.29,561.587],[1208.83,686.909],[1175.29,686.534]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,696.505],[1175.29,696.105],[1208.83,821.769],[1175.29,821.052]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,835.075],[1175.29,834.324],[1208.83,960.34],[1175.29,959.271]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,418.617],[1208.83,293.352],[1221.29,427.762],[1221.29,311.993]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,553.432],[1208.83,428.168],[1221.29,552.357],[1221.29,436.589]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,561.644],[1208.83,686.909],[1221.29,559.947],[1221.29,675.715]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,696.504],[1208.83,821.769],[1221.29,684.584],[1221.29,800.352]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1208.83,835.075],[1208.83,960.34],[1221.29,812.65],[1221.29,928.418]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,557.792],[1209.28,557.753],[1237.11,661.504],[1209.28,661.246]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,669.448],[1209.28,669.174],[1237.11,773.16],[1209.28,772.668]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,784.177],[1209.28,783.661],[1237.11,887.888],[1209.28,887.155]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,439.373],[1209.28,439.583],[1237.11,335.661],[1209.28,336.089]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,550.993],[1209.28,550.968],[1237.11,447.281],[1209.28,447.474]]
                },{
                    num:"506",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,439.373],[1237.11,335.661],[1245.77,445.725],[1245.77,348.608]]
                },{
                    num:"406",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,550.993],[1237.11,447.281],[1245.77,550.246],[1245.77,453.129]]
                },{
                    num:"306",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,557.792],[1237.11,661.503],[1245.77,556.613],[1245.77,653.729]]
                },{
                    num:"206",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,669.448],[1237.11,773.16],[1245.77,661.168],[1245.77,758.285]]
                },{
                    num:"106",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1237.11,784.177],[1237.11,887.888],[1245.77,768.601],[1245.77,865.717]]
                },{
                    num:"505",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,453.99],[1233.23,454.143],[1257.03,365.455],[1233.23,365.767]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,549.274],[1233.23,549.256],[1257.03,460.74],[1233.23,460.881]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,555.079],[1233.23,555.05],[1257.03,643.613],[1233.23,643.426]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,650.395],[1233.23,650.195],[1257.03,738.929],[1233.23,738.571]]
                },{
                    num:"405",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,549.274],[1257.03,460.74],[1263.4,548.725],[1263.4,465.042]]
                },{
                    num:"305",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,555.079],[1257.03,643.613],[1263.4,554.211],[1263.4,637.894]]
                },{
                    num:"205",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1257.03,650.395],[1257.03,738.929],[1263.4,644.305],[1263.4,727.988]]
                },{
                    num:"504",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,469.14],[1258.07,469.243],[1277.68,396.337],[1258.07,396.548]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,547.494],[1258.07,547.481],[1277.68,474.691],[1258.07,474.786]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,552.266],[1258.07,552.247],[1277.68,625.069],[1258.07,624.942]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,630.646],[1258.07,630.511],[1277.68,703.449],[1258.07,703.206]]
                },{
                    num:"104",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,711.182],[1258.07,710.928],[1277.68,783.985],[1258.07,783.623]]
                },{
                    num:"404",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,547.494],[1277.68,474.691],[1282.03,547.119],[1282.03,477.629]]
                },{
                    num:"304",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,552.266],[1277.68,625.069],[1282.03,551.674],[1282.03,621.164]]
                },{
                    num:"204",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1277.68,630.646],[1277.68,703.449],[1282.03,626.487],[1282.03,695.977]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,546.6],[1288.04,481.69],[1269.92,546.59],[1269.92,481.768]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,550.856],[1269.92,550.84],[1288.04,615.766],[1269.92,615.662]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,620.738],[1269.92,620.627],[1288.04,685.649],[1269.92,685.449]]
                },{
                    num:"503",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,476.74],[1288.04,411.83],[1291.51,479.289],[1291.51,417.025]]
                },{
                    num:"403",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,546.6],[1288.04,481.69],[1291.51,546.301],[1291.51,484.037]]
                },{
                    num:"303",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,550.856],[1288.04,615.766],[1291.51,550.383],[1291.51,612.647]]
                },{
                    num:"203",
                    tipo:"TorreI",
                    frame:61,
                    verts:[[1288.04,620.738],[1288.04,685.649],[1291.51,617.416],[1291.51,679.68]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[906.53,412.884],[906.53,281.666],[612.647,414.176],[612.647,284.301]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[906.53,554.106],[906.53,422.889],[612.647,553.954],[612.647,424.079]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[906.53,562.708],[906.53,693.926],[612.647,562.469],[612.647,692.344]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[906.53,703.977],[906.53,835.195],[612.647,702.292],[612.647,832.168]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[906.53,849.133],[906.53,980.351],[612.647,845.964],[612.647,975.839]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[646.015,422.008],[613.943,422.14],[646.015,300.265],[613.943,300.534]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[646.015,561.015],[646.015,682.758],[613.943,560.99],[613.943,682.596]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[646.015,692.084],[613.943,691.912],[646.015,813.827],[613.943,813.518]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[646.015,826.759],[613.943,826.435],[646.015,948.502],[613.943,948.041]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[996.108,412.49],[1298.01,411.162],[996.108,280.863],[1298.01,278.157]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[996.108,554.152],[1298.01,554.309],[996.108,422.526],[1298.01,421.303]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[996.108,562.782],[1298.01,563.028],[996.108,694.408],[1298.01,696.033]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[996.108,704.491],[1298.01,706.222],[996.108,836.117],[1298.01,839.227]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[996.108,850.099],[1298.01,853.355],[996.108,981.726],[1298.01,986.361]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[1288.25,419.363],[1321.86,419.225],[1288.25,294.874],[1321.86,294.592]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[1288.25,561.506],[1321.86,561.531],[1288.25,685.995],[1321.86,686.165]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[1288.25,695.531],[1321.86,695.712],[1288.25,820.021],[1321.86,820.345]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[1288.25,833.244],[1321.86,833.584],[1288.25,957.734],[1321.86,958.217]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:62,
                    verts:[[1288.25,553.345],[1321.86,553.361],[1288.25,428.855],[1321.86,428.728]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[749.652,420.103],[716.502,420.074],[749.652,296.381],[716.502,296.322]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[749.652,553.258],[749.652,429.536],[716.502,553.261],[716.502,429.509]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[749.652,561.368],[716.502,561.374],[749.652,685.09],[716.502,685.126]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[749.652,694.567],[716.502,694.605],[749.652,818.289],[716.502,818.357]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[749.652,831.431],[716.502,831.502],[749.652,955.153],[716.502,955.254]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1038.39,412.259],[738.042,411.979],[1038.39,280.392],[738.042,279.822]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1038.39,554.18],[1038.39,422.313],[738.042,554.212],[738.042,422.056]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1038.39,562.824],[738.042,562.876],[1038.39,694.691],[738.042,695.033]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1038.39,704.792],[738.042,705.157],[1038.39,836.659],[738.042,837.314]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1038.39,850.666],[738.042,851.352],[1038.39,982.533],[738.042,983.509]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1128.46,412.343],[1128.46,280.563],[1427.09,412.621],[1427.09,281.13]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1128.46,554.17],[1128.46,422.39],[1427.09,554.137],[1427.09,422.646]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1128.46,562.809],[1128.46,694.588],[1427.09,562.757],[1427.09,694.248]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1128.46,704.683],[1128.46,836.462],[1427.09,704.32],[1427.09,835.811]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1128.46,850.46],[1128.46,982.24],[1427.09,849.778],[1427.09,981.269]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1394.87,420.665],[1427.7,420.694],[1394.87,297.528],[1427.7,297.586]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1394.87,561.264],[1394.87,684.401],[1427.7,561.259],[1427.7,684.366]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1394.87,693.834],[1427.7,693.797],[1394.87,816.971],[1427.7,816.904]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1394.87,830.052],[1427.7,829.981],[1394.87,953.189],[1427.7,953.089]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:63,
                    verts:[[1394.87,553.191],[1394.87,430.054],[1427.7,553.188],[1427.7,430.08]]
                },
                ],
                [
                {
                    num:"402",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[761.799,548.078],[761.799,483.508],[758.975,547.716],[758.975,485.79]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[761.799,552.311],[761.799,616.88],[758.975,551.776],[758.975,613.703]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[761.799,548.078],[779.722,548.07],[761.799,483.508],[779.722,483.557]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[761.799,552.311],[779.722,552.299],[761.799,616.88],[779.722,616.811]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[761.799,621.826],[779.722,621.753],[761.799,686.395],[779.722,686.266]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[770.208,549.706],[770.208,477.311],[766.674,549.229],[766.674,480.139]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[770.208,554.452],[770.208,626.847],[766.674,553.758],[766.674,622.848]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[770.208,471.791],[789.609,471.855],[770.208,399.396],[789.609,399.529]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[770.208,549.706],[789.609,549.696],[770.208,477.311],[789.609,477.37]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[770.208,554.452],[789.609,554.438],[770.208,626.847],[789.609,626.764]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,551.987],[787.096,463.797],[781.903,551.285],[781.903,467.952]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,557.768],[787.096,645.958],[781.903,556.749],[781.903,640.082]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,652.713],[787.096,740.903],[781.903,646.465],[781.903,729.798]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,750.271],[787.096,838.461],[781.903,738.65],[781.903,821.983]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,457.073],[810.705,457.168],[787.096,368.883],[810.705,369.081]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,551.987],[810.705,551.972],[787.096,463.797],[810.705,463.885]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,557.768],[810.705,557.747],[787.096,645.958],[810.705,645.834]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,652.714],[810.705,652.582],[787.096,740.903],[810.705,740.669]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[787.096,750.271],[810.705,750.026],[787.096,838.461],[810.705,838.113]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.359,442.898],[803.359,339.496],[796.288,449.061],[796.288,352.273]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.359,554.183],[803.359,450.782],[796.288,553.228],[796.288,456.44]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.359,560.962],[803.359,664.363],[796.288,559.573],[796.288,656.361]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.359,672.284],[803.359,775.685],[796.288,663.775],[796.288,760.563]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.359,786.669],[803.359,890.071],[796.288,770.844],[796.288,867.632]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.36,442.898],[831.014,443.029],[803.36,339.496],[831.014,339.768]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.36,554.183],[831.014,554.163],[803.36,450.782],[831.014,450.902]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.36,560.962],[831.014,560.932],[803.36,664.363],[831.014,664.193]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.36,672.284],[831.014,672.103],[803.36,775.686],[831.014,775.363]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[803.36,786.669],[831.014,786.332],[803.36,890.071],[831.014,889.593]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,418.816],[826.432,293.758],[816.231,428.009],[816.231,312.498]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,553.409],[826.432,428.351],[816.231,552.328],[816.231,436.817]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,561.607],[826.432,686.665],[816.231,559.901],[816.231,675.412]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,696.245],[826.432,821.303],[816.231,684.261],[816.231,799.773]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,834.587],[826.432,959.645],[816.231,812.043],[816.231,927.554]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,418.816],[859.83,419.014],[826.432,293.758],[859.83,294.162]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,553.409],[859.83,553.386],[826.432,428.351],[859.83,428.534]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,561.607],[859.83,561.571],[826.432,686.665],[859.83,686.422]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,696.245],[859.83,695.986],[826.432,821.303],[859.83,820.838]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[826.432,834.587],[859.83,834.1],[826.432,959.645],[859.83,958.952]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,410.793],[871.25,277.405],[859.83,419.014],[859.83,294.163]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,554.352],[871.25,420.963],[859.83,553.386],[859.83,428.534]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,563.096],[871.25,696.485],[859.83,561.571],[859.83,686.422]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,706.703],[871.25,840.091],[859.83,695.986],[859.83,820.838]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,854.26],[871.25,987.649],[859.83,834.1],[859.83,958.952]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,410.793],[871.25,277.405],[1169.48,412.688],[1169.48,281.267]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,554.352],[871.25,420.964],[1169.48,554.129],[1169.48,422.708]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,563.096],[871.25,696.485],[1169.48,562.745],[1169.48,694.165]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,706.703],[871.25,840.091],[1169.48,704.233],[1169.48,835.653]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[871.25,854.26],[871.25,987.649],[1169.48,849.613],[1169.48,981.034]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[1257.46,413.247],[1257.46,282.407],[1544.48,415.071],[1544.48,286.124]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[1257.46,554.063],[1257.46,423.223],[1544.48,553.849],[1544.48,424.903]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[1257.46,562.641],[1257.46,693.481],[1544.48,562.302],[1544.48,691.249]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[1257.46,703.504],[1257.46,834.344],[1544.48,701.126],[1544.48,830.073]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:64,
                    verts:[[1257.46,848.242],[1257.46,979.083],[1544.48,843.77],[1544.48,972.716]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,478.013],[709.69,412.835],[699.558,480.503],[699.558,417.975]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,548.161],[709.69,482.983],[699.558,547.799],[699.558,485.271]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,552.434],[709.69,617.612],[699.558,551.898],[699.558,614.426]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,622.605],[709.69,687.783],[699.558,619.215],[699.558,681.743]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,694.706],[709.69,759.885],[699.558,688.385],[699.558,750.913]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,478.013],[727.717,478.113],[709.69,412.835],[727.717,413.042]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,548.161],[709.69,482.983],[727.717,548.146],[727.717,483.075]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,552.434],[709.69,617.612],[727.717,552.412],[727.717,617.484]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,622.605],[727.717,622.468],[709.69,687.783],[727.717,687.54]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[709.69,694.706],[727.717,694.452],[709.69,759.885],[727.717,759.523]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,471.21],[739.714,398.191],[727.057,474.294],[727.057,404.586]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,549.796],[739.714,476.777],[727.057,549.318],[727.057,479.609]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,554.583],[739.714,627.602],[727.057,553.888],[727.057,623.597]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,633.195],[739.714,706.214],[727.057,628.936],[727.057,698.645]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,713.97],[739.714,786.988],[727.057,706.05],[727.057,775.758]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,471.21],[759.164,471.331],[739.714,398.191],[759.164,398.441]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,549.796],[739.714,476.777],[759.164,549.777],[759.164,476.888]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,554.583],[739.714,627.602],[759.164,554.556],[759.164,627.445]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,633.195],[759.164,633.028],[739.714,706.214],[759.164,705.918]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[739.714,713.97],[759.164,713.66],[739.714,786.988],[759.164,786.549]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[770.564,468.738],[770.564,393.067],[759.164,471.331],[759.164,398.441]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[770.564,550.179],[770.564,474.508],[759.164,549.777],[759.164,476.888]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[770.564,555.14],[770.564,630.811],[759.164,554.556],[759.164,627.445]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[770.564,636.608],[770.564,712.279],[759.164,633.028],[759.164,705.918]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[770.564,720.317],[770.564,795.989],[759.164,713.66],[759.164,786.549]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[771.185,468.765],[771.185,393.124],[861.941,469.35],[861.941,394.336]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[771.185,550.175],[771.185,474.533],[861.941,550.084],[861.941,475.07]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[771.185,555.134],[771.185,630.776],[861.941,555.002],[861.941,630.016]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[771.185,636.57],[771.185,712.212],[861.941,635.763],[861.941,710.777]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[771.185,720.247],[771.185,795.889],[861.941,718.745],[861.941,793.76]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,456.5],[800.074,367.696],[781.535,461.018],[781.535,377.062]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,552.075],[800.074,463.271],[781.535,551.375],[781.535,467.419]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,557.897],[800.074,646.701],[781.535,556.879],[781.535,640.835]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,653.504],[800.074,742.308],[781.535,647.266],[781.535,731.222]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,751.741],[800.074,840.545],[781.535,740.14],[781.535,824.096]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,456.5],[823.59,456.679],[800.074,367.696],[823.59,368.066]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,552.075],[800.074,463.271],[823.59,552.048],[823.59,463.435]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,557.897],[800.074,646.701],[823.59,557.857],[823.59,646.47]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,653.504],[823.59,653.258],[800.074,742.308],[823.59,741.87]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[800.074,751.741],[823.59,751.283],[800.074,840.545],[823.59,839.896]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[840.578,452.815],[840.578,360.056],[823.59,456.679],[823.59,368.066]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[840.578,552.646],[840.578,459.887],[823.59,552.048],[823.59,463.435]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[840.578,558.727],[840.578,651.486],[823.59,557.857],[823.59,646.47]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[840.578,658.592],[840.578,751.351],[823.59,653.258],[823.59,741.87]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[840.578,761.204],[840.578,853.963],[823.59,751.283],[823.59,839.896]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.02,442.379],[858.02,338.42],[832.849,448.513],[832.849,351.137]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.02,554.264],[858.02,450.305],[832.849,553.313],[832.849,455.938]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.02,561.079],[858.02,665.037],[832.849,559.697],[832.849,657.072]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.02,673.001],[858.02,776.959],[832.849,664.531],[832.849,761.907]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.02,788.002],[858.02,891.96],[832.849,772.25],[832.849,869.626]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.021,442.379],[885.393,442.623],[858.021,338.42],[885.393,338.927]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.021,554.264],[858.021,450.305],[885.393,554.226],[885.393,450.529]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.021,561.079],[858.021,665.037],[885.393,561.024],[885.393,664.72]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.021,673.001],[885.393,672.663],[858.021,776.959],[885.393,776.36]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[858.021,788.002],[885.393,787.375],[858.021,891.96],[885.393,891.071]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[908.844,437.29],[908.844,327.87],[885.393,442.623],[885.393,338.927]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[908.844,555.052],[908.844,445.633],[885.393,554.226],[885.393,450.529]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[908.844,562.225],[908.844,671.645],[885.393,561.024],[885.393,664.72]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[908.844,680.027],[908.844,789.446],[885.393,672.663],[885.393,776.359]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[908.844,801.069],[908.844,910.489],[885.393,787.375],[885.393,891.071]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,418.436],[940.122,292.985],[903.946,427.549],[903.946,311.56]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,553.453],[940.122,428.002],[903.946,552.382],[903.946,436.393]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,561.678],[940.122,687.129],[903.946,559.986],[903.946,675.976]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,696.739],[940.122,822.191],[903.946,684.861],[903.946,800.85]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,835.517],[940.122,960.969],[903.946,813.171],[903.946,929.16]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,418.436],[972.887,418.804],[940.122,292.985],[972.887,293.734]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,553.453],[940.122,428.002],[972.887,553.41],[972.887,428.34]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,561.678],[940.122,687.13],[972.887,561.61],[972.887,686.68]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,696.739],[972.887,696.26],[940.122,822.191],[972.887,821.331]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[940.122,835.517],[972.887,834.616],[940.122,960.969],[972.887,959.686]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,410.694],[1007.39,277.202],[972.887,418.804],[972.887,293.734]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,554.364],[1007.39,420.872],[972.887,553.41],[972.887,428.34]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,563.115],[1007.39,696.607],[972.887,561.61],[972.887,686.68]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,706.832],[1007.39,840.324],[972.887,696.26],[972.887,821.33]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,854.504],[1007.39,987.996],[972.887,834.616],[972.887,959.686]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,410.694],[1007.39,277.202],[1294.92,414.147],[1294.92,284.24]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,554.364],[1007.39,420.872],[1294.92,553.958],[1294.92,424.051]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,563.115],[1007.39,696.607],[1294.92,562.474],[1294.92,692.38]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,706.832],[1007.39,840.324],[1294.92,702.331],[1294.92,832.238]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1007.39,854.504],[1007.39,987.996],[1294.92,846.037],[1294.92,975.943]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1378.4,415.149],[1378.4,286.284],[1646.59,418.37],[1646.59,292.849]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1378.4,553.84],[1378.4,424.975],[1646.59,553.461],[1646.59,427.94]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1378.4,562.288],[1378.4,691.153],[1646.59,561.69],[1646.59,687.211]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1378.4,701.025],[1378.4,829.89],[1646.59,696.826],[1646.59,822.347]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:65,
                    verts:[[1378.4,843.578],[1378.4,972.444],[1646.59,835.681],[1646.59,961.201]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.936,477.387],[658.936,411.543],[641.319,479.865],[641.319,416.658]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.936,548.252],[658.936,482.408],[641.319,547.891],[641.319,484.684]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.936,552.568],[658.936,618.413],[641.319,552.035],[641.319,615.242]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.936,623.456],[658.936,689.301],[641.319,620.084],[641.319,683.291]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.936,696.295],[658.936,762.139],[641.319,690.006],[641.319,753.213]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.937,477.387],[658.937,411.543],[676.983,477.535],[676.983,411.848]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.937,548.252],[658.937,482.408],[676.983,548.23],[676.983,482.544]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.937,552.568],[658.937,618.413],[676.983,552.537],[676.983,618.223]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.937,623.457],[658.937,689.301],[676.983,623.255],[676.983,688.942]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[658.937,696.295],[676.983,695.919],[658.937,762.139],[676.983,761.606]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[692.187,475.486],[692.187,407.618],[676.983,477.535],[676.983,411.848]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[692.187,548.528],[692.187,480.661],[676.983,548.23],[676.983,482.544]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[692.187,552.978],[692.187,620.845],[676.983,552.537],[676.983,618.223]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[692.187,626.044],[692.187,693.912],[676.983,623.255],[676.983,688.942]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[692.187,701.121],[692.187,768.989],[676.983,695.919],[676.983,761.606]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,470.644],[710.974,397.018],[689.048,473.702],[689.048,403.358]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,549.884],[710.974,476.258],[689.048,549.41],[689.048,479.066]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,554.71],[710.974,628.336],[689.048,554.021],[689.048,624.366]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,633.976],[710.974,707.602],[689.048,629.754],[689.048,700.098]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,715.423],[710.974,789.049],[689.048,707.571],[689.048,777.915]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,470.644],[710.974,397.018],[730.327,470.821],[730.327,397.386]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,549.884],[710.974,476.258],[730.327,549.856],[730.327,476.42]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,554.71],[710.974,628.336],[730.327,554.67],[730.327,628.106]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,633.976],[730.327,633.731],[710.974,707.602],[730.327,707.167]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[710.974,715.423],[730.327,714.968],[710.974,789.049],[730.327,788.403]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[749.472,468.259],[749.472,392.074],[730.327,470.821],[730.327,397.386]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[749.472,550.253],[749.472,474.068],[730.327,549.856],[730.327,476.42]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[749.472,555.248],[749.472,631.433],[730.327,554.67],[730.327,628.106]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[749.472,637.269],[749.472,713.455],[730.327,633.731],[730.327,707.167]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[749.472,721.547],[749.472,797.733],[730.327,714.968],[730.327,788.403]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[750.019,468.288],[750.019,392.134],[839.705,469.142],[839.705,393.904]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[750.019,550.249],[750.019,474.095],[839.705,550.116],[839.705,474.879]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[750.019,555.241],[750.019,631.395],[839.705,555.049],[839.705,630.287]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[750.019,637.229],[750.019,713.383],[839.705,636.05],[839.705,711.288]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[750.019,721.472],[750.019,797.626],[839.705,719.28],[839.705,794.518]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[805.922,460.815],[805.922,376.642],[782.605,463.932],[782.605,383.102]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[805.922,551.407],[805.922,467.233],[782.605,550.924],[782.605,470.095]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[805.922,556.925],[805.922,641.098],[782.605,556.223],[782.605,637.052]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[805.922,647.546],[805.922,731.72],[782.605,643.244],[782.605,724.073]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[805.922,740.661],[805.922,824.834],[782.605,732.659],[782.605,813.488]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,456.127],[815.063,366.923],[783.177,460.574],[783.177,376.142]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,552.133],[815.063,462.929],[783.177,551.444],[783.177,467.012]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,557.981],[815.063,647.186],[783.177,556.979],[783.177,641.411]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,654.019],[815.063,743.224],[783.177,647.879],[783.177,732.311]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,752.699],[815.063,841.904],[783.177,741.28],[783.177,825.712]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,456.127],[815.063,366.922],[838.173,456.387],[838.173,367.461]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,552.133],[815.063,462.929],[838.173,552.093],[838.173,463.167]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,557.981],[815.063,647.186],[838.173,557.923],[838.173,646.848]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,654.019],[838.173,653.66],[815.063,743.224],[838.173,742.586]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[815.063,752.699],[838.173,752.032],[815.063,841.904],[838.173,840.957]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[866.469,452.6],[866.469,359.61],[838.173,456.387],[838.173,367.461]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[866.469,552.68],[866.469,459.69],[838.173,552.093],[838.173,463.167]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[866.469,558.776],[866.469,651.766],[838.173,557.923],[838.173,646.848]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[866.469,658.889],[866.469,751.879],[838.173,653.66],[838.173,742.586]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[866.469,761.756],[866.469,854.746],[838.173,752.032],[838.173,840.957]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[897.225,448.612],[897.225,351.344],[866.54,452.714],[866.54,359.846]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[897.225,553.298],[897.225,456.029],[866.54,552.662],[866.54,459.794]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[897.225,559.674],[897.225,656.943],[866.54,558.75],[866.54,651.618]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[897.225,664.394],[897.225,761.663],[866.54,658.732],[866.54,751.599]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[897.225,771.995],[897.225,869.264],[866.54,761.464],[866.54,854.332]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,442.293],[914.253,338.243],[871.254,448.29],[871.254,350.676]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,554.277],[914.253,450.227],[871.254,553.348],[871.254,455.733]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,561.098],[914.253,665.148],[871.254,559.747],[871.254,657.361]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,673.118],[914.253,777.168],[871.254,664.839],[871.254,762.453]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,788.221],[914.253,892.271],[871.254,772.822],[871.254,870.437]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,442.293],[914.253,338.243],[940.833,442.647],[940.833,338.976]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,554.277],[914.253,450.227],[940.833,554.222],[940.833,450.551]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,561.098],[914.253,665.148],[940.833,561.018],[940.833,664.689]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,673.119],[940.833,672.63],[914.253,777.169],[940.833,776.301]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[914.253,788.221],[940.833,787.313],[914.253,892.271],[940.833,890.984]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[979.584,437.46],[979.584,328.224],[940.832,442.647],[940.832,338.976]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[979.584,555.026],[979.584,445.789],[940.832,554.222],[940.832,450.551]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[979.584,562.187],[979.584,671.424],[940.832,561.018],[940.832,664.689]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[979.584,679.791],[979.584,789.028],[940.832,672.63],[940.832,776.301]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[979.584,800.631],[979.584,909.868],[940.832,787.313],[940.832,890.984]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1022.68,428.238],[1022.68,312.964],[981.273,433.958],[981.273,324.624]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1022.68,552.301],[1022.68,437.027],[981.273,551.629],[981.273,442.295]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1022.68,559.858],[1022.68,675.133],[981.273,558.797],[981.273,668.131]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1022.68,683.963],[1022.68,799.237],[981.273,676.506],[981.273,785.84]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1022.68,811.482],[1022.68,926.756],[981.273,797.454],[981.273,906.788]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,418.946],[1053.63,294.023],[992.413,427.77],[992.413,312.01]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,553.394],[1053.63,428.471],[992.413,552.356],[992.413,436.596]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,561.583],[1053.63,686.506],[992.413,559.945],[992.413,675.705]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,696.075],[1053.63,820.998],[992.413,684.573],[992.413,800.333]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,834.268],[1053.63,959.19],[992.413,812.629],[992.413,928.389]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,418.946],[1053.63,294.023],[1084.91,419.472],[1084.91,295.096]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,553.394],[1053.63,428.471],[1084.91,553.332],[1084.91,428.955]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,561.583],[1053.63,686.506],[1084.91,561.486],[1084.91,685.862]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,696.075],[1084.91,695.389],[1053.63,820.998],[1084.91,819.766]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1053.63,834.268],[1084.91,832.977],[1053.63,959.191],[1084.91,957.354]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,411.673],[1141.28,279.199],[1084.91,419.472],[1084.91,295.096]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,554.248],[1141.28,421.774],[1084.91,553.332],[1084.91,428.955]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,562.933],[1141.28,695.408],[1084.91,561.486],[1084.91,685.862]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,705.555],[1141.28,838.03],[1084.91,695.389],[1084.91,819.766]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,852.102],[1141.28,984.576],[1084.91,832.977],[1084.91,957.354]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,411.673],[1141.28,279.199],[1410.4,416.534],[1410.4,289.107]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,554.248],[1141.28,421.774],[1410.4,553.677],[1410.4,426.25]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,562.933],[1141.28,695.407],[1410.4,562.031],[1410.4,689.458]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,705.555],[1141.28,838.03],[1410.4,699.219],[1410.4,826.646]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1141.28,852.102],[1141.28,984.576],[1410.4,840.182],[1410.4,967.609]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1487.37,417.924],[1487.37,291.941],[1731.21,422.329],[1731.21,300.918]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1487.37,553.514],[1487.37,427.53],[1731.21,552.996],[1731.21,431.586]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1487.37,561.773],[1487.37,687.756],[1731.21,560.955],[1731.21,682.366]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1487.37,697.407],[1487.37,823.391],[1731.21,691.666],[1731.21,813.076]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:66,
                    verts:[[1487.37,836.773],[1487.37,962.756],[1731.21,825.973],[1731.21,947.383]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[601.577,479.33],[601.577,415.554],[582.861,481.089],[582.861,419.184]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[601.577,547.969],[601.577,484.193],[582.861,547.713],[582.861,485.809]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[601.577,552.15],[601.577,615.927],[582.861,551.772],[582.861,613.677]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[601.577,620.812],[601.577,684.589],[582.861,618.419],[582.861,680.324]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[601.577,691.363],[601.577,755.139],[582.861,686.899],[582.861,748.804]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,476.711],[610.078,410.146],[584.814,479.155],[584.814,415.193]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,548.35],[610.078,481.786],[584.814,547.995],[584.814,484.032]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,552.714],[610.078,619.279],[584.814,552.188],[584.814,616.15]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,624.378],[610.078,690.942],[584.814,621.05],[584.814,685.013]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,698.013],[610.078,764.577],[584.814,691.807],[584.814,755.769]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,476.711],[610.078,410.146],[628.056,476.907],[628.056,410.551]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,548.35],[610.078,481.786],[628.056,548.322],[628.056,481.966]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,552.714],[610.078,619.279],[628.056,552.672],[628.056,619.028]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,624.378],[610.078,690.942],[628.056,624.111],[628.056,690.467]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[610.078,698.013],[628.056,697.515],[610.078,764.577],[628.056,763.871]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[649.526,474.891],[649.526,406.391],[628.056,476.907],[628.056,410.551]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[649.526,548.615],[649.526,480.114],[628.056,548.322],[628.056,481.966]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[649.526,553.106],[649.526,621.606],[628.056,552.672],[628.056,619.028]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[649.526,626.854],[649.526,695.354],[628.056,624.111],[628.056,690.467]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[649.526,702.63],[649.526,771.131],[628.056,697.515],[628.056,763.871]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[672.147,473.319],[672.147,402.564],[649.352,475.441],[649.352,406.962]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[672.147,549.469],[672.147,478.714],[649.352,549.14],[649.352,480.662]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[672.147,554.108],[672.147,624.863],[649.352,553.63],[649.352,622.108]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[672.147,630.283],[672.147,701.038],[649.352,627.354],[649.352,695.832]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[672.147,708.554],[672.147,779.309],[649.352,703.106],[649.352,771.584]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,470.098],[684.386,395.885],[653.122,473.098],[653.122,402.106]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,549.968],[684.386,475.756],[653.122,549.503],[653.122,478.511]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,554.833],[684.386,629.046],[653.122,554.157],[653.122,625.15]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,634.73],[684.386,708.943],[653.122,630.588],[653.122,701.581]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,716.826],[684.386,791.038],[653.122,709.122],[653.122,780.114]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,470.098],[684.386,395.885],[703.49,470.331],[703.49,396.369]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,549.968],[684.386,475.756],[703.49,549.932],[703.49,475.97]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,554.833],[684.386,629.046],[703.49,554.781],[703.49,628.743]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,634.73],[684.386,708.943],[703.49,634.408],[703.49,708.37]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[684.386,716.826],[703.49,716.227],[684.386,791.038],[703.49,790.189]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.368,467.827],[730.368,391.178],[703.49,470.331],[703.49,396.369]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.368,550.32],[730.368,473.671],[703.49,549.932],[703.49,475.97]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.368,555.345],[730.368,631.994],[703.49,554.781],[703.49,628.743]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.368,637.866],[730.368,714.515],[703.49,634.408],[703.49,708.37]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.368,722.657],[730.368,799.306],[703.49,716.227],[703.49,790.189]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.835,467.858],[730.835,391.242],[818.684,468.975],[818.684,393.557]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.835,550.315],[730.835,473.699],[818.684,550.142],[818.684,474.725]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.835,555.338],[730.835,631.954],[818.684,555.087],[818.684,630.504]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.835,637.823],[730.835,714.439],[818.684,636.281],[818.684,711.699]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[730.835,722.578],[730.835,799.194],[818.684,719.71],[818.684,795.128]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[808.961,460.585],[808.961,376.164],[776.436,463.612],[776.436,382.44]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[808.961,551.442],[808.961,467.022],[776.436,550.973],[776.436,469.801]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[808.961,556.977],[808.961,641.398],[776.436,556.295],[776.436,637.467]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[808.961,647.864],[808.961,732.285],[776.436,643.685],[776.436,724.857]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[808.961,741.253],[808.961,825.673],[776.436,733.479],[776.436,814.651]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.753,455.955],[831.753,366.566],[786.794,460.27],[786.794,375.511]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.753,552.16],[831.753,462.771],[786.794,551.491],[786.794,466.733]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.753,558.02],[831.753,647.409],[786.794,557.048],[786.794,641.807]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.753,654.256],[831.753,743.645],[786.794,648.299],[786.794,733.058]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.753,753.14],[831.753,842.529],[786.794,742.061],[786.794,826.82]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.754,455.955],[831.754,366.566],[854.151,456.294],[854.151,367.268]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.754,552.16],[831.754,462.771],[854.151,552.107],[854.151,463.081]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.754,558.02],[831.754,647.409],[854.151,557.944],[854.151,646.97]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.754,654.256],[831.754,743.645],[854.151,653.789],[854.151,742.815]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[831.754,753.141],[854.151,752.272],[831.754,842.529],[854.151,841.298]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[893.382,452.638],[893.382,359.69],[854.151,456.294],[854.151,367.268]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[893.382,552.674],[893.382,459.725],[854.151,552.107],[854.151,463.081]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[893.382,558.767],[893.382,651.716],[854.151,557.944],[854.151,646.97]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[893.382,658.836],[893.382,751.784],[854.151,653.789],[854.151,742.815]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[893.382,761.658],[893.382,854.606],[854.151,752.272],[854.151,841.298]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[935.513,448.806],[935.513,351.745],[893.124,452.751],[893.124,359.924]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[935.513,553.268],[935.513,456.206],[893.124,552.656],[893.124,459.829]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[935.513,559.631],[935.513,656.692],[893.124,558.742],[893.124,651.569]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[935.513,664.127],[935.513,761.188],[893.124,658.68],[893.124,751.507]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[935.513,771.498],[935.513,868.56],[893.124,761.368],[893.124,854.195]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,442.632],[970.59,338.945],[910.594,448.389],[910.594,350.881]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,554.224],[970.59,450.537],[910.594,553.332],[910.594,455.824]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,561.022],[970.59,664.709],[910.594,559.725],[910.594,657.233]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,672.651],[970.59,776.338],[910.594,664.702],[910.594,762.21]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,787.353],[970.59,891.039],[910.594,772.568],[910.594,870.076]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,442.632],[970.59,338.944],[995.899,443.086],[995.899,339.888]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,554.224],[970.59,450.537],[995.899,554.154],[995.899,450.955]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,561.022],[970.59,664.709],[995.899,560.919],[995.899,664.118]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,672.652],[970.59,776.339],[995.899,672.023],[995.899,775.223]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[970.59,787.353],[995.899,786.185],[970.59,891.04],[995.899,889.384]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1048.99,438.14],[1048.99,329.633],[995.898,443.087],[995.898,339.888]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1048.99,554.92],[1048.99,446.413],[995.898,554.154],[995.898,450.955]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1048.99,562.034],[1048.99,670.541],[995.898,560.919],[995.898,664.118]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1048.99,678.853],[1048.99,787.36],[995.898,672.023],[995.898,775.222]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1048.99,798.886],[1048.99,907.393],[995.898,786.185],[995.898,889.383]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1107.36,429.239],[1107.36,315.005],[1050.91,434.67],[1050.91,326.074]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1107.36,552.184],[1107.36,437.949],[1050.91,551.545],[1050.91,442.95]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1107.36,559.673],[1107.36,673.907],[1050.91,558.665],[1050.91,667.26]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1107.36,682.658],[1107.36,796.892],[1050.91,675.579],[1050.91,784.174]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1107.36,809.027],[1107.36,923.261],[1050.91,795.709],[1050.91,904.305]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,420.292],[1163.13,296.768],[1078.94,428.642],[1078.94,313.788]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,553.235],[1163.13,429.711],[1078.94,552.254],[1078.94,437.4]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,561.333],[1163.13,684.858],[1078.94,559.783],[1078.94,674.638]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,694.32],[1163.13,817.844],[1078.94,683.436],[1078.94,798.29]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,830.966],[1163.13,954.49],[1078.94,810.49],[1078.94,925.344]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,420.292],[1163.13,296.768],[1192.17,420.959],[1192.17,298.127]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,553.235],[1163.13,429.711],[1192.17,553.157],[1192.17,430.325]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,561.333],[1163.13,684.858],[1192.17,561.21],[1192.17,684.042]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,694.32],[1163.13,817.845],[1192.17,693.451],[1192.17,816.284]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1163.13,830.966],[1192.17,829.331],[1163.13,954.49],[1192.17,952.164]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,413.645],[1268.12,283.218],[1192.17,420.959],[1192.17,298.127]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,554.017],[1268.12,423.59],[1192.17,553.157],[1192.17,430.325]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,562.567],[1268.12,692.994],[1192.17,561.21],[1192.17,684.042]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,702.985],[1268.12,833.412],[1192.17,693.451],[1192.17,816.283]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,847.266],[1268.12,977.693],[1192.17,829.331],[1192.17,952.163]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,413.645],[1268.12,283.219],[1512.64,419.693],[1512.64,295.546]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,554.017],[1268.12,423.59],[1512.64,553.306],[1512.64,429.159]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,562.567],[1268.12,692.994],[1512.64,561.445],[1512.64,685.592]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,702.985],[1268.12,833.411],[1512.64,695.101],[1512.64,819.248]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1268.12,847.266],[1268.12,977.693],[1512.64,832.436],[1512.64,956.583]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1581.65,421.4],[1581.65,299.025],[1797.55,426.74],[1797.55,309.909]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1581.65,553.105],[1581.65,430.73],[1797.55,552.477],[1797.55,435.647]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1581.65,561.128],[1581.65,683.503],[1797.55,560.137],[1797.55,676.967]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1581.65,692.877],[1581.65,815.252],[1797.55,685.916],[1797.55,802.746]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:67,
                    verts:[[1581.65,828.251],[1581.65,950.626],[1797.55,815.156],[1797.55,931.986]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[547.238,478.595],[547.238,414.036],[522.884,480.316],[522.884,417.589]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[547.238,548.076],[547.238,483.517],[522.884,547.826],[522.884,485.099]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[547.238,552.309],[547.238,616.868],[522.884,551.938],[522.884,614.665]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[547.238,621.813],[547.238,686.372],[522.884,619.47],[522.884,682.197]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[547.238,693.23],[547.238,757.789],[522.884,688.86],[522.884,751.587]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,475.986],[563.607,408.65],[530.559,478.376],[530.559,413.585]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,548.456],[563.607,481.12],[530.559,548.108],[530.559,483.317]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,552.87],[563.607,620.206],[530.559,552.355],[530.559,617.147]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,625.364],[563.607,692.7],[530.559,622.11],[530.559,686.902]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,699.853],[563.607,767.189],[530.559,693.784],[530.559,758.576]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,475.986],[563.607,408.65],[581.421,476.23],[581.421,409.154]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,548.456],[563.607,481.12],[581.421,548.42],[581.421,481.344]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,552.87],[563.607,620.206],[581.421,552.818],[581.421,619.894]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,625.364],[563.607,692.7],[581.421,625.032],[581.421,692.108]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[563.607,699.853],[563.607,767.189],[581.421,699.233],[581.421,766.31]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[609.215,474.267],[609.215,405.102],[581.421,476.23],[581.421,409.154]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[609.215,548.706],[609.215,479.54],[581.421,548.42],[581.421,481.344]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[609.215,553.24],[609.215,622.405],[581.421,552.818],[581.421,619.894]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[609.215,627.704],[609.215,696.869],[581.421,625.032],[581.421,692.108]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[609.215,704.216],[609.215,773.381],[581.421,699.233],[581.421,766.31]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[638.415,709.992],[638.415,781.348],[608.976,704.698],[608.976,773.841]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[638.415,472.759],[638.415,401.403],[608.976,474.821],[608.976,405.677]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[638.415,549.556],[638.415,478.2],[608.976,549.236],[608.976,480.093]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[638.415,554.234],[638.415,625.59],[608.976,553.769],[608.976,622.913]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[638.415,631.056],[638.415,702.412],[608.976,628.209],[608.976,697.353]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,469.573],[660.282,394.798],[619.695,472.485],[619.695,400.835]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,550.05],[660.282,475.275],[619.695,549.598],[619.695,477.948]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,554.952],[660.282,629.727],[619.695,554.296],[619.695,625.946]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,635.455],[660.282,710.23],[619.695,631.434],[619.695,703.085]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,718.172],[660.282,792.947],[619.695,710.696],[619.695,782.346]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,469.573],[660.282,394.798],[678.984,469.862],[678.984,395.396]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,550.05],[660.282,475.275],[678.984,550.005],[678.984,475.539]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,554.952],[660.282,629.727],[678.984,554.887],[678.984,629.352]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,635.455],[660.282,710.23],[678.984,635.057],[678.984,709.522]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[660.282,718.172],[660.282,792.947],[678.984,717.432],[678.984,791.898]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.496,467.442],[713.496,390.381],[678.984,469.862],[678.984,395.396]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.496,550.38],[713.496,473.318],[678.984,550.005],[678.984,475.539]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.496,555.432],[713.496,632.494],[678.984,554.887],[678.984,629.352]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.496,638.397],[713.496,715.458],[678.984,635.057],[678.984,709.522]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.496,723.644],[713.496,800.706],[678.984,717.432],[678.984,791.898]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.879,467.475],[713.879,390.447],[799.139,468.844],[799.139,393.287]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.879,550.375],[713.879,473.348],[799.139,550.163],[799.139,474.605]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.879,555.425],[713.879,632.452],[799.139,555.116],[799.139,630.673]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.879,638.352],[713.879,715.379],[799.139,636.461],[799.139,712.018]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[713.879,723.562],[713.879,800.589],[799.139,720.044],[799.139,795.601]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[813.622,460.488],[813.622,375.963],[772.198,463.389],[772.198,381.978]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[813.622,551.457],[813.622,466.933],[772.198,551.008],[772.198,469.596]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[813.622,556.999],[813.622,641.524],[772.198,556.345],[772.198,637.756]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[813.622,647.998],[813.622,732.523],[772.198,643.993],[772.198,725.404]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[813.622,741.502],[813.622,826.027],[772.198,734.052],[772.198,815.463]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,455.978],[849.787,366.613],[792.285,460.103],[792.285,375.165]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,552.156],[849.787,462.792],[792.285,551.517],[792.285,466.579]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,558.015],[849.787,647.38],[792.285,557.085],[792.285,642.023]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,654.225],[849.787,743.59],[792.285,648.529],[792.285,733.467]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,753.082],[849.787,842.447],[792.285,742.49],[792.285,827.427]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,455.978],[849.787,366.613],[871.184,456.389],[871.184,367.466]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,552.156],[849.787,462.792],[871.184,552.093],[871.184,463.169]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,558.015],[849.787,647.38],[871.184,557.922],[871.184,646.846]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,654.225],[849.787,743.59],[871.184,653.657],[871.184,742.581]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[849.787,753.083],[849.787,842.447],[871.184,752.026],[871.184,840.95]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[920.734,452.916],[920.734,360.265],[871.184,456.389],[871.184,367.466]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[920.734,552.631],[920.734,459.98],[871.184,552.093],[871.184,463.169]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[920.734,558.705],[920.734,651.355],[871.184,557.922],[871.184,646.846]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[920.734,658.453],[920.734,751.103],[871.184,653.657],[871.184,742.581]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[920.734,760.945],[920.734,853.595],[871.184,752.026],[871.184,840.95]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[973.454,449.293],[973.454,352.755],[920.155,453.026],[920.155,360.495]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[973.454,553.192],[973.454,456.654],[920.155,552.614],[920.155,460.082]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[973.454,559.521],[973.454,656.059],[920.155,558.68],[920.155,651.212]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[973.454,663.454],[973.454,759.992],[920.155,658.3],[920.155,750.832]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[973.454,770.247],[973.454,866.785],[920.155,760.661],[920.155,853.193]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,443.362],[1025.64,340.459],[949.961,448.791],[949.961,351.714]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,554.111],[1025.64,451.208],[949.961,553.27],[949.961,456.193]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,560.857],[1025.64,663.761],[949.961,559.634],[949.961,656.711]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,671.643],[1025.64,774.546],[949.961,664.147],[949.961,761.224]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,785.477],[1025.64,888.38],[949.961,771.536],[949.961,868.613]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,443.362],[1025.64,340.459],[1049.26,443.907],[1049.26,341.589]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,554.111],[1025.64,451.208],[1049.26,554.027],[1049.26,451.708]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,560.857],[1025.64,663.761],[1049.26,560.735],[1049.26,663.053]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,671.643],[1025.64,774.547],[1049.26,670.891],[1049.26,773.209]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1025.64,785.477],[1025.64,888.38],[1049.26,784.078],[1049.26,886.396]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1115.28,439.279],[1115.28,331.995],[1049.26,443.907],[1049.26,341.589]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1115.28,554.744],[1115.28,447.459],[1049.26,554.027],[1049.26,451.708]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1115.28,561.777],[1115.28,669.062],[1049.26,560.735],[1049.26,663.053]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1115.28,677.28],[1115.28,784.564],[1049.26,670.891],[1049.26,773.209]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1115.28,795.96],[1115.28,903.245],[1049.26,784.078],[1049.26,886.396]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1187.16,430.807],[1187.16,318.199],[1117.39,435.857],[1117.39,328.495]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1187.16,551.999],[1187.16,439.392],[1117.39,551.406],[1117.39,444.043]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1187.16,559.382],[1187.16,671.989],[1117.39,558.444],[1117.39,665.806]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1187.16,680.615],[1187.16,793.222],[1117.39,674.031],[1117.39,781.393]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1187.16,805.183],[1187.16,917.79],[1117.39,792.797],[1117.39,900.16]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,422.373],[1265.33,301.01],[1161.13,430.1],[1161.13,316.759]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,552.991],[1265.33,431.627],[1161.13,552.083],[1161.13,438.742]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,560.947],[1265.33,682.311],[1161.13,559.513],[1161.13,672.854]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,691.607],[1265.33,812.971],[1161.13,681.536],[1161.13,794.877]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,825.863],[1265.33,947.226],[1161.13,806.917],[1161.13,920.258]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,422.373],[1265.33,301.01],[1291.55,423.156],[1291.55,302.605]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,552.991],[1265.33,431.627],[1291.55,552.899],[1291.55,432.348]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,560.947],[1265.33,682.311],[1291.55,560.802],[1291.55,681.353]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,691.607],[1265.33,812.971],[1291.55,690.587],[1291.55,811.138]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1265.33,825.863],[1265.33,947.227],[1291.55,823.944],[1291.55,944.495]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,416.459],[1383.99,288.955],[1291.55,423.156],[1291.55,302.605]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,553.686],[1383.99,426.181],[1291.55,552.899],[1291.55,432.348]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,562.045],[1383.99,689.549],[1291.55,560.802],[1291.55,681.353]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,699.317],[1383.99,826.821],[1291.55,690.587],[1291.55,811.138]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,840.365],[1383.99,967.87],[1291.55,823.943],[1291.55,944.494]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,416.459],[1383.99,288.955],[1599.67,423.434],[1599.67,303.171]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,553.686],[1383.99,426.181],[1599.67,552.866],[1599.67,432.603]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,562.045],[1383.99,689.549],[1599.67,560.75],[1599.67,681.013]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,699.317],[1383.99,826.821],[1599.67,690.225],[1599.67,810.488]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1383.99,840.365],[1383.99,967.87],[1599.67,823.263],[1599.67,943.526]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1659.83,425.379],[1659.83,307.136],[1846.09,431.402],[1846.09,319.412]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1659.83,552.637],[1659.83,434.395],[1846.09,551.93],[1846.09,439.94]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1659.83,560.389],[1659.83,678.632],[1846.09,559.271],[1846.09,671.26]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1659.83,687.69],[1659.83,805.933],[1846.09,679.839],[1846.09,791.828]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:68,
                    verts:[[1659.83,818.493],[1659.83,936.736],[1846.09,803.724],[1846.09,915.713]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[495.519,477.792],[495.519,412.378],[465.416,479.461],[465.416,415.825]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[495.519,548.193],[495.519,482.779],[465.416,547.95],[465.416,484.313]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[495.519,552.481],[495.519,617.895],[465.416,552.122],[465.416,615.759]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[495.519,622.906],[495.519,688.32],[465.416,620.633],[465.416,684.27]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[495.519,695.269],[495.519,760.682],[465.416,691.03],[465.416,754.666]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,475.214],[519.947,407.057],[479.002,477.53],[479.002,411.837]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,548.568],[519.947,480.411],[479.002,548.231],[479.002,482.539]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,553.036],[519.947,621.193],[479.002,552.538],[479.002,618.23]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,626.414],[519.947,694.571],[479.002,623.263],[479.002,688.955]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,701.811],[519.947,769.968],[479.002,695.933],[479.002,761.626]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,475.214],[519.947,407.057],[537.496,475.506],[537.496,407.659]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,548.568],[519.947,480.411],[537.496,548.526],[537.496,480.679]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,553.036],[519.947,621.193],[537.496,552.973],[537.496,620.82]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,626.414],[519.947,694.571],[537.496,626.017],[537.496,693.864]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[519.947,701.811],[519.947,769.968],[537.496,701.07],[537.496,768.917]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[571.636,473.613],[571.636,403.753],[537.496,475.506],[537.496,407.659]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[571.636,548.801],[571.636,478.94],[537.496,548.526],[537.496,480.679]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[571.636,553.381],[571.636,623.242],[537.496,552.973],[537.496,620.82]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[571.636,628.593],[571.636,698.454],[537.496,626.017],[537.496,693.864]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[571.636,705.875],[571.636,775.735],[537.496,701.07],[537.496,768.917]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[607.388,472.19],[607.388,400.223],[571.333,474.172],[571.333,404.333]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[607.388,549.644],[607.388,477.677],[571.333,549.337],[571.333,479.497]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[607.388,554.362],[607.388,626.329],[571.333,553.915],[571.333,623.755]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[607.388,631.842],[607.388,703.809],[571.333,629.105],[571.333,698.945]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[607.388,711.453],[607.388,783.42],[571.333,706.363],[571.333,776.203]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,469.071],[638.917,393.757],[589.108,471.864],[589.108,399.548]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,550.128],[638.917,474.813],[589.108,549.695],[589.108,477.378]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,555.065],[638.917,630.379],[589.108,554.435],[589.108,626.752]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,636.148],[638.917,711.462],[589.108,632.291],[589.108,704.608]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,719.463],[638.917,794.777],[589.108,712.29],[589.108,784.606]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,469.071],[638.917,393.757],[657.063,469.412],[657.063,394.464]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,550.128],[638.917,474.813],[657.063,550.075],[657.063,475.127]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,555.065],[638.917,630.379],[657.063,554.988],[657.063,629.936]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,636.148],[638.917,711.462],[657.063,635.677],[657.063,710.625]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[638.917,719.463],[638.917,794.777],[657.063,718.587],[657.063,793.535]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.028,467.103],[699.028,389.678],[657.063,469.412],[657.063,394.464]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.028,550.432],[699.028,473.007],[657.063,550.075],[657.063,475.127]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.028,555.508],[699.028,632.934],[657.063,554.988],[657.063,629.936]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.028,638.865],[699.028,716.29],[657.063,635.677],[657.063,710.625]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.028,724.515],[699.028,801.94],[657.063,718.587],[657.063,793.535]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.322,467.137],[699.322,389.747],[781.272,468.746],[781.272,393.083]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.322,550.427],[699.322,473.037],[781.272,550.178],[781.272,474.515]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.322,555.501],[699.322,632.891],[781.272,555.138],[781.272,630.801]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.322,638.819],[699.322,716.209],[781.272,636.597],[781.272,712.26]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[699.322,724.429],[699.322,801.82],[781.272,720.297],[781.272,795.96]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[819.766,460.514],[819.766,376.017],[769.893,463.256],[769.893,381.702]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[819.766,551.453],[819.766,466.957],[769.893,551.029],[769.893,469.474]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[819.766,556.993],[819.766,641.489],[769.893,556.375],[769.893,637.929]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[819.766,647.962],[819.766,732.459],[769.893,644.176],[769.893,725.731]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[819.766,741.434],[819.766,825.931],[769.893,734.394],[769.893,815.948]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,456.179],[868.778,367.03],[799.496,460.065],[799.496,375.086]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,552.125],[868.778,462.976],[799.496,551.523],[799.496,466.544]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,557.969],[868.778,647.118],[799.496,557.094],[799.496,642.073]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,653.947],[868.778,743.096],[799.496,648.582],[799.496,733.561]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,752.566],[868.778,841.714],[799.496,742.588],[799.496,827.567]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,456.179],[868.778,367.03],[888.917,456.657],[888.917,368.021]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,552.125],[868.778,462.976],[888.917,552.051],[888.917,463.415]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,557.969],[868.778,647.118],[888.917,557.862],[888.917,646.498]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,653.947],[868.778,743.096],[888.917,653.288],[888.917,741.924]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[868.778,752.566],[868.778,841.714],[888.917,751.339],[888.917,839.976]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[947.967,453.408],[947.967,361.286],[888.917,456.657],[888.917,368.021]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[947.967,552.555],[947.967,460.432],[888.917,552.051],[888.917,463.415]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[947.967,558.594],[947.967,650.716],[888.917,557.862],[888.917,646.498]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[947.967,657.773],[947.967,749.895],[888.917,653.288],[888.917,741.924]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[947.967,759.681],[947.967,851.803],[888.917,751.339],[888.917,839.976]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1010.27,450.041],[1010.27,354.305],[947.08,453.515],[947.08,361.507]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1010.27,553.076],[1010.27,457.34],[947.08,552.538],[947.08,460.53]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1010.27,559.353],[1010.27,655.089],[947.08,558.57],[947.08,650.578]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1010.27,662.422],[1010.27,758.158],[947.08,657.626],[947.08,749.634]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1010.27,768.328],[1010.27,864.064],[947.08,759.407],[947.08,851.415]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,444.435],[1078.18,342.683],[988.519,449.464],[988.519,353.108]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,553.945],[1078.18,452.193],[988.519,553.166],[988.519,456.81]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,560.616],[1078.18,662.368],[988.519,559.483],[988.519,655.838]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,670.162],[1078.18,771.914],[988.519,663.219],[988.519,759.575]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,782.722],[1078.18,884.474],[988.519,769.81],[988.519,866.165]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,444.435],[1078.18,342.683],[1099.78,445.056],[1099.78,343.972]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,553.945],[1078.18,452.193],[1099.78,553.849],[1099.78,452.764]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,560.616],[1078.18,662.368],[1099.78,560.476],[1099.78,661.56]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,670.162],[1078.18,771.914],[1099.78,669.304],[1099.78,770.388]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1078.18,782.722],[1078.18,884.474],[1099.78,781.126],[1099.78,882.211]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1177,440.808],[1177,335.164],[1099.78,445.057],[1099.78,343.972]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1177,554.507],[1177,448.863],[1099.78,553.849],[1099.78,452.764]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1177,561.433],[1177,667.077],[1099.78,560.476],[1099.78,661.56]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1177,675.169],[1177,780.814],[1099.78,669.304],[1099.78,770.388]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1177,792.035],[1177,897.68],[1099.78,781.126],[1099.78,882.211]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1260.3,432.843],[1260.3,322.35],[1179.26,437.448],[1179.26,331.737]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1260.3,551.76],[1260.3,441.267],[1179.26,551.219],[1179.26,445.508]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1260.3,559.004],[1260.3,669.497],[1179.26,558.149],[1179.26,663.86]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1260.3,677.96],[1260.3,788.453],[1179.26,671.957],[1179.26,777.668]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1260.3,800.19],[1260.3,910.683],[1179.26,788.897],[1179.26,894.608]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,425.05],[1357.76,306.465],[1237.05,432.047],[1237.05,320.728]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,552.676],[1357.76,434.092],[1237.05,551.854],[1237.05,440.535]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,560.45],[1357.76,679.035],[1237.05,559.151],[1237.05,670.47]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,688.119],[1357.76,806.703],[1237.05,678.997],[1237.05,790.316]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,819.3],[1357.76,937.884],[1237.05,802.141],[1237.05,913.46]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,425.05],[1357.76,306.465],[1380.77,425.922],[1380.77,308.242]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,552.676],[1357.76,434.091],[1380.77,552.574],[1380.77,434.894]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,560.45],[1357.76,679.035],[1380.77,560.288],[1380.77,677.968]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,688.119],[1357.76,806.703],[1380.77,686.982],[1380.77,804.662]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1357.76,819.3],[1357.76,937.885],[1380.77,817.162],[1380.77,934.842]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,419.926],[1486.21,296.022],[1380.77,425.922],[1380.77,308.242]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,553.278],[1486.21,429.374],[1380.77,552.574],[1380.77,434.894]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,561.401],[1486.21,685.306],[1380.77,560.288],[1380.77,677.968]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,694.797],[1486.21,818.702],[1380.77,686.982],[1380.77,804.662]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,831.864],[1486.21,955.768],[1380.77,817.162],[1380.77,934.841]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,419.926],[1486.21,296.022],[1670.76,427.559],[1670.76,311.579]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,553.278],[1486.21,429.374],[1670.76,552.381],[1670.76,436.402]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,561.401],[1486.21,685.306],[1670.76,559.985],[1670.76,675.964]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,694.797],[1486.21,818.702],[1670.76,684.849],[1670.76,800.828]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1486.21,831.864],[1486.21,955.768],[1670.76,813.148],[1670.76,929.128]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1721.73,429.667],[1721.73,315.876],[1878.2,436.137],[1878.2,329.066]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1721.73,552.133],[1721.73,438.343],[1878.2,551.373],[1878.2,444.301]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1721.73,559.593],[1721.73,673.384],[1878.2,558.392],[1878.2,665.464]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1721.73,682.101],[1721.73,795.891],[1878.2,673.666],[1878.2,780.737]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:69,
                    verts:[[1721.73,807.979],[1721.73,921.77],[1878.2,792.111],[1878.2,899.183]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[446.795,476.921],[446.795,410.581],[410.846,478.525],[410.846,413.892]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[446.795,548.32],[446.795,481.98],[410.846,548.086],[410.846,483.453]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[446.795,552.669],[446.795,619.009],[410.846,552.323],[410.846,616.957]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[446.795,624.091],[446.795,690.431],[410.846,621.908],[410.846,686.541]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[446.795,697.478],[446.795,763.818],[410.846,693.406],[410.846,758.039]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,474.397],[479.444,405.37],[430.525,476.616],[430.525,409.951]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,548.687],[479.444,479.66],[430.525,548.364],[430.525,481.699]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,553.212],[479.444,622.239],[430.525,552.734],[430.525,619.399]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,627.526],[479.444,696.553],[430.525,624.506],[430.525,691.171]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,703.885],[479.444,772.912],[430.525,698.253],[430.525,764.918]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,474.397],[479.444,405.37],[496.623,474.736],[496.623,406.07]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,548.687],[479.444,479.66],[496.623,548.638],[496.623,479.971]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,553.212],[479.444,622.239],[496.623,553.139],[496.623,621.805]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,627.526],[479.444,696.553],[496.623,627.065],[496.623,695.731]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[479.444,703.885],[479.444,772.912],[496.623,703.025],[496.623,771.692]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[537.094,472.931],[537.094,402.345],[496.623,474.736],[496.623,406.07]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[537.094,548.9],[537.094,478.313],[496.623,548.638],[496.623,479.971]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[537.094,553.528],[537.094,624.114],[496.623,553.139],[496.623,621.805]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[537.094,629.521],[537.094,700.108],[496.623,627.065],[496.623,695.731]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[537.094,707.606],[537.094,778.193],[496.623,703.025],[496.623,771.692]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[579.325,712.939],[579.325,785.527],[536.727,708.102],[536.727,778.669]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[579.325,471.611],[579.325,399.023],[536.727,473.495],[536.727,402.928]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[579.325,549.734],[579.325,477.146],[536.727,549.442],[536.727,478.875]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[579.325,554.492],[579.325,627.08],[536.727,554.068],[536.727,624.635]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[579.325,632.641],[579.325,705.229],[536.727,630.04],[536.727,700.607]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,468.589],[620.462,392.757],[561.619,471.236],[561.619,398.245]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,550.202],[620.462,474.37],[561.619,549.792],[561.619,476.801]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,555.174],[620.462,631.005],[561.619,554.577],[561.619,627.568]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,636.814],[620.462,712.646],[561.619,633.159],[561.619,706.151]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,720.701],[620.462,796.533],[561.619,713.904],[561.619,786.895]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,468.589],[620.462,392.757],[637.903,468.98],[637.903,393.569]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,550.202],[620.462,474.37],[637.903,550.142],[637.903,474.73]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,555.174],[620.462,631.005],[637.903,555.085],[637.903,630.497]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,636.814],[620.462,712.646],[637.903,636.273],[637.903,711.685]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[620.462,720.701],[620.462,796.533],[637.903,719.696],[637.903,795.107]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.06,466.805],[687.06,389.06],[637.903,468.98],[637.903,393.569]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.06,550.479],[687.06,472.733],[637.903,550.142],[637.903,474.73]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.06,555.575],[687.06,633.321],[637.903,555.085],[637.903,630.497]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.06,639.276],[687.06,717.022],[637.903,636.273],[637.903,711.685]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.06,725.28],[687.06,803.026],[637.903,719.696],[637.903,795.107]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.261,466.839],[687.261,389.13],[765.225,468.672],[765.225,392.929]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.261,550.473],[687.261,472.764],[765.225,550.189],[765.225,474.447]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.261,555.568],[687.261,633.277],[765.225,555.155],[765.225,630.897]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.261,639.23],[687.261,716.939],[765.225,636.699],[765.225,712.442]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[687.261,725.194],[687.261,802.903],[765.225,720.488],[765.225,796.23]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[827.227,460.649],[827.227,376.297],[769.47,463.203],[769.47,381.592]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[827.227,551.432],[827.227,467.081],[769.47,551.037],[769.47,469.426]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[827.227,556.962],[827.227,641.314],[769.47,556.387],[769.47,637.998]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[827.227,647.776],[827.227,732.128],[769.47,644.25],[769.47,725.861]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[827.227,741.088],[827.227,825.44],[769.47,734.53],[769.47,816.141]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.346,456.537],[888.346,367.773],[808.233,460.141],[808.233,375.245]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.346,552.07],[888.346,463.305],[808.233,551.511],[808.233,466.614]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.346,557.889],[888.346,646.653],[808.233,557.077],[808.233,641.974]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.346,653.453],[888.346,742.217],[808.233,648.477],[808.233,733.373]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.346,751.646],[888.346,840.41],[808.233,742.391],[808.233,827.288]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.347,456.537],[888.347,367.773],[907.008,457.073],[907.008,368.884]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.347,552.07],[888.347,463.305],[907.008,551.987],[907.008,463.798]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.347,557.889],[888.347,646.653],[907.008,557.768],[907.008,645.957]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.347,653.453],[888.347,742.217],[907.008,652.712],[907.008,740.902]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[888.347,751.646],[888.347,840.41],[907.008,750.269],[907.008,838.458]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[974.588,454.083],[974.588,362.685],[907.008,457.073],[907.008,368.884]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[974.588,552.45],[974.588,461.052],[907.008,551.987],[907.008,463.798]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[974.588,558.442],[974.588,649.84],[907.008,557.768],[907.008,645.957]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[974.588,656.841],[974.588,748.239],[907.008,652.712],[907.008,740.902]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[974.588,757.947],[974.588,849.345],[907.008,750.269],[907.008,838.458]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1045.31,451.006],[1045.31,356.305],[973.414,454.185],[973.414,362.896]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1045.31,552.927],[1045.31,458.226],[973.414,552.434],[973.414,461.145]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1045.31,559.135],[1045.31,653.836],[973.414,558.419],[973.414,649.708]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1045.31,661.09],[1045.31,755.791],[973.414,656.701],[973.414,747.99]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1045.31,765.85],[1045.31,860.551],[973.414,757.687],[973.414,848.976]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,445.79],[1127.26,345.491],[1025.55,450.365],[1025.55,354.977]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,553.735],[1127.26,453.437],[1025.55,553.026],[1025.55,457.638]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,560.31],[1127.26,660.609],[1025.55,559.279],[1025.55,654.667]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,668.292],[1127.26,768.59],[1025.55,661.974],[1025.55,757.362]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,779.244],[1127.26,879.542],[1025.55,767.495],[1025.55,862.883]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,445.79],[1127.26,345.491],[1146.58,446.473],[1146.58,346.909]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,553.735],[1127.26,453.437],[1146.58,553.629],[1146.58,454.065]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,560.31],[1127.26,660.609],[1146.58,560.156],[1146.58,659.721]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,668.292],[1127.26,768.59],[1146.58,667.347],[1146.58,766.912]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1127.26,779.244],[1127.26,879.542],[1146.58,777.488],[1146.58,877.052]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1233.12,442.644],[1233.12,338.971],[1146.58,446.473],[1146.58,346.909]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1233.12,554.223],[1233.12,450.549],[1146.58,553.629],[1146.58,454.065]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1233.12,561.019],[1233.12,664.693],[1146.58,560.156],[1146.58,659.721]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1233.12,672.634],[1233.12,776.308],[1146.58,667.347],[1146.58,766.912]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1233.12,787.32],[1233.12,890.994],[1146.58,777.488],[1146.58,877.052]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1325.59,435.238],[1325.59,327.232],[1235.47,439.357],[1235.47,335.628]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1325.59,551.479],[1325.59,443.473],[1235.47,550.994],[1235.47,447.266]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1325.59,558.559],[1325.59,666.565],[1235.47,557.795],[1235.47,661.523]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1325.59,674.838],[1325.59,782.844],[1235.47,669.469],[1235.47,773.198]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1325.59,794.317],[1325.59,902.322],[1235.47,784.216],[1235.47,887.945]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,428.168],[1438.89,312.82],[1305.36,434.376],[1305.36,325.476]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,552.31],[1438.89,436.962],[1305.36,551.58],[1305.36,442.679]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,559.872],[1438.89,675.219],[1305.36,558.719],[1305.36,667.62]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,684.055],[1438.89,799.402],[1305.36,675.962],[1305.36,784.862]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,811.654],[1438.89,927.002],[1305.36,796.43],[1305.36,905.33]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,428.167],[1438.89,312.82],[1458.47,429.101],[1458.47,314.723]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,552.31],[1438.89,436.962],[1458.47,552.2],[1458.47,437.822]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,559.872],[1438.89,675.219],[1458.47,559.698],[1458.47,674.076]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,684.055],[1438.89,799.402],[1458.47,682.838],[1458.47,797.215]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1438.89,811.655],[1438.89,927.002],[1458.47,809.365],[1458.47,923.743]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,423.846],[1573.38,304.012],[1458.47,429.101],[1458.47,314.723]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,552.818],[1573.38,432.983],[1458.47,552.2],[1458.47,437.822]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,560.674],[1573.38,680.508],[1458.47,559.698],[1458.47,674.076]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,689.687],[1573.38,809.522],[1458.47,682.837],[1458.47,797.215]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,822.251],[1573.38,942.085],[1458.47,809.365],[1458.47,923.743]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,423.846],[1573.38,304.012],[1726.23,431.885],[1726.23,320.398]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,552.818],[1573.38,432.983],[1726.23,551.873],[1726.23,440.385]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,560.674],[1573.38,680.508],[1726.23,559.181],[1726.23,670.669]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,689.687],[1573.38,809.522],[1726.23,679.209],[1726.23,790.696]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1573.38,822.251],[1573.38,942.085],[1726.23,802.539],[1726.23,914.026]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1768.12,434.088],[1768.12,324.888],[1895.83,440.805],[1895.83,338.579]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1768.12,551.614],[1768.12,442.414],[1895.83,550.824],[1895.83,448.599]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1768.12,558.773],[1768.12,667.972],[1895.83,557.526],[1895.83,659.751]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1768.12,676.337],[1768.12,785.537],[1895.83,667.582],[1895.83,769.807]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:70,
                    verts:[[1768.12,797.137],[1768.12,906.336],[1895.83,780.666],[1895.83,882.892]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[401.358,475.983],[401.358,408.645],[359.482,477.506],[359.482,411.789]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[401.358,548.456],[401.358,481.118],[359.482,548.235],[359.482,482.517]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[401.358,552.871],[401.358,620.209],[359.482,552.543],[359.482,618.26]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[401.358,625.367],[401.358,692.706],[359.482,623.294],[359.482,689.012]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[401.358,699.859],[401.358,767.197],[359.482,695.992],[359.482,761.71]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,473.533],[442.36,403.588],[385.427,475.635],[385.427,407.926]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,548.813],[442.36,478.867],[385.427,548.507],[385.427,480.797]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,553.398],[442.36,623.344],[385.427,552.946],[385.427,620.655]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,628.702],[442.36,698.648],[385.427,625.842],[385.427,693.551]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,706.078],[442.36,776.023],[385.427,700.743],[385.427,768.453]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,473.533],[442.36,403.588],[459.059,473.918],[459.059,404.382]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,548.813],[442.36,478.867],[459.059,548.756],[459.059,479.22]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,553.398],[442.36,623.344],[459.059,553.315],[459.059,622.851]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,628.702],[442.36,698.648],[459.059,628.178],[459.059,697.714]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[442.36,706.078],[442.36,776.024],[459.059,705.101],[459.059,774.637]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[505.811,472.219],[505.811,400.874],[459.059,473.918],[459.059,404.382]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[505.811,549.004],[505.811,477.659],[459.059,548.756],[459.059,479.22]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[505.811,553.681],[505.811,625.026],[459.059,553.315],[459.059,622.851]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[505.811,630.491],[505.811,701.836],[459.059,628.178],[459.059,697.714]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[505.811,709.415],[505.811,780.76],[459.059,705.101],[459.059,774.637]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[554.398,471.02],[554.398,397.798],[505.38,472.787],[505.38,401.462]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[554.398,549.825],[554.398,476.603],[505.38,549.552],[505.38,478.226]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[554.398,554.626],[554.398,627.848],[505.38,554.228],[505.38,625.553]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[554.398,633.457],[554.398,706.679],[505.38,631.017],[505.38,702.343]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[554.398,714.457],[554.398,787.68],[505.38,709.919],[505.38,781.245]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,468.122],[605.011,391.789],[537.4,470.597],[537.4,396.92]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,550.275],[605.011,473.942],[537.4,549.891],[537.4,476.214]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,555.279],[605.011,631.611],[537.4,554.721],[537.4,628.398]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,637.458],[605.011,713.791],[537.4,634.042],[537.4,707.718]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,721.899],[605.011,798.232],[537.4,715.544],[537.4,789.221]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,468.122],[605.011,391.789],[621.603,468.561],[621.603,392.699]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,550.275],[605.011,473.942],[621.603,550.206],[621.603,474.345]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,555.279],[605.011,631.611],[621.603,555.18],[621.603,631.041]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,637.458],[605.011,713.791],[621.603,636.852],[621.603,712.714]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[605.011,721.899],[605.011,798.232],[621.603,720.772],[621.603,796.634]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.62,466.54],[677.62,388.511],[621.603,468.561],[621.603,392.699]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.62,550.52],[677.62,472.49],[621.603,550.206],[621.603,474.345]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.62,555.635],[677.62,633.665],[621.603,555.18],[621.603,631.041]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.62,639.642],[677.62,717.672],[621.603,636.852],[621.603,712.714]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.62,725.96],[677.62,803.99],[621.603,720.772],[621.603,796.634]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.727,466.574],[677.727,388.581],[751.079,468.612],[751.079,392.806]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.727,550.514],[677.727,472.521],[751.079,550.198],[751.079,474.392]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.727,555.627],[677.727,633.62],[751.079,555.168],[751.079,630.974]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.727,639.595],[677.727,717.588],[751.079,636.781],[751.079,712.587]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[677.727,725.873],[677.727,803.866],[751.079,720.64],[751.079,796.446]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[835.817,460.874],[835.817,376.764],[770.831,463.217],[770.831,381.621]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[835.817,551.398],[835.817,467.288],[770.831,551.034],[770.831,469.439]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[835.817,556.912],[835.817,641.022],[770.831,556.384],[770.831,637.98]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[835.817,647.465],[835.817,731.575],[770.831,644.23],[770.831,725.826]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[835.817,740.509],[835.817,824.619],[770.831,734.493],[770.831,816.089]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.142,457.026],[908.142,368.786],[818.281,460.315],[818.281,375.605]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.142,551.994],[908.142,463.754],[818.281,551.484],[818.281,466.774]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.142,557.779],[908.142,646.019],[818.281,557.038],[818.281,641.748]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.142,652.778],[908.142,741.018],[818.281,648.237],[818.281,732.947]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.142,750.391],[908.142,838.631],[818.281,741.945],[818.281,826.655]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.143,457.026],[908.143,368.786],[925.145,457.612],[925.145,370.001]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.143,551.994],[908.143,463.754],[925.145,551.903],[925.145,464.292]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.143,557.779],[908.143,646.019],[925.145,557.647],[925.145,645.258]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.143,652.778],[908.143,741.018],[925.145,651.969],[925.145,739.58]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[908.143,750.391],[908.143,838.632],[925.145,748.887],[925.145,836.498]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1000.19,454.905],[1000.19,364.389],[925.145,457.612],[925.145,370.001]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1000.19,552.323],[1000.19,461.807],[925.145,551.903],[925.145,464.292]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1000.19,558.257],[1000.19,648.773],[925.145,557.647],[925.145,645.258]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1000.19,655.706],[1000.19,746.222],[925.145,651.969],[925.145,739.58]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1000.19,755.837],[1000.19,846.354],[925.145,748.887],[925.145,836.498]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1078.08,452.14],[1078.08,358.657],[998.754,455],[998.754,364.586]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1078.08,552.751],[1078.08,459.268],[998.754,552.308],[998.754,461.894]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1078.08,558.88],[1078.08,652.363],[998.754,558.235],[998.754,648.649]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1078.08,659.523],[1078.08,753.007],[998.754,655.575],[998.754,745.989]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1078.08,762.937],[1078.08,856.42],[998.754,755.593],[998.754,846.007]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.2,447.36],[1172.2,348.747],[1060.5,451.449],[1060.5,357.224]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.2,553.492],[1172.2,454.879],[1060.5,552.858],[1060.5,458.633]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.2,559.957],[1172.2,658.569],[1060.5,559.035],[1060.5,653.26]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.2,666.123],[1172.2,764.736],[1060.5,660.478],[1060.5,754.703]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.2,775.211],[1172.2,873.824],[1060.5,764.712],[1060.5,858.937]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.21,447.36],[1172.21,348.747],[1189.09,448.091],[1189.09,350.263]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.21,553.492],[1172.21,454.879],[1189.09,553.378],[1189.09,455.55]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.21,559.957],[1172.21,658.57],[1189.09,559.792],[1189.09,657.62]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.21,666.123],[1172.21,764.736],[1189.09,665.114],[1189.09,762.942]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1172.21,775.211],[1172.21,873.824],[1189.09,773.333],[1189.09,871.162]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1283.02,444.703],[1283.02,343.239],[1189.09,448.091],[1189.09,350.263]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1283.02,553.903],[1283.02,452.439],[1189.09,553.378],[1189.09,455.55]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1283.02,560.555],[1283.02,662.019],[1189.09,559.792],[1189.09,657.62]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1283.02,669.792],[1283.02,771.256],[1189.09,665.114],[1189.09,762.942]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1283.02,782.033],[1283.02,883.498],[1189.09,773.333],[1189.09,871.161]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1382.42,437.881],[1382.42,332.62],[1285.41,441.495],[1285.41,339.987]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1382.42,551.168],[1382.42,445.907],[1285.41,550.743],[1285.41,449.235]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1382.42,558.069],[1382.42,663.33],[1285.41,557.398],[1285.41,658.906]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1382.42,671.393],[1382.42,776.654],[1285.41,666.681],[1285.41,768.189]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1382.42,787.835],[1382.42,893.097],[1285.41,778.972],[1285.41,880.48]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,431.574],[1508.07,319.763],[1365.32,436.974],[1365.32,330.771]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,551.909],[1508.07,440.099],[1365.32,551.274],[1365.32,445.072]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,559.239],[1508.07,671.05],[1365.32,558.237],[1365.32,664.44]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,679.615],[1508.07,791.425],[1365.32,672.575],[1365.32,778.778]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,803.302],[1508.07,915.112],[1365.32,790.059],[1365.32,896.262]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,431.574],[1508.07,319.763],[1524.17,432.544],[1524.17,321.742]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,551.909],[1508.07,440.099],[1524.17,551.795],[1524.17,440.993]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,559.239],[1508.07,671.05],[1524.17,559.059],[1524.17,669.862]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,679.615],[1508.07,791.425],[1524.17,678.349],[1524.17,789.152]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1508.07,803.302],[1508.07,915.112],[1524.17,800.922],[1524.17,911.725]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,428.03],[1645.26,312.54],[1524.17,432.544],[1524.17,321.742]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,552.326],[1645.26,436.836],[1524.17,551.795],[1524.17,440.993]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,559.897],[1645.26,675.387],[1524.17,559.059],[1524.17,669.862]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,684.234],[1645.26,799.724],[1524.17,678.349],[1524.17,789.152]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,811.992],[1645.26,927.482],[1524.17,800.922],[1524.17,911.724]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,428.03],[1645.26,312.54],[1767.19,436.257],[1767.19,329.31]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,552.326],[1645.26,436.836],[1767.19,551.359],[1767.19,444.411]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,559.897],[1645.26,675.387],[1767.19,558.37],[1767.19,665.317]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,684.234],[1645.26,799.724],[1767.19,673.51],[1767.19,780.457]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1645.26,811.992],[1645.26,927.482],[1767.19,791.817],[1767.19,898.764]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1800.41,438.499],[1800.41,333.879],[1901.17,445.297],[1901.17,347.737]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1800.41,551.095],[1800.41,446.475],[1901.17,550.296],[1901.17,452.736]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1800.41,557.954],[1800.41,662.574],[1901.17,556.692],[1901.17,654.252]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1800.41,670.588],[1800.41,775.208],[1901.17,661.726],[1901.17,759.286]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:71,
                    verts:[[1800.41,786.321],[1800.41,890.941],[1901.17,769.649],[1901.17,867.21]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[359.423,474.975],[359.423,406.564],[311.557,476.403],[311.557,409.511]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[359.423,548.603],[359.423,480.192],[311.557,548.395],[311.557,481.503]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[359.423,553.088],[359.423,621.499],[311.557,552.78],[311.557,619.672]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[359.423,626.739],[359.423,695.15],[311.557,624.796],[311.557,691.688]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[359.423,702.417],[359.423,770.828],[311.557,698.794],[311.557,765.685]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.875,472.621],[408.875,401.705],[343.925,474.584],[343.925,405.757]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.875,548.945],[408.875,478.028],[343.925,548.66],[343.925,479.832]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.875,553.594],[408.875,624.511],[343.925,553.172],[343.925,621.999]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.875,629.943],[408.875,700.86],[343.925,627.272],[343.925,696.099]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.875,708.393],[408.875,779.31],[343.925,703.41],[343.925,772.238]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.876,472.621],[408.876,401.705],[424.982,473.051],[424.982,402.592]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.876,548.945],[408.876,478.028],[424.982,548.883],[424.982,478.423]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.876,553.594],[408.876,624.511],[424.982,553.502],[424.982,623.961]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.876,629.943],[408.876,700.86],[424.982,629.358],[424.982,699.818]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[408.876,708.393],[408.876,779.31],[424.982,707.302],[424.982,777.761]]
                },{
                    num:"502",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[477.925,471.473],[477.925,399.334],[424.982,473.051],[424.982,402.592]]
                },{
                    num:"402",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[477.925,549.112],[477.925,476.973],[424.982,548.883],[424.982,478.423]]
                },{
                    num:"302",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[477.925,553.841],[477.925,625.98],[424.982,553.502],[424.982,623.961]]
                },{
                    num:"202",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[477.925,631.506],[477.925,703.646],[424.982,629.358],[424.982,699.818]]
                },{
                    num:"102",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[477.925,711.308],[477.925,783.447],[424.982,707.302],[424.982,777.761]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[532.702,470.412],[532.702,396.538],[477.431,472.046],[477.431,399.925]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[532.702,549.92],[532.702,476.045],[477.431,549.666],[477.431,477.545]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[532.702,554.763],[532.702,628.637],[477.431,554.394],[477.431,626.515]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[532.702,634.296],[532.702,708.171],[477.431,632.04],[477.431,704.161]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[532.702,716.018],[532.702,789.892],[477.431,711.822],[477.431,783.943]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,467.665],[592.58,390.841],[516.544,469.944],[516.544,395.566]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,550.345],[592.58,473.522],[516.544,549.992],[516.544,475.615]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,555.382],[592.58,632.205],[516.544,554.868],[516.544,629.246]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,638.09],[592.58,714.913],[516.544,634.943],[516.544,709.321]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,723.073],[592.58,799.897],[516.544,717.221],[516.544,791.599]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,467.665],[592.58,390.841],[608.188,468.148],[608.188,391.843]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,550.345],[592.58,473.522],[608.188,550.271],[608.188,473.966]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,555.382],[592.58,632.205],[608.188,555.273],[608.188,631.578]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,638.09],[592.58,714.913],[608.188,637.423],[608.188,713.728]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[592.58,723.073],[592.58,799.897],[608.188,721.833],[608.188,798.138]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.674,466.299],[670.674,388.011],[608.188,468.148],[608.188,391.843]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.674,550.557],[670.674,472.269],[608.188,550.271],[608.188,473.966]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.674,555.689],[670.674,633.978],[608.188,555.273],[608.188,631.578]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.674,639.974],[670.674,718.263],[608.188,637.423],[608.188,713.728]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.674,726.579],[670.674,804.867],[608.188,721.833],[608.188,798.138]]
                },{
                    num:"501",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.686,466.334],[670.686,388.082],[738.862,468.558],[738.862,392.693]]
                },{
                    num:"401",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.686,550.552],[670.686,472.3],[738.862,550.207],[738.862,474.342]]
                },{
                    num:"301",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.686,555.682],[670.686,633.933],[738.862,555.18],[738.862,631.045]]
                },{
                    num:"201",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.686,639.927],[670.686,718.179],[738.862,636.857],[738.862,712.721]]
                },{
                    num:"101",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[670.686,726.491],[670.686,804.743],[738.862,720.78],[738.862,796.645]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[845.341,461.17],[845.341,377.376],[773.846,463.283],[773.846,381.758]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[845.341,551.352],[845.341,467.559],[773.846,551.024],[773.846,469.499]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[845.341,556.845],[845.341,640.638],[773.846,556.369],[773.846,637.894]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[845.341,647.057],[845.341,730.85],[773.846,644.139],[773.846,725.664]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[845.341,739.751],[845.341,823.544],[773.846,734.324],[773.846,815.849]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.854,457.616],[927.854,370.008],[829.413,460.566],[829.413,376.125]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.854,551.903],[927.854,464.295],[829.413,551.445],[829.413,467.004]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.854,557.646],[927.854,645.253],[829.413,556.981],[829.413,641.422]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.854,651.964],[927.854,739.571],[829.413,647.89],[829.413,732.331]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.854,748.877],[927.854,836.485],[829.413,741.301],[829.413,825.742]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.856,457.616],[927.856,370.008],[943.06,458.243],[943.06,371.309]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.856,551.903],[927.856,464.295],[943.06,551.805],[943.06,464.871]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.856,557.646],[927.856,645.253],[943.06,557.505],[943.06,644.438]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.856,651.964],[927.856,739.571],[943.06,651.098],[943.06,738.032]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[927.856,748.877],[927.856,836.485],[943.06,747.266],[943.06,834.2]]
                },{
                    num:"510",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1024.46,455.835],[1024.46,366.318],[943.06,458.243],[943.06,371.309]]
                },{
                    num:"410",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1024.46,552.178],[1024.46,462.661],[943.06,551.805],[943.06,464.871]]
                },{
                    num:"310",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1024.46,558.047],[1024.46,647.565],[943.06,557.505],[943.06,644.438]]
                },{
                    num:"210",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1024.46,654.422],[1024.46,743.939],[943.06,651.098],[943.06,738.032]]
                },{
                    num:"110",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1024.46,753.448],[1024.46,842.966],[943.06,747.266],[943.06,834.2]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1108.26,453.397],[1108.26,361.262],[1022.79,455.924],[1022.79,366.501]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1108.26,552.556],[1108.26,460.422],[1022.79,552.165],[1022.79,462.742]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1108.26,558.596],[1108.26,650.731],[1022.79,558.027],[1022.79,647.45]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1108.26,657.788],[1108.26,749.923],[1022.79,654.3],[1022.79,743.723]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1108.26,759.71],[1108.26,851.844],[1022.79,753.221],[1022.79,842.644]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,449.08],[1212.62,352.314],[1092.97,452.667],[1092.97,359.748]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,553.225],[1212.62,456.458],[1092.97,552.669],[1092.97,459.751]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,559.569],[1212.62,656.336],[1092.97,558.761],[1092.97,651.679]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,663.748],[1212.62,760.515],[1092.97,658.797],[1092.97,751.715]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,770.794],[1212.62,867.56],[1092.97,761.585],[1092.97,854.503]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,449.08],[1212.62,352.314],[1226.98,449.845],[1226.98,353.9]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,553.225],[1212.62,456.458],[1226.98,553.107],[1226.98,457.161]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,559.569],[1212.62,656.336],[1226.98,559.397],[1226.98,655.342]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,663.748],[1212.62,760.515],[1226.98,662.692],[1226.98,758.638]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1212.62,770.794],[1212.62,867.56],[1226.98,768.829],[1226.98,864.775]]
                },{
                    num:"509",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1326.44,446.904],[1326.44,347.801],[1226.98,449.845],[1226.98,353.9]]
                },{
                    num:"409",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1326.44,553.562],[1326.44,454.46],[1226.98,553.107],[1226.98,457.161]]
                },{
                    num:"309",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1326.44,560.059],[1326.44,659.162],[1226.98,559.397],[1226.98,655.342]]
                },{
                    num:"209",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1326.44,666.753],[1326.44,765.856],[1226.98,662.692],[1226.98,758.638]]
                },{
                    num:"109",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1326.44,776.383],[1326.44,875.486],[1226.98,768.829],[1226.98,864.775]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1430.68,440.668],[1430.68,338.302],[1328.85,443.78],[1328.85,344.644]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1430.68,550.84],[1430.68,448.474],[1328.85,550.475],[1328.85,451.339]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1430.68,557.551],[1430.68,659.918],[1328.85,556.974],[1328.85,656.11]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1430.68,667.759],[1430.68,770.126],[1328.85,663.703],[1328.85,762.839]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1430.68,781],[1430.68,883.367],[1328.85,773.37],[1328.85,872.506]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.39,435.13],[1565.39,327.013],[1416.73,439.736],[1416.73,336.401]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.39,551.491],[1565.39,443.374],[1416.73,550.95],[1416.73,447.615]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.39,558.579],[1565.39,666.696],[1416.73,557.724],[1416.73,661.059]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.39,674.978],[1565.39,783.095],[1416.73,668.975],[1416.73,772.31]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.39,794.58],[1565.39,902.697],[1416.73,783.287],[1416.73,886.622]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.4,435.13],[1565.4,327.013],[1578.09,436.116],[1578.09,329.023]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.4,551.491],[1565.4,443.374],[1578.09,551.375],[1578.09,444.282]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.4,558.579],[1565.4,666.696],[1578.09,558.396],[1578.09,665.489]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.4,674.978],[1565.4,783.095],[1578.09,673.693],[1578.09,780.786]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1565.4,794.58],[1565.4,902.697],[1578.09,792.162],[1578.09,899.256]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,432.314],[1702.47,321.273],[1578.09,436.116],[1578.09,329.023]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,551.822],[1702.47,440.781],[1578.09,551.375],[1578.09,444.282]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,559.102],[1702.47,670.143],[1578.09,558.396],[1578.09,665.489]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,678.649],[1702.47,789.691],[1578.09,673.693],[1578.09,780.786]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,801.486],[1702.47,912.528],[1578.09,792.162],[1578.09,899.255]]
                },{
                    num:"508",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,432.314],[1702.47,321.273],[1795.19,440.553],[1795.19,338.067]]
                },{
                    num:"408",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,551.822],[1702.47,440.781],[1795.19,550.854],[1795.19,448.367]]
                },{
                    num:"308",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,559.102],[1702.47,670.143],[1795.19,557.573],[1795.19,660.059]]
                },{
                    num:"208",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,678.649],[1702.47,789.691],[1795.19,667.909],[1795.19,770.396]]
                },{
                    num:"108",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1702.47,801.486],[1702.47,912.527],[1795.19,781.282],[1795.19,883.769]]
                },{
                    num:"507",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1820.34,442.788],[1820.34,342.623],[1896.36,449.544],[1896.36,356.392]]
                },{
                    num:"407",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1820.34,550.591],[1820.34,450.426],[1896.36,549.797],[1896.36,456.646]]
                },{
                    num:"307",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1820.34,557.158],[1820.34,657.323],[1896.36,555.904],[1896.36,649.055]]
                },{
                    num:"207",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1820.34,664.996],[1820.34,765.161],[1896.36,656.19],[1896.36,749.341]]
                },{
                    num:"107",
                    tipo:"TorreI",
                    frame:72,
                    verts:[[1820.34,775.801],[1820.34,875.966],[1896.36,759.236],[1896.36,852.387]]
                },
                ],
                [
                
                ]
        ]
    }
}